webpackJsonp([1],{

/***/ "+2J0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.446a492.gif";

/***/ }),

/***/ "/45s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Mkz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Vby":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Knil")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "08Al":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Eyt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0TSc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0kbW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAMAAADaFm2tAAAAP1BMVEUAAADY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NihzhucAAAAFHRSTlMAHQ737+bZupJ/a1dEMyQHAsuldKtW/8oAAABQSURBVAjXVc9HEsAwCARBwEnOif+/1VYhamFufZAAkp1irEUSdVgj/6YjUbv5dFrj1ug9nKj9clWi14jnlfjc6KONthhYhMA7HMV1GhKm0AcbCggSjRdY9QAAAABJRU5ErkJggg=="

/***/ }),

/***/ "1TGD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAMAAACPHmKLAAAAkFBMVEUAAAC/v7+/v7+/v7+/v7+/v7+/v7/AwMC/v7+/v7/AwMC/v7+/v7+/v7+/v7/AwMC/v7+/v7++vr7AwMDAwMDAwMC/v7+/v7+/v7+/v7/AwMC/v7+/v7+/v7++vr7BwcG/v7+9vb20tLTAwMC/v7/AwMC/v7+/v7+/v7+/v7+8vLy8vLy9vb3CwsK/v7+/v79raMUlAAAAL3RSTlMAp1XIoHppNvvhhH53bGNaRz8k9evW1MzCuJuWinBfTCELBe3m3a6Rc1EtETIZFHpnb6YAAAE0SURBVEjHldXrcoIwEIbhRc6CiqiI9CBg1Vrbfvd/d00VBIbEZJ//LxmYzUIq78QVLpjBHEdm8QHwDvEAbLhHABNGMMO/jFGscXMxDt5wtzUuDmjsDYNPtGzDYoWHxChwAeYhAXqWBkGEvpw00mSGoXjiVyRz9ReRsw0gFeZOdCmpVe5dawMTa7vw/Joi8FhELjMQYkbgNFPBC7pZ1SuGN0jvZXCvmYEwh86ZiJe8StYmMxAWUJuS1IQZCEcoVKoCQ/qbmEJlRtz3KBTFFCOa5biDSqAoNlBKNbuw83wBf6EvRF9MwtPBOniUWuhYmk+1cu+HntDKpEX7zKCbU//x+X5lhd1ctSv1JLl6Tuo1BKccTYINwZMUPgDrmyTmGXCWTtVpqfyVhjsaixNSq9yauH6o8QfmlbExTIfqagAAAABJRU5ErkJggg=="

/***/ }),

/***/ "1cBH":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABqElEQVRIib2WvUpDQRCFTzZRi6AgCCJip1EQUSt9AbHSaGcbgl1AxFbQykewE0v1DdIZbTRgFSLY+FNYWJjYaBc5MrAXl3hz72xMcmBhi5n9ZmF3ziRIIkIpAKsANgAsA8gA6LfhNQD3AEoAzgA8RB0EAYUsKSBH8oV6FUnOtzgvFDRGsuQBcNUgeUjSxIGmSb62CXF1QTLVCjTeIUigkzCQXPVakfxOskDyWAnLNYPyysQ9p8qKIr5OckTijX3CB5FP81c1Z19XxA8D2JWNsf9kQglqR3kASQFtdhEiGpXPLqClLoMQgKZ6AMoIaKAHoLTxTDAt9nFqmKYnG6csgD4AkwAWPPJqAqp6JKzbwsQSBj3yqsb6iY8EkPTMuRLQuUfCI4AVAAWxMmVOGcBT0LeKyl634/S6O2XOlttU56xpxemS5BDJRZJfivhyYIKuH+0rK/xWxkkhs2HGl7DO2AlJMdkoKxf7Pf0n6JPkmmY4kbVN8qMNyA3JGe0UFCxxxiOSbwrArX1df6afYMUNkCJxYBkexU5kgExL77IdQrqKfPjnyBMA/AAFtvaA5guRzgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "1knL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAFBAMAAAA595h8AAAAElBMVEUkJiYkJiYkJiYkJiYkJiYkJiZdPvqbAAAABXRSTlPA87sgH24qb4UAAAAdSURBVAjXY3AIRQEBBgyqoaiAgUEUTUQAUw2mOQCeEBota7woxgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "1pDs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1sGk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAmCAMAAACIwYlVAAABiVBMVEUAAADozKHewJLr0KbnzKDny5/t0anewJLlyZ7ixpnozaPpzqP027Xz2bPhxJfcvo/y2bLx17DNrXbVtYTJqHHx17Du06vlyZ3ixJjy2bLt0qrUtILlyJ3LqnPy2bLu06zQsHzkyJ3y2LHr0KjlyZ7UtILRsX7v1Kzw1a7y2bLQsHzkx5vozaLlyZ7XuYjy2bLgw5bQsHvixpnt06rkyJvz2rPbvo/qz6bny6DavY303LbWt4bYuonQsHzgxJbKqnPYuYjcv5DOrnn13Lfr0Kfy2bLVtYPixpnWt4Xx17DPr3vpzqTmyp/VtYPJqHHhxJjixpnKqnPny6Dmyp/x2LHNrXjpzqTXuYjx17DewZLpz6Xs0KjTtIHx2LHVtoPOrnrjx5vSsn/v1K3au4vmyZ7t0anhxJjjx5vv1K3qz6bozKLgxJb02rX13Lfz2LPixpnx1rDu06rny5/ewZTcv5DavIzpzqTx17DYuYjw1a7WtoXTs4LRsX7027Xy2bLQr3v02rTNrXfLq3Sd9ELpAAAAZHRSTlMAIREYBERDIWJEDQivbGlpSzwlIf759vTz8u7p5ubi2tTT0cWyp6ajjIaCgGlpaVJIODIpJyEWAvv5+Pbx8e3r6eLf2c3KxL66ubi3t7KxpKOhmZmYlIV3cm9paGBdVlJMQDcyEdltDQAAAbRJREFUOMul0mVzwjAYwPFnLVMc5u7uAnN3d/fhUBgztuH75COkQFJY27v9X+Vyv8vlaQq56pn1tChBXkU2N+fZkolbEa6WifcRXpaJhyvdXNkoyGzQzRWB3PbcXINcO5y4szf30WPqAQVQraEBy+nNoca6AwDdZDi2Qr3AvQ9h7xEQGULR+M8uLIXDscgNsa9owtjPEJvtCJcCh3AX+X52jJ+3s7EKYR2kK6lNYSvxqY0I1wGr8sTqWeInsqSwownSdUej8TkDOqs5UnWemp2tyGDrIOAeaoKhqAmvuyKBQLMerw8tBK7FF1v//A6GFgGnT+AvRwe6y8g4iZ0XAHA28Y7wCY8VVQj7q6/M0PpC4Qrl08LrWxIbgE+VxFZry6mLxq5Knw3jGUil5rHzQ4gtdh5vpvGINL6DdPWSGDIdS+FGAg9I4W4Cl5RJYAaINsRxDZCpxXEbhcfE8RBQNYjhKaDrFMOrAqwXw9cg6LEgUT6qONFlb29fn0aj0Wq1/f238L+UDJuXjGUYBq8KUUZTFlV0/H3naaMA6+gBPdSAOwJcQOMYhdsE2NxZTuIIiecZHv0CGvpC3XpECIQAAAAASUVORK5CYII="

/***/ }),

/***/ "2Eqv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2e05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f79b7cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3N8s":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4G4h":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAiCAMAAAB/VplGAAAAhFBMVEUAAADV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dUhEW0cAAAAK3RSTlMAQ/p5aTwDtKumNOyvUy0pCL+VgR8Z5vbg2YcU89HHup5aJQ3IjXRdTkxHOAtqYgAAATRJREFUOMuNk9magjAMRkNAkLXsqLjruMz//u83LcpAP9v55lw0DYc0uQnpZMInC75TroD4+Mg/Xf48xpBSHdswvWguDbcA1puIKNqsAXTJ6fJ2p2WnXJX9DlCpPzi557LjFcDOFaQh3B2AQj4Grs5k4FwxMlrgQBYOWEgd2HTwHx0O98iZE5EkmXQGHeXDWbW7VOywGmKZa9UjHtx574yiv7QggcSmC9TUoLDpK3rKsbLpluUR42LW/VB4QGrW6TDVDYFZJ/DkWTMLkz5z16gYIjDpAOUQ6w7ep/awbcYbf4/jjHM+GfexpgS/v/qRP8QTo5wWoAQ2Pk35F3Cc5XRjFP2Y1HvAJY1Fi9Z5XR8xYjmLTlOoBq+Hi8awgRWwr+XDXJm31GnBrHpYaAIg6MlOJvT8B2cFIQE7HMP9AAAAAElFTkSuQmCC"

/***/ }),

/***/ "4Lrk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner2.9288dd5.jpg";

/***/ }),

/***/ "55wZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5JD3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAAOklEQVQImWP8EyHfxsDAUMLAwMDKQBn4wsDAkA4y8CcDAwMbhYbBwH4mBgaGXgYGht9UMOwLAwPDHABpAAobgpgRrQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "5N1u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5QQ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5obQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5z+K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "60wv":
/***/ (function(module, exports) {

module.exports = [{"name":"北京","value":"110000"},{"parent":"110000","name":"北京市","value":"110100"},{"parent":"110100","name":"东城区","value":"110101"},{"parent":"110100","name":"西城区","value":"110102"},{"parent":"110100","name":"崇文区","value":"110103"},{"parent":"110100","name":"宣武区","value":"110104"},{"parent":"110100","name":"朝阳区","value":"110105"},{"parent":"110100","name":"丰台区","value":"110106"},{"parent":"110100","name":"石景山区","value":"110107"},{"parent":"110100","name":"海淀区","value":"110108"},{"parent":"110100","name":"门头沟区","value":"110109"},{"parent":"110100","name":"房山区","value":"110111"},{"parent":"110100","name":"通州区","value":"110112"},{"parent":"110100","name":"顺义区","value":"110113"},{"parent":"110100","name":"昌平区","value":"110114"},{"parent":"110100","name":"大兴区","value":"110115"},{"parent":"110100","name":"怀柔区","value":"110116"},{"parent":"110100","name":"平谷区","value":"110117"},{"parent":"110100","name":"密云区","value":"110228"},{"parent":"110100","name":"延庆区","value":"110229"},{"parent":"110100","name":"其它区","value":"110230"},{"name":"天津","value":"120000"},{"parent":"120000","name":"天津市","value":"120100"},{"parent":"120100","name":"和平区","value":"120101"},{"parent":"120100","name":"河东区","value":"120102"},{"parent":"120100","name":"河西区","value":"120103"},{"parent":"120100","name":"南开区","value":"120104"},{"parent":"120100","name":"河北区","value":"120105"},{"parent":"120100","name":"红桥区","value":"120106"},{"parent":"120100","name":"塘沽区","value":"120107"},{"parent":"120100","name":"汉沽区","value":"120108"},{"parent":"120100","name":"大港区","value":"120109"},{"parent":"120100","name":"东丽区","value":"120110"},{"parent":"120100","name":"西青区","value":"120111"},{"parent":"120100","name":"津南区","value":"120112"},{"parent":"120100","name":"北辰区","value":"120113"},{"parent":"120100","name":"武清区","value":"120114"},{"parent":"120100","name":"宝坻区","value":"120115"},{"parent":"120100","name":"滨海新区","value":"120116"},{"parent":"120100","name":"宁河区","value":"120221"},{"parent":"120100","name":"静海区","value":"120223"},{"parent":"120100","name":"蓟州区","value":"120225"},{"parent":"120100","name":"其它区","value":"120226"},{"name":"河北省","value":"130000"},{"parent":"130000","name":"石家庄市","value":"130100"},{"parent":"130100","name":"长安区","value":"130102"},{"parent":"130100","name":"桥东区","value":"130103"},{"parent":"130100","name":"桥西区","value":"130104"},{"parent":"130100","name":"新华区","value":"130105"},{"parent":"130100","name":"井陉矿区","value":"130107"},{"parent":"130100","name":"裕华区","value":"130108"},{"parent":"130100","name":"井陉县","value":"130121"},{"parent":"130100","name":"正定县","value":"130123"},{"parent":"130100","name":"栾城区","value":"130124"},{"parent":"130100","name":"行唐县","value":"130125"},{"parent":"130100","name":"灵寿县","value":"130126"},{"parent":"130100","name":"高邑县","value":"130127"},{"parent":"130100","name":"深泽县","value":"130128"},{"parent":"130100","name":"赞皇县","value":"130129"},{"parent":"130100","name":"无极县","value":"130130"},{"parent":"130100","name":"平山县","value":"130131"},{"parent":"130100","name":"元氏县","value":"130132"},{"parent":"130100","name":"赵县","value":"130133"},{"parent":"130100","name":"辛集市","value":"130181"},{"parent":"130100","name":"藁城区","value":"130182"},{"parent":"130100","name":"晋州市","value":"130183"},{"parent":"130100","name":"新乐市","value":"130184"},{"parent":"130100","name":"鹿泉区","value":"130185"},{"parent":"130100","name":"其它区","value":"130186"},{"parent":"130000","name":"唐山市","value":"130200"},{"parent":"130200","name":"路南区","value":"130202"},{"parent":"130200","name":"路北区","value":"130203"},{"parent":"130200","name":"古冶区","value":"130204"},{"parent":"130200","name":"开平区","value":"130205"},{"parent":"130200","name":"丰南区","value":"130207"},{"parent":"130200","name":"丰润区","value":"130208"},{"parent":"130200","name":"滦县","value":"130223"},{"parent":"130200","name":"滦南县","value":"130224"},{"parent":"130200","name":"乐亭县","value":"130225"},{"parent":"130200","name":"迁西县","value":"130227"},{"parent":"130200","name":"玉田县","value":"130229"},{"parent":"130200","name":"曹妃甸区","value":"130230"},{"parent":"130200","name":"遵化市","value":"130281"},{"parent":"130200","name":"迁安市","value":"130283"},{"parent":"130200","name":"其它区","value":"130284"},{"parent":"130000","name":"秦皇岛市","value":"130300"},{"parent":"130300","name":"海港区","value":"130302"},{"parent":"130300","name":"山海关区","value":"130303"},{"parent":"130300","name":"北戴河区","value":"130304"},{"parent":"130300","name":"青龙满族自治县","value":"130321"},{"parent":"130300","name":"昌黎县","value":"130322"},{"parent":"130300","name":"抚宁区","value":"130323"},{"parent":"130300","name":"卢龙县","value":"130324"},{"parent":"130300","name":"其它区","value":"130398"},{"parent":"130300","name":"经济技术开发区","value":"130399"},{"parent":"130000","name":"邯郸市","value":"130400"},{"parent":"130400","name":"邯山区","value":"130402"},{"parent":"130400","name":"丛台区","value":"130403"},{"parent":"130400","name":"复兴区","value":"130404"},{"parent":"130400","name":"峰峰矿区","value":"130406"},{"parent":"130400","name":"邯郸县","value":"130421"},{"parent":"130400","name":"临漳县","value":"130423"},{"parent":"130400","name":"成安县","value":"130424"},{"parent":"130400","name":"大名县","value":"130425"},{"parent":"130400","name":"涉县","value":"130426"},{"parent":"130400","name":"磁县","value":"130427"},{"parent":"130400","name":"肥乡区","value":"130428"},{"parent":"130400","name":"永年区","value":"130429"},{"parent":"130400","name":"邱县","value":"130430"},{"parent":"130400","name":"鸡泽县","value":"130431"},{"parent":"130400","name":"广平县","value":"130432"},{"parent":"130400","name":"馆陶县","value":"130433"},{"parent":"130400","name":"魏县","value":"130434"},{"parent":"130400","name":"曲周县","value":"130435"},{"parent":"130400","name":"武安市","value":"130481"},{"parent":"130400","name":"其它区","value":"130482"},{"parent":"130000","name":"邢台市","value":"130500"},{"parent":"130500","name":"桥东区","value":"130502"},{"parent":"130500","name":"桥西区","value":"130503"},{"parent":"130500","name":"邢台县","value":"130521"},{"parent":"130500","name":"临城县","value":"130522"},{"parent":"130500","name":"内丘县","value":"130523"},{"parent":"130500","name":"柏乡县","value":"130524"},{"parent":"130500","name":"隆尧县","value":"130525"},{"parent":"130500","name":"任县","value":"130526"},{"parent":"130500","name":"南和县","value":"130527"},{"parent":"130500","name":"宁晋县","value":"130528"},{"parent":"130500","name":"巨鹿县","value":"130529"},{"parent":"130500","name":"新河县","value":"130530"},{"parent":"130500","name":"广宗县","value":"130531"},{"parent":"130500","name":"平乡县","value":"130532"},{"parent":"130500","name":"威县","value":"130533"},{"parent":"130500","name":"清河县","value":"130534"},{"parent":"130500","name":"临西县","value":"130535"},{"parent":"130500","name":"南宫市","value":"130581"},{"parent":"130500","name":"沙河市","value":"130582"},{"parent":"130500","name":"其它区","value":"130583"},{"parent":"130000","name":"保定市","value":"130600"},{"parent":"130600","name":"竞秀区","value":"130602"},{"parent":"130600","name":"莲池区","value":"130603"},{"parent":"130600","name":"南市区","value":"130604"},{"parent":"130600","name":"满城区","value":"130621"},{"parent":"130600","name":"清苑区","value":"130622"},{"parent":"130600","name":"涞水县","value":"130623"},{"parent":"130600","name":"阜平县","value":"130624"},{"parent":"130600","name":"徐水区","value":"130625"},{"parent":"130600","name":"定兴县","value":"130626"},{"parent":"130600","name":"唐县","value":"130627"},{"parent":"130600","name":"高阳县","value":"130628"},{"parent":"130600","name":"容城县","value":"130629"},{"parent":"130600","name":"涞源县","value":"130630"},{"parent":"130600","name":"望都县","value":"130631"},{"parent":"130600","name":"安新县","value":"130632"},{"parent":"130600","name":"易县","value":"130633"},{"parent":"130600","name":"曲阳县","value":"130634"},{"parent":"130600","name":"蠡县","value":"130635"},{"parent":"130600","name":"顺平县","value":"130636"},{"parent":"130600","name":"博野县","value":"130637"},{"parent":"130600","name":"雄县","value":"130638"},{"parent":"130600","name":"涿州市","value":"130681"},{"parent":"130600","name":"定州市","value":"130682"},{"parent":"130600","name":"安国市","value":"130683"},{"parent":"130600","name":"高碑店市","value":"130684"},{"parent":"130600","name":"高开区","value":"130698"},{"parent":"130600","name":"其它区","value":"130699"},{"parent":"130000","name":"张家口市","value":"130700"},{"parent":"130700","name":"桥东区","value":"130702"},{"parent":"130700","name":"桥西区","value":"130703"},{"parent":"130700","name":"宣化区","value":"130705"},{"parent":"130700","name":"下花园区","value":"130706"},{"parent":"130700","name":"宣化县","value":"130721"},{"parent":"130700","name":"张北县","value":"130722"},{"parent":"130700","name":"康保县","value":"130723"},{"parent":"130700","name":"沽源县","value":"130724"},{"parent":"130700","name":"尚义县","value":"130725"},{"parent":"130700","name":"蔚县","value":"130726"},{"parent":"130700","name":"阳原县","value":"130727"},{"parent":"130700","name":"怀安县","value":"130728"},{"parent":"130700","name":"万全区","value":"130729"},{"parent":"130700","name":"怀来县","value":"130730"},{"parent":"130700","name":"涿鹿县","value":"130731"},{"parent":"130700","name":"赤城县","value":"130732"},{"parent":"130700","name":"崇礼区","value":"130733"},{"parent":"130700","name":"其它区","value":"130734"},{"parent":"130000","name":"承德市","value":"130800"},{"parent":"130800","name":"双桥区","value":"130802"},{"parent":"130800","name":"双滦区","value":"130803"},{"parent":"130800","name":"鹰手营子矿区","value":"130804"},{"parent":"130800","name":"承德县","value":"130821"},{"parent":"130800","name":"兴隆县","value":"130822"},{"parent":"130800","name":"平泉市","value":"130823"},{"parent":"130800","name":"滦平县","value":"130824"},{"parent":"130800","name":"隆化县","value":"130825"},{"parent":"130800","name":"丰宁满族自治县","value":"130826"},{"parent":"130800","name":"宽城满族自治县","value":"130827"},{"parent":"130800","name":"围场满族蒙古族自治县","value":"130828"},{"parent":"130800","name":"其它区","value":"130829"},{"parent":"130000","name":"沧州市","value":"130900"},{"parent":"130900","name":"新华区","value":"130902"},{"parent":"130900","name":"运河区","value":"130903"},{"parent":"130900","name":"沧县","value":"130921"},{"parent":"130900","name":"青县","value":"130922"},{"parent":"130900","name":"东光县","value":"130923"},{"parent":"130900","name":"海兴县","value":"130924"},{"parent":"130900","name":"盐山县","value":"130925"},{"parent":"130900","name":"肃宁县","value":"130926"},{"parent":"130900","name":"南皮县","value":"130927"},{"parent":"130900","name":"吴桥县","value":"130928"},{"parent":"130900","name":"献县","value":"130929"},{"parent":"130900","name":"孟村回族自治县","value":"130930"},{"parent":"130900","name":"泊头市","value":"130981"},{"parent":"130900","name":"任丘市","value":"130982"},{"parent":"130900","name":"黄骅市","value":"130983"},{"parent":"130900","name":"河间市","value":"130984"},{"parent":"130900","name":"其它区","value":"130985"},{"parent":"130000","name":"廊坊市","value":"131000"},{"parent":"131000","name":"安次区","value":"131002"},{"parent":"131000","name":"广阳区","value":"131003"},{"parent":"131000","name":"固安县","value":"131022"},{"parent":"131000","name":"永清县","value":"131023"},{"parent":"131000","name":"香河县","value":"131024"},{"parent":"131000","name":"大城县","value":"131025"},{"parent":"131000","name":"文安县","value":"131026"},{"parent":"131000","name":"大厂回族自治县","value":"131028"},{"parent":"131000","name":"开发区","value":"131051"},{"parent":"131000","name":"燕郊经济技术开发区","value":"131052"},{"parent":"131000","name":"霸州市","value":"131081"},{"parent":"131000","name":"三河市","value":"131082"},{"parent":"131000","name":"其它区","value":"131083"},{"parent":"130000","name":"衡水市","value":"131100"},{"parent":"131100","name":"桃城区","value":"131102"},{"parent":"131100","name":"枣强县","value":"131121"},{"parent":"131100","name":"武邑县","value":"131122"},{"parent":"131100","name":"武强县","value":"131123"},{"parent":"131100","name":"饶阳县","value":"131124"},{"parent":"131100","name":"安平县","value":"131125"},{"parent":"131100","name":"故城县","value":"131126"},{"parent":"131100","name":"景县","value":"131127"},{"parent":"131100","name":"阜城县","value":"131128"},{"parent":"131100","name":"冀州区","value":"131181"},{"parent":"131100","name":"深州市","value":"131182"},{"parent":"131100","name":"其它区","value":"131183"},{"name":"山西省","value":"140000"},{"parent":"140000","name":"太原市","value":"140100"},{"parent":"140100","name":"小店区","value":"140105"},{"parent":"140100","name":"迎泽区","value":"140106"},{"parent":"140100","name":"杏花岭区","value":"140107"},{"parent":"140100","name":"尖草坪区","value":"140108"},{"parent":"140100","name":"万柏林区","value":"140109"},{"parent":"140100","name":"晋源区","value":"140110"},{"parent":"140100","name":"清徐县","value":"140121"},{"parent":"140100","name":"阳曲县","value":"140122"},{"parent":"140100","name":"娄烦县","value":"140123"},{"parent":"140100","name":"古交市","value":"140181"},{"parent":"140100","name":"其它区","value":"140182"},{"parent":"140000","name":"大同市","value":"140200"},{"parent":"140200","name":"城区","value":"140202"},{"parent":"140200","name":"矿区","value":"140203"},{"parent":"140200","name":"南郊区","value":"140211"},{"parent":"140200","name":"新荣区","value":"140212"},{"parent":"140200","name":"阳高县","value":"140221"},{"parent":"140200","name":"天镇县","value":"140222"},{"parent":"140200","name":"广灵县","value":"140223"},{"parent":"140200","name":"灵丘县","value":"140224"},{"parent":"140200","name":"浑源县","value":"140225"},{"parent":"140200","name":"左云县","value":"140226"},{"parent":"140200","name":"大同县","value":"140227"},{"parent":"140200","name":"其它区","value":"140228"},{"parent":"140000","name":"阳泉市","value":"140300"},{"parent":"140300","name":"城区","value":"140302"},{"parent":"140300","name":"矿区","value":"140303"},{"parent":"140300","name":"郊区","value":"140311"},{"parent":"140300","name":"平定县","value":"140321"},{"parent":"140300","name":"盂县","value":"140322"},{"parent":"140300","name":"其它区","value":"140323"},{"parent":"140000","name":"长治市","value":"140400"},{"parent":"140400","name":"长治县","value":"140421"},{"parent":"140400","name":"襄垣县","value":"140423"},{"parent":"140400","name":"屯留县","value":"140424"},{"parent":"140400","name":"平顺县","value":"140425"},{"parent":"140400","name":"黎城县","value":"140426"},{"parent":"140400","name":"壶关县","value":"140427"},{"parent":"140400","name":"长子县","value":"140428"},{"parent":"140400","name":"武乡县","value":"140429"},{"parent":"140400","name":"沁县","value":"140430"},{"parent":"140400","name":"沁源县","value":"140431"},{"parent":"140400","name":"潞城市","value":"140481"},{"parent":"140400","name":"城区","value":"140482"},{"parent":"140400","name":"郊区","value":"140483"},{"parent":"140400","name":"高新区","value":"140484"},{"parent":"140400","name":"其它区","value":"140485"},{"parent":"140000","name":"晋城市","value":"140500"},{"parent":"140500","name":"城区","value":"140502"},{"parent":"140500","name":"沁水县","value":"140521"},{"parent":"140500","name":"阳城县","value":"140522"},{"parent":"140500","name":"陵川县","value":"140524"},{"parent":"140500","name":"泽州县","value":"140525"},{"parent":"140500","name":"高平市","value":"140581"},{"parent":"140500","name":"其它区","value":"140582"},{"parent":"140000","name":"朔州市","value":"140600"},{"parent":"140600","name":"朔城区","value":"140602"},{"parent":"140600","name":"平鲁区","value":"140603"},{"parent":"140600","name":"山阴县","value":"140621"},{"parent":"140600","name":"应县","value":"140622"},{"parent":"140600","name":"右玉县","value":"140623"},{"parent":"140600","name":"怀仁县","value":"140624"},{"parent":"140600","name":"其它区","value":"140625"},{"parent":"140000","name":"晋中市","value":"140700"},{"parent":"140700","name":"榆次区","value":"140702"},{"parent":"140700","name":"榆社县","value":"140721"},{"parent":"140700","name":"左权县","value":"140722"},{"parent":"140700","name":"和顺县","value":"140723"},{"parent":"140700","name":"昔阳县","value":"140724"},{"parent":"140700","name":"寿阳县","value":"140725"},{"parent":"140700","name":"太谷县","value":"140726"},{"parent":"140700","name":"祁县","value":"140727"},{"parent":"140700","name":"平遥县","value":"140728"},{"parent":"140700","name":"灵石县","value":"140729"},{"parent":"140700","name":"介休市","value":"140781"},{"parent":"140700","name":"其它区","value":"140782"},{"parent":"140000","name":"运城市","value":"140800"},{"parent":"140800","name":"盐湖区","value":"140802"},{"parent":"140800","name":"临猗县","value":"140821"},{"parent":"140800","name":"万荣县","value":"140822"},{"parent":"140800","name":"闻喜县","value":"140823"},{"parent":"140800","name":"稷山县","value":"140824"},{"parent":"140800","name":"新绛县","value":"140825"},{"parent":"140800","name":"绛县","value":"140826"},{"parent":"140800","name":"垣曲县","value":"140827"},{"parent":"140800","name":"夏县","value":"140828"},{"parent":"140800","name":"平陆县","value":"140829"},{"parent":"140800","name":"芮城县","value":"140830"},{"parent":"140800","name":"永济市","value":"140881"},{"parent":"140800","name":"河津市","value":"140882"},{"parent":"140800","name":"其它区","value":"140883"},{"parent":"140000","name":"忻州市","value":"140900"},{"parent":"140900","name":"忻府区","value":"140902"},{"parent":"140900","name":"定襄县","value":"140921"},{"parent":"140900","name":"五台县","value":"140922"},{"parent":"140900","name":"代县","value":"140923"},{"parent":"140900","name":"繁峙县","value":"140924"},{"parent":"140900","name":"宁武县","value":"140925"},{"parent":"140900","name":"静乐县","value":"140926"},{"parent":"140900","name":"神池县","value":"140927"},{"parent":"140900","name":"五寨县","value":"140928"},{"parent":"140900","name":"岢岚县","value":"140929"},{"parent":"140900","name":"河曲县","value":"140930"},{"parent":"140900","name":"保德县","value":"140931"},{"parent":"140900","name":"偏关县","value":"140932"},{"parent":"140900","name":"原平市","value":"140981"},{"parent":"140900","name":"其它区","value":"140982"},{"parent":"140000","name":"临汾市","value":"141000"},{"parent":"141000","name":"尧都区","value":"141002"},{"parent":"141000","name":"曲沃县","value":"141021"},{"parent":"141000","name":"翼城县","value":"141022"},{"parent":"141000","name":"襄汾县","value":"141023"},{"parent":"141000","name":"洪洞县","value":"141024"},{"parent":"141000","name":"古县","value":"141025"},{"parent":"141000","name":"安泽县","value":"141026"},{"parent":"141000","name":"浮山县","value":"141027"},{"parent":"141000","name":"吉县","value":"141028"},{"parent":"141000","name":"乡宁县","value":"141029"},{"parent":"141000","name":"大宁县","value":"141030"},{"parent":"141000","name":"隰县","value":"141031"},{"parent":"141000","name":"永和县","value":"141032"},{"parent":"141000","name":"蒲县","value":"141033"},{"parent":"141000","name":"汾西县","value":"141034"},{"parent":"141000","name":"侯马市","value":"141081"},{"parent":"141000","name":"霍州市","value":"141082"},{"parent":"141000","name":"其它区","value":"141083"},{"parent":"140000","name":"吕梁市","value":"141100"},{"parent":"141100","name":"离石区","value":"141102"},{"parent":"141100","name":"文水县","value":"141121"},{"parent":"141100","name":"交城县","value":"141122"},{"parent":"141100","name":"兴县","value":"141123"},{"parent":"141100","name":"临县","value":"141124"},{"parent":"141100","name":"柳林县","value":"141125"},{"parent":"141100","name":"石楼县","value":"141126"},{"parent":"141100","name":"岚县","value":"141127"},{"parent":"141100","name":"方山县","value":"141128"},{"parent":"141100","name":"中阳县","value":"141129"},{"parent":"141100","name":"交口县","value":"141130"},{"parent":"141100","name":"孝义市","value":"141181"},{"parent":"141100","name":"汾阳市","value":"141182"},{"parent":"141100","name":"其它区","value":"141183"},{"name":"内蒙古自治区","value":"150000"},{"parent":"150000","name":"呼和浩特市","value":"150100"},{"parent":"150100","name":"新城区","value":"150102"},{"parent":"150100","name":"回民区","value":"150103"},{"parent":"150100","name":"玉泉区","value":"150104"},{"parent":"150100","name":"赛罕区","value":"150105"},{"parent":"150100","name":"土默特左旗","value":"150121"},{"parent":"150100","name":"托克托县","value":"150122"},{"parent":"150100","name":"和林格尔县","value":"150123"},{"parent":"150100","name":"清水河县","value":"150124"},{"parent":"150100","name":"武川县","value":"150125"},{"parent":"150100","name":"其它区","value":"150126"},{"parent":"150000","name":"包头市","value":"150200"},{"parent":"150200","name":"东河区","value":"150202"},{"parent":"150200","name":"昆都仑区","value":"150203"},{"parent":"150200","name":"青山区","value":"150204"},{"parent":"150200","name":"石拐区","value":"150205"},{"parent":"150200","name":"白云鄂博矿区","value":"150206"},{"parent":"150200","name":"九原区","value":"150207"},{"parent":"150200","name":"土默特右旗","value":"150221"},{"parent":"150200","name":"固阳县","value":"150222"},{"parent":"150200","name":"达尔罕茂明安联合旗","value":"150223"},{"parent":"150200","name":"其它区","value":"150224"},{"parent":"150000","name":"乌海市","value":"150300"},{"parent":"150300","name":"海勃湾区","value":"150302"},{"parent":"150300","name":"海南区","value":"150303"},{"parent":"150300","name":"乌达区","value":"150304"},{"parent":"150300","name":"其它区","value":"150305"},{"parent":"150000","name":"赤峰市","value":"150400"},{"parent":"150400","name":"红山区","value":"150402"},{"parent":"150400","name":"元宝山区","value":"150403"},{"parent":"150400","name":"松山区","value":"150404"},{"parent":"150400","name":"阿鲁科尔沁旗","value":"150421"},{"parent":"150400","name":"巴林左旗","value":"150422"},{"parent":"150400","name":"巴林右旗","value":"150423"},{"parent":"150400","name":"林西县","value":"150424"},{"parent":"150400","name":"克什克腾旗","value":"150425"},{"parent":"150400","name":"翁牛特旗","value":"150426"},{"parent":"150400","name":"喀喇沁旗","value":"150428"},{"parent":"150400","name":"宁城县","value":"150429"},{"parent":"150400","name":"敖汉旗","value":"150430"},{"parent":"150400","name":"其它区","value":"150431"},{"parent":"150000","name":"通辽市","value":"150500"},{"parent":"150500","name":"科尔沁区","value":"150502"},{"parent":"150500","name":"科尔沁左翼中旗","value":"150521"},{"parent":"150500","name":"科尔沁左翼后旗","value":"150522"},{"parent":"150500","name":"开鲁县","value":"150523"},{"parent":"150500","name":"库伦旗","value":"150524"},{"parent":"150500","name":"奈曼旗","value":"150525"},{"parent":"150500","name":"扎鲁特旗","value":"150526"},{"parent":"150500","name":"霍林郭勒市","value":"150581"},{"parent":"150500","name":"其它区","value":"150582"},{"parent":"150000","name":"鄂尔多斯市","value":"150600"},{"parent":"150600","name":"东胜区","value":"150602"},{"parent":"150600","name":"康巴什区","value":"150603"},{"parent":"150600","name":"达拉特旗","value":"150621"},{"parent":"150600","name":"准格尔旗","value":"150622"},{"parent":"150600","name":"鄂托克前旗","value":"150623"},{"parent":"150600","name":"鄂托克旗","value":"150624"},{"parent":"150600","name":"杭锦旗","value":"150625"},{"parent":"150600","name":"乌审旗","value":"150626"},{"parent":"150600","name":"伊金霍洛旗","value":"150627"},{"parent":"150600","name":"其它区","value":"150628"},{"parent":"150000","name":"呼伦贝尔市","value":"150700"},{"parent":"150700","name":"海拉尔区","value":"150702"},{"parent":"150700","name":"扎赉诺尔区","value":"150703"},{"parent":"150700","name":"阿荣旗","value":"150721"},{"parent":"150700","name":"莫力达瓦达斡尔族自治旗","value":"150722"},{"parent":"150700","name":"鄂伦春自治旗","value":"150723"},{"parent":"150700","name":"鄂温克族自治旗","value":"150724"},{"parent":"150700","name":"陈巴尔虎旗","value":"150725"},{"parent":"150700","name":"新巴尔虎左旗","value":"150726"},{"parent":"150700","name":"新巴尔虎右旗","value":"150727"},{"parent":"150700","name":"满洲里市","value":"150781"},{"parent":"150700","name":"牙克石市","value":"150782"},{"parent":"150700","name":"扎兰屯市","value":"150783"},{"parent":"150700","name":"额尔古纳市","value":"150784"},{"parent":"150700","name":"根河市","value":"150785"},{"parent":"150700","name":"其它区","value":"150786"},{"parent":"150000","name":"巴彦淖尔市","value":"150800"},{"parent":"150800","name":"临河区","value":"150802"},{"parent":"150800","name":"五原县","value":"150821"},{"parent":"150800","name":"磴口县","value":"150822"},{"parent":"150800","name":"乌拉特前旗","value":"150823"},{"parent":"150800","name":"乌拉特中旗","value":"150824"},{"parent":"150800","name":"乌拉特后旗","value":"150825"},{"parent":"150800","name":"杭锦后旗","value":"150826"},{"parent":"150800","name":"其它区","value":"150827"},{"parent":"150000","name":"乌兰察布市","value":"150900"},{"parent":"150900","name":"集宁区","value":"150902"},{"parent":"150900","name":"卓资县","value":"150921"},{"parent":"150900","name":"化德县","value":"150922"},{"parent":"150900","name":"商都县","value":"150923"},{"parent":"150900","name":"兴和县","value":"150924"},{"parent":"150900","name":"凉城县","value":"150925"},{"parent":"150900","name":"察哈尔右翼前旗","value":"150926"},{"parent":"150900","name":"察哈尔右翼中旗","value":"150927"},{"parent":"150900","name":"察哈尔右翼后旗","value":"150928"},{"parent":"150900","name":"四子王旗","value":"150929"},{"parent":"150900","name":"丰镇市","value":"150981"},{"parent":"150900","name":"其它区","value":"150982"},{"parent":"150000","name":"兴安盟","value":"152200"},{"parent":"152200","name":"乌兰浩特市","value":"152201"},{"parent":"152200","name":"阿尔山市","value":"152202"},{"parent":"152200","name":"科尔沁右翼前旗","value":"152221"},{"parent":"152200","name":"科尔沁右翼中旗","value":"152222"},{"parent":"152200","name":"扎赉特旗","value":"152223"},{"parent":"152200","name":"突泉县","value":"152224"},{"parent":"152200","name":"其它区","value":"152225"},{"parent":"150000","name":"锡林郭勒盟","value":"152500"},{"parent":"152500","name":"二连浩特市","value":"152501"},{"parent":"152500","name":"锡林浩特市","value":"152502"},{"parent":"152500","name":"阿巴嘎旗","value":"152522"},{"parent":"152500","name":"苏尼特左旗","value":"152523"},{"parent":"152500","name":"苏尼特右旗","value":"152524"},{"parent":"152500","name":"东乌珠穆沁旗","value":"152525"},{"parent":"152500","name":"西乌珠穆沁旗","value":"152526"},{"parent":"152500","name":"太仆寺旗","value":"152527"},{"parent":"152500","name":"镶黄旗","value":"152528"},{"parent":"152500","name":"正镶白旗","value":"152529"},{"parent":"152500","name":"正蓝旗","value":"152530"},{"parent":"152500","name":"多伦县","value":"152531"},{"parent":"152500","name":"其它区","value":"152532"},{"parent":"150000","name":"阿拉善盟","value":"152900"},{"parent":"152900","name":"阿拉善左旗","value":"152921"},{"parent":"152900","name":"阿拉善右旗","value":"152922"},{"parent":"152900","name":"额济纳旗","value":"152923"},{"parent":"152900","name":"其它区","value":"152924"},{"name":"辽宁省","value":"210000"},{"parent":"210000","name":"沈阳市","value":"210100"},{"parent":"210100","name":"和平区","value":"210102"},{"parent":"210100","name":"沈河区","value":"210103"},{"parent":"210100","name":"大东区","value":"210104"},{"parent":"210100","name":"皇姑区","value":"210105"},{"parent":"210100","name":"铁西区","value":"210106"},{"parent":"210100","name":"苏家屯区","value":"210111"},{"parent":"210100","name":"浑南区","value":"210112"},{"parent":"210100","name":"新城子区","value":"210113"},{"parent":"210100","name":"于洪区","value":"210114"},{"parent":"210100","name":"辽中区","value":"210122"},{"parent":"210100","name":"康平县","value":"210123"},{"parent":"210100","name":"法库县","value":"210124"},{"parent":"210100","name":"新民市","value":"210181"},{"parent":"210100","name":"浑南新区","value":"210182"},{"parent":"210100","name":"张士开发区","value":"210183"},{"parent":"210100","name":"沈北新区","value":"210184"},{"parent":"210100","name":"其它区","value":"210185"},{"parent":"210000","name":"大连市","value":"210200"},{"parent":"210200","name":"中山区","value":"210202"},{"parent":"210200","name":"西岗区","value":"210203"},{"parent":"210200","name":"沙河口区","value":"210204"},{"parent":"210200","name":"甘井子区","value":"210211"},{"parent":"210200","name":"旅顺口区","value":"210212"},{"parent":"210200","name":"金州区","value":"210213"},{"parent":"210200","name":"长海县","value":"210224"},{"parent":"210200","name":"开发区","value":"210251"},{"parent":"210200","name":"瓦房店市","value":"210281"},{"parent":"210200","name":"普兰店区","value":"210282"},{"parent":"210200","name":"庄河市","value":"210283"},{"parent":"210200","name":"岭前区","value":"210297"},{"parent":"210200","name":"其它区","value":"210298"},{"parent":"210000","name":"鞍山市","value":"210300"},{"parent":"210300","name":"铁东区","value":"210302"},{"parent":"210300","name":"铁西区","value":"210303"},{"parent":"210300","name":"立山区","value":"210304"},{"parent":"210300","name":"千山区","value":"210311"},{"parent":"210300","name":"台安县","value":"210321"},{"parent":"210300","name":"岫岩满族自治县","value":"210323"},{"parent":"210300","name":"高新区","value":"210351"},{"parent":"210300","name":"海城市","value":"210381"},{"parent":"210300","name":"其它区","value":"210382"},{"parent":"210000","name":"抚顺市","value":"210400"},{"parent":"210400","name":"新抚区","value":"210402"},{"parent":"210400","name":"东洲区","value":"210403"},{"parent":"210400","name":"望花区","value":"210404"},{"parent":"210400","name":"顺城区","value":"210411"},{"parent":"210400","name":"抚顺县","value":"210421"},{"parent":"210400","name":"新宾满族自治县","value":"210422"},{"parent":"210400","name":"清原满族自治县","value":"210423"},{"parent":"210400","name":"其它区","value":"210424"},{"parent":"210000","name":"本溪市","value":"210500"},{"parent":"210500","name":"平山区","value":"210502"},{"parent":"210500","name":"溪湖区","value":"210503"},{"parent":"210500","name":"明山区","value":"210504"},{"parent":"210500","name":"南芬区","value":"210505"},{"parent":"210500","name":"本溪满族自治县","value":"210521"},{"parent":"210500","name":"桓仁满族自治县","value":"210522"},{"parent":"210500","name":"其它区","value":"210523"},{"parent":"210000","name":"丹东市","value":"210600"},{"parent":"210600","name":"元宝区","value":"210602"},{"parent":"210600","name":"振兴区","value":"210603"},{"parent":"210600","name":"振安区","value":"210604"},{"parent":"210600","name":"宽甸满族自治县","value":"210624"},{"parent":"210600","name":"东港市","value":"210681"},{"parent":"210600","name":"凤城市","value":"210682"},{"parent":"210600","name":"其它区","value":"210683"},{"parent":"210000","name":"锦州市","value":"210700"},{"parent":"210700","name":"古塔区","value":"210702"},{"parent":"210700","name":"凌河区","value":"210703"},{"parent":"210700","name":"太和区","value":"210711"},{"parent":"210700","name":"黑山县","value":"210726"},{"parent":"210700","name":"义县","value":"210727"},{"parent":"210700","name":"凌海市","value":"210781"},{"parent":"210700","name":"北镇市","value":"210782"},{"parent":"210700","name":"其它区","value":"210783"},{"parent":"210000","name":"营口市","value":"210800"},{"parent":"210800","name":"站前区","value":"210802"},{"parent":"210800","name":"西市区","value":"210803"},{"parent":"210800","name":"鲅鱼圈区","value":"210804"},{"parent":"210800","name":"老边区","value":"210811"},{"parent":"210800","name":"盖州市","value":"210881"},{"parent":"210800","name":"大石桥市","value":"210882"},{"parent":"210800","name":"其它区","value":"210883"},{"parent":"210000","name":"阜新市","value":"210900"},{"parent":"210900","name":"海州区","value":"210902"},{"parent":"210900","name":"新邱区","value":"210903"},{"parent":"210900","name":"太平区","value":"210904"},{"parent":"210900","name":"清河门区","value":"210905"},{"parent":"210900","name":"细河区","value":"210911"},{"parent":"210900","name":"阜新蒙古族自治县","value":"210921"},{"parent":"210900","name":"彰武县","value":"210922"},{"parent":"210900","name":"其它区","value":"210923"},{"parent":"210000","name":"辽阳市","value":"211000"},{"parent":"211000","name":"白塔区","value":"211002"},{"parent":"211000","name":"文圣区","value":"211003"},{"parent":"211000","name":"宏伟区","value":"211004"},{"parent":"211000","name":"弓长岭区","value":"211005"},{"parent":"211000","name":"太子河区","value":"211011"},{"parent":"211000","name":"辽阳县","value":"211021"},{"parent":"211000","name":"灯塔市","value":"211081"},{"parent":"211000","name":"其它区","value":"211082"},{"parent":"210000","name":"盘锦市","value":"211100"},{"parent":"211100","name":"双台子区","value":"211102"},{"parent":"211100","name":"兴隆台区","value":"211103"},{"parent":"211100","name":"大洼区","value":"211121"},{"parent":"211100","name":"盘山县","value":"211122"},{"parent":"211100","name":"其它区","value":"211123"},{"parent":"210000","name":"铁岭市","value":"211200"},{"parent":"211200","name":"银州区","value":"211202"},{"parent":"211200","name":"清河区","value":"211204"},{"parent":"211200","name":"铁岭县","value":"211221"},{"parent":"211200","name":"西丰县","value":"211223"},{"parent":"211200","name":"昌图县","value":"211224"},{"parent":"211200","name":"调兵山市","value":"211281"},{"parent":"211200","name":"开原市","value":"211282"},{"parent":"211200","name":"其它区","value":"211283"},{"parent":"210000","name":"朝阳市","value":"211300"},{"parent":"211300","name":"双塔区","value":"211302"},{"parent":"211300","name":"龙城区","value":"211303"},{"parent":"211300","name":"朝阳县","value":"211321"},{"parent":"211300","name":"建平县","value":"211322"},{"parent":"211300","name":"喀喇沁左翼蒙古族自治县","value":"211324"},{"parent":"211300","name":"北票市","value":"211381"},{"parent":"211300","name":"凌源市","value":"211382"},{"parent":"211300","name":"其它区","value":"211383"},{"parent":"210000","name":"葫芦岛市","value":"211400"},{"parent":"211400","name":"连山区","value":"211402"},{"parent":"211400","name":"龙港区","value":"211403"},{"parent":"211400","name":"南票区","value":"211404"},{"parent":"211400","name":"绥中县","value":"211421"},{"parent":"211400","name":"建昌县","value":"211422"},{"parent":"211400","name":"兴城市","value":"211481"},{"parent":"211400","name":"其它区","value":"211482"},{"name":"吉林省","value":"220000"},{"parent":"220000","name":"长春市","value":"220100"},{"parent":"220100","name":"南关区","value":"220102"},{"parent":"220100","name":"宽城区","value":"220103"},{"parent":"220100","name":"朝阳区","value":"220104"},{"parent":"220100","name":"二道区","value":"220105"},{"parent":"220100","name":"绿园区","value":"220106"},{"parent":"220100","name":"双阳区","value":"220112"},{"parent":"220100","name":"农安县","value":"220122"},{"parent":"220100","name":"九台区","value":"220181"},{"parent":"220100","name":"榆树市","value":"220182"},{"parent":"220100","name":"德惠市","value":"220183"},{"parent":"220100","name":"高新技术产业开发区","value":"220184"},{"parent":"220100","name":"汽车产业开发区","value":"220185"},{"parent":"220100","name":"经济技术开发区","value":"220186"},{"parent":"220100","name":"净月旅游开发区","value":"220187"},{"parent":"220100","name":"其它区","value":"220188"},{"parent":"220000","name":"吉林市","value":"220200"},{"parent":"220200","name":"昌邑区","value":"220202"},{"parent":"220200","name":"龙潭区","value":"220203"},{"parent":"220200","name":"船营区","value":"220204"},{"parent":"220200","name":"丰满区","value":"220211"},{"parent":"220200","name":"永吉县","value":"220221"},{"parent":"220200","name":"蛟河市","value":"220281"},{"parent":"220200","name":"桦甸市","value":"220282"},{"parent":"220200","name":"舒兰市","value":"220283"},{"parent":"220200","name":"磐石市","value":"220284"},{"parent":"220200","name":"其它区","value":"220285"},{"parent":"220000","name":"四平市","value":"220300"},{"parent":"220300","name":"铁西区","value":"220302"},{"parent":"220300","name":"铁东区","value":"220303"},{"parent":"220300","name":"梨树县","value":"220322"},{"parent":"220300","name":"伊通满族自治县","value":"220323"},{"parent":"220300","name":"公主岭市","value":"220381"},{"parent":"220300","name":"双辽市","value":"220382"},{"parent":"220300","name":"其它区","value":"220383"},{"parent":"220000","name":"辽源市","value":"220400"},{"parent":"220400","name":"龙山区","value":"220402"},{"parent":"220400","name":"西安区","value":"220403"},{"parent":"220400","name":"东丰县","value":"220421"},{"parent":"220400","name":"东辽县","value":"220422"},{"parent":"220400","name":"其它区","value":"220423"},{"parent":"220000","name":"通化市","value":"220500"},{"parent":"220500","name":"东昌区","value":"220502"},{"parent":"220500","name":"二道江区","value":"220503"},{"parent":"220500","name":"通化县","value":"220521"},{"parent":"220500","name":"辉南县","value":"220523"},{"parent":"220500","name":"柳河县","value":"220524"},{"parent":"220500","name":"梅河口市","value":"220581"},{"parent":"220500","name":"集安市","value":"220582"},{"parent":"220500","name":"其它区","value":"220583"},{"parent":"220000","name":"白山市","value":"220600"},{"parent":"220600","name":"浑江区","value":"220602"},{"parent":"220600","name":"抚松县","value":"220621"},{"parent":"220600","name":"靖宇县","value":"220622"},{"parent":"220600","name":"长白朝鲜族自治县","value":"220623"},{"parent":"220600","name":"江源区","value":"220625"},{"parent":"220600","name":"临江市","value":"220681"},{"parent":"220600","name":"其它区","value":"220682"},{"parent":"220000","name":"松原市","value":"220700"},{"parent":"220700","name":"宁江区","value":"220702"},{"parent":"220700","name":"前郭尔罗斯蒙古族自治县","value":"220721"},{"parent":"220700","name":"长岭县","value":"220722"},{"parent":"220700","name":"乾安县","value":"220723"},{"parent":"220700","name":"扶余市","value":"220724"},{"parent":"220700","name":"其它区","value":"220725"},{"parent":"220000","name":"白城市","value":"220800"},{"parent":"220800","name":"洮北区","value":"220802"},{"parent":"220800","name":"镇赉县","value":"220821"},{"parent":"220800","name":"通榆县","value":"220822"},{"parent":"220800","name":"洮南市","value":"220881"},{"parent":"220800","name":"大安市","value":"220882"},{"parent":"220800","name":"其它区","value":"220883"},{"parent":"220000","name":"延边朝鲜族自治州","value":"222400"},{"parent":"222400","name":"延吉市","value":"222401"},{"parent":"222400","name":"图们市","value":"222402"},{"parent":"222400","name":"敦化市","value":"222403"},{"parent":"222400","name":"珲春市","value":"222404"},{"parent":"222400","name":"龙井市","value":"222405"},{"parent":"222400","name":"和龙市","value":"222406"},{"parent":"222400","name":"汪清县","value":"222424"},{"parent":"222400","name":"安图县","value":"222426"},{"parent":"222400","name":"其它区","value":"222427"},{"name":"黑龙江省","value":"230000"},{"parent":"230000","name":"哈尔滨市","value":"230100"},{"parent":"230100","name":"道里区","value":"230102"},{"parent":"230100","name":"南岗区","value":"230103"},{"parent":"230100","name":"道外区","value":"230104"},{"parent":"230100","name":"香坊区","value":"230106"},{"parent":"230100","name":"动力区","value":"230107"},{"parent":"230100","name":"平房区","value":"230108"},{"parent":"230100","name":"松北区","value":"230109"},{"parent":"230100","name":"呼兰区","value":"230111"},{"parent":"230100","name":"依兰县","value":"230123"},{"parent":"230100","name":"方正县","value":"230124"},{"parent":"230100","name":"宾县","value":"230125"},{"parent":"230100","name":"巴彦县","value":"230126"},{"parent":"230100","name":"木兰县","value":"230127"},{"parent":"230100","name":"通河县","value":"230128"},{"parent":"230100","name":"延寿县","value":"230129"},{"parent":"230100","name":"阿城区","value":"230181"},{"parent":"230100","name":"双城区","value":"230182"},{"parent":"230100","name":"尚志市","value":"230183"},{"parent":"230100","name":"五常市","value":"230184"},{"parent":"230100","name":"阿城市","value":"230185"},{"parent":"230100","name":"其它区","value":"230186"},{"parent":"230000","name":"齐齐哈尔市","value":"230200"},{"parent":"230200","name":"龙沙区","value":"230202"},{"parent":"230200","name":"建华区","value":"230203"},{"parent":"230200","name":"铁锋区","value":"230204"},{"parent":"230200","name":"昂昂溪区","value":"230205"},{"parent":"230200","name":"富拉尔基区","value":"230206"},{"parent":"230200","name":"碾子山区","value":"230207"},{"parent":"230200","name":"梅里斯达斡尔族区","value":"230208"},{"parent":"230200","name":"龙江县","value":"230221"},{"parent":"230200","name":"依安县","value":"230223"},{"parent":"230200","name":"泰来县","value":"230224"},{"parent":"230200","name":"甘南县","value":"230225"},{"parent":"230200","name":"富裕县","value":"230227"},{"parent":"230200","name":"克山县","value":"230229"},{"parent":"230200","name":"克东县","value":"230230"},{"parent":"230200","name":"拜泉县","value":"230231"},{"parent":"230200","name":"讷河市","value":"230281"},{"parent":"230200","name":"其它区","value":"230282"},{"parent":"230000","name":"鸡西市","value":"230300"},{"parent":"230300","name":"鸡冠区","value":"230302"},{"parent":"230300","name":"恒山区","value":"230303"},{"parent":"230300","name":"滴道区","value":"230304"},{"parent":"230300","name":"梨树区","value":"230305"},{"parent":"230300","name":"城子河区","value":"230306"},{"parent":"230300","name":"麻山区","value":"230307"},{"parent":"230300","name":"鸡东县","value":"230321"},{"parent":"230300","name":"虎林市","value":"230381"},{"parent":"230300","name":"密山市","value":"230382"},{"parent":"230300","name":"其它区","value":"230383"},{"parent":"230000","name":"鹤岗市","value":"230400"},{"parent":"230400","name":"向阳区","value":"230402"},{"parent":"230400","name":"工农区","value":"230403"},{"parent":"230400","name":"南山区","value":"230404"},{"parent":"230400","name":"兴安区","value":"230405"},{"parent":"230400","name":"东山区","value":"230406"},{"parent":"230400","name":"兴山区","value":"230407"},{"parent":"230400","name":"萝北县","value":"230421"},{"parent":"230400","name":"绥滨县","value":"230422"},{"parent":"230400","name":"其它区","value":"230423"},{"parent":"230000","name":"双鸭山市","value":"230500"},{"parent":"230500","name":"尖山区","value":"230502"},{"parent":"230500","name":"岭东区","value":"230503"},{"parent":"230500","name":"四方台区","value":"230505"},{"parent":"230500","name":"宝山区","value":"230506"},{"parent":"230500","name":"集贤县","value":"230521"},{"parent":"230500","name":"友谊县","value":"230522"},{"parent":"230500","name":"宝清县","value":"230523"},{"parent":"230500","name":"饶河县","value":"230524"},{"parent":"230500","name":"其它区","value":"230525"},{"parent":"230000","name":"大庆市","value":"230600"},{"parent":"230600","name":"萨尔图区","value":"230602"},{"parent":"230600","name":"龙凤区","value":"230603"},{"parent":"230600","name":"让胡路区","value":"230604"},{"parent":"230600","name":"红岗区","value":"230605"},{"parent":"230600","name":"大同区","value":"230606"},{"parent":"230600","name":"肇州县","value":"230621"},{"parent":"230600","name":"肇源县","value":"230622"},{"parent":"230600","name":"林甸县","value":"230623"},{"parent":"230600","name":"杜尔伯特蒙古族自治县","value":"230624"},{"parent":"230600","name":"其它区","value":"230625"},{"parent":"230000","name":"伊春市","value":"230700"},{"parent":"230700","name":"伊春区","value":"230702"},{"parent":"230700","name":"南岔区","value":"230703"},{"parent":"230700","name":"友好区","value":"230704"},{"parent":"230700","name":"西林区","value":"230705"},{"parent":"230700","name":"翠峦区","value":"230706"},{"parent":"230700","name":"新青区","value":"230707"},{"parent":"230700","name":"美溪区","value":"230708"},{"parent":"230700","name":"金山屯区","value":"230709"},{"parent":"230700","name":"五营区","value":"230710"},{"parent":"230700","name":"乌马河区","value":"230711"},{"parent":"230700","name":"汤旺河区","value":"230712"},{"parent":"230700","name":"带岭区","value":"230713"},{"parent":"230700","name":"乌伊岭区","value":"230714"},{"parent":"230700","name":"红星区","value":"230715"},{"parent":"230700","name":"上甘岭区","value":"230716"},{"parent":"230700","name":"嘉荫县","value":"230722"},{"parent":"230700","name":"铁力市","value":"230781"},{"parent":"230700","name":"其它区","value":"230782"},{"parent":"230000","name":"佳木斯市","value":"230800"},{"parent":"230800","name":"永红区","value":"230802"},{"parent":"230800","name":"向阳区","value":"230803"},{"parent":"230800","name":"前进区","value":"230804"},{"parent":"230800","name":"东风区","value":"230805"},{"parent":"230800","name":"郊区","value":"230811"},{"parent":"230800","name":"桦南县","value":"230822"},{"parent":"230800","name":"桦川县","value":"230826"},{"parent":"230800","name":"汤原县","value":"230828"},{"parent":"230800","name":"抚远市","value":"230833"},{"parent":"230800","name":"同江市","value":"230881"},{"parent":"230800","name":"富锦市","value":"230882"},{"parent":"230800","name":"其它区","value":"230883"},{"parent":"230000","name":"七台河市","value":"230900"},{"parent":"230900","name":"新兴区","value":"230902"},{"parent":"230900","name":"桃山区","value":"230903"},{"parent":"230900","name":"茄子河区","value":"230904"},{"parent":"230900","name":"勃利县","value":"230921"},{"parent":"230900","name":"其它区","value":"230922"},{"parent":"230000","name":"牡丹江市","value":"231000"},{"parent":"231000","name":"东安区","value":"231002"},{"parent":"231000","name":"阳明区","value":"231003"},{"parent":"231000","name":"爱民区","value":"231004"},{"parent":"231000","name":"西安区","value":"231005"},{"parent":"231000","name":"东宁市","value":"231024"},{"parent":"231000","name":"林口县","value":"231025"},{"parent":"231000","name":"绥芬河市","value":"231081"},{"parent":"231000","name":"海林市","value":"231083"},{"parent":"231000","name":"宁安市","value":"231084"},{"parent":"231000","name":"穆棱市","value":"231085"},{"parent":"231000","name":"其它区","value":"231086"},{"parent":"230000","name":"黑河市","value":"231100"},{"parent":"231100","name":"爱辉区","value":"231102"},{"parent":"231100","name":"嫩江县","value":"231121"},{"parent":"231100","name":"逊克县","value":"231123"},{"parent":"231100","name":"孙吴县","value":"231124"},{"parent":"231100","name":"北安市","value":"231181"},{"parent":"231100","name":"五大连池市","value":"231182"},{"parent":"231100","name":"其它区","value":"231183"},{"parent":"230000","name":"绥化市","value":"231200"},{"parent":"231200","name":"北林区","value":"231202"},{"parent":"231200","name":"望奎县","value":"231221"},{"parent":"231200","name":"兰西县","value":"231222"},{"parent":"231200","name":"青冈县","value":"231223"},{"parent":"231200","name":"庆安县","value":"231224"},{"parent":"231200","name":"明水县","value":"231225"},{"parent":"231200","name":"绥棱县","value":"231226"},{"parent":"231200","name":"安达市","value":"231281"},{"parent":"231200","name":"肇东市","value":"231282"},{"parent":"231200","name":"海伦市","value":"231283"},{"parent":"231200","name":"其它区","value":"231284"},{"parent":"230000","name":"大兴安岭地区","value":"232700"},{"parent":"232700","name":"松岭区","value":"232702"},{"parent":"232700","name":"新林区","value":"232703"},{"parent":"232700","name":"呼中区","value":"232704"},{"parent":"232700","name":"呼玛县","value":"232721"},{"parent":"232700","name":"塔河县","value":"232722"},{"parent":"232700","name":"漠河县","value":"232723"},{"parent":"232700","name":"加格达奇区","value":"232724"},{"parent":"232700","name":"其它区","value":"232725"},{"name":"上海","value":"310000"},{"parent":"310000","name":"上海市","value":"310100"},{"parent":"310100","name":"黄浦区","value":"310101"},{"parent":"310100","name":"卢湾区","value":"310103"},{"parent":"310100","name":"徐汇区","value":"310104"},{"parent":"310100","name":"长宁区","value":"310105"},{"parent":"310100","name":"静安区","value":"310106"},{"parent":"310100","name":"普陀区","value":"310107"},{"parent":"310100","name":"闸北区","value":"310108"},{"parent":"310100","name":"虹口区","value":"310109"},{"parent":"310100","name":"杨浦区","value":"310110"},{"parent":"310100","name":"闵行区","value":"310112"},{"parent":"310100","name":"宝山区","value":"310113"},{"parent":"310100","name":"嘉定区","value":"310114"},{"parent":"310100","name":"浦东新区","value":"310115"},{"parent":"310100","name":"金山区","value":"310116"},{"parent":"310100","name":"松江区","value":"310117"},{"parent":"310100","name":"青浦区","value":"310118"},{"parent":"310100","name":"南汇区","value":"310119"},{"parent":"310100","name":"奉贤区","value":"310120"},{"parent":"310100","name":"川沙区","value":"310152"},{"parent":"310100","name":"崇明区","value":"310230"},{"parent":"310100","name":"其它区","value":"310231"},{"name":"江苏省","value":"320000"},{"parent":"320000","name":"南京市","value":"320100"},{"parent":"320100","name":"玄武区","value":"320102"},{"parent":"320100","name":"白下区","value":"320103"},{"parent":"320100","name":"秦淮区","value":"320104"},{"parent":"320100","name":"建邺区","value":"320105"},{"parent":"320100","name":"鼓楼区","value":"320106"},{"parent":"320100","name":"下关区","value":"320107"},{"parent":"320100","name":"浦口区","value":"320111"},{"parent":"320100","name":"栖霞区","value":"320113"},{"parent":"320100","name":"雨花台区","value":"320114"},{"parent":"320100","name":"江宁区","value":"320115"},{"parent":"320100","name":"六合区","value":"320116"},{"parent":"320100","name":"溧水区","value":"320124"},{"parent":"320100","name":"高淳区","value":"320125"},{"parent":"320100","name":"其它区","value":"320126"},{"parent":"320000","name":"无锡市","value":"320200"},{"parent":"320200","name":"崇安区","value":"320202"},{"parent":"320200","name":"南长区","value":"320203"},{"parent":"320200","name":"北塘区","value":"320204"},{"parent":"320200","name":"锡山区","value":"320205"},{"parent":"320200","name":"惠山区","value":"320206"},{"parent":"320200","name":"滨湖区","value":"320211"},{"parent":"320200","name":"梁溪区","value":"320213"},{"parent":"320200","name":"新吴区","value":"320214"},{"parent":"320200","name":"江阴市","value":"320281"},{"parent":"320200","name":"宜兴市","value":"320282"},{"parent":"320200","name":"新区","value":"320296"},{"parent":"320200","name":"其它区","value":"320297"},{"parent":"320000","name":"徐州市","value":"320300"},{"parent":"320300","name":"鼓楼区","value":"320302"},{"parent":"320300","name":"云龙区","value":"320303"},{"parent":"320300","name":"九里区","value":"320304"},{"parent":"320300","name":"贾汪区","value":"320305"},{"parent":"320300","name":"泉山区","value":"320311"},{"parent":"320300","name":"丰县","value":"320321"},{"parent":"320300","name":"沛县","value":"320322"},{"parent":"320300","name":"铜山区","value":"320323"},{"parent":"320300","name":"睢宁县","value":"320324"},{"parent":"320300","name":"新沂市","value":"320381"},{"parent":"320300","name":"邳州市","value":"320382"},{"parent":"320300","name":"其它区","value":"320383"},{"parent":"320000","name":"常州市","value":"320400"},{"parent":"320400","name":"天宁区","value":"320402"},{"parent":"320400","name":"钟楼区","value":"320404"},{"parent":"320400","name":"戚墅堰区","value":"320405"},{"parent":"320400","name":"新北区","value":"320411"},{"parent":"320400","name":"武进区","value":"320412"},{"parent":"320400","name":"溧阳市","value":"320481"},{"parent":"320400","name":"金坛区","value":"320482"},{"parent":"320400","name":"其它区","value":"320483"},{"parent":"320000","name":"苏州市","value":"320500"},{"parent":"320500","name":"沧浪区","value":"320502"},{"parent":"320500","name":"平江区","value":"320503"},{"parent":"320500","name":"金阊区","value":"320504"},{"parent":"320500","name":"虎丘区","value":"320505"},{"parent":"320500","name":"吴中区","value":"320506"},{"parent":"320500","name":"相城区","value":"320507"},{"parent":"320500","name":"姑苏区","value":"320508"},{"parent":"320500","name":"常熟市","value":"320581"},{"parent":"320500","name":"张家港市","value":"320582"},{"parent":"320500","name":"昆山市","value":"320583"},{"parent":"320500","name":"吴江区","value":"320584"},{"parent":"320500","name":"太仓市","value":"320585"},{"parent":"320500","name":"苏州工业园区","value":"320586"},{"parent":"320500","name":"新区","value":"320594"},{"parent":"320500","name":"园区","value":"320595"},{"parent":"320500","name":"其它区","value":"320596"},{"parent":"320000","name":"南通市","value":"320600"},{"parent":"320600","name":"崇川区","value":"320602"},{"parent":"320600","name":"港闸区","value":"320611"},{"parent":"320600","name":"通州区","value":"320612"},{"parent":"320600","name":"海安县","value":"320621"},{"parent":"320600","name":"如东县","value":"320623"},{"parent":"320600","name":"启东市","value":"320681"},{"parent":"320600","name":"如皋市","value":"320682"},{"parent":"320600","name":"通州市","value":"320683"},{"parent":"320600","name":"海门市","value":"320684"},{"parent":"320600","name":"开发区","value":"320693"},{"parent":"320600","name":"其它区","value":"320694"},{"parent":"320000","name":"连云港市","value":"320700"},{"parent":"320700","name":"连云区","value":"320703"},{"parent":"320700","name":"新浦区","value":"320705"},{"parent":"320700","name":"海州区","value":"320706"},{"parent":"320700","name":"赣榆区","value":"320721"},{"parent":"320700","name":"东海县","value":"320722"},{"parent":"320700","name":"灌云县","value":"320723"},{"parent":"320700","name":"灌南县","value":"320724"},{"parent":"320700","name":"其它区","value":"320725"},{"parent":"320000","name":"淮安市","value":"320800"},{"parent":"320800","name":"清江浦区","value":"320802"},{"parent":"320800","name":"淮安区","value":"320803"},{"parent":"320800","name":"淮阴区","value":"320804"},{"parent":"320800","name":"清浦区","value":"320811"},{"parent":"320800","name":"涟水县","value":"320826"},{"parent":"320800","name":"洪泽区","value":"320829"},{"parent":"320800","name":"盱眙县","value":"320830"},{"parent":"320800","name":"金湖县","value":"320831"},{"parent":"320800","name":"其它区","value":"320832"},{"parent":"320000","name":"盐城市","value":"320900"},{"parent":"320900","name":"亭湖区","value":"320902"},{"parent":"320900","name":"盐都区","value":"320903"},{"parent":"320900","name":"响水县","value":"320921"},{"parent":"320900","name":"滨海县","value":"320922"},{"parent":"320900","name":"阜宁县","value":"320923"},{"parent":"320900","name":"射阳县","value":"320924"},{"parent":"320900","name":"建湖县","value":"320925"},{"parent":"320900","name":"东台市","value":"320981"},{"parent":"320900","name":"大丰区","value":"320982"},{"parent":"320900","name":"其它区","value":"320983"},{"parent":"320000","name":"扬州市","value":"321000"},{"parent":"321000","name":"广陵区","value":"321002"},{"parent":"321000","name":"邗江区","value":"321003"},{"parent":"321000","name":"维扬区","value":"321011"},{"parent":"321000","name":"宝应县","value":"321023"},{"parent":"321000","name":"仪征市","value":"321081"},{"parent":"321000","name":"高邮市","value":"321084"},{"parent":"321000","name":"江都区","value":"321088"},{"parent":"321000","name":"经济开发区","value":"321092"},{"parent":"321000","name":"其它区","value":"321093"},{"parent":"320000","name":"镇江市","value":"321100"},{"parent":"321100","name":"京口区","value":"321102"},{"parent":"321100","name":"润州区","value":"321111"},{"parent":"321100","name":"丹徒区","value":"321112"},{"parent":"321100","name":"丹阳市","value":"321181"},{"parent":"321100","name":"扬中市","value":"321182"},{"parent":"321100","name":"句容市","value":"321183"},{"parent":"321100","name":"其它区","value":"321184"},{"parent":"320000","name":"泰州市","value":"321200"},{"parent":"321200","name":"海陵区","value":"321202"},{"parent":"321200","name":"高港区","value":"321203"},{"parent":"321200","name":"兴化市","value":"321281"},{"parent":"321200","name":"靖江市","value":"321282"},{"parent":"321200","name":"泰兴市","value":"321283"},{"parent":"321200","name":"姜堰区","value":"321284"},{"parent":"321200","name":"其它区","value":"321285"},{"parent":"320000","name":"宿迁市","value":"321300"},{"parent":"321300","name":"宿城区","value":"321302"},{"parent":"321300","name":"宿豫区","value":"321311"},{"parent":"321300","name":"沭阳县","value":"321322"},{"parent":"321300","name":"泗阳县","value":"321323"},{"parent":"321300","name":"泗洪县","value":"321324"},{"parent":"321300","name":"其它区","value":"321325"},{"name":"浙江省","value":"330000"},{"parent":"330000","name":"杭州市","value":"330100"},{"parent":"330100","name":"上城区","value":"330102"},{"parent":"330100","name":"下城区","value":"330103"},{"parent":"330100","name":"江干区","value":"330104"},{"parent":"330100","name":"拱墅区","value":"330105"},{"parent":"330100","name":"西湖区","value":"330106"},{"parent":"330100","name":"滨江区","value":"330108"},{"parent":"330100","name":"萧山区","value":"330109"},{"parent":"330100","name":"余杭区","value":"330110"},{"parent":"330100","name":"桐庐县","value":"330122"},{"parent":"330100","name":"淳安县","value":"330127"},{"parent":"330100","name":"建德市","value":"330182"},{"parent":"330100","name":"富阳区","value":"330183"},{"parent":"330100","name":"临安区","value":"330185"},{"parent":"330100","name":"其它区","value":"330186"},{"parent":"330000","name":"宁波市","value":"330200"},{"parent":"330200","name":"海曙区","value":"330203"},{"parent":"330200","name":"江东区","value":"330204"},{"parent":"330200","name":"江北区","value":"330205"},{"parent":"330200","name":"北仑区","value":"330206"},{"parent":"330200","name":"镇海区","value":"330211"},{"parent":"330200","name":"鄞州区","value":"330212"},{"parent":"330200","name":"象山县","value":"330225"},{"parent":"330200","name":"宁海县","value":"330226"},{"parent":"330200","name":"余姚市","value":"330281"},{"parent":"330200","name":"慈溪市","value":"330282"},{"parent":"330200","name":"奉化区","value":"330283"},{"parent":"330200","name":"其它区","value":"330284"},{"parent":"330000","name":"温州市","value":"330300"},{"parent":"330300","name":"鹿城区","value":"330302"},{"parent":"330300","name":"龙湾区","value":"330303"},{"parent":"330300","name":"瓯海区","value":"330304"},{"parent":"330300","name":"洞头区","value":"330322"},{"parent":"330300","name":"永嘉县","value":"330324"},{"parent":"330300","name":"平阳县","value":"330326"},{"parent":"330300","name":"苍南县","value":"330327"},{"parent":"330300","name":"文成县","value":"330328"},{"parent":"330300","name":"泰顺县","value":"330329"},{"parent":"330300","name":"瑞安市","value":"330381"},{"parent":"330300","name":"乐清市","value":"330382"},{"parent":"330300","name":"其它区","value":"330383"},{"parent":"330000","name":"嘉兴市","value":"330400"},{"parent":"330400","name":"南湖区","value":"330402"},{"parent":"330400","name":"秀洲区","value":"330411"},{"parent":"330400","name":"嘉善县","value":"330421"},{"parent":"330400","name":"海盐县","value":"330424"},{"parent":"330400","name":"海宁市","value":"330481"},{"parent":"330400","name":"平湖市","value":"330482"},{"parent":"330400","name":"桐乡市","value":"330483"},{"parent":"330400","name":"其它区","value":"330484"},{"parent":"330000","name":"湖州市","value":"330500"},{"parent":"330500","name":"吴兴区","value":"330502"},{"parent":"330500","name":"南浔区","value":"330503"},{"parent":"330500","name":"德清县","value":"330521"},{"parent":"330500","name":"长兴县","value":"330522"},{"parent":"330500","name":"安吉县","value":"330523"},{"parent":"330500","name":"其它区","value":"330524"},{"parent":"330000","name":"绍兴市","value":"330600"},{"parent":"330600","name":"越城区","value":"330602"},{"parent":"330600","name":"柯桥区","value":"330621"},{"parent":"330600","name":"新昌县","value":"330624"},{"parent":"330600","name":"诸暨市","value":"330681"},{"parent":"330600","name":"上虞区","value":"330682"},{"parent":"330600","name":"嵊州市","value":"330683"},{"parent":"330600","name":"其它区","value":"330684"},{"parent":"330000","name":"金华市","value":"330700"},{"parent":"330700","name":"婺城区","value":"330702"},{"parent":"330700","name":"金东区","value":"330703"},{"parent":"330700","name":"武义县","value":"330723"},{"parent":"330700","name":"浦江县","value":"330726"},{"parent":"330700","name":"磐安县","value":"330727"},{"parent":"330700","name":"兰溪市","value":"330781"},{"parent":"330700","name":"义乌市","value":"330782"},{"parent":"330700","name":"东阳市","value":"330783"},{"parent":"330700","name":"永康市","value":"330784"},{"parent":"330700","name":"其它区","value":"330785"},{"parent":"330000","name":"衢州市","value":"330800"},{"parent":"330800","name":"柯城区","value":"330802"},{"parent":"330800","name":"衢江区","value":"330803"},{"parent":"330800","name":"常山县","value":"330822"},{"parent":"330800","name":"开化县","value":"330824"},{"parent":"330800","name":"龙游县","value":"330825"},{"parent":"330800","name":"江山市","value":"330881"},{"parent":"330800","name":"其它区","value":"330882"},{"parent":"330000","name":"舟山市","value":"330900"},{"parent":"330900","name":"定海区","value":"330902"},{"parent":"330900","name":"普陀区","value":"330903"},{"parent":"330900","name":"岱山县","value":"330921"},{"parent":"330900","name":"嵊泗县","value":"330922"},{"parent":"330900","name":"其它区","value":"330923"},{"parent":"330000","name":"台州市","value":"331000"},{"parent":"331000","name":"椒江区","value":"331002"},{"parent":"331000","name":"黄岩区","value":"331003"},{"parent":"331000","name":"路桥区","value":"331004"},{"parent":"331000","name":"玉环市","value":"331021"},{"parent":"331000","name":"三门县","value":"331022"},{"parent":"331000","name":"天台县","value":"331023"},{"parent":"331000","name":"仙居县","value":"331024"},{"parent":"331000","name":"温岭市","value":"331081"},{"parent":"331000","name":"临海市","value":"331082"},{"parent":"331000","name":"其它区","value":"331083"},{"parent":"330000","name":"丽水市","value":"331100"},{"parent":"331100","name":"莲都区","value":"331102"},{"parent":"331100","name":"青田县","value":"331121"},{"parent":"331100","name":"缙云县","value":"331122"},{"parent":"331100","name":"遂昌县","value":"331123"},{"parent":"331100","name":"松阳县","value":"331124"},{"parent":"331100","name":"云和县","value":"331125"},{"parent":"331100","name":"庆元县","value":"331126"},{"parent":"331100","name":"景宁畲族自治县","value":"331127"},{"parent":"331100","name":"龙泉市","value":"331181"},{"parent":"331100","name":"其它区","value":"331182"},{"name":"安徽省","value":"340000"},{"parent":"340000","name":"合肥市","value":"340100"},{"parent":"340100","name":"瑶海区","value":"340102"},{"parent":"340100","name":"庐阳区","value":"340103"},{"parent":"340100","name":"蜀山区","value":"340104"},{"parent":"340100","name":"包河区","value":"340111"},{"parent":"340100","name":"长丰县","value":"340121"},{"parent":"340100","name":"肥东县","value":"340122"},{"parent":"340100","name":"肥西县","value":"340123"},{"parent":"340100","name":"高新区","value":"340151"},{"parent":"340100","name":"中区","value":"340191"},{"parent":"340100","name":"其它区","value":"340192"},{"parent":"340100","name":"巢湖市","value":"341400"},{"parent":"340100","name":"居巢区","value":"341402"},{"parent":"340100","name":"庐江县","value":"341421"},{"parent":"340000","name":"芜湖市","value":"340200"},{"parent":"340200","name":"镜湖区","value":"340202"},{"parent":"340200","name":"弋江区","value":"340203"},{"parent":"340200","name":"鸠江区","value":"340207"},{"parent":"340200","name":"三山区","value":"340208"},{"parent":"340200","name":"芜湖县","value":"340221"},{"parent":"340200","name":"繁昌县","value":"340222"},{"parent":"340200","name":"南陵县","value":"340223"},{"parent":"340200","name":"其它区","value":"340224"},{"parent":"340200","name":"无为县","value":"341422"},{"parent":"340000","name":"蚌埠市","value":"340300"},{"parent":"340300","name":"龙子湖区","value":"340302"},{"parent":"340300","name":"蚌山区","value":"340303"},{"parent":"340300","name":"禹会区","value":"340304"},{"parent":"340300","name":"淮上区","value":"340311"},{"parent":"340300","name":"怀远县","value":"340321"},{"parent":"340300","name":"五河县","value":"340322"},{"parent":"340300","name":"固镇县","value":"340323"},{"parent":"340300","name":"其它区","value":"340324"},{"parent":"340000","name":"淮南市","value":"340400"},{"parent":"340400","name":"大通区","value":"340402"},{"parent":"340400","name":"田家庵区","value":"340403"},{"parent":"340400","name":"谢家集区","value":"340404"},{"parent":"340400","name":"八公山区","value":"340405"},{"parent":"340400","name":"潘集区","value":"340406"},{"parent":"340400","name":"凤台县","value":"340421"},{"parent":"340400","name":"其它区","value":"340422"},{"parent":"340400","name":"寿县","value":"340499"},{"parent":"340000","name":"马鞍山市","value":"340500"},{"parent":"340500","name":"金家庄区","value":"340502"},{"parent":"340500","name":"花山区","value":"340503"},{"parent":"340500","name":"雨山区","value":"340504"},{"parent":"340500","name":"博望区","value":"340506"},{"parent":"340500","name":"当涂县","value":"340521"},{"parent":"340500","name":"其它区","value":"340522"},{"parent":"340500","name":"含山县","value":"341423"},{"parent":"340500","name":"和县","value":"341424"},{"parent":"340000","name":"淮北市","value":"340600"},{"parent":"340600","name":"杜集区","value":"340602"},{"parent":"340600","name":"相山区","value":"340603"},{"parent":"340600","name":"烈山区","value":"340604"},{"parent":"340600","name":"濉溪县","value":"340621"},{"parent":"340600","name":"其它区","value":"340622"},{"parent":"340000","name":"铜陵市","value":"340700"},{"parent":"340700","name":"铜官山区","value":"340702"},{"parent":"340700","name":"狮子山区","value":"340703"},{"parent":"340700","name":"铜官区","value":"340705"},{"parent":"340700","name":"郊区","value":"340711"},{"parent":"340700","name":"义安区","value":"340721"},{"parent":"340700","name":"其它区","value":"340722"},{"parent":"340700","name":"枞阳县","value":"340799"},{"parent":"340000","name":"安庆市","value":"340800"},{"parent":"340800","name":"迎江区","value":"340802"},{"parent":"340800","name":"大观区","value":"340803"},{"parent":"340800","name":"宜秀区","value":"340811"},{"parent":"340800","name":"怀宁县","value":"340822"},{"parent":"340800","name":"枞阳县","value":"340823"},{"parent":"340800","name":"潜山县","value":"340824"},{"parent":"340800","name":"太湖县","value":"340825"},{"parent":"340800","name":"宿松县","value":"340826"},{"parent":"340800","name":"望江县","value":"340827"},{"parent":"340800","name":"岳西县","value":"340828"},{"parent":"340800","name":"桐城市","value":"340881"},{"parent":"340800","name":"其它区","value":"340882"},{"parent":"340000","name":"黄山市","value":"341000"},{"parent":"341000","name":"屯溪区","value":"341002"},{"parent":"341000","name":"黄山区","value":"341003"},{"parent":"341000","name":"徽州区","value":"341004"},{"parent":"341000","name":"歙县","value":"341021"},{"parent":"341000","name":"休宁县","value":"341022"},{"parent":"341000","name":"黟县","value":"341023"},{"parent":"341000","name":"祁门县","value":"341024"},{"parent":"341000","name":"其它区","value":"341025"},{"parent":"340000","name":"滁州市","value":"341100"},{"parent":"341100","name":"琅琊区","value":"341102"},{"parent":"341100","name":"南谯区","value":"341103"},{"parent":"341100","name":"来安县","value":"341122"},{"parent":"341100","name":"全椒县","value":"341124"},{"parent":"341100","name":"定远县","value":"341125"},{"parent":"341100","name":"凤阳县","value":"341126"},{"parent":"341100","name":"天长市","value":"341181"},{"parent":"341100","name":"明光市","value":"341182"},{"parent":"341100","name":"其它区","value":"341183"},{"parent":"340000","name":"阜阳市","value":"341200"},{"parent":"341200","name":"颍州区","value":"341202"},{"parent":"341200","name":"颍东区","value":"341203"},{"parent":"341200","name":"颍泉区","value":"341204"},{"parent":"341200","name":"临泉县","value":"341221"},{"parent":"341200","name":"太和县","value":"341222"},{"parent":"341200","name":"阜南县","value":"341225"},{"parent":"341200","name":"颍上县","value":"341226"},{"parent":"341200","name":"界首市","value":"341282"},{"parent":"341200","name":"其它区","value":"341283"},{"parent":"340000","name":"宿州市","value":"341300"},{"parent":"341300","name":"埇桥区","value":"341302"},{"parent":"341300","name":"砀山县","value":"341321"},{"parent":"341300","name":"萧县","value":"341322"},{"parent":"341300","name":"灵璧县","value":"341323"},{"parent":"341300","name":"泗县","value":"341324"},{"parent":"341300","name":"其它区","value":"341325"},{"parent":"340000","name":"六安市","value":"341500"},{"parent":"341500","name":"金安区","value":"341502"},{"parent":"341500","name":"裕安区","value":"341503"},{"parent":"341500","name":"叶集区","value":"341504"},{"parent":"341500","name":"寿县","value":"341521"},{"parent":"341500","name":"霍邱县","value":"341522"},{"parent":"341500","name":"舒城县","value":"341523"},{"parent":"341500","name":"金寨县","value":"341524"},{"parent":"341500","name":"霍山县","value":"341525"},{"parent":"341500","name":"其它区","value":"341526"},{"parent":"340000","name":"亳州市","value":"341600"},{"parent":"341600","name":"谯城区","value":"341602"},{"parent":"341600","name":"涡阳县","value":"341621"},{"parent":"341600","name":"蒙城县","value":"341622"},{"parent":"341600","name":"利辛县","value":"341623"},{"parent":"341600","name":"其它区","value":"341624"},{"parent":"340000","name":"池州市","value":"341700"},{"parent":"341700","name":"贵池区","value":"341702"},{"parent":"341700","name":"东至县","value":"341721"},{"parent":"341700","name":"石台县","value":"341722"},{"parent":"341700","name":"青阳县","value":"341723"},{"parent":"341700","name":"其它区","value":"341724"},{"parent":"340000","name":"宣城市","value":"341800"},{"parent":"341800","name":"宣州区","value":"341802"},{"parent":"341800","name":"郎溪县","value":"341821"},{"parent":"341800","name":"广德县","value":"341822"},{"parent":"341800","name":"泾县","value":"341823"},{"parent":"341800","name":"绩溪县","value":"341824"},{"parent":"341800","name":"旌德县","value":"341825"},{"parent":"341800","name":"宁国市","value":"341881"},{"parent":"341800","name":"其它区","value":"341882"},{"name":"福建省","value":"350000"},{"parent":"350000","name":"福州市","value":"350100"},{"parent":"350100","name":"鼓楼区","value":"350102"},{"parent":"350100","name":"台江区","value":"350103"},{"parent":"350100","name":"仓山区","value":"350104"},{"parent":"350100","name":"马尾区","value":"350105"},{"parent":"350100","name":"晋安区","value":"350111"},{"parent":"350100","name":"闽侯县","value":"350121"},{"parent":"350100","name":"连江县","value":"350122"},{"parent":"350100","name":"罗源县","value":"350123"},{"parent":"350100","name":"闽清县","value":"350124"},{"parent":"350100","name":"永泰县","value":"350125"},{"parent":"350100","name":"平潭县","value":"350128"},{"parent":"350100","name":"福清市","value":"350181"},{"parent":"350100","name":"长乐区","value":"350182"},{"parent":"350100","name":"其它区","value":"350183"},{"parent":"350000","name":"厦门市","value":"350200"},{"parent":"350200","name":"思明区","value":"350203"},{"parent":"350200","name":"海沧区","value":"350205"},{"parent":"350200","name":"湖里区","value":"350206"},{"parent":"350200","name":"集美区","value":"350211"},{"parent":"350200","name":"同安区","value":"350212"},{"parent":"350200","name":"翔安区","value":"350213"},{"parent":"350200","name":"其它区","value":"350214"},{"parent":"350000","name":"莆田市","value":"350300"},{"parent":"350300","name":"城厢区","value":"350302"},{"parent":"350300","name":"涵江区","value":"350303"},{"parent":"350300","name":"荔城区","value":"350304"},{"parent":"350300","name":"秀屿区","value":"350305"},{"parent":"350300","name":"仙游县","value":"350322"},{"parent":"350300","name":"其它区","value":"350323"},{"parent":"350000","name":"三明市","value":"350400"},{"parent":"350400","name":"梅列区","value":"350402"},{"parent":"350400","name":"三元区","value":"350403"},{"parent":"350400","name":"明溪县","value":"350421"},{"parent":"350400","name":"清流县","value":"350423"},{"parent":"350400","name":"宁化县","value":"350424"},{"parent":"350400","name":"大田县","value":"350425"},{"parent":"350400","name":"尤溪县","value":"350426"},{"parent":"350400","name":"沙县","value":"350427"},{"parent":"350400","name":"将乐县","value":"350428"},{"parent":"350400","name":"泰宁县","value":"350429"},{"parent":"350400","name":"建宁县","value":"350430"},{"parent":"350400","name":"永安市","value":"350481"},{"parent":"350400","name":"其它区","value":"350482"},{"parent":"350000","name":"泉州市","value":"350500"},{"parent":"350500","name":"鲤城区","value":"350502"},{"parent":"350500","name":"丰泽区","value":"350503"},{"parent":"350500","name":"洛江区","value":"350504"},{"parent":"350500","name":"泉港区","value":"350505"},{"parent":"350500","name":"惠安县","value":"350521"},{"parent":"350500","name":"安溪县","value":"350524"},{"parent":"350500","name":"永春县","value":"350525"},{"parent":"350500","name":"德化县","value":"350526"},{"parent":"350500","name":"金门县","value":"350527"},{"parent":"350500","name":"石狮市","value":"350581"},{"parent":"350500","name":"晋江市","value":"350582"},{"parent":"350500","name":"南安市","value":"350583"},{"parent":"350500","name":"其它区","value":"350584"},{"parent":"350000","name":"漳州市","value":"350600"},{"parent":"350600","name":"芗城区","value":"350602"},{"parent":"350600","name":"龙文区","value":"350603"},{"parent":"350600","name":"云霄县","value":"350622"},{"parent":"350600","name":"漳浦县","value":"350623"},{"parent":"350600","name":"诏安县","value":"350624"},{"parent":"350600","name":"长泰县","value":"350625"},{"parent":"350600","name":"东山县","value":"350626"},{"parent":"350600","name":"南靖县","value":"350627"},{"parent":"350600","name":"平和县","value":"350628"},{"parent":"350600","name":"华安县","value":"350629"},{"parent":"350600","name":"龙海市","value":"350681"},{"parent":"350600","name":"其它区","value":"350682"},{"parent":"350000","name":"南平市","value":"350700"},{"parent":"350700","name":"延平区","value":"350702"},{"parent":"350700","name":"顺昌县","value":"350721"},{"parent":"350700","name":"浦城县","value":"350722"},{"parent":"350700","name":"光泽县","value":"350723"},{"parent":"350700","name":"松溪县","value":"350724"},{"parent":"350700","name":"政和县","value":"350725"},{"parent":"350700","name":"邵武市","value":"350781"},{"parent":"350700","name":"武夷山市","value":"350782"},{"parent":"350700","name":"建瓯市","value":"350783"},{"parent":"350700","name":"建阳区","value":"350784"},{"parent":"350700","name":"其它区","value":"350785"},{"parent":"350000","name":"龙岩市","value":"350800"},{"parent":"350800","name":"新罗区","value":"350802"},{"parent":"350800","name":"长汀县","value":"350821"},{"parent":"350800","name":"永定区","value":"350822"},{"parent":"350800","name":"上杭县","value":"350823"},{"parent":"350800","name":"武平县","value":"350824"},{"parent":"350800","name":"连城县","value":"350825"},{"parent":"350800","name":"漳平市","value":"350881"},{"parent":"350800","name":"其它区","value":"350882"},{"parent":"350000","name":"宁德市","value":"350900"},{"parent":"350900","name":"蕉城区","value":"350902"},{"parent":"350900","name":"霞浦县","value":"350921"},{"parent":"350900","name":"古田县","value":"350922"},{"parent":"350900","name":"屏南县","value":"350923"},{"parent":"350900","name":"寿宁县","value":"350924"},{"parent":"350900","name":"周宁县","value":"350925"},{"parent":"350900","name":"柘荣县","value":"350926"},{"parent":"350900","name":"福安市","value":"350981"},{"parent":"350900","name":"福鼎市","value":"350982"},{"parent":"350900","name":"其它区","value":"350983"},{"name":"江西省","value":"360000"},{"parent":"360000","name":"南昌市","value":"360100"},{"parent":"360100","name":"东湖区","value":"360102"},{"parent":"360100","name":"西湖区","value":"360103"},{"parent":"360100","name":"青云谱区","value":"360104"},{"parent":"360100","name":"湾里区","value":"360105"},{"parent":"360100","name":"青山湖区","value":"360111"},{"parent":"360100","name":"南昌县","value":"360121"},{"parent":"360100","name":"新建区","value":"360122"},{"parent":"360100","name":"安义县","value":"360123"},{"parent":"360100","name":"进贤县","value":"360124"},{"parent":"360100","name":"红谷滩新区","value":"360125"},{"parent":"360100","name":"经济技术开发区","value":"360126"},{"parent":"360100","name":"昌北区","value":"360127"},{"parent":"360100","name":"其它区","value":"360128"},{"parent":"360000","name":"景德镇市","value":"360200"},{"parent":"360200","name":"昌江区","value":"360202"},{"parent":"360200","name":"珠山区","value":"360203"},{"parent":"360200","name":"浮梁县","value":"360222"},{"parent":"360200","name":"乐平市","value":"360281"},{"parent":"360200","name":"其它区","value":"360282"},{"parent":"360000","name":"萍乡市","value":"360300"},{"parent":"360300","name":"安源区","value":"360302"},{"parent":"360300","name":"湘东区","value":"360313"},{"parent":"360300","name":"莲花县","value":"360321"},{"parent":"360300","name":"上栗县","value":"360322"},{"parent":"360300","name":"芦溪县","value":"360323"},{"parent":"360300","name":"其它区","value":"360324"},{"parent":"360000","name":"九江市","value":"360400"},{"parent":"360400","name":"濂溪区","value":"360402"},{"parent":"360400","name":"浔阳区","value":"360403"},{"parent":"360400","name":"柴桑区","value":"360421"},{"parent":"360400","name":"武宁县","value":"360423"},{"parent":"360400","name":"修水县","value":"360424"},{"parent":"360400","name":"永修县","value":"360425"},{"parent":"360400","name":"德安县","value":"360426"},{"parent":"360400","name":"庐山市","value":"360427"},{"parent":"360400","name":"都昌县","value":"360428"},{"parent":"360400","name":"湖口县","value":"360429"},{"parent":"360400","name":"彭泽县","value":"360430"},{"parent":"360400","name":"瑞昌市","value":"360481"},{"parent":"360400","name":"其它区","value":"360482"},{"parent":"360400","name":"共青城市","value":"360483"},{"parent":"360000","name":"新余市","value":"360500"},{"parent":"360500","name":"渝水区","value":"360502"},{"parent":"360500","name":"分宜县","value":"360521"},{"parent":"360500","name":"其它区","value":"360522"},{"parent":"360000","name":"鹰潭市","value":"360600"},{"parent":"360600","name":"月湖区","value":"360602"},{"parent":"360600","name":"余江县","value":"360622"},{"parent":"360600","name":"贵溪市","value":"360681"},{"parent":"360600","name":"其它区","value":"360682"},{"parent":"360000","name":"赣州市","value":"360700"},{"parent":"360700","name":"章贡区","value":"360702"},{"parent":"360700","name":"赣县区","value":"360721"},{"parent":"360700","name":"信丰县","value":"360722"},{"parent":"360700","name":"大余县","value":"360723"},{"parent":"360700","name":"上犹县","value":"360724"},{"parent":"360700","name":"崇义县","value":"360725"},{"parent":"360700","name":"安远县","value":"360726"},{"parent":"360700","name":"龙南县","value":"360727"},{"parent":"360700","name":"定南县","value":"360728"},{"parent":"360700","name":"全南县","value":"360729"},{"parent":"360700","name":"宁都县","value":"360730"},{"parent":"360700","name":"于都县","value":"360731"},{"parent":"360700","name":"兴国县","value":"360732"},{"parent":"360700","name":"会昌县","value":"360733"},{"parent":"360700","name":"寻乌县","value":"360734"},{"parent":"360700","name":"石城县","value":"360735"},{"parent":"360700","name":"黄金区","value":"360751"},{"parent":"360700","name":"瑞金市","value":"360781"},{"parent":"360700","name":"南康区","value":"360782"},{"parent":"360700","name":"其它区","value":"360783"},{"parent":"360000","name":"吉安市","value":"360800"},{"parent":"360800","name":"吉州区","value":"360802"},{"parent":"360800","name":"青原区","value":"360803"},{"parent":"360800","name":"吉安县","value":"360821"},{"parent":"360800","name":"吉水县","value":"360822"},{"parent":"360800","name":"峡江县","value":"360823"},{"parent":"360800","name":"新干县","value":"360824"},{"parent":"360800","name":"永丰县","value":"360825"},{"parent":"360800","name":"泰和县","value":"360826"},{"parent":"360800","name":"遂川县","value":"360827"},{"parent":"360800","name":"万安县","value":"360828"},{"parent":"360800","name":"安福县","value":"360829"},{"parent":"360800","name":"永新县","value":"360830"},{"parent":"360800","name":"井冈山市","value":"360881"},{"parent":"360800","name":"其它区","value":"360882"},{"parent":"360000","name":"宜春市","value":"360900"},{"parent":"360900","name":"袁州区","value":"360902"},{"parent":"360900","name":"奉新县","value":"360921"},{"parent":"360900","name":"万载县","value":"360922"},{"parent":"360900","name":"上高县","value":"360923"},{"parent":"360900","name":"宜丰县","value":"360924"},{"parent":"360900","name":"靖安县","value":"360925"},{"parent":"360900","name":"铜鼓县","value":"360926"},{"parent":"360900","name":"丰城市","value":"360981"},{"parent":"360900","name":"樟树市","value":"360982"},{"parent":"360900","name":"高安市","value":"360983"},{"parent":"360900","name":"其它区","value":"360984"},{"parent":"360000","name":"抚州市","value":"361000"},{"parent":"361000","name":"临川区","value":"361002"},{"parent":"361000","name":"南城县","value":"361021"},{"parent":"361000","name":"黎川县","value":"361022"},{"parent":"361000","name":"南丰县","value":"361023"},{"parent":"361000","name":"崇仁县","value":"361024"},{"parent":"361000","name":"乐安县","value":"361025"},{"parent":"361000","name":"宜黄县","value":"361026"},{"parent":"361000","name":"金溪县","value":"361027"},{"parent":"361000","name":"资溪县","value":"361028"},{"parent":"361000","name":"东乡区","value":"361029"},{"parent":"361000","name":"广昌县","value":"361030"},{"parent":"361000","name":"其它区","value":"361031"},{"parent":"360000","name":"上饶市","value":"361100"},{"parent":"361100","name":"信州区","value":"361102"},{"parent":"361100","name":"广信区","value":"361121"},{"parent":"361100","name":"广丰区","value":"361122"},{"parent":"361100","name":"玉山县","value":"361123"},{"parent":"361100","name":"铅山县","value":"361124"},{"parent":"361100","name":"横峰县","value":"361125"},{"parent":"361100","name":"弋阳县","value":"361126"},{"parent":"361100","name":"余干县","value":"361127"},{"parent":"361100","name":"鄱阳县","value":"361128"},{"parent":"361100","name":"万年县","value":"361129"},{"parent":"361100","name":"婺源县","value":"361130"},{"parent":"361100","name":"德兴市","value":"361181"},{"parent":"361100","name":"其它区","value":"361182"},{"name":"山东省","value":"370000"},{"parent":"370000","name":"济南市","value":"370100"},{"parent":"370100","name":"历下区","value":"370102"},{"parent":"370100","name":"市中区","value":"370103"},{"parent":"370100","name":"槐荫区","value":"370104"},{"parent":"370100","name":"天桥区","value":"370105"},{"parent":"370100","name":"历城区","value":"370112"},{"parent":"370100","name":"长清区","value":"370113"},{"parent":"370100","name":"平阴县","value":"370124"},{"parent":"370100","name":"济阳县","value":"370125"},{"parent":"370100","name":"商河县","value":"370126"},{"parent":"370100","name":"章丘区","value":"370181"},{"parent":"370100","name":"其它区","value":"370182"},{"parent":"370000","name":"青岛市","value":"370200"},{"parent":"370200","name":"市南区","value":"370202"},{"parent":"370200","name":"市北区","value":"370203"},{"parent":"370200","name":"四方区","value":"370205"},{"parent":"370200","name":"黄岛区","value":"370211"},{"parent":"370200","name":"崂山区","value":"370212"},{"parent":"370200","name":"李沧区","value":"370213"},{"parent":"370200","name":"城阳区","value":"370214"},{"parent":"370200","name":"开发区","value":"370251"},{"parent":"370200","name":"胶州市","value":"370281"},{"parent":"370200","name":"即墨区","value":"370282"},{"parent":"370200","name":"平度市","value":"370283"},{"parent":"370200","name":"胶南市","value":"370284"},{"parent":"370200","name":"莱西市","value":"370285"},{"parent":"370200","name":"其它区","value":"370286"},{"parent":"370000","name":"淄博市","value":"370300"},{"parent":"370300","name":"淄川区","value":"370302"},{"parent":"370300","name":"张店区","value":"370303"},{"parent":"370300","name":"博山区","value":"370304"},{"parent":"370300","name":"临淄区","value":"370305"},{"parent":"370300","name":"周村区","value":"370306"},{"parent":"370300","name":"桓台县","value":"370321"},{"parent":"370300","name":"高青县","value":"370322"},{"parent":"370300","name":"沂源县","value":"370323"},{"parent":"370300","name":"其它区","value":"370324"},{"parent":"370000","name":"枣庄市","value":"370400"},{"parent":"370400","name":"市中区","value":"370402"},{"parent":"370400","name":"薛城区","value":"370403"},{"parent":"370400","name":"峄城区","value":"370404"},{"parent":"370400","name":"台儿庄区","value":"370405"},{"parent":"370400","name":"山亭区","value":"370406"},{"parent":"370400","name":"滕州市","value":"370481"},{"parent":"370400","name":"其它区","value":"370482"},{"parent":"370000","name":"东营市","value":"370500"},{"parent":"370500","name":"东营区","value":"370502"},{"parent":"370500","name":"河口区","value":"370503"},{"parent":"370500","name":"垦利区","value":"370521"},{"parent":"370500","name":"利津县","value":"370522"},{"parent":"370500","name":"广饶县","value":"370523"},{"parent":"370500","name":"西城区","value":"370589"},{"parent":"370500","name":"东城区","value":"370590"},{"parent":"370500","name":"其它区","value":"370591"},{"parent":"370000","name":"烟台市","value":"370600"},{"parent":"370600","name":"芝罘区","value":"370602"},{"parent":"370600","name":"福山区","value":"370611"},{"parent":"370600","name":"牟平区","value":"370612"},{"parent":"370600","name":"莱山区","value":"370613"},{"parent":"370600","name":"长岛县","value":"370634"},{"parent":"370600","name":"龙口市","value":"370681"},{"parent":"370600","name":"莱阳市","value":"370682"},{"parent":"370600","name":"莱州市","value":"370683"},{"parent":"370600","name":"蓬莱市","value":"370684"},{"parent":"370600","name":"招远市","value":"370685"},{"parent":"370600","name":"栖霞市","value":"370686"},{"parent":"370600","name":"海阳市","value":"370687"},{"parent":"370600","name":"其它区","value":"370688"},{"parent":"370000","name":"潍坊市","value":"370700"},{"parent":"370700","name":"潍城区","value":"370702"},{"parent":"370700","name":"寒亭区","value":"370703"},{"parent":"370700","name":"坊子区","value":"370704"},{"parent":"370700","name":"奎文区","value":"370705"},{"parent":"370700","name":"临朐县","value":"370724"},{"parent":"370700","name":"昌乐县","value":"370725"},{"parent":"370700","name":"开发区","value":"370751"},{"parent":"370700","name":"青州市","value":"370781"},{"parent":"370700","name":"诸城市","value":"370782"},{"parent":"370700","name":"寿光市","value":"370783"},{"parent":"370700","name":"安丘市","value":"370784"},{"parent":"370700","name":"高密市","value":"370785"},{"parent":"370700","name":"昌邑市","value":"370786"},{"parent":"370700","name":"其它区","value":"370787"},{"parent":"370000","name":"济宁市","value":"370800"},{"parent":"370800","name":"市中区","value":"370802"},{"parent":"370800","name":"任城区","value":"370811"},{"parent":"370800","name":"微山县","value":"370826"},{"parent":"370800","name":"鱼台县","value":"370827"},{"parent":"370800","name":"金乡县","value":"370828"},{"parent":"370800","name":"嘉祥县","value":"370829"},{"parent":"370800","name":"汶上县","value":"370830"},{"parent":"370800","name":"泗水县","value":"370831"},{"parent":"370800","name":"梁山县","value":"370832"},{"parent":"370800","name":"曲阜市","value":"370881"},{"parent":"370800","name":"兖州区","value":"370882"},{"parent":"370800","name":"邹城市","value":"370883"},{"parent":"370800","name":"其它区","value":"370884"},{"parent":"370000","name":"泰安市","value":"370900"},{"parent":"370900","name":"泰山区","value":"370902"},{"parent":"370900","name":"岱岳区","value":"370903"},{"parent":"370900","name":"宁阳县","value":"370921"},{"parent":"370900","name":"东平县","value":"370923"},{"parent":"370900","name":"新泰市","value":"370982"},{"parent":"370900","name":"肥城市","value":"370983"},{"parent":"370900","name":"其它区","value":"370984"},{"parent":"370000","name":"威海市","value":"371000"},{"parent":"371000","name":"环翠区","value":"371002"},{"parent":"371000","name":"文登区","value":"371081"},{"parent":"371000","name":"荣成市","value":"371082"},{"parent":"371000","name":"乳山市","value":"371083"},{"parent":"371000","name":"其它区","value":"371084"},{"parent":"370000","name":"日照市","value":"371100"},{"parent":"371100","name":"东港区","value":"371102"},{"parent":"371100","name":"岚山区","value":"371103"},{"parent":"371100","name":"五莲县","value":"371121"},{"parent":"371100","name":"莒县","value":"371122"},{"parent":"371100","name":"其它区","value":"371123"},{"parent":"370000","name":"莱芜市","value":"371200"},{"parent":"371200","name":"莱城区","value":"371202"},{"parent":"371200","name":"钢城区","value":"371203"},{"parent":"371200","name":"其它区","value":"371204"},{"parent":"370000","name":"临沂市","value":"371300"},{"parent":"371300","name":"兰山区","value":"371302"},{"parent":"371300","name":"罗庄区","value":"371311"},{"parent":"371300","name":"河东区","value":"371312"},{"parent":"371300","name":"沂南县","value":"371321"},{"parent":"371300","name":"郯城县","value":"371322"},{"parent":"371300","name":"沂水县","value":"371323"},{"parent":"371300","name":"兰陵县","value":"371324"},{"parent":"371300","name":"费县","value":"371325"},{"parent":"371300","name":"平邑县","value":"371326"},{"parent":"371300","name":"莒南县","value":"371327"},{"parent":"371300","name":"蒙阴县","value":"371328"},{"parent":"371300","name":"临沭县","value":"371329"},{"parent":"371300","name":"其它区","value":"371330"},{"parent":"370000","name":"德州市","value":"371400"},{"parent":"371400","name":"德城区","value":"371402"},{"parent":"371400","name":"陵城区","value":"371421"},{"parent":"371400","name":"宁津县","value":"371422"},{"parent":"371400","name":"庆云县","value":"371423"},{"parent":"371400","name":"临邑县","value":"371424"},{"parent":"371400","name":"齐河县","value":"371425"},{"parent":"371400","name":"平原县","value":"371426"},{"parent":"371400","name":"夏津县","value":"371427"},{"parent":"371400","name":"武城县","value":"371428"},{"parent":"371400","name":"开发区","value":"371451"},{"parent":"371400","name":"乐陵市","value":"371481"},{"parent":"371400","name":"禹城市","value":"371482"},{"parent":"371400","name":"其它区","value":"371483"},{"parent":"370000","name":"聊城市","value":"371500"},{"parent":"371500","name":"东昌府区","value":"371502"},{"parent":"371500","name":"阳谷县","value":"371521"},{"parent":"371500","name":"莘县","value":"371522"},{"parent":"371500","name":"茌平县","value":"371523"},{"parent":"371500","name":"东阿县","value":"371524"},{"parent":"371500","name":"冠县","value":"371525"},{"parent":"371500","name":"高唐县","value":"371526"},{"parent":"371500","name":"临清市","value":"371581"},{"parent":"371500","name":"其它区","value":"371582"},{"parent":"370000","name":"滨州市","value":"371600"},{"parent":"371600","name":"滨城区","value":"371602"},{"parent":"371600","name":"惠民县","value":"371621"},{"parent":"371600","name":"阳信县","value":"371622"},{"parent":"371600","name":"无棣县","value":"371623"},{"parent":"371600","name":"沾化区","value":"371624"},{"parent":"371600","name":"博兴县","value":"371625"},{"parent":"371600","name":"邹平县","value":"371626"},{"parent":"371600","name":"其它区","value":"371627"},{"parent":"370000","name":"菏泽市","value":"371700"},{"parent":"371700","name":"牡丹区","value":"371702"},{"parent":"371700","name":"曹县","value":"371721"},{"parent":"371700","name":"单县","value":"371722"},{"parent":"371700","name":"成武县","value":"371723"},{"parent":"371700","name":"巨野县","value":"371724"},{"parent":"371700","name":"郓城县","value":"371725"},{"parent":"371700","name":"鄄城县","value":"371726"},{"parent":"371700","name":"定陶区","value":"371727"},{"parent":"371700","name":"东明县","value":"371728"},{"parent":"371700","name":"其它区","value":"371729"},{"name":"河南省","value":"410000"},{"parent":"410000","name":"郑州市","value":"410100"},{"parent":"410100","name":"中原区","value":"410102"},{"parent":"410100","name":"二七区","value":"410103"},{"parent":"410100","name":"管城回族区","value":"410104"},{"parent":"410100","name":"金水区","value":"410105"},{"parent":"410100","name":"上街区","value":"410106"},{"parent":"410100","name":"惠济区","value":"410108"},{"parent":"410100","name":"中牟县","value":"410122"},{"parent":"410100","name":"巩义市","value":"410181"},{"parent":"410100","name":"荥阳市","value":"410182"},{"parent":"410100","name":"新密市","value":"410183"},{"parent":"410100","name":"新郑市","value":"410184"},{"parent":"410100","name":"登封市","value":"410185"},{"parent":"410100","name":"郑东新区","value":"410186"},{"parent":"410100","name":"高新区","value":"410187"},{"parent":"410100","name":"其它区","value":"410188"},{"parent":"410000","name":"开封市","value":"410200"},{"parent":"410200","name":"龙亭区","value":"410202"},{"parent":"410200","name":"顺河回族区","value":"410203"},{"parent":"410200","name":"鼓楼区","value":"410204"},{"parent":"410200","name":"禹王台区","value":"410205"},{"parent":"410200","name":"金明区","value":"410211"},{"parent":"410200","name":"杞县","value":"410221"},{"parent":"410200","name":"通许县","value":"410222"},{"parent":"410200","name":"尉氏县","value":"410223"},{"parent":"410200","name":"祥符区","value":"410224"},{"parent":"410200","name":"兰考县","value":"410225"},{"parent":"410200","name":"其它区","value":"410226"},{"parent":"410000","name":"洛阳市","value":"410300"},{"parent":"410300","name":"老城区","value":"410302"},{"parent":"410300","name":"西工区","value":"410303"},{"parent":"410300","name":"瀍河回族区","value":"410304"},{"parent":"410300","name":"涧西区","value":"410305"},{"parent":"410300","name":"吉利区","value":"410306"},{"parent":"410300","name":"洛龙区","value":"410307"},{"parent":"410300","name":"孟津县","value":"410322"},{"parent":"410300","name":"新安县","value":"410323"},{"parent":"410300","name":"栾川县","value":"410324"},{"parent":"410300","name":"嵩县","value":"410325"},{"parent":"410300","name":"汝阳县","value":"410326"},{"parent":"410300","name":"宜阳县","value":"410327"},{"parent":"410300","name":"洛宁县","value":"410328"},{"parent":"410300","name":"伊川县","value":"410329"},{"parent":"410300","name":"偃师市","value":"410381"},{"parent":"410300","name":"高新区","value":"471004"},{"parent":"410300","name":"其它区","value":"471005"},{"parent":"410000","name":"平顶山市","value":"410400"},{"parent":"410400","name":"新华区","value":"410402"},{"parent":"410400","name":"卫东区","value":"410403"},{"parent":"410400","name":"石龙区","value":"410404"},{"parent":"410400","name":"湛河区","value":"410411"},{"parent":"410400","name":"宝丰县","value":"410421"},{"parent":"410400","name":"叶县","value":"410422"},{"parent":"410400","name":"鲁山县","value":"410423"},{"parent":"410400","name":"郏县","value":"410425"},{"parent":"410400","name":"舞钢市","value":"410481"},{"parent":"410400","name":"汝州市","value":"410482"},{"parent":"410400","name":"其它区","value":"410483"},{"parent":"410000","name":"安阳市","value":"410500"},{"parent":"410500","name":"文峰区","value":"410502"},{"parent":"410500","name":"北关区","value":"410503"},{"parent":"410500","name":"殷都区","value":"410505"},{"parent":"410500","name":"龙安区","value":"410506"},{"parent":"410500","name":"安阳县","value":"410522"},{"parent":"410500","name":"汤阴县","value":"410523"},{"parent":"410500","name":"滑县","value":"410526"},{"parent":"410500","name":"内黄县","value":"410527"},{"parent":"410500","name":"林州市","value":"410581"},{"parent":"410500","name":"其它区","value":"410582"},{"parent":"410000","name":"鹤壁市","value":"410600"},{"parent":"410600","name":"鹤山区","value":"410602"},{"parent":"410600","name":"山城区","value":"410603"},{"parent":"410600","name":"淇滨区","value":"410611"},{"parent":"410600","name":"浚县","value":"410621"},{"parent":"410600","name":"淇县","value":"410622"},{"parent":"410600","name":"其它区","value":"410623"},{"parent":"410000","name":"新乡市","value":"410700"},{"parent":"410700","name":"红旗区","value":"410702"},{"parent":"410700","name":"卫滨区","value":"410703"},{"parent":"410700","name":"凤泉区","value":"410704"},{"parent":"410700","name":"牧野区","value":"410711"},{"parent":"410700","name":"新乡县","value":"410721"},{"parent":"410700","name":"获嘉县","value":"410724"},{"parent":"410700","name":"原阳县","value":"410725"},{"parent":"410700","name":"延津县","value":"410726"},{"parent":"410700","name":"封丘县","value":"410727"},{"parent":"410700","name":"长垣县","value":"410728"},{"parent":"410700","name":"卫辉市","value":"410781"},{"parent":"410700","name":"辉县市","value":"410782"},{"parent":"410700","name":"其它区","value":"410783"},{"parent":"410000","name":"焦作市","value":"410800"},{"parent":"410800","name":"解放区","value":"410802"},{"parent":"410800","name":"中站区","value":"410803"},{"parent":"410800","name":"马村区","value":"410804"},{"parent":"410800","name":"山阳区","value":"410811"},{"parent":"410800","name":"修武县","value":"410821"},{"parent":"410800","name":"博爱县","value":"410822"},{"parent":"410800","name":"武陟县","value":"410823"},{"parent":"410800","name":"温县","value":"410825"},{"parent":"410800","name":"沁阳市","value":"410882"},{"parent":"410800","name":"孟州市","value":"410883"},{"parent":"410800","name":"其它区","value":"410884"},{"parent":"410000","name":"济源市","value":"410881"},{"parent":"410000","name":"濮阳市","value":"410900"},{"parent":"410900","name":"华龙区","value":"410902"},{"parent":"410900","name":"清丰县","value":"410922"},{"parent":"410900","name":"南乐县","value":"410923"},{"parent":"410900","name":"范县","value":"410926"},{"parent":"410900","name":"台前县","value":"410927"},{"parent":"410900","name":"濮阳县","value":"410928"},{"parent":"410900","name":"其它区","value":"410929"},{"parent":"410000","name":"许昌市","value":"411000"},{"parent":"411000","name":"魏都区","value":"411002"},{"parent":"411000","name":"建安区","value":"411023"},{"parent":"411000","name":"鄢陵县","value":"411024"},{"parent":"411000","name":"襄城县","value":"411025"},{"parent":"411000","name":"禹州市","value":"411081"},{"parent":"411000","name":"长葛市","value":"411082"},{"parent":"411000","name":"其它区","value":"411083"},{"parent":"410000","name":"漯河市","value":"411100"},{"parent":"411100","name":"源汇区","value":"411102"},{"parent":"411100","name":"郾城区","value":"411103"},{"parent":"411100","name":"召陵区","value":"411104"},{"parent":"411100","name":"舞阳县","value":"411121"},{"parent":"411100","name":"临颍县","value":"411122"},{"parent":"411100","name":"其它区","value":"411123"},{"parent":"410000","name":"三门峡市","value":"411200"},{"parent":"411200","name":"湖滨区","value":"411202"},{"parent":"411200","name":"渑池县","value":"411221"},{"parent":"411200","name":"陕州区","value":"411222"},{"parent":"411200","name":"卢氏县","value":"411224"},{"parent":"411200","name":"义马市","value":"411281"},{"parent":"411200","name":"灵宝市","value":"411282"},{"parent":"411200","name":"其它区","value":"411283"},{"parent":"410000","name":"南阳市","value":"411300"},{"parent":"411300","name":"宛城区","value":"411302"},{"parent":"411300","name":"卧龙区","value":"411303"},{"parent":"411300","name":"南召县","value":"411321"},{"parent":"411300","name":"方城县","value":"411322"},{"parent":"411300","name":"西峡县","value":"411323"},{"parent":"411300","name":"镇平县","value":"411324"},{"parent":"411300","name":"内乡县","value":"411325"},{"parent":"411300","name":"淅川县","value":"411326"},{"parent":"411300","name":"社旗县","value":"411327"},{"parent":"411300","name":"唐河县","value":"411328"},{"parent":"411300","name":"新野县","value":"411329"},{"parent":"411300","name":"桐柏县","value":"411330"},{"parent":"411300","name":"邓州市","value":"411381"},{"parent":"411300","name":"其它区","value":"411382"},{"parent":"410000","name":"商丘市","value":"411400"},{"parent":"411400","name":"梁园区","value":"411402"},{"parent":"411400","name":"睢阳区","value":"411403"},{"parent":"411400","name":"民权县","value":"411421"},{"parent":"411400","name":"睢县","value":"411422"},{"parent":"411400","name":"宁陵县","value":"411423"},{"parent":"411400","name":"柘城县","value":"411424"},{"parent":"411400","name":"虞城县","value":"411425"},{"parent":"411400","name":"夏邑县","value":"411426"},{"parent":"411400","name":"永城市","value":"411481"},{"parent":"411400","name":"其它区","value":"411482"},{"parent":"410000","name":"信阳市","value":"411500"},{"parent":"411500","name":"浉河区","value":"411502"},{"parent":"411500","name":"平桥区","value":"411503"},{"parent":"411500","name":"罗山县","value":"411521"},{"parent":"411500","name":"光山县","value":"411522"},{"parent":"411500","name":"新县","value":"411523"},{"parent":"411500","name":"商城县","value":"411524"},{"parent":"411500","name":"固始县","value":"411525"},{"parent":"411500","name":"潢川县","value":"411526"},{"parent":"411500","name":"淮滨县","value":"411527"},{"parent":"411500","name":"息县","value":"411528"},{"parent":"411500","name":"其它区","value":"411529"},{"parent":"410000","name":"周口市","value":"411600"},{"parent":"411600","name":"川汇区","value":"411602"},{"parent":"411600","name":"扶沟县","value":"411621"},{"parent":"411600","name":"西华县","value":"411622"},{"parent":"411600","name":"商水县","value":"411623"},{"parent":"411600","name":"沈丘县","value":"411624"},{"parent":"411600","name":"郸城县","value":"411625"},{"parent":"411600","name":"淮阳县","value":"411626"},{"parent":"411600","name":"太康县","value":"411627"},{"parent":"411600","name":"鹿邑县","value":"411628"},{"parent":"411600","name":"项城市","value":"411681"},{"parent":"411600","name":"其它区","value":"411682"},{"parent":"410000","name":"驻马店市","value":"411700"},{"parent":"411700","name":"驿城区","value":"411702"},{"parent":"411700","name":"西平县","value":"411721"},{"parent":"411700","name":"上蔡县","value":"411722"},{"parent":"411700","name":"平舆县","value":"411723"},{"parent":"411700","name":"正阳县","value":"411724"},{"parent":"411700","name":"确山县","value":"411725"},{"parent":"411700","name":"泌阳县","value":"411726"},{"parent":"411700","name":"汝南县","value":"411727"},{"parent":"411700","name":"遂平县","value":"411728"},{"parent":"411700","name":"新蔡县","value":"411729"},{"parent":"411700","name":"其它区","value":"411730"},{"name":"湖北省","value":"420000"},{"parent":"420000","name":"武汉市","value":"420100"},{"parent":"420100","name":"江岸区","value":"420102"},{"parent":"420100","name":"江汉区","value":"420103"},{"parent":"420100","name":"硚口区","value":"420104"},{"parent":"420100","name":"汉阳区","value":"420105"},{"parent":"420100","name":"武昌区","value":"420106"},{"parent":"420100","name":"青山区","value":"420107"},{"parent":"420100","name":"洪山区","value":"420111"},{"parent":"420100","name":"东西湖区","value":"420112"},{"parent":"420100","name":"汉南区","value":"420113"},{"parent":"420100","name":"蔡甸区","value":"420114"},{"parent":"420100","name":"江夏区","value":"420115"},{"parent":"420100","name":"黄陂区","value":"420116"},{"parent":"420100","name":"新洲区","value":"420117"},{"parent":"420100","name":"其它区","value":"420118"},{"parent":"420000","name":"黄石市","value":"420200"},{"parent":"420200","name":"黄石港区","value":"420202"},{"parent":"420200","name":"西塞山区","value":"420203"},{"parent":"420200","name":"下陆区","value":"420204"},{"parent":"420200","name":"铁山区","value":"420205"},{"parent":"420200","name":"阳新县","value":"420222"},{"parent":"420200","name":"大冶市","value":"420281"},{"parent":"420200","name":"其它区","value":"420282"},{"parent":"420000","name":"十堰市","value":"420300"},{"parent":"420300","name":"茅箭区","value":"420302"},{"parent":"420300","name":"张湾区","value":"420303"},{"parent":"420300","name":"郧阳区","value":"420321"},{"parent":"420300","name":"郧西县","value":"420322"},{"parent":"420300","name":"竹山县","value":"420323"},{"parent":"420300","name":"竹溪县","value":"420324"},{"parent":"420300","name":"房县","value":"420325"},{"parent":"420300","name":"丹江口市","value":"420381"},{"parent":"420300","name":"城区","value":"420382"},{"parent":"420300","name":"其它区","value":"420383"},{"parent":"420000","name":"宜昌市","value":"420500"},{"parent":"420500","name":"西陵区","value":"420502"},{"parent":"420500","name":"伍家岗区","value":"420503"},{"parent":"420500","name":"点军区","value":"420504"},{"parent":"420500","name":"猇亭区","value":"420505"},{"parent":"420500","name":"夷陵区","value":"420506"},{"parent":"420500","name":"远安县","value":"420525"},{"parent":"420500","name":"兴山县","value":"420526"},{"parent":"420500","name":"秭归县","value":"420527"},{"parent":"420500","name":"长阳土家族自治县","value":"420528"},{"parent":"420500","name":"五峰土家族自治县","value":"420529"},{"parent":"420500","name":"葛洲坝区","value":"420551"},{"parent":"420500","name":"开发区","value":"420552"},{"parent":"420500","name":"宜都市","value":"420581"},{"parent":"420500","name":"当阳市","value":"420582"},{"parent":"420500","name":"枝江市","value":"420583"},{"parent":"420500","name":"其它区","value":"420584"},{"parent":"420000","name":"襄阳市","value":"420600"},{"parent":"420600","name":"襄城区","value":"420602"},{"parent":"420600","name":"樊城区","value":"420606"},{"parent":"420600","name":"襄州区","value":"420607"},{"parent":"420600","name":"南漳县","value":"420624"},{"parent":"420600","name":"谷城县","value":"420625"},{"parent":"420600","name":"保康县","value":"420626"},{"parent":"420600","name":"老河口市","value":"420682"},{"parent":"420600","name":"枣阳市","value":"420683"},{"parent":"420600","name":"宜城市","value":"420684"},{"parent":"420600","name":"其它区","value":"420685"},{"parent":"420000","name":"鄂州市","value":"420700"},{"parent":"420700","name":"梁子湖区","value":"420702"},{"parent":"420700","name":"华容区","value":"420703"},{"parent":"420700","name":"鄂城区","value":"420704"},{"parent":"420700","name":"其它区","value":"420705"},{"parent":"420000","name":"荆门市","value":"420800"},{"parent":"420800","name":"东宝区","value":"420802"},{"parent":"420800","name":"掇刀区","value":"420804"},{"parent":"420800","name":"京山县","value":"420821"},{"parent":"420800","name":"沙洋县","value":"420822"},{"parent":"420800","name":"钟祥市","value":"420881"},{"parent":"420800","name":"其它区","value":"420882"},{"parent":"420000","name":"孝感市","value":"420900"},{"parent":"420900","name":"孝南区","value":"420902"},{"parent":"420900","name":"孝昌县","value":"420921"},{"parent":"420900","name":"大悟县","value":"420922"},{"parent":"420900","name":"云梦县","value":"420923"},{"parent":"420900","name":"应城市","value":"420981"},{"parent":"420900","name":"安陆市","value":"420982"},{"parent":"420900","name":"汉川市","value":"420984"},{"parent":"420900","name":"其它区","value":"420985"},{"parent":"420000","name":"荆州市","value":"421000"},{"parent":"421000","name":"沙市区","value":"421002"},{"parent":"421000","name":"荆州区","value":"421003"},{"parent":"421000","name":"公安县","value":"421022"},{"parent":"421000","name":"监利县","value":"421023"},{"parent":"421000","name":"江陵县","value":"421024"},{"parent":"421000","name":"石首市","value":"421081"},{"parent":"421000","name":"洪湖市","value":"421083"},{"parent":"421000","name":"松滋市","value":"421087"},{"parent":"421000","name":"其它区","value":"421088"},{"parent":"420000","name":"黄冈市","value":"421100"},{"parent":"421100","name":"黄州区","value":"421102"},{"parent":"421100","name":"团风县","value":"421121"},{"parent":"421100","name":"红安县","value":"421122"},{"parent":"421100","name":"罗田县","value":"421123"},{"parent":"421100","name":"英山县","value":"421124"},{"parent":"421100","name":"浠水县","value":"421125"},{"parent":"421100","name":"蕲春县","value":"421126"},{"parent":"421100","name":"黄梅县","value":"421127"},{"parent":"421100","name":"麻城市","value":"421181"},{"parent":"421100","name":"武穴市","value":"421182"},{"parent":"421100","name":"其它区","value":"421183"},{"parent":"420000","name":"咸宁市","value":"421200"},{"parent":"421200","name":"咸安区","value":"421202"},{"parent":"421200","name":"嘉鱼县","value":"421221"},{"parent":"421200","name":"通城县","value":"421222"},{"parent":"421200","name":"崇阳县","value":"421223"},{"parent":"421200","name":"通山县","value":"421224"},{"parent":"421200","name":"赤壁市","value":"421281"},{"parent":"421200","name":"温泉城区","value":"421282"},{"parent":"421200","name":"其它区","value":"421283"},{"parent":"420000","name":"随州市","value":"421300"},{"parent":"421300","name":"曾都区","value":"421302"},{"parent":"421300","name":"随县","value":"421321"},{"parent":"421300","name":"广水市","value":"421381"},{"parent":"421300","name":"其它区","value":"421382"},{"parent":"420000","name":"恩施土家族苗族自治州","value":"422800"},{"parent":"422800","name":"恩施市","value":"422801"},{"parent":"422800","name":"利川市","value":"422802"},{"parent":"422800","name":"建始县","value":"422822"},{"parent":"422800","name":"巴东县","value":"422823"},{"parent":"422800","name":"宣恩县","value":"422825"},{"parent":"422800","name":"咸丰县","value":"422826"},{"parent":"422800","name":"来凤县","value":"422827"},{"parent":"422800","name":"鹤峰县","value":"422828"},{"parent":"422800","name":"其它区","value":"422829"},{"parent":"420000","name":"仙桃市","value":"429004"},{"parent":"420000","name":"潜江市","value":"429005"},{"parent":"420000","name":"天门市","value":"429006"},{"parent":"420000","name":"神农架林区","value":"429021"},{"name":"湖南省","value":"430000"},{"parent":"430000","name":"长沙市","value":"430100"},{"parent":"430100","name":"芙蓉区","value":"430102"},{"parent":"430100","name":"天心区","value":"430103"},{"parent":"430100","name":"岳麓区","value":"430104"},{"parent":"430100","name":"开福区","value":"430105"},{"parent":"430100","name":"雨花区","value":"430111"},{"parent":"430100","name":"长沙县","value":"430121"},{"parent":"430100","name":"望城区","value":"430122"},{"parent":"430100","name":"宁乡市","value":"430124"},{"parent":"430100","name":"浏阳市","value":"430181"},{"parent":"430100","name":"其它区","value":"430182"},{"parent":"430000","name":"株洲市","value":"430200"},{"parent":"430200","name":"荷塘区","value":"430202"},{"parent":"430200","name":"芦淞区","value":"430203"},{"parent":"430200","name":"石峰区","value":"430204"},{"parent":"430200","name":"天元区","value":"430211"},{"parent":"430200","name":"株洲县","value":"430221"},{"parent":"430200","name":"攸县","value":"430223"},{"parent":"430200","name":"茶陵县","value":"430224"},{"parent":"430200","name":"炎陵县","value":"430225"},{"parent":"430200","name":"醴陵市","value":"430281"},{"parent":"430200","name":"其它区","value":"430282"},{"parent":"430000","name":"湘潭市","value":"430300"},{"parent":"430300","name":"雨湖区","value":"430302"},{"parent":"430300","name":"岳塘区","value":"430304"},{"parent":"430300","name":"湘潭县","value":"430321"},{"parent":"430300","name":"湘乡市","value":"430381"},{"parent":"430300","name":"韶山市","value":"430382"},{"parent":"430300","name":"其它区","value":"430383"},{"parent":"430000","name":"衡阳市","value":"430400"},{"parent":"430400","name":"珠晖区","value":"430405"},{"parent":"430400","name":"雁峰区","value":"430406"},{"parent":"430400","name":"石鼓区","value":"430407"},{"parent":"430400","name":"蒸湘区","value":"430408"},{"parent":"430400","name":"南岳区","value":"430412"},{"parent":"430400","name":"衡阳县","value":"430421"},{"parent":"430400","name":"衡南县","value":"430422"},{"parent":"430400","name":"衡山县","value":"430423"},{"parent":"430400","name":"衡东县","value":"430424"},{"parent":"430400","name":"祁东县","value":"430426"},{"parent":"430400","name":"耒阳市","value":"430481"},{"parent":"430400","name":"常宁市","value":"430482"},{"parent":"430400","name":"其它区","value":"430483"},{"parent":"430000","name":"邵阳市","value":"430500"},{"parent":"430500","name":"双清区","value":"430502"},{"parent":"430500","name":"大祥区","value":"430503"},{"parent":"430500","name":"北塔区","value":"430511"},{"parent":"430500","name":"邵东县","value":"430521"},{"parent":"430500","name":"新邵县","value":"430522"},{"parent":"430500","name":"邵阳县","value":"430523"},{"parent":"430500","name":"隆回县","value":"430524"},{"parent":"430500","name":"洞口县","value":"430525"},{"parent":"430500","name":"绥宁县","value":"430527"},{"parent":"430500","name":"新宁县","value":"430528"},{"parent":"430500","name":"城步苗族自治县","value":"430529"},{"parent":"430500","name":"武冈市","value":"430581"},{"parent":"430500","name":"其它区","value":"430582"},{"parent":"430000","name":"岳阳市","value":"430600"},{"parent":"430600","name":"岳阳楼区","value":"430602"},{"parent":"430600","name":"云溪区","value":"430603"},{"parent":"430600","name":"君山区","value":"430611"},{"parent":"430600","name":"岳阳县","value":"430621"},{"parent":"430600","name":"华容县","value":"430623"},{"parent":"430600","name":"湘阴县","value":"430624"},{"parent":"430600","name":"平江县","value":"430626"},{"parent":"430600","name":"汨罗市","value":"430681"},{"parent":"430600","name":"临湘市","value":"430682"},{"parent":"430600","name":"其它区","value":"430683"},{"parent":"430000","name":"常德市","value":"430700"},{"parent":"430700","name":"武陵区","value":"430702"},{"parent":"430700","name":"鼎城区","value":"430703"},{"parent":"430700","name":"安乡县","value":"430721"},{"parent":"430700","name":"汉寿县","value":"430722"},{"parent":"430700","name":"澧县","value":"430723"},{"parent":"430700","name":"临澧县","value":"430724"},{"parent":"430700","name":"桃源县","value":"430725"},{"parent":"430700","name":"石门县","value":"430726"},{"parent":"430700","name":"津市市","value":"430781"},{"parent":"430700","name":"其它区","value":"430782"},{"parent":"430000","name":"张家界市","value":"430800"},{"parent":"430800","name":"永定区","value":"430802"},{"parent":"430800","name":"武陵源区","value":"430811"},{"parent":"430800","name":"慈利县","value":"430821"},{"parent":"430800","name":"桑植县","value":"430822"},{"parent":"430800","name":"其它区","value":"430823"},{"parent":"430000","name":"益阳市","value":"430900"},{"parent":"430900","name":"资阳区","value":"430902"},{"parent":"430900","name":"赫山区","value":"430903"},{"parent":"430900","name":"南县","value":"430921"},{"parent":"430900","name":"桃江县","value":"430922"},{"parent":"430900","name":"安化县","value":"430923"},{"parent":"430900","name":"沅江市","value":"430981"},{"parent":"430900","name":"其它区","value":"430982"},{"parent":"430000","name":"郴州市","value":"431000"},{"parent":"431000","name":"北湖区","value":"431002"},{"parent":"431000","name":"苏仙区","value":"431003"},{"parent":"431000","name":"桂阳县","value":"431021"},{"parent":"431000","name":"宜章县","value":"431022"},{"parent":"431000","name":"永兴县","value":"431023"},{"parent":"431000","name":"嘉禾县","value":"431024"},{"parent":"431000","name":"临武县","value":"431025"},{"parent":"431000","name":"汝城县","value":"431026"},{"parent":"431000","name":"桂东县","value":"431027"},{"parent":"431000","name":"安仁县","value":"431028"},{"parent":"431000","name":"资兴市","value":"431081"},{"parent":"431000","name":"其它区","value":"431082"},{"parent":"430000","name":"永州市","value":"431100"},{"parent":"431100","name":"零陵区","value":"431102"},{"parent":"431100","name":"冷水滩区","value":"431103"},{"parent":"431100","name":"祁阳县","value":"431121"},{"parent":"431100","name":"东安县","value":"431122"},{"parent":"431100","name":"双牌县","value":"431123"},{"parent":"431100","name":"道县","value":"431124"},{"parent":"431100","name":"江永县","value":"431125"},{"parent":"431100","name":"宁远县","value":"431126"},{"parent":"431100","name":"蓝山县","value":"431127"},{"parent":"431100","name":"新田县","value":"431128"},{"parent":"431100","name":"江华瑶族自治县","value":"431129"},{"parent":"431100","name":"其它区","value":"431130"},{"parent":"430000","name":"怀化市","value":"431200"},{"parent":"431200","name":"鹤城区","value":"431202"},{"parent":"431200","name":"中方县","value":"431221"},{"parent":"431200","name":"沅陵县","value":"431222"},{"parent":"431200","name":"辰溪县","value":"431223"},{"parent":"431200","name":"溆浦县","value":"431224"},{"parent":"431200","name":"会同县","value":"431225"},{"parent":"431200","name":"麻阳苗族自治县","value":"431226"},{"parent":"431200","name":"新晃侗族自治县","value":"431227"},{"parent":"431200","name":"芷江侗族自治县","value":"431228"},{"parent":"431200","name":"靖州苗族侗族自治县","value":"431229"},{"parent":"431200","name":"通道侗族自治县","value":"431230"},{"parent":"431200","name":"洪江市","value":"431281"},{"parent":"431200","name":"其它区","value":"431282"},{"parent":"430000","name":"娄底市","value":"431300"},{"parent":"431300","name":"娄星区","value":"431302"},{"parent":"431300","name":"双峰县","value":"431321"},{"parent":"431300","name":"新化县","value":"431322"},{"parent":"431300","name":"冷水江市","value":"431381"},{"parent":"431300","name":"涟源市","value":"431382"},{"parent":"431300","name":"其它区","value":"431383"},{"parent":"430000","name":"湘西土家族苗族自治州","value":"433100"},{"parent":"433100","name":"吉首市","value":"433101"},{"parent":"433100","name":"泸溪县","value":"433122"},{"parent":"433100","name":"凤凰县","value":"433123"},{"parent":"433100","name":"花垣县","value":"433124"},{"parent":"433100","name":"保靖县","value":"433125"},{"parent":"433100","name":"古丈县","value":"433126"},{"parent":"433100","name":"永顺县","value":"433127"},{"parent":"433100","name":"龙山县","value":"433130"},{"parent":"433100","name":"其它区","value":"433131"},{"name":"广东省","value":"440000"},{"parent":"440000","name":"广州市","value":"440100"},{"parent":"440100","name":"荔湾区","value":"440103"},{"parent":"440100","name":"越秀区","value":"440104"},{"parent":"440100","name":"海珠区","value":"440105"},{"parent":"440100","name":"天河区","value":"440106"},{"parent":"440100","name":"白云区","value":"440111"},{"parent":"440100","name":"黄埔区","value":"440112"},{"parent":"440100","name":"番禺区","value":"440113"},{"parent":"440100","name":"花都区","value":"440114"},{"parent":"440100","name":"南沙区","value":"440115"},{"parent":"440100","name":"萝岗区","value":"440116"},{"parent":"440100","name":"增城区","value":"440183"},{"parent":"440100","name":"从化区","value":"440184"},{"parent":"440100","name":"东山区","value":"440188"},{"parent":"440100","name":"其它区","value":"440189"},{"parent":"440000","name":"韶关市","value":"440200"},{"parent":"440200","name":"武江区","value":"440203"},{"parent":"440200","name":"浈江区","value":"440204"},{"parent":"440200","name":"曲江区","value":"440205"},{"parent":"440200","name":"始兴县","value":"440222"},{"parent":"440200","name":"仁化县","value":"440224"},{"parent":"440200","name":"翁源县","value":"440229"},{"parent":"440200","name":"乳源瑶族自治县","value":"440232"},{"parent":"440200","name":"新丰县","value":"440233"},{"parent":"440200","name":"乐昌市","value":"440281"},{"parent":"440200","name":"南雄市","value":"440282"},{"parent":"440200","name":"其它区","value":"440283"},{"parent":"440000","name":"深圳市","value":"440300"},{"parent":"440300","name":"罗湖区","value":"440303"},{"parent":"440300","name":"福田区","value":"440304"},{"parent":"440300","name":"南山区","value":"440305"},{"parent":"440300","name":"宝安区","value":"440306"},{"parent":"440300","name":"龙岗区","value":"440307"},{"parent":"440300","name":"盐田区","value":"440308"},{"parent":"440300","name":"其它区","value":"440309"},{"parent":"440300","name":"坪山区","value":"440310"},{"parent":"440300","name":"龙华区","value":"440311"},{"parent":"440300","name":"光明新区","value":"440320"},{"parent":"440300","name":"坪山新区","value":"440321"},{"parent":"440300","name":"大鹏新区","value":"440322"},{"parent":"440300","name":"龙华新区","value":"440323"},{"parent":"440000","name":"珠海市","value":"440400"},{"parent":"440400","name":"香洲区","value":"440402"},{"parent":"440400","name":"斗门区","value":"440403"},{"parent":"440400","name":"金湾区","value":"440404"},{"parent":"440400","name":"金唐区","value":"440486"},{"parent":"440400","name":"南湾区","value":"440487"},{"parent":"440400","name":"其它区","value":"440488"},{"parent":"440000","name":"汕头市","value":"440500"},{"parent":"440500","name":"龙湖区","value":"440507"},{"parent":"440500","name":"金平区","value":"440511"},{"parent":"440500","name":"濠江区","value":"440512"},{"parent":"440500","name":"潮阳区","value":"440513"},{"parent":"440500","name":"潮南区","value":"440514"},{"parent":"440500","name":"澄海区","value":"440515"},{"parent":"440500","name":"南澳县","value":"440523"},{"parent":"440500","name":"其它区","value":"440524"},{"parent":"440000","name":"佛山市","value":"440600"},{"parent":"440600","name":"禅城区","value":"440604"},{"parent":"440600","name":"南海区","value":"440605"},{"parent":"440600","name":"顺德区","value":"440606"},{"parent":"440600","name":"三水区","value":"440607"},{"parent":"440600","name":"高明区","value":"440608"},{"parent":"440600","name":"其它区","value":"440609"},{"parent":"440000","name":"江门市","value":"440700"},{"parent":"440700","name":"蓬江区","value":"440703"},{"parent":"440700","name":"江海区","value":"440704"},{"parent":"440700","name":"新会区","value":"440705"},{"parent":"440700","name":"台山市","value":"440781"},{"parent":"440700","name":"开平市","value":"440783"},{"parent":"440700","name":"鹤山市","value":"440784"},{"parent":"440700","name":"恩平市","value":"440785"},{"parent":"440700","name":"其它区","value":"440786"},{"parent":"440000","name":"湛江市","value":"440800"},{"parent":"440800","name":"赤坎区","value":"440802"},{"parent":"440800","name":"霞山区","value":"440803"},{"parent":"440800","name":"坡头区","value":"440804"},{"parent":"440800","name":"麻章区","value":"440811"},{"parent":"440800","name":"遂溪县","value":"440823"},{"parent":"440800","name":"徐闻县","value":"440825"},{"parent":"440800","name":"廉江市","value":"440881"},{"parent":"440800","name":"雷州市","value":"440882"},{"parent":"440800","name":"吴川市","value":"440883"},{"parent":"440800","name":"其它区","value":"440884"},{"parent":"440000","name":"茂名市","value":"440900"},{"parent":"440900","name":"茂南区","value":"440902"},{"parent":"440900","name":"电白区","value":"440903"},{"parent":"440900","name":"电白县","value":"440923"},{"parent":"440900","name":"高州市","value":"440981"},{"parent":"440900","name":"化州市","value":"440982"},{"parent":"440900","name":"信宜市","value":"440983"},{"parent":"440900","name":"其它区","value":"440984"},{"parent":"440000","name":"肇庆市","value":"441200"},{"parent":"441200","name":"端州区","value":"441202"},{"parent":"441200","name":"鼎湖区","value":"441203"},{"parent":"441200","name":"广宁县","value":"441223"},{"parent":"441200","name":"怀集县","value":"441224"},{"parent":"441200","name":"封开县","value":"441225"},{"parent":"441200","name":"德庆县","value":"441226"},{"parent":"441200","name":"高要区","value":"441283"},{"parent":"441200","name":"四会市","value":"441284"},{"parent":"441200","name":"其它区","value":"441285"},{"parent":"440000","name":"惠州市","value":"441300"},{"parent":"441300","name":"惠城区","value":"441302"},{"parent":"441300","name":"惠阳区","value":"441303"},{"parent":"441300","name":"博罗县","value":"441322"},{"parent":"441300","name":"惠东县","value":"441323"},{"parent":"441300","name":"龙门县","value":"441324"},{"parent":"441300","name":"其它区","value":"441325"},{"parent":"440000","name":"梅州市","value":"441400"},{"parent":"441400","name":"梅江区","value":"441402"},{"parent":"441400","name":"梅县区","value":"441421"},{"parent":"441400","name":"大埔县","value":"441422"},{"parent":"441400","name":"丰顺县","value":"441423"},{"parent":"441400","name":"五华县","value":"441424"},{"parent":"441400","name":"平远县","value":"441426"},{"parent":"441400","name":"蕉岭县","value":"441427"},{"parent":"441400","name":"兴宁市","value":"441481"},{"parent":"441400","name":"其它区","value":"441482"},{"parent":"440000","name":"汕尾市","value":"441500"},{"parent":"441500","name":"城区","value":"441502"},{"parent":"441500","name":"海丰县","value":"441521"},{"parent":"441500","name":"陆河县","value":"441523"},{"parent":"441500","name":"陆丰市","value":"441581"},{"parent":"441500","name":"其它区","value":"441582"},{"parent":"440000","name":"河源市","value":"441600"},{"parent":"441600","name":"源城区","value":"441602"},{"parent":"441600","name":"紫金县","value":"441621"},{"parent":"441600","name":"龙川县","value":"441622"},{"parent":"441600","name":"连平县","value":"441623"},{"parent":"441600","name":"和平县","value":"441624"},{"parent":"441600","name":"东源县","value":"441625"},{"parent":"441600","name":"其它区","value":"441626"},{"parent":"440000","name":"阳江市","value":"441700"},{"parent":"441700","name":"江城区","value":"441702"},{"parent":"441700","name":"阳西县","value":"441721"},{"parent":"441700","name":"阳东区","value":"441723"},{"parent":"441700","name":"阳春市","value":"441781"},{"parent":"441700","name":"其它区","value":"441782"},{"parent":"440000","name":"清远市","value":"441800"},{"parent":"441800","name":"清城区","value":"441802"},{"parent":"441800","name":"佛冈县","value":"441821"},{"parent":"441800","name":"阳山县","value":"441823"},{"parent":"441800","name":"连山壮族瑶族自治县","value":"441825"},{"parent":"441800","name":"连南瑶族自治县","value":"441826"},{"parent":"441800","name":"清新区","value":"441827"},{"parent":"441800","name":"英德市","value":"441881"},{"parent":"441800","name":"连州市","value":"441882"},{"parent":"441800","name":"其它区","value":"441883"},{"parent":"440000","name":"东莞市","value":"441900"},{"parent":"440000","name":"中山市","value":"442000"},{"parent":"440000","name":"东沙群岛","value":"442101"},{"parent":"440000","name":"潮州市","value":"445100"},{"parent":"445100","name":"湘桥区","value":"445102"},{"parent":"445100","name":"潮安区","value":"445121"},{"parent":"445100","name":"饶平县","value":"445122"},{"parent":"445100","name":"枫溪区","value":"445185"},{"parent":"445100","name":"其它区","value":"445186"},{"parent":"440000","name":"揭阳市","value":"445200"},{"parent":"445200","name":"榕城区","value":"445202"},{"parent":"445200","name":"揭东区","value":"445221"},{"parent":"445200","name":"揭西县","value":"445222"},{"parent":"445200","name":"惠来县","value":"445224"},{"parent":"445200","name":"普宁市","value":"445281"},{"parent":"445200","name":"东山区","value":"445284"},{"parent":"445200","name":"其它区","value":"445285"},{"parent":"440000","name":"云浮市","value":"445300"},{"parent":"445300","name":"云城区","value":"445302"},{"parent":"445300","name":"新兴县","value":"445321"},{"parent":"445300","name":"郁南县","value":"445322"},{"parent":"445300","name":"云安区","value":"445323"},{"parent":"445300","name":"罗定市","value":"445381"},{"parent":"445300","name":"其它区","value":"445382"},{"name":"广西壮族自治区","value":"450000"},{"parent":"450000","name":"南宁市","value":"450100"},{"parent":"450100","name":"兴宁区","value":"450102"},{"parent":"450100","name":"青秀区","value":"450103"},{"parent":"450100","name":"江南区","value":"450105"},{"parent":"450100","name":"西乡塘区","value":"450107"},{"parent":"450100","name":"良庆区","value":"450108"},{"parent":"450100","name":"邕宁区","value":"450109"},{"parent":"450100","name":"武鸣区","value":"450122"},{"parent":"450100","name":"隆安县","value":"450123"},{"parent":"450100","name":"马山县","value":"450124"},{"parent":"450100","name":"上林县","value":"450125"},{"parent":"450100","name":"宾阳县","value":"450126"},{"parent":"450100","name":"横县","value":"450127"},{"parent":"450100","name":"其它区","value":"450128"},{"parent":"450000","name":"柳州市","value":"450200"},{"parent":"450200","name":"城中区","value":"450202"},{"parent":"450200","name":"鱼峰区","value":"450203"},{"parent":"450200","name":"柳南区","value":"450204"},{"parent":"450200","name":"柳北区","value":"450205"},{"parent":"450200","name":"柳江区","value":"450221"},{"parent":"450200","name":"柳城县","value":"450222"},{"parent":"450200","name":"鹿寨县","value":"450223"},{"parent":"450200","name":"融安县","value":"450224"},{"parent":"450200","name":"融水苗族自治县","value":"450225"},{"parent":"450200","name":"三江侗族自治县","value":"450226"},{"parent":"450200","name":"其它区","value":"450227"},{"parent":"450000","name":"桂林市","value":"450300"},{"parent":"450300","name":"秀峰区","value":"450302"},{"parent":"450300","name":"叠彩区","value":"450303"},{"parent":"450300","name":"象山区","value":"450304"},{"parent":"450300","name":"七星区","value":"450305"},{"parent":"450300","name":"雁山区","value":"450311"},{"parent":"450300","name":"阳朔县","value":"450321"},{"parent":"450300","name":"临桂区","value":"450322"},{"parent":"450300","name":"灵川县","value":"450323"},{"parent":"450300","name":"全州县","value":"450324"},{"parent":"450300","name":"兴安县","value":"450325"},{"parent":"450300","name":"永福县","value":"450326"},{"parent":"450300","name":"灌阳县","value":"450327"},{"parent":"450300","name":"龙胜各族自治县","value":"450328"},{"parent":"450300","name":"资源县","value":"450329"},{"parent":"450300","name":"平乐县","value":"450330"},{"parent":"450300","name":"荔浦县","value":"450331"},{"parent":"450300","name":"恭城瑶族自治县","value":"450332"},{"parent":"450300","name":"其它区","value":"450333"},{"parent":"450000","name":"梧州市","value":"450400"},{"parent":"450400","name":"万秀区","value":"450403"},{"parent":"450400","name":"蝶山区","value":"450404"},{"parent":"450400","name":"长洲区","value":"450405"},{"parent":"450400","name":"龙圩区","value":"450406"},{"parent":"450400","name":"苍梧县","value":"450421"},{"parent":"450400","name":"藤县","value":"450422"},{"parent":"450400","name":"蒙山县","value":"450423"},{"parent":"450400","name":"岑溪市","value":"450481"},{"parent":"450400","name":"其它区","value":"450482"},{"parent":"450000","name":"北海市","value":"450500"},{"parent":"450500","name":"海城区","value":"450502"},{"parent":"450500","name":"银海区","value":"450503"},{"parent":"450500","name":"铁山港区","value":"450512"},{"parent":"450500","name":"合浦县","value":"450521"},{"parent":"450500","name":"其它区","value":"450522"},{"parent":"450000","name":"防城港市","value":"450600"},{"parent":"450600","name":"港口区","value":"450602"},{"parent":"450600","name":"防城区","value":"450603"},{"parent":"450600","name":"上思县","value":"450621"},{"parent":"450600","name":"东兴市","value":"450681"},{"parent":"450600","name":"其它区","value":"450682"},{"parent":"450000","name":"钦州市","value":"450700"},{"parent":"450700","name":"钦南区","value":"450702"},{"parent":"450700","name":"钦北区","value":"450703"},{"parent":"450700","name":"灵山县","value":"450721"},{"parent":"450700","name":"浦北县","value":"450722"},{"parent":"450700","name":"其它区","value":"450723"},{"parent":"450000","name":"贵港市","value":"450800"},{"parent":"450800","name":"港北区","value":"450802"},{"parent":"450800","name":"港南区","value":"450803"},{"parent":"450800","name":"覃塘区","value":"450804"},{"parent":"450800","name":"平南县","value":"450821"},{"parent":"450800","name":"桂平市","value":"450881"},{"parent":"450800","name":"其它区","value":"450882"},{"parent":"450000","name":"玉林市","value":"450900"},{"parent":"450900","name":"玉州区","value":"450902"},{"parent":"450900","name":"福绵区","value":"450903"},{"parent":"450900","name":"容县","value":"450921"},{"parent":"450900","name":"陆川县","value":"450922"},{"parent":"450900","name":"博白县","value":"450923"},{"parent":"450900","name":"兴业县","value":"450924"},{"parent":"450900","name":"北流市","value":"450981"},{"parent":"450900","name":"其它区","value":"450982"},{"parent":"450000","name":"百色市","value":"451000"},{"parent":"451000","name":"右江区","value":"451002"},{"parent":"451000","name":"田阳县","value":"451021"},{"parent":"451000","name":"田东县","value":"451022"},{"parent":"451000","name":"平果县","value":"451023"},{"parent":"451000","name":"德保县","value":"451024"},{"parent":"451000","name":"靖西市","value":"451025"},{"parent":"451000","name":"那坡县","value":"451026"},{"parent":"451000","name":"凌云县","value":"451027"},{"parent":"451000","name":"乐业县","value":"451028"},{"parent":"451000","name":"田林县","value":"451029"},{"parent":"451000","name":"西林县","value":"451030"},{"parent":"451000","name":"隆林各族自治县","value":"451031"},{"parent":"451000","name":"其它区","value":"451032"},{"parent":"450000","name":"贺州市","value":"451100"},{"parent":"451100","name":"八步区","value":"451102"},{"parent":"451100","name":"平桂区","value":"451103"},{"parent":"451100","name":"平桂管理区","value":"451119"},{"parent":"451100","name":"昭平县","value":"451121"},{"parent":"451100","name":"钟山县","value":"451122"},{"parent":"451100","name":"富川瑶族自治县","value":"451123"},{"parent":"451100","name":"其它区","value":"451124"},{"parent":"450000","name":"河池市","value":"451200"},{"parent":"451200","name":"金城江区","value":"451202"},{"parent":"451200","name":"南丹县","value":"451221"},{"parent":"451200","name":"天峨县","value":"451222"},{"parent":"451200","name":"凤山县","value":"451223"},{"parent":"451200","name":"东兰县","value":"451224"},{"parent":"451200","name":"罗城仫佬族自治县","value":"451225"},{"parent":"451200","name":"环江毛南族自治县","value":"451226"},{"parent":"451200","name":"巴马瑶族自治县","value":"451227"},{"parent":"451200","name":"都安瑶族自治县","value":"451228"},{"parent":"451200","name":"大化瑶族自治县","value":"451229"},{"parent":"451200","name":"宜州区","value":"451281"},{"parent":"451200","name":"其它区","value":"451282"},{"parent":"450000","name":"来宾市","value":"451300"},{"parent":"451300","name":"兴宾区","value":"451302"},{"parent":"451300","name":"忻城县","value":"451321"},{"parent":"451300","name":"象州县","value":"451322"},{"parent":"451300","name":"武宣县","value":"451323"},{"parent":"451300","name":"金秀瑶族自治县","value":"451324"},{"parent":"451300","name":"合山市","value":"451381"},{"parent":"451300","name":"其它区","value":"451382"},{"parent":"450000","name":"崇左市","value":"451400"},{"parent":"451400","name":"江州区","value":"451402"},{"parent":"451400","name":"扶绥县","value":"451421"},{"parent":"451400","name":"宁明县","value":"451422"},{"parent":"451400","name":"龙州县","value":"451423"},{"parent":"451400","name":"大新县","value":"451424"},{"parent":"451400","name":"天等县","value":"451425"},{"parent":"451400","name":"凭祥市","value":"451481"},{"parent":"451400","name":"其它区","value":"451482"},{"name":"海南省","value":"460000"},{"parent":"460000","name":"海口市","value":"460100"},{"parent":"460100","name":"秀英区","value":"460105"},{"parent":"460100","name":"龙华区","value":"460106"},{"parent":"460100","name":"琼山区","value":"460107"},{"parent":"460100","name":"美兰区","value":"460108"},{"parent":"460100","name":"其它区","value":"460109"},{"parent":"460000","name":"三亚市","value":"460200"},{"parent":"460200","name":"海棠区","value":"460202"},{"parent":"460200","name":"吉阳区","value":"460203"},{"parent":"460200","name":"天涯区","value":"460204"},{"parent":"460200","name":"崖州区","value":"460205"},{"parent":"460000","name":"三沙市","value":"460300"},{"parent":"460300","name":"西沙群岛","value":"460321"},{"parent":"460300","name":"南沙群岛","value":"460322"},{"parent":"460300","name":"中沙群岛的岛礁及其海域","value":"460323"},{"parent":"460000","name":"五指山市","value":"469001"},{"parent":"460000","name":"琼海市","value":"469002"},{"parent":"460000","name":"儋州市","value":"469003"},{"parent":"460000","name":"文昌市","value":"469005"},{"parent":"460000","name":"万宁市","value":"469006"},{"parent":"460000","name":"东方市","value":"469007"},{"parent":"460000","name":"定安县","value":"469025"},{"parent":"460000","name":"屯昌县","value":"469026"},{"parent":"460000","name":"澄迈县","value":"469027"},{"parent":"460000","name":"临高县","value":"469028"},{"parent":"460000","name":"白沙黎族自治县","value":"469030"},{"parent":"460000","name":"昌江黎族自治县","value":"469031"},{"parent":"460000","name":"乐东黎族自治县","value":"469033"},{"parent":"460000","name":"陵水黎族自治县","value":"469034"},{"parent":"460000","name":"保亭黎族苗族自治县","value":"469035"},{"parent":"460000","name":"琼中黎族苗族自治县","value":"469036"},{"parent":"460000","name":"西沙群岛","value":"469037"},{"parent":"460000","name":"南沙群岛","value":"469038"},{"parent":"460000","name":"中沙群岛的岛礁及其海域","value":"469039"},{"name":"重庆","value":"500000"},{"parent":"500000","name":"重庆市","value":"500100"},{"parent":"500100","name":"万州区","value":"500101"},{"parent":"500100","name":"涪陵区","value":"500102"},{"parent":"500100","name":"渝中区","value":"500103"},{"parent":"500100","name":"大渡口区","value":"500104"},{"parent":"500100","name":"江北区","value":"500105"},{"parent":"500100","name":"沙坪坝区","value":"500106"},{"parent":"500100","name":"九龙坡区","value":"500107"},{"parent":"500100","name":"南岸区","value":"500108"},{"parent":"500100","name":"北碚区","value":"500109"},{"parent":"500100","name":"万盛区","value":"500110"},{"parent":"500100","name":"双桥区","value":"500111"},{"parent":"500100","name":"渝北区","value":"500112"},{"parent":"500100","name":"巴南区","value":"500113"},{"parent":"500100","name":"黔江区","value":"500114"},{"parent":"500100","name":"长寿区","value":"500115"},{"parent":"500100","name":"綦江区","value":"500222"},{"parent":"500100","name":"潼南区","value":"500223"},{"parent":"500100","name":"铜梁区","value":"500224"},{"parent":"500100","name":"大足区","value":"500225"},{"parent":"500100","name":"荣昌区","value":"500226"},{"parent":"500100","name":"璧山区","value":"500227"},{"parent":"500100","name":"梁平区","value":"500228"},{"parent":"500100","name":"城口县","value":"500229"},{"parent":"500100","name":"丰都县","value":"500230"},{"parent":"500100","name":"垫江县","value":"500231"},{"parent":"500100","name":"武隆区","value":"500232"},{"parent":"500100","name":"忠县","value":"500233"},{"parent":"500100","name":"开州区","value":"500234"},{"parent":"500100","name":"云阳县","value":"500235"},{"parent":"500100","name":"奉节县","value":"500236"},{"parent":"500100","name":"巫山县","value":"500237"},{"parent":"500100","name":"巫溪县","value":"500238"},{"parent":"500100","name":"石柱土家族自治县","value":"500240"},{"parent":"500100","name":"秀山土家族苗族自治县","value":"500241"},{"parent":"500100","name":"酉阳土家族苗族自治县","value":"500242"},{"parent":"500100","name":"彭水苗族土家族自治县","value":"500243"},{"parent":"500100","name":"江津区","value":"500381"},{"parent":"500100","name":"合川区","value":"500382"},{"parent":"500100","name":"永川区","value":"500383"},{"parent":"500100","name":"南川区","value":"500384"},{"parent":"500100","name":"其它区","value":"500385"},{"name":"四川省","value":"510000"},{"parent":"510000","name":"成都市","value":"510100"},{"parent":"510100","name":"锦江区","value":"510104"},{"parent":"510100","name":"青羊区","value":"510105"},{"parent":"510100","name":"金牛区","value":"510106"},{"parent":"510100","name":"武侯区","value":"510107"},{"parent":"510100","name":"成华区","value":"510108"},{"parent":"510100","name":"龙泉驿区","value":"510112"},{"parent":"510100","name":"青白江区","value":"510113"},{"parent":"510100","name":"新都区","value":"510114"},{"parent":"510100","name":"温江区","value":"510115"},{"parent":"510100","name":"金堂县","value":"510121"},{"parent":"510100","name":"双流区","value":"510122"},{"parent":"510100","name":"郫都区","value":"510124"},{"parent":"510100","name":"大邑县","value":"510129"},{"parent":"510100","name":"蒲江县","value":"510131"},{"parent":"510100","name":"新津县","value":"510132"},{"parent":"510100","name":"都江堰市","value":"510181"},{"parent":"510100","name":"彭州市","value":"510182"},{"parent":"510100","name":"邛崃市","value":"510183"},{"parent":"510100","name":"崇州市","value":"510184"},{"parent":"510100","name":"其它区","value":"510185"},{"parent":"510100","name":"简阳市","value":"512081"},{"parent":"510000","name":"自贡市","value":"510300"},{"parent":"510300","name":"自流井区","value":"510302"},{"parent":"510300","name":"贡井区","value":"510303"},{"parent":"510300","name":"大安区","value":"510304"},{"parent":"510300","name":"沿滩区","value":"510311"},{"parent":"510300","name":"荣县","value":"510321"},{"parent":"510300","name":"富顺县","value":"510322"},{"parent":"510300","name":"其它区","value":"510323"},{"parent":"510000","name":"攀枝花市","value":"510400"},{"parent":"510400","name":"东区","value":"510402"},{"parent":"510400","name":"西区","value":"510403"},{"parent":"510400","name":"仁和区","value":"510411"},{"parent":"510400","name":"米易县","value":"510421"},{"parent":"510400","name":"盐边县","value":"510422"},{"parent":"510400","name":"其它区","value":"510423"},{"parent":"510000","name":"泸州市","value":"510500"},{"parent":"510500","name":"江阳区","value":"510502"},{"parent":"510500","name":"纳溪区","value":"510503"},{"parent":"510500","name":"龙马潭区","value":"510504"},{"parent":"510500","name":"泸县","value":"510521"},{"parent":"510500","name":"合江县","value":"510522"},{"parent":"510500","name":"叙永县","value":"510524"},{"parent":"510500","name":"古蔺县","value":"510525"},{"parent":"510500","name":"其它区","value":"510526"},{"parent":"510000","name":"德阳市","value":"510600"},{"parent":"510600","name":"旌阳区","value":"510603"},{"parent":"510600","name":"中江县","value":"510623"},{"parent":"510600","name":"罗江区","value":"510626"},{"parent":"510600","name":"广汉市","value":"510681"},{"parent":"510600","name":"什邡市","value":"510682"},{"parent":"510600","name":"绵竹市","value":"510683"},{"parent":"510600","name":"其它区","value":"510684"},{"parent":"510000","name":"绵阳市","value":"510700"},{"parent":"510700","name":"涪城区","value":"510703"},{"parent":"510700","name":"游仙区","value":"510704"},{"parent":"510700","name":"三台县","value":"510722"},{"parent":"510700","name":"盐亭县","value":"510723"},{"parent":"510700","name":"安州区","value":"510724"},{"parent":"510700","name":"梓潼县","value":"510725"},{"parent":"510700","name":"北川羌族自治县","value":"510726"},{"parent":"510700","name":"平武县","value":"510727"},{"parent":"510700","name":"高新区","value":"510751"},{"parent":"510700","name":"江油市","value":"510781"},{"parent":"510700","name":"其它区","value":"510782"},{"parent":"510000","name":"广元市","value":"510800"},{"parent":"510800","name":"利州区","value":"510802"},{"parent":"510800","name":"昭化区","value":"510811"},{"parent":"510800","name":"朝天区","value":"510812"},{"parent":"510800","name":"旺苍县","value":"510821"},{"parent":"510800","name":"青川县","value":"510822"},{"parent":"510800","name":"剑阁县","value":"510823"},{"parent":"510800","name":"苍溪县","value":"510824"},{"parent":"510800","name":"其它区","value":"510825"},{"parent":"510000","name":"遂宁市","value":"510900"},{"parent":"510900","name":"船山区","value":"510903"},{"parent":"510900","name":"安居区","value":"510904"},{"parent":"510900","name":"蓬溪县","value":"510921"},{"parent":"510900","name":"射洪县","value":"510922"},{"parent":"510900","name":"大英县","value":"510923"},{"parent":"510900","name":"其它区","value":"510924"},{"parent":"510000","name":"内江市","value":"511000"},{"parent":"511000","name":"市中区","value":"511002"},{"parent":"511000","name":"东兴区","value":"511011"},{"parent":"511000","name":"威远县","value":"511024"},{"parent":"511000","name":"资中县","value":"511025"},{"parent":"511000","name":"隆昌市","value":"511028"},{"parent":"511000","name":"其它区","value":"511029"},{"parent":"510000","name":"乐山市","value":"511100"},{"parent":"511100","name":"市中区","value":"511102"},{"parent":"511100","name":"沙湾区","value":"511111"},{"parent":"511100","name":"五通桥区","value":"511112"},{"parent":"511100","name":"金口河区","value":"511113"},{"parent":"511100","name":"犍为县","value":"511123"},{"parent":"511100","name":"井研县","value":"511124"},{"parent":"511100","name":"夹江县","value":"511126"},{"parent":"511100","name":"沐川县","value":"511129"},{"parent":"511100","name":"峨边彝族自治县","value":"511132"},{"parent":"511100","name":"马边彝族自治县","value":"511133"},{"parent":"511100","name":"峨眉山市","value":"511181"},{"parent":"511100","name":"其它区","value":"511182"},{"parent":"510000","name":"南充市","value":"511300"},{"parent":"511300","name":"顺庆区","value":"511302"},{"parent":"511300","name":"高坪区","value":"511303"},{"parent":"511300","name":"嘉陵区","value":"511304"},{"parent":"511300","name":"南部县","value":"511321"},{"parent":"511300","name":"营山县","value":"511322"},{"parent":"511300","name":"蓬安县","value":"511323"},{"parent":"511300","name":"仪陇县","value":"511324"},{"parent":"511300","name":"西充县","value":"511325"},{"parent":"511300","name":"阆中市","value":"511381"},{"parent":"511300","name":"其它区","value":"511382"},{"parent":"510000","name":"眉山市","value":"511400"},{"parent":"511400","name":"东坡区","value":"511402"},{"parent":"511400","name":"仁寿县","value":"511421"},{"parent":"511400","name":"彭山区","value":"511422"},{"parent":"511400","name":"洪雅县","value":"511423"},{"parent":"511400","name":"丹棱县","value":"511424"},{"parent":"511400","name":"青神县","value":"511425"},{"parent":"511400","name":"其它区","value":"511426"},{"parent":"510000","name":"宜宾市","value":"511500"},{"parent":"511500","name":"翠屏区","value":"511502"},{"parent":"511500","name":"宜宾县","value":"511521"},{"parent":"511500","name":"南溪区","value":"511522"},{"parent":"511500","name":"江安县","value":"511523"},{"parent":"511500","name":"长宁县","value":"511524"},{"parent":"511500","name":"高县","value":"511525"},{"parent":"511500","name":"珙县","value":"511526"},{"parent":"511500","name":"筠连县","value":"511527"},{"parent":"511500","name":"兴文县","value":"511528"},{"parent":"511500","name":"屏山县","value":"511529"},{"parent":"511500","name":"其它区","value":"511530"},{"parent":"510000","name":"广安市","value":"511600"},{"parent":"511600","name":"广安区","value":"511602"},{"parent":"511600","name":"前锋区","value":"511603"},{"parent":"511600","name":"岳池县","value":"511621"},{"parent":"511600","name":"武胜县","value":"511622"},{"parent":"511600","name":"邻水县","value":"511623"},{"parent":"511600","name":"华蓥市","value":"511681"},{"parent":"511600","name":"市辖区","value":"511682"},{"parent":"511600","name":"其它区","value":"511683"},{"parent":"510000","name":"达州市","value":"511700"},{"parent":"511700","name":"通川区","value":"511702"},{"parent":"511700","name":"达川区","value":"511721"},{"parent":"511700","name":"宣汉县","value":"511722"},{"parent":"511700","name":"开江县","value":"511723"},{"parent":"511700","name":"大竹县","value":"511724"},{"parent":"511700","name":"渠县","value":"511725"},{"parent":"511700","name":"万源市","value":"511781"},{"parent":"511700","name":"其它区","value":"511782"},{"parent":"510000","name":"雅安市","value":"511800"},{"parent":"511800","name":"雨城区","value":"511802"},{"parent":"511800","name":"名山区","value":"511821"},{"parent":"511800","name":"荥经县","value":"511822"},{"parent":"511800","name":"汉源县","value":"511823"},{"parent":"511800","name":"石棉县","value":"511824"},{"parent":"511800","name":"天全县","value":"511825"},{"parent":"511800","name":"芦山县","value":"511826"},{"parent":"511800","name":"宝兴县","value":"511827"},{"parent":"511800","name":"其它区","value":"511828"},{"parent":"510000","name":"巴中市","value":"511900"},{"parent":"511900","name":"巴州区","value":"511902"},{"parent":"511900","name":"恩阳区","value":"511903"},{"parent":"511900","name":"通江县","value":"511921"},{"parent":"511900","name":"南江县","value":"511922"},{"parent":"511900","name":"平昌县","value":"511923"},{"parent":"511900","name":"其它区","value":"511924"},{"parent":"510000","name":"资阳市","value":"512000"},{"parent":"512000","name":"雁江区","value":"512002"},{"parent":"512000","name":"安岳县","value":"512021"},{"parent":"512000","name":"乐至县","value":"512022"},{"parent":"512000","name":"其它区","value":"512082"},{"parent":"510000","name":"阿坝藏族羌族自治州","value":"513200"},{"parent":"513200","name":"汶川县","value":"513221"},{"parent":"513200","name":"理县","value":"513222"},{"parent":"513200","name":"茂县","value":"513223"},{"parent":"513200","name":"松潘县","value":"513224"},{"parent":"513200","name":"九寨沟县","value":"513225"},{"parent":"513200","name":"金川县","value":"513226"},{"parent":"513200","name":"小金县","value":"513227"},{"parent":"513200","name":"黑水县","value":"513228"},{"parent":"513200","name":"马尔康市","value":"513229"},{"parent":"513200","name":"壤塘县","value":"513230"},{"parent":"513200","name":"阿坝县","value":"513231"},{"parent":"513200","name":"若尔盖县","value":"513232"},{"parent":"513200","name":"红原县","value":"513233"},{"parent":"513200","name":"其它区","value":"513234"},{"parent":"510000","name":"甘孜藏族自治州","value":"513300"},{"parent":"513300","name":"康定市","value":"513321"},{"parent":"513300","name":"泸定县","value":"513322"},{"parent":"513300","name":"丹巴县","value":"513323"},{"parent":"513300","name":"九龙县","value":"513324"},{"parent":"513300","name":"雅江县","value":"513325"},{"parent":"513300","name":"道孚县","value":"513326"},{"parent":"513300","name":"炉霍县","value":"513327"},{"parent":"513300","name":"甘孜县","value":"513328"},{"parent":"513300","name":"新龙县","value":"513329"},{"parent":"513300","name":"德格县","value":"513330"},{"parent":"513300","name":"白玉县","value":"513331"},{"parent":"513300","name":"石渠县","value":"513332"},{"parent":"513300","name":"色达县","value":"513333"},{"parent":"513300","name":"理塘县","value":"513334"},{"parent":"513300","name":"巴塘县","value":"513335"},{"parent":"513300","name":"乡城县","value":"513336"},{"parent":"513300","name":"稻城县","value":"513337"},{"parent":"513300","name":"得荣县","value":"513338"},{"parent":"513300","name":"其它区","value":"513339"},{"parent":"510000","name":"凉山彝族自治州","value":"513400"},{"parent":"513400","name":"西昌市","value":"513401"},{"parent":"513400","name":"木里藏族自治县","value":"513422"},{"parent":"513400","name":"盐源县","value":"513423"},{"parent":"513400","name":"德昌县","value":"513424"},{"parent":"513400","name":"会理县","value":"513425"},{"parent":"513400","name":"会东县","value":"513426"},{"parent":"513400","name":"宁南县","value":"513427"},{"parent":"513400","name":"普格县","value":"513428"},{"parent":"513400","name":"布拖县","value":"513429"},{"parent":"513400","name":"金阳县","value":"513430"},{"parent":"513400","name":"昭觉县","value":"513431"},{"parent":"513400","name":"喜德县","value":"513432"},{"parent":"513400","name":"冕宁县","value":"513433"},{"parent":"513400","name":"越西县","value":"513434"},{"parent":"513400","name":"甘洛县","value":"513435"},{"parent":"513400","name":"美姑县","value":"513436"},{"parent":"513400","name":"雷波县","value":"513437"},{"parent":"513400","name":"其它区","value":"513438"},{"name":"贵州省","value":"520000"},{"parent":"520000","name":"贵阳市","value":"520100"},{"parent":"520100","name":"南明区","value":"520102"},{"parent":"520100","name":"云岩区","value":"520103"},{"parent":"520100","name":"花溪区","value":"520111"},{"parent":"520100","name":"乌当区","value":"520112"},{"parent":"520100","name":"白云区","value":"520113"},{"parent":"520100","name":"小河区","value":"520114"},{"parent":"520100","name":"开阳县","value":"520121"},{"parent":"520100","name":"息烽县","value":"520122"},{"parent":"520100","name":"修文县","value":"520123"},{"parent":"520100","name":"观山湖区","value":"520151"},{"parent":"520100","name":"清镇市","value":"520181"},{"parent":"520100","name":"其它区","value":"520182"},{"parent":"520000","name":"六盘水市","value":"520200"},{"parent":"520200","name":"钟山区","value":"520201"},{"parent":"520200","name":"六枝特区","value":"520203"},{"parent":"520200","name":"水城县","value":"520221"},{"parent":"520200","name":"盘州市","value":"520222"},{"parent":"520200","name":"其它区","value":"520223"},{"parent":"520000","name":"遵义市","value":"520300"},{"parent":"520300","name":"红花岗区","value":"520302"},{"parent":"520300","name":"汇川区","value":"520303"},{"parent":"520300","name":"播州区","value":"520321"},{"parent":"520300","name":"桐梓县","value":"520322"},{"parent":"520300","name":"绥阳县","value":"520323"},{"parent":"520300","name":"正安县","value":"520324"},{"parent":"520300","name":"道真仡佬族苗族自治县","value":"520325"},{"parent":"520300","name":"务川仡佬族苗族自治县","value":"520326"},{"parent":"520300","name":"凤冈县","value":"520327"},{"parent":"520300","name":"湄潭县","value":"520328"},{"parent":"520300","name":"余庆县","value":"520329"},{"parent":"520300","name":"习水县","value":"520330"},{"parent":"520300","name":"赤水市","value":"520381"},{"parent":"520300","name":"仁怀市","value":"520382"},{"parent":"520300","name":"其它区","value":"520383"},{"parent":"520000","name":"安顺市","value":"520400"},{"parent":"520400","name":"西秀区","value":"520402"},{"parent":"520400","name":"平坝区","value":"520421"},{"parent":"520400","name":"普定县","value":"520422"},{"parent":"520400","name":"镇宁布依族苗族自治县","value":"520423"},{"parent":"520400","name":"关岭布依族苗族自治县","value":"520424"},{"parent":"520400","name":"紫云苗族布依族自治县","value":"520425"},{"parent":"520400","name":"其它区","value":"520426"},{"parent":"520000","name":"铜仁市","value":"522200"},{"parent":"522200","name":"碧江区","value":"522201"},{"parent":"522200","name":"江口县","value":"522222"},{"parent":"522200","name":"玉屏侗族自治县","value":"522223"},{"parent":"522200","name":"石阡县","value":"522224"},{"parent":"522200","name":"思南县","value":"522225"},{"parent":"522200","name":"印江土家族苗族自治县","value":"522226"},{"parent":"522200","name":"德江县","value":"522227"},{"parent":"522200","name":"沿河土家族自治县","value":"522228"},{"parent":"522200","name":"松桃苗族自治县","value":"522229"},{"parent":"522200","name":"万山区","value":"522230"},{"parent":"522200","name":"其它区","value":"522231"},{"parent":"520000","name":"黔西南布依族苗族自治州","value":"522300"},{"parent":"522300","name":"兴义市","value":"522301"},{"parent":"522300","name":"兴仁县","value":"522322"},{"parent":"522300","name":"普安县","value":"522323"},{"parent":"522300","name":"晴隆县","value":"522324"},{"parent":"522300","name":"贞丰县","value":"522325"},{"parent":"522300","name":"望谟县","value":"522326"},{"parent":"522300","name":"册亨县","value":"522327"},{"parent":"522300","name":"安龙县","value":"522328"},{"parent":"522300","name":"其它区","value":"522329"},{"parent":"520000","name":"毕节市","value":"522400"},{"parent":"522400","name":"七星关区","value":"522401"},{"parent":"522400","name":"大方县","value":"522422"},{"parent":"522400","name":"黔西县","value":"522423"},{"parent":"522400","name":"金沙县","value":"522424"},{"parent":"522400","name":"织金县","value":"522425"},{"parent":"522400","name":"纳雍县","value":"522426"},{"parent":"522400","name":"威宁彝族回族苗族自治县","value":"522427"},{"parent":"522400","name":"赫章县","value":"522428"},{"parent":"522400","name":"其它区","value":"522429"},{"parent":"520000","name":"黔东南苗族侗族自治州","value":"522600"},{"parent":"522600","name":"凯里市","value":"522601"},{"parent":"522600","name":"黄平县","value":"522622"},{"parent":"522600","name":"施秉县","value":"522623"},{"parent":"522600","name":"三穗县","value":"522624"},{"parent":"522600","name":"镇远县","value":"522625"},{"parent":"522600","name":"岑巩县","value":"522626"},{"parent":"522600","name":"天柱县","value":"522627"},{"parent":"522600","name":"锦屏县","value":"522628"},{"parent":"522600","name":"剑河县","value":"522629"},{"parent":"522600","name":"台江县","value":"522630"},{"parent":"522600","name":"黎平县","value":"522631"},{"parent":"522600","name":"榕江县","value":"522632"},{"parent":"522600","name":"从江县","value":"522633"},{"parent":"522600","name":"雷山县","value":"522634"},{"parent":"522600","name":"麻江县","value":"522635"},{"parent":"522600","name":"丹寨县","value":"522636"},{"parent":"522600","name":"其它区","value":"522637"},{"parent":"520000","name":"黔南布依族苗族自治州","value":"522700"},{"parent":"522700","name":"都匀市","value":"522701"},{"parent":"522700","name":"福泉市","value":"522702"},{"parent":"522700","name":"荔波县","value":"522722"},{"parent":"522700","name":"贵定县","value":"522723"},{"parent":"522700","name":"瓮安县","value":"522725"},{"parent":"522700","name":"独山县","value":"522726"},{"parent":"522700","name":"平塘县","value":"522727"},{"parent":"522700","name":"罗甸县","value":"522728"},{"parent":"522700","name":"长顺县","value":"522729"},{"parent":"522700","name":"龙里县","value":"522730"},{"parent":"522700","name":"惠水县","value":"522731"},{"parent":"522700","name":"三都水族自治县","value":"522732"},{"parent":"522700","name":"其它区","value":"522733"},{"name":"云南省","value":"530000"},{"parent":"530000","name":"昆明市","value":"530100"},{"parent":"530100","name":"五华区","value":"530102"},{"parent":"530100","name":"盘龙区","value":"530103"},{"parent":"530100","name":"官渡区","value":"530111"},{"parent":"530100","name":"西山区","value":"530112"},{"parent":"530100","name":"东川区","value":"530113"},{"parent":"530100","name":"呈贡区","value":"530121"},{"parent":"530100","name":"晋宁区","value":"530122"},{"parent":"530100","name":"富民县","value":"530124"},{"parent":"530100","name":"宜良县","value":"530125"},{"parent":"530100","name":"石林彝族自治县","value":"530126"},{"parent":"530100","name":"嵩明县","value":"530127"},{"parent":"530100","name":"禄劝彝族苗族自治县","value":"530128"},{"parent":"530100","name":"寻甸回族彝族自治县","value":"530129"},{"parent":"530100","name":"安宁市","value":"530181"},{"parent":"530100","name":"其它区","value":"530182"},{"parent":"530000","name":"曲靖市","value":"530300"},{"parent":"530300","name":"麒麟区","value":"530302"},{"parent":"530300","name":"马龙县","value":"530321"},{"parent":"530300","name":"陆良县","value":"530322"},{"parent":"530300","name":"师宗县","value":"530323"},{"parent":"530300","name":"罗平县","value":"530324"},{"parent":"530300","name":"富源县","value":"530325"},{"parent":"530300","name":"会泽县","value":"530326"},{"parent":"530300","name":"沾益区","value":"530328"},{"parent":"530300","name":"宣威市","value":"530381"},{"parent":"530300","name":"其它区","value":"530382"},{"parent":"530000","name":"玉溪市","value":"530400"},{"parent":"530400","name":"红塔区","value":"530402"},{"parent":"530400","name":"江川区","value":"530421"},{"parent":"530400","name":"澄江县","value":"530422"},{"parent":"530400","name":"通海县","value":"530423"},{"parent":"530400","name":"华宁县","value":"530424"},{"parent":"530400","name":"易门县","value":"530425"},{"parent":"530400","name":"峨山彝族自治县","value":"530426"},{"parent":"530400","name":"新平彝族傣族自治县","value":"530427"},{"parent":"530400","name":"元江哈尼族彝族傣族自治县","value":"530428"},{"parent":"530400","name":"其它区","value":"530429"},{"parent":"530000","name":"保山市","value":"530500"},{"parent":"530500","name":"隆阳区","value":"530502"},{"parent":"530500","name":"施甸县","value":"530521"},{"parent":"530500","name":"腾冲市","value":"530522"},{"parent":"530500","name":"龙陵县","value":"530523"},{"parent":"530500","name":"昌宁县","value":"530524"},{"parent":"530500","name":"其它区","value":"530525"},{"parent":"530000","name":"昭通市","value":"530600"},{"parent":"530600","name":"昭阳区","value":"530602"},{"parent":"530600","name":"鲁甸县","value":"530621"},{"parent":"530600","name":"巧家县","value":"530622"},{"parent":"530600","name":"盐津县","value":"530623"},{"parent":"530600","name":"大关县","value":"530624"},{"parent":"530600","name":"永善县","value":"530625"},{"parent":"530600","name":"绥江县","value":"530626"},{"parent":"530600","name":"镇雄县","value":"530627"},{"parent":"530600","name":"彝良县","value":"530628"},{"parent":"530600","name":"威信县","value":"530629"},{"parent":"530600","name":"水富县","value":"530630"},{"parent":"530600","name":"其它区","value":"530631"},{"parent":"530000","name":"丽江市","value":"530700"},{"parent":"530700","name":"古城区","value":"530702"},{"parent":"530700","name":"玉龙纳西族自治县","value":"530721"},{"parent":"530700","name":"永胜县","value":"530722"},{"parent":"530700","name":"华坪县","value":"530723"},{"parent":"530700","name":"宁蒗彝族自治县","value":"530724"},{"parent":"530700","name":"其它区","value":"530725"},{"parent":"530000","name":"普洱市","value":"530800"},{"parent":"530800","name":"思茅区","value":"530802"},{"parent":"530800","name":"宁洱哈尼族彝族自治县","value":"530821"},{"parent":"530800","name":"墨江哈尼族自治县","value":"530822"},{"parent":"530800","name":"景东彝族自治县","value":"530823"},{"parent":"530800","name":"景谷傣族彝族自治县","value":"530824"},{"parent":"530800","name":"镇沅彝族哈尼族拉祜族自治县","value":"530825"},{"parent":"530800","name":"江城哈尼族彝族自治县","value":"530826"},{"parent":"530800","name":"孟连傣族拉祜族佤族自治县","value":"530827"},{"parent":"530800","name":"澜沧拉祜族自治县","value":"530828"},{"parent":"530800","name":"西盟佤族自治县","value":"530829"},{"parent":"530800","name":"其它区","value":"530830"},{"parent":"530000","name":"临沧市","value":"530900"},{"parent":"530900","name":"临翔区","value":"530902"},{"parent":"530900","name":"凤庆县","value":"530921"},{"parent":"530900","name":"云县","value":"530922"},{"parent":"530900","name":"永德县","value":"530923"},{"parent":"530900","name":"镇康县","value":"530924"},{"parent":"530900","name":"双江拉祜族佤族布朗族傣族自治县","value":"530925"},{"parent":"530900","name":"耿马傣族佤族自治县","value":"530926"},{"parent":"530900","name":"沧源佤族自治县","value":"530927"},{"parent":"530900","name":"其它区","value":"530928"},{"parent":"530000","name":"楚雄彝族自治州","value":"532300"},{"parent":"532300","name":"楚雄市","value":"532301"},{"parent":"532300","name":"双柏县","value":"532322"},{"parent":"532300","name":"牟定县","value":"532323"},{"parent":"532300","name":"南华县","value":"532324"},{"parent":"532300","name":"姚安县","value":"532325"},{"parent":"532300","name":"大姚县","value":"532326"},{"parent":"532300","name":"永仁县","value":"532327"},{"parent":"532300","name":"元谋县","value":"532328"},{"parent":"532300","name":"武定县","value":"532329"},{"parent":"532300","name":"禄丰县","value":"532331"},{"parent":"532300","name":"其它区","value":"532332"},{"parent":"530000","name":"红河哈尼族彝族自治州","value":"532500"},{"parent":"532500","name":"个旧市","value":"532501"},{"parent":"532500","name":"开远市","value":"532502"},{"parent":"532500","name":"蒙自市","value":"532522"},{"parent":"532500","name":"屏边苗族自治县","value":"532523"},{"parent":"532500","name":"建水县","value":"532524"},{"parent":"532500","name":"石屏县","value":"532525"},{"parent":"532500","name":"弥勒市","value":"532526"},{"parent":"532500","name":"泸西县","value":"532527"},{"parent":"532500","name":"元阳县","value":"532528"},{"parent":"532500","name":"红河县","value":"532529"},{"parent":"532500","name":"金平苗族瑶族傣族自治县","value":"532530"},{"parent":"532500","name":"绿春县","value":"532531"},{"parent":"532500","name":"河口瑶族自治县","value":"532532"},{"parent":"532500","name":"其它区","value":"532533"},{"parent":"530000","name":"文山壮族苗族自治州","value":"532600"},{"parent":"532600","name":"文山市","value":"532621"},{"parent":"532600","name":"砚山县","value":"532622"},{"parent":"532600","name":"西畴县","value":"532623"},{"parent":"532600","name":"麻栗坡县","value":"532624"},{"parent":"532600","name":"马关县","value":"532625"},{"parent":"532600","name":"丘北县","value":"532626"},{"parent":"532600","name":"广南县","value":"532627"},{"parent":"532600","name":"富宁县","value":"532628"},{"parent":"532600","name":"其它区","value":"532629"},{"parent":"530000","name":"西双版纳傣族自治州","value":"532800"},{"parent":"532800","name":"景洪市","value":"532801"},{"parent":"532800","name":"勐海县","value":"532822"},{"parent":"532800","name":"勐腊县","value":"532823"},{"parent":"532800","name":"其它区","value":"532824"},{"parent":"530000","name":"大理白族自治州","value":"532900"},{"parent":"532900","name":"大理市","value":"532901"},{"parent":"532900","name":"漾濞彝族自治县","value":"532922"},{"parent":"532900","name":"祥云县","value":"532923"},{"parent":"532900","name":"宾川县","value":"532924"},{"parent":"532900","name":"弥渡县","value":"532925"},{"parent":"532900","name":"南涧彝族自治县","value":"532926"},{"parent":"532900","name":"巍山彝族回族自治县","value":"532927"},{"parent":"532900","name":"永平县","value":"532928"},{"parent":"532900","name":"云龙县","value":"532929"},{"parent":"532900","name":"洱源县","value":"532930"},{"parent":"532900","name":"剑川县","value":"532931"},{"parent":"532900","name":"鹤庆县","value":"532932"},{"parent":"532900","name":"其它区","value":"532933"},{"parent":"530000","name":"德宏傣族景颇族自治州","value":"533100"},{"parent":"533100","name":"瑞丽市","value":"533102"},{"parent":"533100","name":"芒市","value":"533103"},{"parent":"533100","name":"梁河县","value":"533122"},{"parent":"533100","name":"盈江县","value":"533123"},{"parent":"533100","name":"陇川县","value":"533124"},{"parent":"533100","name":"其它区","value":"533125"},{"parent":"530000","name":"怒江傈僳族自治州","value":"533300"},{"parent":"533300","name":"泸水市","value":"533321"},{"parent":"533300","name":"福贡县","value":"533323"},{"parent":"533300","name":"贡山独龙族怒族自治县","value":"533324"},{"parent":"533300","name":"兰坪白族普米族自治县","value":"533325"},{"parent":"533300","name":"其它区","value":"533326"},{"parent":"530000","name":"迪庆藏族自治州","value":"533400"},{"parent":"533400","name":"香格里拉市","value":"533421"},{"parent":"533400","name":"德钦县","value":"533422"},{"parent":"533400","name":"维西傈僳族自治县","value":"533423"},{"parent":"533400","name":"其它区","value":"533424"},{"name":"西藏自治区","value":"540000"},{"parent":"540000","name":"拉萨市","value":"540100"},{"parent":"540100","name":"城关区","value":"540102"},{"parent":"540100","name":"林周县","value":"540121"},{"parent":"540100","name":"当雄县","value":"540122"},{"parent":"540100","name":"尼木县","value":"540123"},{"parent":"540100","name":"曲水县","value":"540124"},{"parent":"540100","name":"堆龙德庆区","value":"540125"},{"parent":"540100","name":"达孜县","value":"540126"},{"parent":"540100","name":"墨竹工卡县","value":"540127"},{"parent":"540100","name":"其它区","value":"540128"},{"parent":"540000","name":"昌都市","value":"542100"},{"parent":"542100","name":"卡若区","value":"542121"},{"parent":"542100","name":"江达县","value":"542122"},{"parent":"542100","name":"贡觉县","value":"542123"},{"parent":"542100","name":"类乌齐县","value":"542124"},{"parent":"542100","name":"丁青县","value":"542125"},{"parent":"542100","name":"察雅县","value":"542126"},{"parent":"542100","name":"八宿县","value":"542127"},{"parent":"542100","name":"左贡县","value":"542128"},{"parent":"542100","name":"芒康县","value":"542129"},{"parent":"542100","name":"洛隆县","value":"542132"},{"parent":"542100","name":"边坝县","value":"542133"},{"parent":"542100","name":"其它区","value":"542134"},{"parent":"540000","name":"山南市","value":"542200"},{"parent":"542200","name":"乃东区","value":"542221"},{"parent":"542200","name":"扎囊县","value":"542222"},{"parent":"542200","name":"贡嘎县","value":"542223"},{"parent":"542200","name":"桑日县","value":"542224"},{"parent":"542200","name":"琼结县","value":"542225"},{"parent":"542200","name":"曲松县","value":"542226"},{"parent":"542200","name":"措美县","value":"542227"},{"parent":"542200","name":"洛扎县","value":"542228"},{"parent":"542200","name":"加查县","value":"542229"},{"parent":"542200","name":"隆子县","value":"542231"},{"parent":"542200","name":"错那县","value":"542232"},{"parent":"542200","name":"浪卡子县","value":"542233"},{"parent":"542200","name":"其它区","value":"542234"},{"parent":"540000","name":"日喀则市","value":"542300"},{"parent":"542300","name":"桑珠孜区","value":"542301"},{"parent":"542300","name":"南木林县","value":"542322"},{"parent":"542300","name":"江孜县","value":"542323"},{"parent":"542300","name":"定日县","value":"542324"},{"parent":"542300","name":"萨迦县","value":"542325"},{"parent":"542300","name":"拉孜县","value":"542326"},{"parent":"542300","name":"昂仁县","value":"542327"},{"parent":"542300","name":"谢通门县","value":"542328"},{"parent":"542300","name":"白朗县","value":"542329"},{"parent":"542300","name":"仁布县","value":"542330"},{"parent":"542300","name":"康马县","value":"542331"},{"parent":"542300","name":"定结县","value":"542332"},{"parent":"542300","name":"仲巴县","value":"542333"},{"parent":"542300","name":"亚东县","value":"542334"},{"parent":"542300","name":"吉隆县","value":"542335"},{"parent":"542300","name":"聂拉木县","value":"542336"},{"parent":"542300","name":"萨嘎县","value":"542337"},{"parent":"542300","name":"岗巴县","value":"542338"},{"parent":"542300","name":"其它区","value":"542339"},{"parent":"540000","name":"那曲市","value":"542400"},{"parent":"542400","name":"色尼区","value":"542421"},{"parent":"542400","name":"嘉黎县","value":"542422"},{"parent":"542400","name":"比如县","value":"542423"},{"parent":"542400","name":"聂荣县","value":"542424"},{"parent":"542400","name":"安多县","value":"542425"},{"parent":"542400","name":"申扎县","value":"542426"},{"parent":"542400","name":"索县","value":"542427"},{"parent":"542400","name":"班戈县","value":"542428"},{"parent":"542400","name":"巴青县","value":"542429"},{"parent":"542400","name":"尼玛县","value":"542430"},{"parent":"542400","name":"其它区","value":"542431"},{"parent":"542400","name":"双湖县","value":"542432"},{"parent":"540000","name":"阿里地区","value":"542500"},{"parent":"542500","name":"普兰县","value":"542521"},{"parent":"542500","name":"札达县","value":"542522"},{"parent":"542500","name":"噶尔县","value":"542523"},{"parent":"542500","name":"日土县","value":"542524"},{"parent":"542500","name":"革吉县","value":"542525"},{"parent":"542500","name":"改则县","value":"542526"},{"parent":"542500","name":"措勤县","value":"542527"},{"parent":"542500","name":"其它区","value":"542528"},{"parent":"540000","name":"林芝市","value":"542600"},{"parent":"542600","name":"巴宜区","value":"542621"},{"parent":"542600","name":"工布江达县","value":"542622"},{"parent":"542600","name":"米林县","value":"542623"},{"parent":"542600","name":"墨脱县","value":"542624"},{"parent":"542600","name":"波密县","value":"542625"},{"parent":"542600","name":"察隅县","value":"542626"},{"parent":"542600","name":"朗县","value":"542627"},{"parent":"542600","name":"其它区","value":"542628"},{"name":"陕西省","value":"610000"},{"parent":"610000","name":"西安市","value":"610100"},{"parent":"610100","name":"新城区","value":"610102"},{"parent":"610100","name":"碑林区","value":"610103"},{"parent":"610100","name":"莲湖区","value":"610104"},{"parent":"610100","name":"灞桥区","value":"610111"},{"parent":"610100","name":"未央区","value":"610112"},{"parent":"610100","name":"雁塔区","value":"610113"},{"parent":"610100","name":"阎良区","value":"610114"},{"parent":"610100","name":"临潼区","value":"610115"},{"parent":"610100","name":"长安区","value":"610116"},{"parent":"610100","name":"蓝田县","value":"610122"},{"parent":"610100","name":"周至县","value":"610124"},{"parent":"610100","name":"鄠邑区","value":"610125"},{"parent":"610100","name":"高陵区","value":"610126"},{"parent":"610100","name":"其它区","value":"610127"},{"parent":"610000","name":"铜川市","value":"610200"},{"parent":"610200","name":"王益区","value":"610202"},{"parent":"610200","name":"印台区","value":"610203"},{"parent":"610200","name":"耀州区","value":"610204"},{"parent":"610200","name":"宜君县","value":"610222"},{"parent":"610200","name":"其它区","value":"610223"},{"parent":"610000","name":"宝鸡市","value":"610300"},{"parent":"610300","name":"渭滨区","value":"610302"},{"parent":"610300","name":"金台区","value":"610303"},{"parent":"610300","name":"陈仓区","value":"610304"},{"parent":"610300","name":"凤翔县","value":"610322"},{"parent":"610300","name":"岐山县","value":"610323"},{"parent":"610300","name":"扶风县","value":"610324"},{"parent":"610300","name":"眉县","value":"610326"},{"parent":"610300","name":"陇县","value":"610327"},{"parent":"610300","name":"千阳县","value":"610328"},{"parent":"610300","name":"麟游县","value":"610329"},{"parent":"610300","name":"凤县","value":"610330"},{"parent":"610300","name":"太白县","value":"610331"},{"parent":"610300","name":"其它区","value":"610332"},{"parent":"610000","name":"咸阳市","value":"610400"},{"parent":"610400","name":"秦都区","value":"610402"},{"parent":"610400","name":"杨陵区","value":"610403"},{"parent":"610400","name":"渭城区","value":"610404"},{"parent":"610400","name":"三原县","value":"610422"},{"parent":"610400","name":"泾阳县","value":"610423"},{"parent":"610400","name":"乾县","value":"610424"},{"parent":"610400","name":"礼泉县","value":"610425"},{"parent":"610400","name":"永寿县","value":"610426"},{"parent":"610400","name":"彬县","value":"610427"},{"parent":"610400","name":"长武县","value":"610428"},{"parent":"610400","name":"旬邑县","value":"610429"},{"parent":"610400","name":"淳化县","value":"610430"},{"parent":"610400","name":"武功县","value":"610431"},{"parent":"610400","name":"兴平市","value":"610481"},{"parent":"610400","name":"其它区","value":"610482"},{"parent":"610000","name":"渭南市","value":"610500"},{"parent":"610500","name":"临渭区","value":"610502"},{"parent":"610500","name":"华州区","value":"610521"},{"parent":"610500","name":"潼关县","value":"610522"},{"parent":"610500","name":"大荔县","value":"610523"},{"parent":"610500","name":"合阳县","value":"610524"},{"parent":"610500","name":"澄城县","value":"610525"},{"parent":"610500","name":"蒲城县","value":"610526"},{"parent":"610500","name":"白水县","value":"610527"},{"parent":"610500","name":"富平县","value":"610528"},{"parent":"610500","name":"韩城市","value":"610581"},{"parent":"610500","name":"华阴市","value":"610582"},{"parent":"610500","name":"其它区","value":"610583"},{"parent":"610000","name":"延安市","value":"610600"},{"parent":"610600","name":"宝塔区","value":"610602"},{"parent":"610600","name":"延长县","value":"610621"},{"parent":"610600","name":"延川县","value":"610622"},{"parent":"610600","name":"子长县","value":"610623"},{"parent":"610600","name":"安塞区","value":"610624"},{"parent":"610600","name":"志丹县","value":"610625"},{"parent":"610600","name":"吴起县","value":"610626"},{"parent":"610600","name":"甘泉县","value":"610627"},{"parent":"610600","name":"富县","value":"610628"},{"parent":"610600","name":"洛川县","value":"610629"},{"parent":"610600","name":"宜川县","value":"610630"},{"parent":"610600","name":"黄龙县","value":"610631"},{"parent":"610600","name":"黄陵县","value":"610632"},{"parent":"610600","name":"其它区","value":"610633"},{"parent":"610000","name":"汉中市","value":"610700"},{"parent":"610700","name":"汉台区","value":"610702"},{"parent":"610700","name":"南郑区","value":"610721"},{"parent":"610700","name":"城固县","value":"610722"},{"parent":"610700","name":"洋县","value":"610723"},{"parent":"610700","name":"西乡县","value":"610724"},{"parent":"610700","name":"勉县","value":"610725"},{"parent":"610700","name":"宁强县","value":"610726"},{"parent":"610700","name":"略阳县","value":"610727"},{"parent":"610700","name":"镇巴县","value":"610728"},{"parent":"610700","name":"留坝县","value":"610729"},{"parent":"610700","name":"佛坪县","value":"610730"},{"parent":"610700","name":"其它区","value":"610731"},{"parent":"610000","name":"榆林市","value":"610800"},{"parent":"610800","name":"榆阳区","value":"610802"},{"parent":"610800","name":"神木市","value":"610821"},{"parent":"610800","name":"府谷县","value":"610822"},{"parent":"610800","name":"横山区","value":"610823"},{"parent":"610800","name":"靖边县","value":"610824"},{"parent":"610800","name":"定边县","value":"610825"},{"parent":"610800","name":"绥德县","value":"610826"},{"parent":"610800","name":"米脂县","value":"610827"},{"parent":"610800","name":"佳县","value":"610828"},{"parent":"610800","name":"吴堡县","value":"610829"},{"parent":"610800","name":"清涧县","value":"610830"},{"parent":"610800","name":"子洲县","value":"610831"},{"parent":"610800","name":"其它区","value":"610832"},{"parent":"610000","name":"安康市","value":"610900"},{"parent":"610900","name":"汉滨区","value":"610902"},{"parent":"610900","name":"汉阴县","value":"610921"},{"parent":"610900","name":"石泉县","value":"610922"},{"parent":"610900","name":"宁陕县","value":"610923"},{"parent":"610900","name":"紫阳县","value":"610924"},{"parent":"610900","name":"岚皋县","value":"610925"},{"parent":"610900","name":"平利县","value":"610926"},{"parent":"610900","name":"镇坪县","value":"610927"},{"parent":"610900","name":"旬阳县","value":"610928"},{"parent":"610900","name":"白河县","value":"610929"},{"parent":"610900","name":"其它区","value":"610930"},{"parent":"610000","name":"商洛市","value":"611000"},{"parent":"611000","name":"商州区","value":"611002"},{"parent":"611000","name":"洛南县","value":"611021"},{"parent":"611000","name":"丹凤县","value":"611022"},{"parent":"611000","name":"商南县","value":"611023"},{"parent":"611000","name":"山阳县","value":"611024"},{"parent":"611000","name":"镇安县","value":"611025"},{"parent":"611000","name":"柞水县","value":"611026"},{"parent":"611000","name":"其它区","value":"611027"},{"name":"甘肃省","value":"620000"},{"parent":"620000","name":"兰州市","value":"620100"},{"parent":"620100","name":"城关区","value":"620102"},{"parent":"620100","name":"七里河区","value":"620103"},{"parent":"620100","name":"西固区","value":"620104"},{"parent":"620100","name":"安宁区","value":"620105"},{"parent":"620100","name":"红古区","value":"620111"},{"parent":"620100","name":"永登县","value":"620121"},{"parent":"620100","name":"皋兰县","value":"620122"},{"parent":"620100","name":"榆中县","value":"620123"},{"parent":"620100","name":"其它区","value":"620124"},{"parent":"620000","name":"嘉峪关市","value":"620200"},{"parent":"620000","name":"金昌市","value":"620300"},{"parent":"620300","name":"金川区","value":"620302"},{"parent":"620300","name":"永昌县","value":"620321"},{"parent":"620300","name":"其它区","value":"620322"},{"parent":"620000","name":"白银市","value":"620400"},{"parent":"620400","name":"白银区","value":"620402"},{"parent":"620400","name":"平川区","value":"620403"},{"parent":"620400","name":"靖远县","value":"620421"},{"parent":"620400","name":"会宁县","value":"620422"},{"parent":"620400","name":"景泰县","value":"620423"},{"parent":"620400","name":"其它区","value":"620424"},{"parent":"620000","name":"天水市","value":"620500"},{"parent":"620500","name":"秦州区","value":"620502"},{"parent":"620500","name":"麦积区","value":"620503"},{"parent":"620500","name":"清水县","value":"620521"},{"parent":"620500","name":"秦安县","value":"620522"},{"parent":"620500","name":"甘谷县","value":"620523"},{"parent":"620500","name":"武山县","value":"620524"},{"parent":"620500","name":"张家川回族自治县","value":"620525"},{"parent":"620500","name":"其它区","value":"620526"},{"parent":"620000","name":"武威市","value":"620600"},{"parent":"620600","name":"凉州区","value":"620602"},{"parent":"620600","name":"民勤县","value":"620621"},{"parent":"620600","name":"古浪县","value":"620622"},{"parent":"620600","name":"天祝藏族自治县","value":"620623"},{"parent":"620600","name":"其它区","value":"620624"},{"parent":"620000","name":"张掖市","value":"620700"},{"parent":"620700","name":"甘州区","value":"620702"},{"parent":"620700","name":"肃南裕固族自治县","value":"620721"},{"parent":"620700","name":"民乐县","value":"620722"},{"parent":"620700","name":"临泽县","value":"620723"},{"parent":"620700","name":"高台县","value":"620724"},{"parent":"620700","name":"山丹县","value":"620725"},{"parent":"620700","name":"其它区","value":"620726"},{"parent":"620000","name":"平凉市","value":"620800"},{"parent":"620800","name":"崆峒区","value":"620802"},{"parent":"620800","name":"泾川县","value":"620821"},{"parent":"620800","name":"灵台县","value":"620822"},{"parent":"620800","name":"崇信县","value":"620823"},{"parent":"620800","name":"华亭县","value":"620824"},{"parent":"620800","name":"庄浪县","value":"620825"},{"parent":"620800","name":"静宁县","value":"620826"},{"parent":"620800","name":"其它区","value":"620827"},{"parent":"620000","name":"酒泉市","value":"620900"},{"parent":"620900","name":"肃州区","value":"620902"},{"parent":"620900","name":"金塔县","value":"620921"},{"parent":"620900","name":"瓜州县","value":"620922"},{"parent":"620900","name":"肃北蒙古族自治县","value":"620923"},{"parent":"620900","name":"阿克塞哈萨克族自治县","value":"620924"},{"parent":"620900","name":"玉门市","value":"620981"},{"parent":"620900","name":"敦煌市","value":"620982"},{"parent":"620900","name":"其它区","value":"620983"},{"parent":"620000","name":"庆阳市","value":"621000"},{"parent":"621000","name":"西峰区","value":"621002"},{"parent":"621000","name":"庆城县","value":"621021"},{"parent":"621000","name":"环县","value":"621022"},{"parent":"621000","name":"华池县","value":"621023"},{"parent":"621000","name":"合水县","value":"621024"},{"parent":"621000","name":"正宁县","value":"621025"},{"parent":"621000","name":"宁县","value":"621026"},{"parent":"621000","name":"镇原县","value":"621027"},{"parent":"621000","name":"其它区","value":"621028"},{"parent":"620000","name":"定西市","value":"621100"},{"parent":"621100","name":"安定区","value":"621102"},{"parent":"621100","name":"通渭县","value":"621121"},{"parent":"621100","name":"陇西县","value":"621122"},{"parent":"621100","name":"渭源县","value":"621123"},{"parent":"621100","name":"临洮县","value":"621124"},{"parent":"621100","name":"漳县","value":"621125"},{"parent":"621100","name":"岷县","value":"621126"},{"parent":"621100","name":"其它区","value":"621127"},{"parent":"620000","name":"陇南市","value":"621200"},{"parent":"621200","name":"武都区","value":"621202"},{"parent":"621200","name":"成县","value":"621221"},{"parent":"621200","name":"文县","value":"621222"},{"parent":"621200","name":"宕昌县","value":"621223"},{"parent":"621200","name":"康县","value":"621224"},{"parent":"621200","name":"西和县","value":"621225"},{"parent":"621200","name":"礼县","value":"621226"},{"parent":"621200","name":"徽县","value":"621227"},{"parent":"621200","name":"两当县","value":"621228"},{"parent":"621200","name":"其它区","value":"621229"},{"parent":"620000","name":"临夏回族自治州","value":"622900"},{"parent":"622900","name":"临夏市","value":"622901"},{"parent":"622900","name":"临夏县","value":"622921"},{"parent":"622900","name":"康乐县","value":"622922"},{"parent":"622900","name":"永靖县","value":"622923"},{"parent":"622900","name":"广河县","value":"622924"},{"parent":"622900","name":"和政县","value":"622925"},{"parent":"622900","name":"东乡族自治县","value":"622926"},{"parent":"622900","name":"积石山保安族东乡族撒拉族自治县","value":"622927"},{"parent":"622900","name":"其它区","value":"622928"},{"parent":"620000","name":"甘南藏族自治州","value":"623000"},{"parent":"623000","name":"合作市","value":"623001"},{"parent":"623000","name":"临潭县","value":"623021"},{"parent":"623000","name":"卓尼县","value":"623022"},{"parent":"623000","name":"舟曲县","value":"623023"},{"parent":"623000","name":"迭部县","value":"623024"},{"parent":"623000","name":"玛曲县","value":"623025"},{"parent":"623000","name":"碌曲县","value":"623026"},{"parent":"623000","name":"夏河县","value":"623027"},{"parent":"623000","name":"其它区","value":"623028"},{"name":"青海省","value":"630000"},{"parent":"630000","name":"西宁市","value":"630100"},{"parent":"630100","name":"城东区","value":"630102"},{"parent":"630100","name":"城中区","value":"630103"},{"parent":"630100","name":"城西区","value":"630104"},{"parent":"630100","name":"城北区","value":"630105"},{"parent":"630100","name":"大通回族土族自治县","value":"630121"},{"parent":"630100","name":"湟中县","value":"630122"},{"parent":"630100","name":"湟源县","value":"630123"},{"parent":"630100","name":"其它区","value":"630124"},{"parent":"630000","name":"海东市","value":"632100"},{"parent":"632100","name":"平安区","value":"632121"},{"parent":"632100","name":"民和回族土族自治县","value":"632122"},{"parent":"632100","name":"乐都区","value":"632123"},{"parent":"632100","name":"互助土族自治县","value":"632126"},{"parent":"632100","name":"化隆回族自治县","value":"632127"},{"parent":"632100","name":"循化撒拉族自治县","value":"632128"},{"parent":"632100","name":"其它区","value":"632129"},{"parent":"630000","name":"海北藏族自治州","value":"632200"},{"parent":"632200","name":"门源回族自治县","value":"632221"},{"parent":"632200","name":"祁连县","value":"632222"},{"parent":"632200","name":"海晏县","value":"632223"},{"parent":"632200","name":"刚察县","value":"632224"},{"parent":"632200","name":"其它区","value":"632225"},{"parent":"630000","name":"黄南藏族自治州","value":"632300"},{"parent":"632300","name":"同仁县","value":"632321"},{"parent":"632300","name":"尖扎县","value":"632322"},{"parent":"632300","name":"泽库县","value":"632323"},{"parent":"632300","name":"河南蒙古族自治县","value":"632324"},{"parent":"632300","name":"其它区","value":"632325"},{"parent":"630000","name":"海南藏族自治州","value":"632500"},{"parent":"632500","name":"共和县","value":"632521"},{"parent":"632500","name":"同德县","value":"632522"},{"parent":"632500","name":"贵德县","value":"632523"},{"parent":"632500","name":"兴海县","value":"632524"},{"parent":"632500","name":"贵南县","value":"632525"},{"parent":"632500","name":"其它区","value":"632526"},{"parent":"630000","name":"果洛藏族自治州","value":"632600"},{"parent":"632600","name":"玛沁县","value":"632621"},{"parent":"632600","name":"班玛县","value":"632622"},{"parent":"632600","name":"甘德县","value":"632623"},{"parent":"632600","name":"达日县","value":"632624"},{"parent":"632600","name":"久治县","value":"632625"},{"parent":"632600","name":"玛多县","value":"632626"},{"parent":"632600","name":"其它区","value":"632627"},{"parent":"630000","name":"玉树藏族自治州","value":"632700"},{"parent":"632700","name":"玉树市","value":"632721"},{"parent":"632700","name":"杂多县","value":"632722"},{"parent":"632700","name":"称多县","value":"632723"},{"parent":"632700","name":"治多县","value":"632724"},{"parent":"632700","name":"囊谦县","value":"632725"},{"parent":"632700","name":"曲麻莱县","value":"632726"},{"parent":"632700","name":"其它区","value":"632727"},{"parent":"630000","name":"海西蒙古族藏族自治州","value":"632800"},{"parent":"632800","name":"格尔木市","value":"632801"},{"parent":"632800","name":"德令哈市","value":"632802"},{"parent":"632800","name":"乌兰县","value":"632821"},{"parent":"632800","name":"都兰县","value":"632822"},{"parent":"632800","name":"天峻县","value":"632823"},{"parent":"632800","name":"其它区","value":"632824"},{"parent":"632800","name":"海西蒙古族藏族自治州直辖","value":"632825"},{"name":"宁夏回族自治区","value":"640000"},{"parent":"640000","name":"银川市","value":"640100"},{"parent":"640100","name":"兴庆区","value":"640104"},{"parent":"640100","name":"西夏区","value":"640105"},{"parent":"640100","name":"金凤区","value":"640106"},{"parent":"640100","name":"永宁县","value":"640121"},{"parent":"640100","name":"贺兰县","value":"640122"},{"parent":"640100","name":"灵武市","value":"640181"},{"parent":"640100","name":"其它区","value":"640182"},{"parent":"640000","name":"石嘴山市","value":"640200"},{"parent":"640200","name":"大武口区","value":"640202"},{"parent":"640200","name":"惠农区","value":"640205"},{"parent":"640200","name":"平罗县","value":"640221"},{"parent":"640200","name":"其它区","value":"640222"},{"parent":"640000","name":"吴忠市","value":"640300"},{"parent":"640300","name":"利通区","value":"640302"},{"parent":"640300","name":"红寺堡区","value":"640303"},{"parent":"640300","name":"盐池县","value":"640323"},{"parent":"640300","name":"同心县","value":"640324"},{"parent":"640300","name":"青铜峡市","value":"640381"},{"parent":"640300","name":"其它区","value":"640382"},{"parent":"640000","name":"固原市","value":"640400"},{"parent":"640400","name":"原州区","value":"640402"},{"parent":"640400","name":"西吉县","value":"640422"},{"parent":"640400","name":"隆德县","value":"640423"},{"parent":"640400","name":"泾源县","value":"640424"},{"parent":"640400","name":"彭阳县","value":"640425"},{"parent":"640400","name":"其它区","value":"640426"},{"parent":"640000","name":"中卫市","value":"640500"},{"parent":"640500","name":"沙坡头区","value":"640502"},{"parent":"640500","name":"中宁县","value":"640521"},{"parent":"640500","name":"海原县","value":"640522"},{"parent":"640500","name":"其它区","value":"640523"},{"name":"新疆维吾尔自治区","value":"650000"},{"parent":"650000","name":"乌鲁木齐市","value":"650100"},{"parent":"650100","name":"天山区","value":"650102"},{"parent":"650100","name":"沙依巴克区","value":"650103"},{"parent":"650100","name":"新市区","value":"650104"},{"parent":"650100","name":"水磨沟区","value":"650105"},{"parent":"650100","name":"头屯河区","value":"650106"},{"parent":"650100","name":"达坂城区","value":"650107"},{"parent":"650100","name":"东山区","value":"650108"},{"parent":"650100","name":"米东区","value":"650109"},{"parent":"650100","name":"乌鲁木齐县","value":"650121"},{"parent":"650100","name":"其它区","value":"650122"},{"parent":"650000","name":"克拉玛依市","value":"650200"},{"parent":"650200","name":"独山子区","value":"650202"},{"parent":"650200","name":"克拉玛依区","value":"650203"},{"parent":"650200","name":"白碱滩区","value":"650204"},{"parent":"650200","name":"乌尔禾区","value":"650205"},{"parent":"650200","name":"其它区","value":"650206"},{"parent":"650000","name":"吐鲁番市","value":"652100"},{"parent":"652100","name":"高昌区","value":"652101"},{"parent":"652100","name":"鄯善县","value":"652122"},{"parent":"652100","name":"托克逊县","value":"652123"},{"parent":"652100","name":"其它区","value":"652124"},{"parent":"650000","name":"哈密市","value":"652200"},{"parent":"652200","name":"伊州区","value":"652201"},{"parent":"652200","name":"巴里坤哈萨克自治县","value":"652222"},{"parent":"652200","name":"伊吾县","value":"652223"},{"parent":"652200","name":"其它区","value":"652224"},{"parent":"650000","name":"昌吉回族自治州","value":"652300"},{"parent":"652300","name":"昌吉市","value":"652301"},{"parent":"652300","name":"阜康市","value":"652302"},{"parent":"652300","name":"米泉市","value":"652303"},{"parent":"652300","name":"呼图壁县","value":"652323"},{"parent":"652300","name":"玛纳斯县","value":"652324"},{"parent":"652300","name":"奇台县","value":"652325"},{"parent":"652300","name":"吉木萨尔县","value":"652327"},{"parent":"652300","name":"木垒哈萨克自治县","value":"652328"},{"parent":"652300","name":"其它区","value":"652329"},{"parent":"650000","name":"博尔塔拉蒙古自治州","value":"652700"},{"parent":"652700","name":"博乐市","value":"652701"},{"parent":"652700","name":"阿拉山口市","value":"652702"},{"parent":"652700","name":"精河县","value":"652722"},{"parent":"652700","name":"温泉县","value":"652723"},{"parent":"652700","name":"其它区","value":"652724"},{"parent":"650000","name":"巴音郭楞蒙古自治州","value":"652800"},{"parent":"652800","name":"库尔勒市","value":"652801"},{"parent":"652800","name":"轮台县","value":"652822"},{"parent":"652800","name":"尉犁县","value":"652823"},{"parent":"652800","name":"若羌县","value":"652824"},{"parent":"652800","name":"且末县","value":"652825"},{"parent":"652800","name":"焉耆回族自治县","value":"652826"},{"parent":"652800","name":"和静县","value":"652827"},{"parent":"652800","name":"和硕县","value":"652828"},{"parent":"652800","name":"博湖县","value":"652829"},{"parent":"652800","name":"其它区","value":"652830"},{"parent":"650000","name":"阿克苏地区","value":"652900"},{"parent":"652900","name":"阿克苏市","value":"652901"},{"parent":"652900","name":"温宿县","value":"652922"},{"parent":"652900","name":"库车县","value":"652923"},{"parent":"652900","name":"沙雅县","value":"652924"},{"parent":"652900","name":"新和县","value":"652925"},{"parent":"652900","name":"拜城县","value":"652926"},{"parent":"652900","name":"乌什县","value":"652927"},{"parent":"652900","name":"阿瓦提县","value":"652928"},{"parent":"652900","name":"柯坪县","value":"652929"},{"parent":"652900","name":"其它区","value":"652930"},{"parent":"650000","name":"克孜勒苏柯尔克孜自治州","value":"653000"},{"parent":"653000","name":"阿图什市","value":"653001"},{"parent":"653000","name":"阿克陶县","value":"653022"},{"parent":"653000","name":"阿合奇县","value":"653023"},{"parent":"653000","name":"乌恰县","value":"653024"},{"parent":"653000","name":"其它区","value":"653025"},{"parent":"650000","name":"喀什地区","value":"653100"},{"parent":"653100","name":"喀什市","value":"653101"},{"parent":"653100","name":"疏附县","value":"653121"},{"parent":"653100","name":"疏勒县","value":"653122"},{"parent":"653100","name":"英吉沙县","value":"653123"},{"parent":"653100","name":"泽普县","value":"653124"},{"parent":"653100","name":"莎车县","value":"653125"},{"parent":"653100","name":"叶城县","value":"653126"},{"parent":"653100","name":"麦盖提县","value":"653127"},{"parent":"653100","name":"岳普湖县","value":"653128"},{"parent":"653100","name":"伽师县","value":"653129"},{"parent":"653100","name":"巴楚县","value":"653130"},{"parent":"653100","name":"塔什库尔干塔吉克自治县","value":"653131"},{"parent":"653100","name":"其它区","value":"653132"},{"parent":"650000","name":"和田地区","value":"653200"},{"parent":"653200","name":"和田市","value":"653201"},{"parent":"653200","name":"和田县","value":"653221"},{"parent":"653200","name":"墨玉县","value":"653222"},{"parent":"653200","name":"皮山县","value":"653223"},{"parent":"653200","name":"洛浦县","value":"653224"},{"parent":"653200","name":"策勒县","value":"653225"},{"parent":"653200","name":"于田县","value":"653226"},{"parent":"653200","name":"民丰县","value":"653227"},{"parent":"653200","name":"其它区","value":"653228"},{"parent":"650000","name":"伊犁哈萨克自治州","value":"654000"},{"parent":"654000","name":"伊宁市","value":"654002"},{"parent":"654000","name":"奎屯市","value":"654003"},{"parent":"654000","name":"霍尔果斯市","value":"654004"},{"parent":"654000","name":"伊宁县","value":"654021"},{"parent":"654000","name":"察布查尔锡伯自治县","value":"654022"},{"parent":"654000","name":"霍城县","value":"654023"},{"parent":"654000","name":"巩留县","value":"654024"},{"parent":"654000","name":"新源县","value":"654025"},{"parent":"654000","name":"昭苏县","value":"654026"},{"parent":"654000","name":"特克斯县","value":"654027"},{"parent":"654000","name":"尼勒克县","value":"654028"},{"parent":"654000","name":"其它区","value":"654029"},{"parent":"650000","name":"塔城地区","value":"654200"},{"parent":"654200","name":"塔城市","value":"654201"},{"parent":"654200","name":"乌苏市","value":"654202"},{"parent":"654200","name":"额敏县","value":"654221"},{"parent":"654200","name":"沙湾县","value":"654223"},{"parent":"654200","name":"托里县","value":"654224"},{"parent":"654200","name":"裕民县","value":"654225"},{"parent":"654200","name":"和布克赛尔蒙古自治县","value":"654226"},{"parent":"654200","name":"其它区","value":"654227"},{"parent":"650000","name":"阿勒泰地区","value":"654300"},{"parent":"654300","name":"阿勒泰市","value":"654301"},{"parent":"654300","name":"布尔津县","value":"654321"},{"parent":"654300","name":"富蕴县","value":"654322"},{"parent":"654300","name":"福海县","value":"654323"},{"parent":"654300","name":"哈巴河县","value":"654324"},{"parent":"654300","name":"青河县","value":"654325"},{"parent":"654300","name":"吉木乃县","value":"654326"},{"parent":"654300","name":"其它区","value":"654327"},{"parent":"650000","name":"可克达拉市","value":"659000"},{"parent":"659000","name":"双河市","value":"659007"},{"parent":"659000","name":"可克达拉市","value":"659008"},{"parent":"650000","name":"石河子市","value":"659001"},{"parent":"650000","name":"阿拉尔市","value":"659002"},{"parent":"650000","name":"图木舒克市","value":"659003"},{"parent":"650000","name":"五家渠市","value":"659004"},{"parent":"650000","name":"北屯市","value":"659005"},{"parent":"650000","name":"铁门关市","value":"659006"},{"parent":"650000","name":"昆玉市","value":"659009"},{"name":"台湾","value":"710000"},{"parent":"710000","name":"台北市","value":"710100"},{"parent":"710100","name":"中正区","value":"710101"},{"parent":"710100","name":"大同区","value":"710102"},{"parent":"710100","name":"中山区","value":"710103"},{"parent":"710100","name":"松山区","value":"710104"},{"parent":"710100","name":"大安区","value":"710105"},{"parent":"710100","name":"万华区","value":"710106"},{"parent":"710100","name":"信义区","value":"710107"},{"parent":"710100","name":"士林区","value":"710108"},{"parent":"710100","name":"北投区","value":"710109"},{"parent":"710100","name":"内湖区","value":"710110"},{"parent":"710100","name":"南港区","value":"710111"},{"parent":"710100","name":"文山区","value":"710112"},{"parent":"710100","name":"其它区","value":"710113"},{"parent":"710000","name":"高雄市","value":"710200"},{"parent":"710200","name":"新兴区","value":"710201"},{"parent":"710200","name":"前金区","value":"710202"},{"parent":"710200","name":"芩雅区","value":"710203"},{"parent":"710200","name":"盐埕区","value":"710204"},{"parent":"710200","name":"鼓山区","value":"710205"},{"parent":"710200","name":"旗津区","value":"710206"},{"parent":"710200","name":"前镇区","value":"710207"},{"parent":"710200","name":"三民区","value":"710208"},{"parent":"710200","name":"左营区","value":"710209"},{"parent":"710200","name":"楠梓区","value":"710210"},{"parent":"710200","name":"小港区","value":"710211"},{"parent":"710200","name":"其它区","value":"710212"},{"parent":"710200","name":"苓雅区","value":"710241"},{"parent":"710200","name":"仁武区","value":"710242"},{"parent":"710200","name":"大社区","value":"710243"},{"parent":"710200","name":"冈山区","value":"710244"},{"parent":"710200","name":"路竹区","value":"710245"},{"parent":"710200","name":"阿莲区","value":"710246"},{"parent":"710200","name":"田寮区","value":"710247"},{"parent":"710200","name":"燕巢区","value":"710248"},{"parent":"710200","name":"桥头区","value":"710249"},{"parent":"710200","name":"梓官区","value":"710250"},{"parent":"710200","name":"弥陀区","value":"710251"},{"parent":"710200","name":"永安区","value":"710252"},{"parent":"710200","name":"湖内区","value":"710253"},{"parent":"710200","name":"凤山区","value":"710254"},{"parent":"710200","name":"大寮区","value":"710255"},{"parent":"710200","name":"林园区","value":"710256"},{"parent":"710200","name":"鸟松区","value":"710257"},{"parent":"710200","name":"大树区","value":"710258"},{"parent":"710200","name":"旗山区","value":"710259"},{"parent":"710200","name":"美浓区","value":"710260"},{"parent":"710200","name":"六龟区","value":"710261"},{"parent":"710200","name":"内门区","value":"710262"},{"parent":"710200","name":"杉林区","value":"710263"},{"parent":"710200","name":"甲仙区","value":"710264"},{"parent":"710200","name":"桃源区","value":"710265"},{"parent":"710200","name":"那玛夏区","value":"710266"},{"parent":"710200","name":"茂林区","value":"710267"},{"parent":"710200","name":"茄萣区","value":"710268"},{"parent":"710000","name":"台南市","value":"710300"},{"parent":"710300","name":"中西区","value":"710301"},{"parent":"710300","name":"东区","value":"710302"},{"parent":"710300","name":"南区","value":"710303"},{"parent":"710300","name":"北区","value":"710304"},{"parent":"710300","name":"安平区","value":"710305"},{"parent":"710300","name":"安南区","value":"710306"},{"parent":"710300","name":"其它区","value":"710307"},{"parent":"710300","name":"永康区","value":"710339"},{"parent":"710300","name":"归仁区","value":"710340"},{"parent":"710300","name":"新化区","value":"710341"},{"parent":"710300","name":"左镇区","value":"710342"},{"parent":"710300","name":"玉井区","value":"710343"},{"parent":"710300","name":"楠西区","value":"710344"},{"parent":"710300","name":"南化区","value":"710345"},{"parent":"710300","name":"仁德区","value":"710346"},{"parent":"710300","name":"关庙区","value":"710347"},{"parent":"710300","name":"龙崎区","value":"710348"},{"parent":"710300","name":"官田区","value":"710349"},{"parent":"710300","name":"麻豆区","value":"710350"},{"parent":"710300","name":"佳里区","value":"710351"},{"parent":"710300","name":"西港区","value":"710352"},{"parent":"710300","name":"七股区","value":"710353"},{"parent":"710300","name":"将军区","value":"710354"},{"parent":"710300","name":"学甲区","value":"710355"},{"parent":"710300","name":"北门区","value":"710356"},{"parent":"710300","name":"新营区","value":"710357"},{"parent":"710300","name":"后壁区","value":"710358"},{"parent":"710300","name":"白河区","value":"710359"},{"parent":"710300","name":"东山区","value":"710360"},{"parent":"710300","name":"六甲区","value":"710361"},{"parent":"710300","name":"下营区","value":"710362"},{"parent":"710300","name":"柳营区","value":"710363"},{"parent":"710300","name":"盐水区","value":"710364"},{"parent":"710300","name":"善化区","value":"710365"},{"parent":"710300","name":"大内区","value":"710366"},{"parent":"710300","name":"山上区","value":"710367"},{"parent":"710300","name":"新市区","value":"710368"},{"parent":"710300","name":"安定区","value":"710369"},{"parent":"710000","name":"台中市","value":"710400"},{"parent":"710400","name":"中区","value":"710401"},{"parent":"710400","name":"东区","value":"710402"},{"parent":"710400","name":"南区","value":"710403"},{"parent":"710400","name":"西区","value":"710404"},{"parent":"710400","name":"北区","value":"710405"},{"parent":"710400","name":"北屯区","value":"710406"},{"parent":"710400","name":"西屯区","value":"710407"},{"parent":"710400","name":"南屯区","value":"710408"},{"parent":"710400","name":"其它区","value":"710409"},{"parent":"710400","name":"太平区","value":"710431"},{"parent":"710400","name":"大里区","value":"710432"},{"parent":"710400","name":"雾峰区","value":"710433"},{"parent":"710400","name":"乌日区","value":"710434"},{"parent":"710400","name":"丰原区","value":"710435"},{"parent":"710400","name":"后里区","value":"710436"},{"parent":"710400","name":"石冈区","value":"710437"},{"parent":"710400","name":"东势区","value":"710438"},{"parent":"710400","name":"和平区","value":"710439"},{"parent":"710400","name":"新社区","value":"710440"},{"parent":"710400","name":"潭子区","value":"710441"},{"parent":"710400","name":"大雅区","value":"710442"},{"parent":"710400","name":"神冈区","value":"710443"},{"parent":"710400","name":"大肚区","value":"710444"},{"parent":"710400","name":"沙鹿区","value":"710445"},{"parent":"710400","name":"龙井区","value":"710446"},{"parent":"710400","name":"梧栖区","value":"710447"},{"parent":"710400","name":"清水区","value":"710448"},{"parent":"710400","name":"大甲区","value":"710449"},{"parent":"710400","name":"外埔区","value":"710450"},{"parent":"710400","name":"大安区","value":"710451"},{"parent":"710000","name":"金门县","value":"710500"},{"parent":"710500","name":"金沙镇","value":"710507"},{"parent":"710500","name":"金湖镇","value":"710508"},{"parent":"710500","name":"金宁乡","value":"710509"},{"parent":"710500","name":"金城镇","value":"710510"},{"parent":"710500","name":"烈屿乡","value":"710511"},{"parent":"710500","name":"乌坵乡","value":"710512"},{"parent":"710000","name":"南投县","value":"710600"},{"parent":"710600","name":"南投市","value":"710614"},{"parent":"710600","name":"中寮乡","value":"710615"},{"parent":"710600","name":"草屯镇","value":"710616"},{"parent":"710600","name":"国姓乡","value":"710617"},{"parent":"710600","name":"埔里镇","value":"710618"},{"parent":"710600","name":"仁爱乡","value":"710619"},{"parent":"710600","name":"名间乡","value":"710620"},{"parent":"710600","name":"集集镇","value":"710621"},{"parent":"710600","name":"水里乡","value":"710622"},{"parent":"710600","name":"鱼池乡","value":"710623"},{"parent":"710600","name":"信义乡","value":"710624"},{"parent":"710600","name":"竹山镇","value":"710625"},{"parent":"710600","name":"鹿谷乡","value":"710626"},{"parent":"710000","name":"基隆市","value":"710700"},{"parent":"710700","name":"仁爱区","value":"710701"},{"parent":"710700","name":"信义区","value":"710702"},{"parent":"710700","name":"中正区","value":"710703"},{"parent":"710700","name":"中山区","value":"710704"},{"parent":"710700","name":"安乐区","value":"710705"},{"parent":"710700","name":"暖暖区","value":"710706"},{"parent":"710700","name":"七堵区","value":"710707"},{"parent":"710700","name":"其它区","value":"710708"},{"parent":"710000","name":"新竹市","value":"710800"},{"parent":"710800","name":"东区","value":"710801"},{"parent":"710800","name":"北区","value":"710802"},{"parent":"710800","name":"香山区","value":"710803"},{"parent":"710800","name":"其它区","value":"710804"},{"parent":"710000","name":"嘉义市","value":"710900"},{"parent":"710900","name":"东区","value":"710901"},{"parent":"710900","name":"西区","value":"710902"},{"parent":"710900","name":"其它区","value":"710903"},{"parent":"710000","name":"新北市","value":"711100"},{"parent":"711100","name":"万里区","value":"711130"},{"parent":"711100","name":"金山区","value":"711131"},{"parent":"711100","name":"板桥区","value":"711132"},{"parent":"711100","name":"汐止区","value":"711133"},{"parent":"711100","name":"深坑区","value":"711134"},{"parent":"711100","name":"石碇区","value":"711135"},{"parent":"711100","name":"瑞芳区","value":"711136"},{"parent":"711100","name":"平溪区","value":"711137"},{"parent":"711100","name":"双溪区","value":"711138"},{"parent":"711100","name":"贡寮区","value":"711139"},{"parent":"711100","name":"新店区","value":"711140"},{"parent":"711100","name":"坪林区","value":"711141"},{"parent":"711100","name":"乌来区","value":"711142"},{"parent":"711100","name":"永和区","value":"711143"},{"parent":"711100","name":"中和区","value":"711144"},{"parent":"711100","name":"土城区","value":"711145"},{"parent":"711100","name":"三峡区","value":"711146"},{"parent":"711100","name":"树林区","value":"711147"},{"parent":"711100","name":"莺歌区","value":"711148"},{"parent":"711100","name":"三重区","value":"711149"},{"parent":"711100","name":"新庄区","value":"711150"},{"parent":"711100","name":"泰山区","value":"711151"},{"parent":"711100","name":"林口区","value":"711152"},{"parent":"711100","name":"芦洲区","value":"711153"},{"parent":"711100","name":"五股区","value":"711154"},{"parent":"711100","name":"八里区","value":"711155"},{"parent":"711100","name":"淡水区","value":"711156"},{"parent":"711100","name":"三芝区","value":"711157"},{"parent":"711100","name":"石门区","value":"711158"},{"parent":"710000","name":"宜兰县","value":"711200"},{"parent":"711200","name":"宜兰市","value":"711214"},{"parent":"711200","name":"头城镇","value":"711215"},{"parent":"711200","name":"礁溪乡","value":"711216"},{"parent":"711200","name":"壮围乡","value":"711217"},{"parent":"711200","name":"员山乡","value":"711218"},{"parent":"711200","name":"罗东镇","value":"711219"},{"parent":"711200","name":"三星乡","value":"711220"},{"parent":"711200","name":"大同乡","value":"711221"},{"parent":"711200","name":"五结乡","value":"711222"},{"parent":"711200","name":"冬山乡","value":"711223"},{"parent":"711200","name":"苏澳镇","value":"711224"},{"parent":"711200","name":"南澳乡","value":"711225"},{"parent":"711200","name":"钓鱼台","value":"711226"},{"parent":"710000","name":"新竹县","value":"711300"},{"parent":"711300","name":"竹北市","value":"711314"},{"parent":"711300","name":"湖口乡","value":"711315"},{"parent":"711300","name":"新丰乡","value":"711316"},{"parent":"711300","name":"新埔镇","value":"711317"},{"parent":"711300","name":"关西镇","value":"711318"},{"parent":"711300","name":"芎林乡","value":"711319"},{"parent":"711300","name":"宝山乡","value":"711320"},{"parent":"711300","name":"竹东镇","value":"711321"},{"parent":"711300","name":"五峰乡","value":"711322"},{"parent":"711300","name":"横山乡","value":"711323"},{"parent":"711300","name":"尖石乡","value":"711324"},{"parent":"711300","name":"北埔乡","value":"711325"},{"parent":"711300","name":"峨眉乡","value":"711326"},{"parent":"710000","name":"桃园县","value":"711400"},{"parent":"711400","name":"中坜市","value":"711414"},{"parent":"711400","name":"平镇市","value":"711415"},{"parent":"711400","name":"龙潭乡","value":"711416"},{"parent":"711400","name":"杨梅市","value":"711417"},{"parent":"711400","name":"新屋乡","value":"711418"},{"parent":"711400","name":"观音乡","value":"711419"},{"parent":"711400","name":"桃园市","value":"711420"},{"parent":"711400","name":"龟山乡","value":"711421"},{"parent":"711400","name":"八德市","value":"711422"},{"parent":"711400","name":"大溪镇","value":"711423"},{"parent":"711400","name":"复兴乡","value":"711424"},{"parent":"711400","name":"大园乡","value":"711425"},{"parent":"711400","name":"芦竹乡","value":"711426"},{"parent":"710000","name":"苗栗县","value":"711500"},{"parent":"711500","name":"竹南镇","value":"711519"},{"parent":"711500","name":"头份镇","value":"711520"},{"parent":"711500","name":"三湾乡","value":"711521"},{"parent":"711500","name":"南庄乡","value":"711522"},{"parent":"711500","name":"狮潭乡","value":"711523"},{"parent":"711500","name":"后龙镇","value":"711524"},{"parent":"711500","name":"通霄镇","value":"711525"},{"parent":"711500","name":"苑里镇","value":"711526"},{"parent":"711500","name":"苗栗市","value":"711527"},{"parent":"711500","name":"造桥乡","value":"711528"},{"parent":"711500","name":"头屋乡","value":"711529"},{"parent":"711500","name":"公馆乡","value":"711530"},{"parent":"711500","name":"大湖乡","value":"711531"},{"parent":"711500","name":"泰安乡","value":"711532"},{"parent":"711500","name":"铜锣乡","value":"711533"},{"parent":"711500","name":"三义乡","value":"711534"},{"parent":"711500","name":"西湖乡","value":"711535"},{"parent":"711500","name":"卓兰镇","value":"711536"},{"parent":"710000","name":"彰化县","value":"711700"},{"parent":"711700","name":"彰化市","value":"711727"},{"parent":"711700","name":"芬园乡","value":"711728"},{"parent":"711700","name":"花坛乡","value":"711729"},{"parent":"711700","name":"秀水乡","value":"711730"},{"parent":"711700","name":"鹿港镇","value":"711731"},{"parent":"711700","name":"福兴乡","value":"711732"},{"parent":"711700","name":"线西乡","value":"711733"},{"parent":"711700","name":"和美镇","value":"711734"},{"parent":"711700","name":"伸港乡","value":"711735"},{"parent":"711700","name":"员林镇","value":"711736"},{"parent":"711700","name":"社头乡","value":"711737"},{"parent":"711700","name":"永靖乡","value":"711738"},{"parent":"711700","name":"埔心乡","value":"711739"},{"parent":"711700","name":"溪湖镇","value":"711740"},{"parent":"711700","name":"大村乡","value":"711741"},{"parent":"711700","name":"埔盐乡","value":"711742"},{"parent":"711700","name":"田中镇","value":"711743"},{"parent":"711700","name":"北斗镇","value":"711744"},{"parent":"711700","name":"田尾乡","value":"711745"},{"parent":"711700","name":"埤头乡","value":"711746"},{"parent":"711700","name":"溪州乡","value":"711747"},{"parent":"711700","name":"竹塘乡","value":"711748"},{"parent":"711700","name":"二林镇","value":"711749"},{"parent":"711700","name":"大城乡","value":"711750"},{"parent":"711700","name":"芳苑乡","value":"711751"},{"parent":"711700","name":"二水乡","value":"711752"},{"parent":"710000","name":"嘉义县","value":"711900"},{"parent":"711900","name":"番路乡","value":"711919"},{"parent":"711900","name":"梅山乡","value":"711920"},{"parent":"711900","name":"竹崎乡","value":"711921"},{"parent":"711900","name":"阿里山乡","value":"711922"},{"parent":"711900","name":"中埔乡","value":"711923"},{"parent":"711900","name":"大埔乡","value":"711924"},{"parent":"711900","name":"水上乡","value":"711925"},{"parent":"711900","name":"鹿草乡","value":"711926"},{"parent":"711900","name":"太保市","value":"711927"},{"parent":"711900","name":"朴子市","value":"711928"},{"parent":"711900","name":"东石乡","value":"711929"},{"parent":"711900","name":"六脚乡","value":"711930"},{"parent":"711900","name":"新港乡","value":"711931"},{"parent":"711900","name":"民雄乡","value":"711932"},{"parent":"711900","name":"大林镇","value":"711933"},{"parent":"711900","name":"溪口乡","value":"711934"},{"parent":"711900","name":"义竹乡","value":"711935"},{"parent":"711900","name":"布袋镇","value":"711936"},{"parent":"710000","name":"云林县","value":"712100"},{"parent":"712100","name":"斗南镇","value":"712121"},{"parent":"712100","name":"大埤乡","value":"712122"},{"parent":"712100","name":"虎尾镇","value":"712123"},{"parent":"712100","name":"土库镇","value":"712124"},{"parent":"712100","name":"褒忠乡","value":"712125"},{"parent":"712100","name":"东势乡","value":"712126"},{"parent":"712100","name":"台西乡","value":"712127"},{"parent":"712100","name":"仑背乡","value":"712128"},{"parent":"712100","name":"麦寮乡","value":"712129"},{"parent":"712100","name":"斗六市","value":"712130"},{"parent":"712100","name":"林内乡","value":"712131"},{"parent":"712100","name":"古坑乡","value":"712132"},{"parent":"712100","name":"莿桐乡","value":"712133"},{"parent":"712100","name":"西螺镇","value":"712134"},{"parent":"712100","name":"二仑乡","value":"712135"},{"parent":"712100","name":"北港镇","value":"712136"},{"parent":"712100","name":"水林乡","value":"712137"},{"parent":"712100","name":"口湖乡","value":"712138"},{"parent":"712100","name":"四湖乡","value":"712139"},{"parent":"712100","name":"元长乡","value":"712140"},{"parent":"710000","name":"屏东县","value":"712400"},{"parent":"712400","name":"屏东市","value":"712434"},{"parent":"712400","name":"三地门乡","value":"712435"},{"parent":"712400","name":"雾台乡","value":"712436"},{"parent":"712400","name":"玛家乡","value":"712437"},{"parent":"712400","name":"九如乡","value":"712438"},{"parent":"712400","name":"里港乡","value":"712439"},{"parent":"712400","name":"高树乡","value":"712440"},{"parent":"712400","name":"盐埔乡","value":"712441"},{"parent":"712400","name":"长治乡","value":"712442"},{"parent":"712400","name":"麟洛乡","value":"712443"},{"parent":"712400","name":"竹田乡","value":"712444"},{"parent":"712400","name":"内埔乡","value":"712445"},{"parent":"712400","name":"万丹乡","value":"712446"},{"parent":"712400","name":"潮州镇","value":"712447"},{"parent":"712400","name":"泰武乡","value":"712448"},{"parent":"712400","name":"来义乡","value":"712449"},{"parent":"712400","name":"万峦乡","value":"712450"},{"parent":"712400","name":"崁顶乡","value":"712451"},{"parent":"712400","name":"新埤乡","value":"712452"},{"parent":"712400","name":"南州乡","value":"712453"},{"parent":"712400","name":"林边乡","value":"712454"},{"parent":"712400","name":"东港镇","value":"712455"},{"parent":"712400","name":"琉球乡","value":"712456"},{"parent":"712400","name":"佳冬乡","value":"712457"},{"parent":"712400","name":"新园乡","value":"712458"},{"parent":"712400","name":"枋寮乡","value":"712459"},{"parent":"712400","name":"枋山乡","value":"712460"},{"parent":"712400","name":"春日乡","value":"712461"},{"parent":"712400","name":"狮子乡","value":"712462"},{"parent":"712400","name":"车城乡","value":"712463"},{"parent":"712400","name":"牡丹乡","value":"712464"},{"parent":"712400","name":"恒春镇","value":"712465"},{"parent":"712400","name":"满州乡","value":"712466"},{"parent":"710000","name":"台东县","value":"712500"},{"parent":"712500","name":"台东市","value":"712517"},{"parent":"712500","name":"绿岛乡","value":"712518"},{"parent":"712500","name":"兰屿乡","value":"712519"},{"parent":"712500","name":"延平乡","value":"712520"},{"parent":"712500","name":"卑南乡","value":"712521"},{"parent":"712500","name":"鹿野乡","value":"712522"},{"parent":"712500","name":"关山镇","value":"712523"},{"parent":"712500","name":"海端乡","value":"712524"},{"parent":"712500","name":"池上乡","value":"712525"},{"parent":"712500","name":"东河乡","value":"712526"},{"parent":"712500","name":"成功镇","value":"712527"},{"parent":"712500","name":"长滨乡","value":"712528"},{"parent":"712500","name":"金峰乡","value":"712529"},{"parent":"712500","name":"大武乡","value":"712530"},{"parent":"712500","name":"达仁乡","value":"712531"},{"parent":"712500","name":"太麻里乡","value":"712532"},{"parent":"710000","name":"花莲县","value":"712600"},{"parent":"712600","name":"花莲市","value":"712615"},{"parent":"712600","name":"新城乡","value":"712616"},{"parent":"712600","name":"太鲁阁","value":"712617"},{"parent":"712600","name":"秀林乡","value":"712618"},{"parent":"712600","name":"吉安乡","value":"712619"},{"parent":"712600","name":"寿丰乡","value":"712620"},{"parent":"712600","name":"凤林镇","value":"712621"},{"parent":"712600","name":"光复乡","value":"712622"},{"parent":"712600","name":"丰滨乡","value":"712623"},{"parent":"712600","name":"瑞穗乡","value":"712624"},{"parent":"712600","name":"万荣乡","value":"712625"},{"parent":"712600","name":"玉里镇","value":"712626"},{"parent":"712600","name":"卓溪乡","value":"712627"},{"parent":"712600","name":"富里乡","value":"712628"},{"parent":"710000","name":"澎湖县","value":"712700"},{"parent":"712700","name":"马公市","value":"712707"},{"parent":"712700","name":"西屿乡","value":"712708"},{"parent":"712700","name":"望安乡","value":"712709"},{"parent":"712700","name":"七美乡","value":"712710"},{"parent":"712700","name":"白沙乡","value":"712711"},{"parent":"712700","name":"湖西乡","value":"712712"},{"parent":"710000","name":"连江县","value":"712800"},{"parent":"712800","name":"南竿乡","value":"712805"},{"parent":"712800","name":"北竿乡","value":"712806"},{"parent":"712800","name":"莒光乡","value":"712807"},{"parent":"712800","name":"东引乡","value":"712808"},{"name":"香港特别行政区","value":"810000"},{"parent":"810000","name":"香港岛","value":"810100"},{"parent":"810100","name":"中西区","value":"810101"},{"parent":"810100","name":"湾仔","value":"810102"},{"parent":"810100","name":"东区","value":"810103"},{"parent":"810100","name":"南区","value":"810104"},{"parent":"810000","name":"九龙","value":"810200"},{"parent":"810200","name":"九龙城区","value":"810201"},{"parent":"810200","name":"油尖旺区","value":"810202"},{"parent":"810200","name":"深水埗区","value":"810203"},{"parent":"810200","name":"黄大仙区","value":"810204"},{"parent":"810200","name":"观塘区","value":"810205"},{"parent":"810000","name":"新界","value":"810300"},{"parent":"810300","name":"北区","value":"810301"},{"parent":"810300","name":"大埔区","value":"810302"},{"parent":"810300","name":"沙田区","value":"810303"},{"parent":"810300","name":"西贡区","value":"810304"},{"parent":"810300","name":"元朗区","value":"810305"},{"parent":"810300","name":"屯门区","value":"810306"},{"parent":"810300","name":"荃湾区","value":"810307"},{"parent":"810300","name":"葵青区","value":"810308"},{"parent":"810300","name":"离岛区","value":"810309"},{"name":"澳门特别行政区","value":"820000"},{"parent":"820000","name":"澳门半岛","value":"820100"},{"parent":"820000","name":"离岛","value":"820200"},{"name":"海外","value":"990000"},{"parent":"990000","name":"海外","value":"990100"}]

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ers8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6AT+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAgCAMAAACvkzHFAAAAtFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////oK74hAAAAO3RSTlMA/PgGoALvzAnru4ZaEPPZklNJFtPDv7GYc2xoQj0uJN+2fzcpIR0Np46Ke2JOGhLnyK2rOjPj4l53Rus1YCAAAAHKSURBVDjLhZPncuMwDIRBVavLluUuy733kuRu3/+9DuTFocdxnO8HByAXELEc0U9E/YheUekFroCw5vQc+9r2DcBopEcMnwlmm4UHFohahdUNTD73zcsobyrBKpHnVpi1MCYmRJsU83cwfaJxDKfZcQVftYo1MdntY6aVVjuyIBEbk2iELdFeNNRZ3TDpxo4LSpxlWCDl1TUqMlmip+9aj80SlmobJ7wGqMmkhkBrUhS2N1BhEzOiHpbKJ8PVmi0XnFHKsIMNdzPqar8h9l+auXGkLroynGDBq49MJmtUdaNcRFOcVPjmbdMECGU8RktrRlwwcGwZWoA0aqYexhlozYULbu7mo8uXLSdM9Us6iXL3Eb6kTpqYSncfKbHQCY+s3H3AhK8THlm5+0AHK9K8e/Z/dzX9tg9nRhoLV3ZXP/OHdQCQ9+mOEH9oiFK5vk3rAA7Wx46zuztm8Fnn/u2NcgHEw3ZfbobWm7hqkesR28iIY1CYXF9bym6eFd1NJocqglWV9+zxumEAsc/dnlJ2Tw4g3KD3za5JHvtTmqcDAINWdU/fsRMkcKmAd+5O6Tk7NMlHRJn94h93vJVzoNeEBuIa/UJWRM8P/gHMkzLpbrikTgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "6vAA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACMklEQVRoge2ZP2gUQRSHv907Y/wTixTaiCIIStBoYxVsYimIYBBsLKwF0UpBREttFBQMBBOxtE6tvSAExHSCiBAEiZgceMTcPHl3k2Rvub3dObPZXZgPjt2ZeW/u99t9d7M3h8fzfwQrS0tZJrgKTO3wtZ4G3qUFZTFwFPgEjGybtGx8B8aBX/2iw5SpAmC2APHKYeBZWlCagZvA5PZpcuY6cLlfUr8SOg4sAPsKNKD8AE4BP3sNJt2BGvC6BOKVQ8DLpMEkA7eBifw0OaPfgNd6JfUqoTHgIzBcIgPKsi2lLsHxO1C3pVM28cooMBPvjBu4B5zbOU3OXARuRJOiJXQG+AAMldiAsgKcBr5pI6w1FrGi31RAvHLALq7B4vun7ZpXHiBmHCQhRzYPSRGJIxI9Tc7eiu0dE+u9UKsN6SL7PGh8XZhiffUtrWYgIogYOsfouT0aExvv9CGmO4atttnMMYiJzrvRNphYuytGBNpzdvraF1GEXcMjZvf+g5fqwd/lRyIm6H9pysfan9/hWnP1SQhysmriNxDTGgszPNCVmkqLxxsoAd5A0XgDRVMf4P3ngc856T6R9iM+jquBx8DdgeVlQ7dSbmUNdi2huRwEx5l2CXY1sGdgWdnZ6xLsauD+gJ+brOjcD10TXLgCfLG7Fus5iD8LHMvTgHLEvkqBX8iKxhsoGm+gaLyBolEDjQrrb4Z2o7SqvNJHiTuAblGfr8jutNKyfwW8KIEWT4UB/gHaSdzY++9ohwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7jhc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "82bl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9fs9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "B5zY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAYCAMAAADAi10DAAAAdVBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZkLL5WPAAAAJnRSTlMA7xAE+xqklK3j0sGeCs24mY1J2LJXOij0hH13bmIz6NzHh09DIsvUAPQAAADsSURBVBjTXc/rdoMgEATgQVZQBDXejbG5dt//EbuibU/y/WGUYTkgetXtpJwd8CutmF3XOeYsRfR1JRvjt6d8jJ1cvXB4TrdElo62EUnTbB8NGznGJ0A/iJlmDXgacSKZU3OxrsW2OfIZ7r41DaSaSQNtgckDM+03SgNZDqoBkyNSXrJCngGWAkRCMqxoUUnjyReIhRtoZXDZ1pKWND1TAfTcI1GlRupYlClCew2QmgV0b22vAcMrRCf/dtqz2UPGXh/B6GPTcCYxVFxrHHTNVQjxjf8sl45nvHkwLX+Hkt0wHAG48YcSd/Wh+gFh8xGEttd+TwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("RmeA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C3Yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CntB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D7TH":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAABAlBMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/y5+f8WB/8WB/8WB/y5+f8WB/8WB/y5+f8WB/8WB/y5+f8WB/8WB/8WB/y5+f7bDv6eUzy5+f00Mf4jmvy5+fy5+f8WB/y5+f1w7Ty5+fy5+fy5+f8WB/8WB/8WB/y5+fy5+fy5+f8WB/y5+f8WB/y5+f1xLX1vq36fFL7bDv7ZC/8XCXz2NL1tqL2r5nGKHygAAAAS3RSTlMAAwv58Oxz/MSMbD0G1rgVD/bz5HhPI+fh0b6slEhCKhnJkIVbSi3327WyraGblH5mUTYfHAbv6unev7umpJ+Kh3dvYmBeQzssGxmMZREoAAABxElEQVRIx92UaVfyMBCFL4W2dIFCKTsiKOK+67vvr3virv//r+hJU5oobfLZ59ucc9NzZ+ZO8RExPGur3DBtEnbGPyPPV6hPNupEIlz/byCLo0GJzCEcHGIetaUiyaC4VMM7mm2SQ2MFMv6AKHAKUrNVoqRqCPoy0aA8e1HYIDpUPHB2deTVtO0DW6mub0/Z5FvswVglb0cBc+6aZbYAhXw8ifM07L4WTQC5E7L7vNNWP54UcJgjLzktHhsniU0Lbrr+miWlac01AG6eJLjop6MIMO3Oql4zycJChaT0IVTLgO/YLJ5bU3AWq/L2IJyAaQAYdkh7d5Rm3n7TFsTKYo6PCoBoXgZinx0ulczLFNEQy1OkpOZFGuiJZRcJwWB+wnpYluoFMHyrlHV4GMofiM2vkSxWUJCP/4CZz8T08cZTx9rOOw8HQBASbUK20YhoE8X7/KSr7/pgfL3X05f4dRyvXj/o6ItDxFxQeqPxot4E54xSeq10ZXpI2KevPN4q/pOXmHFOGU93Oe26YvCPv9CY54wndSeAxP4q5dzMMVaxmFzi6t+vze+bP3Z2/vz9/e2zeOXr0SLUjLzJnmXtTbwRPiYvGOmAKpuWrCUAAAAASUVORK5CYII="

/***/ }),

/***/ "Drhy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EgD5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAA9lBMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/y5+f8WB/8WB/8WB/8WB/y5+fy5+fy5+fy5+fy5+f8WB/8WB/8WB/y5+f8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/y5+fy5+f8WB/y5+f8WB/8WB/y5+fy5+fy5+f8WB/y5+b8WB/y5+fy5+f8WB/8WB/y5+fy5+f8WB/8WB/8WB/8WB/8WB/8WB/5gVj5hV/8WB/8WB/8WB/8WB/y5+fy5+f8WB/8WB/y5+f7ZzT0yLz1u6r2r5n5hl/6dUf8Xify4+Ly4d/z19Hz19D0yb30yLv7ZTEm6T09AAAAQnRSTlMA/fij1uPIKh0MBfr048+1sq6aLyLp3MC7p3JRSjgpJBEN7uvU0J+ZkIqKhHh2XFxWVEpGPzwZFhXq6ZB3bGYxCgeA+D2OAAABoUlEQVRIx4WU1XLDMBBFFTdMduxQ0zAzU7mVwuX//5lO63HilVfyedycq1GuJBMn65HuTylKyq+P1sSdeSJCz0QScxe9mKUc2aLMzynUgZIT6uEmRWmGCc4VFXCF+10qpIv5eY844Mk7/ZCPSvCFHIE+ldLn/deaPFDjmxpTF27klUYajYi8Wh/8dUXICq7hg34ZW+0aDMsgYIDWl+ZwCU7GAIEFteG1pl77dAECBfdAAQRKYEtBcxgEWyrBmw0eQgL50wp3chkKEkFCgrAkP//WuOuZTnOX9wHoYL84JcKRlfsZwjNzu3sO/DLfiz1RWWAMVLRZtFOIISzKUyAo96KADjT3D0eqTATMPOJKcXT8Qykm5HX66RCRUFR4XzGIlCc+8Cj3A7076N/2niX6JM7Y29HuH98Zi08EekVjf3xsLv7P5/9Iq6B+nJlsT5Z/2jKT+AsSGDCLnRXYMYsBEtDYmb3p7y8TDQm02IWvw2Zz+LYNWlijUSYkGiAI06jQnxKUpIr7alJ80J0Yb8c6ASIlOWyr9ViVsWqsrraHjsV/Afw3MPfpEJcmAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Ej8a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G0MN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAFCAYAAADL2YVPAAAASElEQVQokcXSoRWAMBAE0QmaHpJi6BqTGF76iUMwvBO0wP0GdsSiVrWrj/+L3VbUEzjI0yNiAXtixL0BMzEgXN8nRsIfwlDbC6ssDdPtD5XrAAAAAElFTkSuQmCC"

/***/ }),

/***/ "GYvt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAAApCAMAAADktvBNAAAA5FBMVEUAAAD//////////v7//v7////////+/v7////////////////////////////////////////8/Pv////////////////////////9/Pz////8+fn////////////////////////////////////////////////////////////////////////////////////////////////////////////+/f3//v7////////////////////////////+/v7///+eXVr////////////07Ozy6OijZ1/y6+r////////foF9qAAAAS3RSTlMACwUDE8f7AQgvltei9z7u4n0YENQy2sSdRLsOgin06cpGvqxIQDXm0adsWoZYHIlQTN63snVwYGggmFLxYzuOJSIIzZose2AUlnuPvYvlAAAGP0lEQVRYw7WY6XqiMBRA2Qy4RFCsglawUjeqtOKCWreOnc5y3/99BkYgILGzdOb8ITdNv5zcXALCnPn09evX4EqiTwyVT6l+Erw3ShTfHyMmhn8iY3nPdTtsHHo1d55nKFSfD73EDEJF55gsXNuucAmnsu1kxgj3i8LxPHfZLtzxYTe7WrWjNm8DmC0mYmnAqc9kUR8H6FUgse7WPPJfRGJumGUSS2O5lFlie4a23nkJBwSvUuTa2M58V5HzkZa+lMBFLHypPRfApJA8GUxdjPO7wEhTs+7tEUYl4i50wXhiLpBsGYUqeRfcaLQzgFOVYb6UAjoAeFSK6CCQZ0FDq5IdlnxaOwNKqhSytsC896+ceJEqx0Iu0cgbMMvms2WhbvucqqWB78LePuAd70uNAk4A2BpFnHypZtAoEal+ZexzGIJxGIdoA1CCq71OGgU4c6QJ4hluDMU9H7TSVnmlGKo4JbyIco/mTuDJBgTbV2Ujgu3rBQ1JJPVT8qWD5GmbTQOD3LViDm0mZr18DJgjZfN45lCHWiFoVKrp22Ese+E6npRS2DcrTnnm9wtdqvoIPqqqVjB09GqMwCXqadONGSLAHRJaaybFS2cZCrBaM5xktJBIwexMs0akVq7ZvGGuIh0A5lWGCi+xMRMZzD0JE2lnVH911aMjhLysw4YTdEXjhHy+zZP75XP+yF6XepkDKvDML3n2pehr4w6568xZhl3dXmdPnbpcA8NmPiQ1A5hVaFgIlBZTzSHk0oQ7W4SWXPKcjlhgkB/aMeu/k1pIPIUH46dUB/CCpSB0AJJSTk0JMQAMJcadpQ8pUlQP6Zq6lOJoupNYyqauJpeWkvT7MzsD0Pd7wj79eLzVIroY8DyONuyllHDTv6CalBLVDKxEpFLwEwDXYa7hjEsRP6XiSMtI6d3OBRM+IeU0c7lGAr+kFuoVKakJcCD9GWdViPC2YPaEGDGxx/unp6PoPE8ID48YzKnoTJ/uuLPUyxaQViEUATbCFak7A+Qe1Yde6FTODx2ewPU7SLGl8C+CVa95gVSZIcwDKate9/i4VMq9kBmC06SXos/+vhQdvtdAihenQNpP79c0KXU/na7jlE+HtTNFDCAXg4ZP2Ddrf1Qq30CyfbEtVKn0TVU+89QEVOr5jV4TgWGfOxOZ4hIEj5l+skO85vQ5cGKZP5IiiM8KFF/OtbWl1Bx72yQED+RcIi60r+yd7zRYsszfSq0bID+HOSkBFI9MGmlVIMwwYCsRLxy6076LBjuJoUnZZULjipT0iFBBim7rAaDoRPxITR27yFhIlASYGLtFgoxxoUVZ00pG82NsOMawXUofleI9BHWBloGyfkmby47yFNTct9h4KSMErsd9VGoFUGOZv0Syle1op2njqOhfHmVi9UdSzuSBoAEou0Q8+bkXrXaexkURc57ifnd2AMXoPrbkbUmG+oOYGHRzR7g1QLYTcT+uCP1UJJgAuJ6Ih18Yn3K3VhumCY7KUeosECruXGcZIsXvEAzWz02s2KT8Wps6YYAAKYnY+syEqHnCzSNAfZ9P8LPApgMwbp9STGYAudRRsmlOWJFJSq0ABi1etU/uYR2Pe7khVBAYlUTcZqk1ZWdqKpSS79Nd7GtaqrV4DtKRlQq2bL/YUT8p3ALgceoU/7dSvBruom8yTEsFUFOgzgDAEv6XFIFbAGpmpOjcyABQv///UmwBUOH3pKQRAAakCb+SWgIMPyRVPQG++y0pzjPALMgg7/hfSFUAGh+REqcYikL0eHhPir+rAS44BYCi/r4UdwAoSVSpKZdC1ahS1Rxgmw8F9XekeD2HkHUU1zMEwz7/rpQFYPM0KVRrpMgNADqZgcIrwiOHIR+4zCtSrQcF4dlaDI59DPWdylynpUDtc7b7yQSlcMHcgGHmXUwzsHZMvMdg7FCn2b9iVB8L4e/AOhhamb0qdWeYtFeNiYFuMy+oTajz6TRPm9j0z25Cv4HvKdtRPgzx4HXKRu7TkoKG47J0ZfcKxqNDe3cwtGpmrD50k518vlB3C3orPX1uk/kwvLJqynzZF8TEY7NvW0rRWh1p5375NBaoRfmlReldvyWl2m9vuiplPm6+sRfr+/bm6YLEZb5aVXXv7RtlHu6Lnk3hDztKL1w7Q9eaAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Gbqg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Ggcn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HfaK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "HhrA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAB2lBMVEUAAADx2Lry5+fdx63y5+fy5+fy5+by5+fy5uPavZbw17zq0LTy5+fy5+fy5+fy5+fy5+fy5+fw28jy5+fy5+fy5N/y5+fx2b/VuZPy5+fkyqvy5+fx2sLx3Mjv2sXw28fex6zw39Tv28ry5+fm0bzgxKHw17zbv5zw2L7Ut5Lv177cwaDy5+fy5+fx28Xx28XnzrPdw6Tx28Ty5+fx28Xq07vbwaPo0brexqrv3c7y5+fgzLbu2cXy5+fcxKjx3cvy5+fq077y5+fy5+fy5+fw3Mry5+fx3czs18XeyK/dx63y5+fx3s7y5+fw3c3y5+fnyqjRsYXQsIPOroDrz6zt0rHau5PMq3zcvpYkJibKqXnlx6PkxaHjxKDTs4fmyKTpzKrmyabixJ7hw5zUtInVtovs0K7fwpvWt43ewJjNrH3YuZDXuI7bvZTu07PLqnrv1LTx1bXIp3Y5NzIwMC3v4t3o0brfybLUuJPt4Nvr3NPk0b7cxKju28zo18rPs47GrYuBcl7w5ODp1L/jz7nZwaTZv5/OsIbFqYTKq327oXuYhm2VgmhvZFNkW01RS0FKRTxDPzk0My/x5ePv39br18bn1MHUto7JrovMr4e3oIO+pH+slHKCc1/0OS0tAAAAT3RSTlMA/rv+9NR1SgP+9/Ll1tHOnI98WzUnFvXz8PDu7LKolXthPzIc/Pn18e7t6uPZ2dXV1c7ExMLCr6+smJGKiIeDgXlwbmlcTk1LSz84HRAIF/52mgAAAjBJREFUSMeV1fdX01AUwPFr9x60VIYDBPfee+95gdKUoFYUBRFBsS3d1AICssG9/ldf0hJI8tq+fH/O55w3bs4Dea1XTx9paNjZPzDEWa3W3fuPnmlqhbLdOWl//OTpi97+ga6uIY4bfPv61ctIe3vdqbtAq8be9vwZDXR0BOuaQNkOe09beRB8s/ceyLrQ11kZhIOXYEPb+jqrgfC78yC1PcQCws3S+oeZQLe+tgT2hdjAtK50nsOMoDttFsEeZpA4DqTb75lBEoVdnGAHn/EKATZ28CHlBngwogGM4UOo0QIyaIatWkACr8FhOigUaECP52ALFeRjsTwFZFEHm6ngH88XKOATumETDfyM8XxshgYOqMHvxWXyuVBsefGvckn1avAxykutzio3bYAR1ZLWRXRWdaxIAb1rIvpHfXFI3fRCESxQRsNABUtFsKQePqynglWeX1khp6Qeb3TQLi7PR+c4bj7Kz6h+IHTTRiM5xwnD92P+lwIkEHVwSMO0phE9WsZ7GhFNcJkdJAi4BbXMIJwiIACwixVkEfEgABxjBME4AV4CmhlBBkn3CbDYmMAUkpzF14EFJMcF4BPBI1t1kIwjyWUBsZtVwdQXFPJLT1xlEMmg2A2QOlsBRPRxFLsIGzLlQnQwOJnCYtdBVosrnhvtkQMuO5nGUq4WUGTxGRHHv+a+TUyMkr6PpeMoZfRZgJLf60RKTq8fyhYwmzw6o6PRgGhodBh1HpM5ALL+A8SiyIsrjF8vAAAAAElFTkSuQmCC"

/***/ }),

/***/ "IEov":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IPaY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAABPlBMVEUAAAD1cUX4dEjg4enohGbE1+3A1u3z5OLy5+fy5+fx5+fvelbM2uzt5ejhjnjh4enplX34k3L3mXr3mnvy5+fy5+f3nX/l4+nq5Ojp5Ojn4+j2oof5bDzY3urT3evg4enp5OjxiGb4jmr4kW34lHLV3erweVL6bj/i4und4OrK2ezp5OjzhWHl4+njjHXyh2Xr5Of2po33p47d4OrqlHvy5+fz2NLy5+fy5+f4l3f4mHjX3urT3Ovy5+fy5+f3nH7y5+f3n4P8WB/y5+f////7YCv3mnv7Xijz19H8cD78ajj8WyT/9fH3pYv3oof/6+T0zMH1w7X2tKD9q474knD5fVP5ZzT8Yi3/8+7/7uj/7ebz4d7+49nz29X+3ND+1sj+xLD+uqL2sJr4lXT9l3P9lnL5hl/9flL6dkj8aDUqAp5BAAAAQnRSTlMA/PL76cqaXBQD/fjm1sWcgn1LPzYyHP7+/v78+/Ty6t3JqJWJWfj36+bl39TRysrDrJGQjIh1bmlkXFpUSSooIwjMzTbTAAAB7klEQVRIx5XVZ1PbQBAG4JV7twHbEAgBEkjvvZfdU5flggsQegnh//+B3CgaDdKdh/Pz+V7dzu5qDuLajVqmrI11E9HUx1o5U2u0Yar5DQ0ltI15kJlL4VSpOUhaSBwXIgsQs2niDcxNuOYuKngNkXuows1H9ZuoZOUn/JdCNc7LsJ+oqvctvEBV51kwX1Q2ou888AKV6fSGBzRUZz0CaOMM+qUCNHAGA/oKNZxBh3KQQantbZQwKAtllJl43kQaeAya/ALGZFcM6Q6MpVuzw5jnyAJp0DHh8vjQYwHv8PgyWdIyCKtt77LIrp0M3AIU2HsstGcLbSVASaLLAl1bHByBiaITFjgRV4OXpKPoiAWOxOWjZWlbeVP39xnbEdeb0rLBXbHuBeJFl10JPxAf3H0U6Ocucu55slyfqAIZVNcjysJzVOYQUQ7eojKfB77AD1TlWjxQALiNis6I6CEAPEU15gEP1HngE6o5Ja7JA0W1mv4Q90T9dfj7m7h8EPj1QOH8AXHVIgQ+31xP8P1SS/GJ008p8BEir1ycyj2zKPAOrnm/4qCU44fHSx8gplXt+aMJxkxGfo9C1RYkFPPrRFZ/0DGM4dAwOoO+RZH1fBEkmvU1klirN2GqwlYuW1lNLy4RLS2mVyvZ3FYBYv4BR3H+VOUkN48AAAAASUVORK5CYII="

/***/ }),

/***/ "Ic6x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4c5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAABP0lEQVRIDe1VPVPCQBB9G86hZ7BHbRgraG0c/wC2MmNJS6u/wV+iPwMLGhobrdWehhImybqbHDcXIOSDsUua7N2+fXuzl7xH4bg3A/MtTnwItArAd/T2++FTGSWX5AaEbz9RKWZ0GHweAUOp22mgTELeev3pVyL1wNG49wTGi7flQuMiG/Dj1Q3CuLu7f2wdg681T4QBP1yMHDY4+8w0UPIoDOcOUDbgFMiMaYR4ui0jXi8zDdzJiRYEzLbAWm/miTTsZhtYJiWXO3muRWyL5F7u5QPqBKeQlKltGhROqRlRM6LCCRQCUqkQPVfJTVTRCldhZUmAUSdSs8jT85I8uTCjNmedKNVzkdxcdI2EsR6a2Jyaha/nNfj2Sv79Tz7oB6Ljk0TP985TaeNS0dkG7dYXbeKlOpGaRSW6Q2Ci9z+FQmIdthXjfQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "JJUA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAMAAADTXB33AAAAVFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////8wXzyWAAAAG3RSTlMABurdLeK89OjWZzMhDvCyXlzLtKiOKBQBwKpHAPLbAAAAmElEQVQoz3XO2xKDIAxF0RNBFATvtzb//5+lWkerZD0xsyckiMiZmsuhI4C6oeTaOMKmUryzWlveqWorBR+KyzM2UpykCI4FDkZKL9RSKsEi5PJUI6UGrZRakPBjTkAnDUXv9KavoJ5FBWx8di+Zx4/ObkUDZxNKNOeXs2f88fYo1uNm6ffSL3gIhiMTkEAj80hIWqdpxekDMUgrt2W3U3wAAAAASUVORK5CYII="

/***/ }),

/***/ "JUbA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KPh9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Khvw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAMAAADHso01AAAAkFBMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB8XFnnZAAAAL3RSTlMAI90D+ermoy78883JxLCBNyGZlZAYE9S3eXRwaWVPSkVD4tqrhj88HA4MvV1XCmU1UiIAAAEMSURBVCjPhZLncoMwEITPIED0jrFNiVsSO2Xf/+0CBoIykpXvD3esZud0WgoBh54TAO47achw0MkvCHWyaeEf93ij5j65P8OY3W1DwQk2jeTYk4I3RI/vEYFKPiBeZk8VsoOONO5nlFPxCl9Wb661bMaW3M20Rb00OXZzded9c3XCkwtMk63ux8i3sOBtow2t7kPtAGBG6Fybnt9IpBjdyy4pTVJvyCc1q7uGApb0JkKKuAsJMaOVFIZUGlMDvwR5+ZvPKCwqUe0ZAGte/dcjSqK+RcxrZPM13TYZfggXh7fGphqX1CKiFRudmeEynfU8/l2jEOQGYGDJ1OzGxvuzx88zC5Kl2RvsY2h+AJiiID+odCLiAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Knil":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Knmv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhBAMAAAClyt9cAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMAwPPGIrwgH1Ba8nAAAAA8SURBVCjPY4ACR1UHBlRg0WGAJtLR0TC8RAo7UEBjAkNEByoQYNBAE1HAVINpzqDzKaUiBNOGoyIs/QAAkYJTLWppCdsAAAAASUVORK5CYII="

/***/ }),

/***/ "Kssp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "MO6P":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAMAAADHso01AAAAhFBMVEUAAAD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aD50aA//2z1AAAAK3RSTlMAId0D+urmyqNDLvPFsH9oN8+WkHZxJBgT4tW4TUg8wKubmoZfVBwODIQKsk6TYQAAAQNJREFUKM+NktlugzAQRQdslpg9JGVNszdp7///X7HAMghj5bzA1UUHMwPFQEibyBo/ZOGKo60+IbbVzLPbb0gdM29Z77CFO9l910ADnyR789m/kdBoD0z1Eak6u2OoQ/Q02Q+GukVF2/YXPDUZf2VnToZOBW1/i1N2D+OGA/jV31DIdySFB0XUJl+k7cN9CIC75/Ce9eJFc0ppr555xWiJtltgzWC3UMJb7WS2CcGxIiRN7axg9DniEuwrFXZJXNaLH5YD8KbRPzHgzvsWqehwnYbIH3mBVLcMkV5sLa8ZEtL46NkNl/HZKBJ/HUrSZAAHz8eQyhAt5vhweZCrcHD5eQj/he0dttDCVKgAAAAASUVORK5CYII="

/***/ }),

/***/ "MPJr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ms1A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productImg.c8ccc9d.png";

/***/ }),

/***/ "MzHY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAmCAMAAACIwYlVAAAAyVBMVEUAAAD+xxH+xxL90BH+zxH+zhH/vxP90BH90BH90BH90BH90BH/whP+xBP+yxH+zhH+zhH9zxH/wRP/wRP+wxP+xBP90BH+xxL90BH+yxH+zhH+yBL90BH90BH90BH90BH+wxP90BH+wxP90BH+wxP+xBP90BH90BH90BH+xhP90BH+zBH90BH+zBH+yxH+zRH9zxH90BH+wRP+wxP+wxP90BH+wxP90BH90BH90BH+xRP90BH+xRP90BH+yBL+yxL/vBT90BH/vhTfL1snAAAAQHRSTlMAaSBEIhH7GLBL9/LppoFtKAf28eO4hV88NzIlBQTq4t7Y1NTEsqSjmZeMdGRVUUAOC+zr0M/Nysa+urmiXUgW14eRcgAAAWZJREFUOMul0mlzgjAQgOGtNVARRby1HvW2Wq/ed3f9/z+qSQXZ0BqY6fuJ2XkGQhL4q2IPxz6k64YIsZYSXyh8mxLPFH5MidsOoXUJKcsRNiBtU8KrtLZNhCdenfFWXX3yonC5o81aQ/ddrs8hevL1FSuM13xWsuRkAgOSfbB5d3TAlmDDAqoJkKqun5/EslocozwuWS4a73oh3peiaRZlVRBS9212iSjEeM+mcs136py2D5Rfhhti5yOMn8Fw48rvBC+sE9GoeXieE8NVUG1fURaeUpNUM1ttEXGMnhwt5QrYTnYOn86fydup47LfrgaPwcWKyHOddIyV4wOEeRQPefqml5LxGo71k7AFUfMkPGR4nYSLDO+cBCyA9WbGLvA8My5oOGvGLdAamHAZ9BYmPI7hpgk3IFbrnHfGW8H/8oWd/ckWQmRYX79oZ3p6zZVMDOdMPziJ4Y2O94YDlC2ck9gVgfkGwUK94DOwrFAAAAAASUVORK5CYII="

/***/ }),

/***/ "N2HJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/utils/auth.js

var TOKEN_KEY = "USER_TOKEN"; // 用户token，由后台生成
var PAY_CHANNEL_VERSION = "2";
function baseUrl() {
  var payChannelVersion = "2";
  var baseUrl = "";
  // 根据页面路径名称，修改对应的api接口路径地址
  var host = window.location.host; // 获取URL的主机部分
  if (host == "sdb.giga99.com") {
    // if(payChannelVersion === "1"){
    //   setPayChannel("1007");
    // }else if(payChannelVersion === "2"){
    //   setPayChannel("1017");
    // }
    // baseUrl = "https://apisdb.giga99.com:8222";

    if (payChannelVersion === "1") {
      setPayChannel("1016");
    } else if (payChannelVersion === "2") {
      setPayChannel("1016");
    }
    baseUrl = "http://apifuqi.giga99.com";
  } else if (host == "sdb.ganzhoubx.com") {
    if (payChannelVersion === "1") {
      setPayChannel("1008");
    } else if (payChannelVersion === "2") {
      setPayChannel("1012");
    }
    baseUrl = "https://api.ganzhoubx.com:8222";
  } else if (host == "sdb.gzjiajiuhui.com") {
    if (payChannelVersion === "1") {
      setPayChannel("1005");
    } else if (payChannelVersion === "2") {
      setPayChannel("1018");
    }
    baseUrl = "https://api.gzjiajiuhui.com:8222";
  } else if (host == "sdb.fuqiyymx.com") {
    if (payChannelVersion === "1") {
      setPayChannel("1009");
    } else if (payChannelVersion === "2") {
      setPayChannel("1016");
    }
    baseUrl = "https://api.fuqiyymx.com:8222";
  } else if (host == "sdb.beifuyymx.com") {
    if (payChannelVersion === "1") {
      setPayChannel("1010");
    } else if (payChannelVersion === "2") {
      setPayChannel("1013");
    }
    baseUrl = "https://api.beifuyymx.com:8222";
  } else if (host == "sdb.cehaoyymx.com") {
    if (payChannelVersion === "1") {
      setPayChannel("1011");
    } else if (payChannelVersion === "2") {
      setPayChannel("1015");
    }
    baseUrl = "https://api.cehaoyymx.com:8222";
  } else if (host == "sdb.ganzhoublq.com") {
    if (payChannelVersion === "1") {
      setPayChannel("1004");
    } else if (payChannelVersion === "2") {
      setPayChannel("1014");
    }
    baseUrl = "https://api.ganzhoublq.com:8222";
  } else {
    setPayChannel("1012");
    // 测试地址
    baseUrl = "http://yts.natappvip.cc/sdb-api/";
  }
  setPayChannel("1019");
  baseUrl = "https://apisdb.giga99.com:8222";
  return baseUrl;
}

function setToken(token) {
  return sessionStorage.setItem(TOKEN_KEY, token);
}

function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

function removeToken() {
  return sessionStorage.removeItem(TOKEN_KEY);
}

function setUserInfo(data) {
  return sessionStorage.setItem("YYMX_USER", stringify_default()(data));
}

function auth_getUserInfo() {
  var userInfo = sessionStorage.getItem("YYMX_USER");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }
  return userInfo;
}

function removeUserInfo() {
  return sessionStorage.removeItem("YYMX_USER");
}

function setPayChannel(data) {
  return sessionStorage.setItem("PAY_CHANNEL", data);
}

function getPayChannel() {
  return sessionStorage.getItem("PAY_CHANNEL");
}

var VERSION = "2.5.5"; // 当前系统版本

var PRODUCTID = "8154648227158500"; // 产品固定id
// CONCATENATED MODULE: ./src/utils/sysUtils.js
/**
 * @author Bruce
 * @time 2019-07-16
 * @description 系统相关工具，比如判断浏览器环境之类的方法
 */

/* harmony default export */ var sysUtils = ({
  /**
   * 判断当前浏览器是不是微信浏览器
   */
  isWeiXin: function isWeiXin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 判断安卓还是IOS客户端
   */
  judgePhone: function judgePhone() {
    // console.log(navigator.userAgent); 
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //判断iPhone|iPad|iPod|iOS
      return 'ios';
    } else if (/(Android)/i.test(navigator.userAgent)) {
      //判断Android
      return 'android';
    }
  },

  /**
   * 获取可视区域高度，监听页面窗口变化，动态修改高度
   * @param self this作用域，指向引用组件data中的pageHeight
   */
  adaptHeight: function adaptHeight(self) {
    // 获取页面可视区域高度，动态计算内容区域显示高度，监听窗口变化，动态修改显示高度
    var clientHeight = document.documentElement.clientHeight;
    self.pageHeight = clientHeight + "px";
    window.onresize = function () {
      return function () {
        var currentHeight = document.documentElement.clientHeight;
        var diff = Math.abs(currentHeight - clientHeight);
        if (diff < 50) {
          // 解决手机底部上有虚拟操作键的情况，虚拟按键的高度一般为42px
          // 虚拟按键显示隐藏的情况下，动态修改页面，
          self.pageHeight = currentHeight + "px";
        }
      }();
    };
  },

  /**
   * 解决ios上输入框失去焦点后，页面不会回来的问题
   * 当失去焦点后，控制页面滚动到顶部
   */
  scrollPageView: function scrollPageView() {
    setTimeout(function () {
      window.scrollTo(0, document.body.scrollTop + 1);
      document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1);
    }, 10);
  },

  /**
   * 获取url中的参数
   * @param name url中的url
   */
  getUrlKey: function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  },
  /**
   * 跳转到外部签合同系统
   * @param {*} userId 
   * @param {*} companyId 
   * @param {*} themeType 
   * @param {*} noreturn 
   */
  navWeb: function navWeb(userId, companyId, themeType, noreturn) {
    var returnUrl = window.location.origin + window.location.pathname + "#/robbing";
    if (noreturn) {
      returnUrl = "";
    }
    window.location.href = "https://sign.nutrition-esthetics.com/index.html#/home" + "?userId=" + userId + "&companyId=" + companyId + "&themeType=" + themeType + "&returnUrl=" + encodeURIComponent(encodeURIComponent(returnUrl));
  },

  /**
   * 根据当前用户星级，设置当前主题类型
   * @param {Number} starLevel 用户星级 
   */
  setThemeType: function setThemeType(starLevel, self) {
    var root = document.querySelector(":root");
    // 判断当前用户星级，四星金卡以下为黄色主题，以上为黑色主题
    if (Number(starLevel) <= 4) {
      root.style.setProperty("--color", "#fc581f");
      self.$root.themeType = "yellow";
      document.getElementById("app").classList.remove("theme-black"); // 删除黑色主题class
      document.getElementById("app").classList.add("theme-yellow"); // 添加黄色主题class
      document.documentElement.style.backgroundColor = "#fff";
    } else {
      root.style.setProperty("--color", "#facd89");
      self.$root.themeType = "black";
      document.getElementById("app").classList.remove("theme-yellow"); // 删除黄色主题class
      document.getElementById("app").classList.add("theme-black"); // 添加黑色主题class
      document.documentElement.style.backgroundColor = "#242626";
    }

    localStorage.setItem("JYDB_THEME", self.$root.themeType); // 设置长期缓存，即使退出操作也不清除此缓存
  }
});
// CONCATENATED MODULE: ./src/api/request.js







// // 开发环境下使用固定的基础接口路径
// if (process.env.NODE_ENV === 'development') {}

// axios 配置
var request = axios_default.a.create({
  baseURL: baseUrl(),
  timeout: 20000 // 20s
});

var hide_loading = false;

/** 下一次请求不显示Loading */
request.hideLoadingOnce = function () {
  hide_loading = true;
};

/**
 * 是否隐藏Loading
 * @returns
 */
function isHideLoading() {
  var b = hide_loading;
  // 每次请求后都设置为不隐藏加载框
  hide_loading = false;
  return b;
}

// http request 拦截器
request.interceptors.request.use(function (config) {
  if (!isHideLoading()) {
    vue_esm["a" /* default */].$vux.loading.show();
  }
  var userToken = getToken();
  if (userToken) {
    config.headers['accessToken'] = userToken;
  }
  var payChannel = getPayChannel();
  config.headers['payChannel'] = payChannel;
  return config;
}, function (error) {
  vue_esm["a" /* default */].$vux.loading.hide();
  return promise_default.a.reject(error);
});

// http response 拦截器
request.interceptors.response.use(function (response) {
  vue_esm["a" /* default */].$vux.loading.hide();
  var res = response.data;
  // 拿到当前接口的返回response，根据response.data中的fail字段判断当前接口调用是否正确
  if (res && (res.code == 0 || res.appId)) {
    return res;
  }
  // 当返回信息为未登录或者登录失效的时候重定向为登录页面
  // 微信环境下需要授权登录，此时判断code是否存在，如果存在，清空code，进入授权页，重新获取code
  if (res.code == 401) {
    vue_esm["a" /* default */].$vux.alert.hide();
    removeToken();
    sessionStorage.clear();
    localStorage.clear();
    res.msg = "用户信息过期，请重新登录"; // 修改提示
    // 微信环境下重新授权登录
    if (sysUtils.isWeiXin()) {
      window.location.href = window.location.origin + window.location.pathname + "#/wxAuth";
    } else {
      src_router.push({
        path: "/login"
      });
    }
  } else if (res.code == '5001') {
    // 如果code为5001，说明系统正在维护中，进入维护提示界面
    src_router.push({
      path: "/maintain"
    });
  }
  // 如果失败，显示失败原因
  console.log("操作失败：--------------------");
  console.log(res);
  return promise_default.a.reject(res);
}, function (error) {
  console.log(error);
  if (error.code == 'ECONNABORTED') {
    error.msg = "请求超时!";
  }
  error.msg = error.message;
  vue_esm["a" /* default */].$vux.loading.hide();
  return promise_default.a.reject(error);
});

/* harmony default export */ var api_request = (request);
// CONCATENATED MODULE: ./src/api/wxService.js



/**
 * 微信相关接口
 * @author 小圣贤君
 * @time 2020/03/13
 */
/* harmony default export */ var wxService = ({
  /**
   * 微信网页授权
   */
  wxAuth: function wxAuth(redirectUri) {
    var payChannel = "";
    var payChannelVersion = "2";
    var host = window.location.host; // 获取URL的主机部分
    if (host == "sdb.giga99.com") {
      // if(payChannelVersion === "1"){
      //   payChannel = "1007";
      // }else if(payChannelVersion === "2"){
      //   payChannel = "1017";
      // }

      if (payChannelVersion === "1") {
        payChannel = "1016";
      } else if (payChannelVersion === "2") {
        payChannel = "1016";
      }
    } else if (host == "sdb.ganzhoubx.com") {
      if (payChannelVersion === "1") {
        payChannel = "1008";
      } else if (payChannelVersion === "2") {
        payChannel = "1012";
      }
    } else if (host == "sdb.gzjiajiuhui.com") {
      if (payChannelVersion === "1") {
        payChannel = "1005";
      } else if (payChannelVersion === "2") {
        payChannel = "1018";
      }
    } else if (host == "sdb.fuqiyymx.com") {
      if (payChannelVersion === "1") {
        payChannel = "1009";
      } else if (payChannelVersion === "2") {
        payChannel = "1016";
      }
    } else if (host == "sdb.beifuyymx.com") {
      if (payChannelVersion === "1") {
        payChannel = "1010";
      } else if (payChannelVersion === "2") {
        payChannel = "1013";
      }
    } else if (host == "sdb.cehaoyymx.com") {
      if (payChannelVersion === "1") {
        payChannel = "1011";
      } else if (payChannelVersion === "2") {
        payChannel = "1015";
      }
    } else if (host == "sdb.ganzhoublq.com") {
      if (payChannelVersion === "1") {
        payChannel = "1004";
      } else if (payChannelVersion === "2") {
        payChannel = "1014";
      }
    } else {
      payChannel = "1012";
    }
    payChannel = "1019";
    setPayChannel(payChannel);
    window.location.href = baseUrl() + "/api/user/wx/view/getWeChatCode?redirect_uri=" + encodeURIComponent(redirectUri) + "&payChannel=" + payChannel;
  },

  /**
   * 获取微信配置
   * @param url 页面url href.split('#')[0]
   */
  getConfig: function getConfig(url) {
    return api_request.post('/user/wechat/getWxConfig?url=' + encodeURIComponent(url));
  }
});
// CONCATENATED MODULE: ./src/api/userService.js


/**
 * 用户相关接口
 * @author 小圣贤君
 * @time 2020/03/12
 */
/* harmony default export */ var userService = ({
  /**
   * 获取uuid
   */
  getUuid: function getUuid() {
    return api_request.get("/sys/uuid");
  },

  /**
   * 获取图形验证码
   * @param uuid 
   */
  getImgCode: function getImgCode(uuid) {
    return baseUrl() + "/captcha.jpg?uuid=" + uuid;
  },

  /**
   * 获取短信验证码
   * @param mobile 手机号
   * @param captcha 图片验证码
   * @param uuid
   */
  getMsgCode: function getMsgCode(mobile, captcha, uuid) {
    return api_request.post("/msg/sms/sendcode?mobile=" + mobile + "&captcha=" + captcha + "&uuid=" + uuid);
  },

  /**
   * 绑定手机号
   * @param mobile 手机号
   * @param wechatCode 微信code
   * @param code 短息验证码
   */
  bindMobile: function bindMobile(mobile, code, wechatCode) {
    return api_request.post("/user/bingPhone?mobile=" + mobile + "&code=" + code + "&wechatCode=" + wechatCode);
  },

  /**
   * 微信登录
   * @param code 微信授权code
   */
  wxLogin: function wxLogin(code) {
    return api_request.get("/user/wechat/weChatLogin?code=" + code);
  },

  /**
   * 查询库存
   */
  queryStock: function queryStock(productId) {
    return api_request.post("/shop/shopstock/rush/stock?productId=" + productId);
  },

  /**
   * 获取用户信息
   */
  getUserInfo: function getUserInfo() {
    return api_request.get("/user/myInfo");
  },

  /**
   * 退出
   */
  logout: function logout() {
    return api_request.post("/user/sys/logout");
  },

  /**
   * 获取考核信息
   */
  agentExamineCycle: function agentExamineCycle() {
    return api_request.get('/user/agentExamineCycle');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/wxAuth.vue
//
//
//






/**
 * 微信授权页面
 * 进入到这里，说明缓存中没有网页授权access_token，调接口获取授权链接，拿到code，然后通过code获取到access_token
 * 授权成功后，重新回到这个页面，判断路径中有没有code，根据code获取access token并将access token缓存，成功后跳转到登录页
 */
/* harmony default export */ var views_wxAuth = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    // 如果路径中有code，说明已经被微信授权过了，通过code拿到access_token后跳转到登录页
    if (window.location.search.indexOf("code") != -1) {
      var oauthCode = sysUtils.getUrlKey("code");
      // 如果路径包含场景值scene并且为quit，说明是从退出操作过来，直接进入登录页
      if (this.$route.query.scene == "quit") {
        this.$router.push({
          path: "/login"
        });
      } else {
        userService.wxLogin(oauthCode).then(function (res) {
          setUserInfo(res.data);
          setToken(res.data.accessToken); // 缓存accessToken
          var data = res.data;

          sysUtils.setThemeType(data.starLevel, _this); // 设置主题

          if (data.phoneStatus != 1) {
            // 如果该用户没有绑定手机号，跳转到login页，手动登录
            _this.$router.push({
              path: "/login"
            });
          } else {
            if (data.logisticsContractStatus != 1 || data.purchaseContractStatus != 1 || data.idCardStatus != 1) {
              _this.$router.push({
                path: "/remind",
                query: {
                  memberId: data.memberId,
                  companyId: data.companyId
                }
              });
            } else {
              _this.$router.push({
                path: "/robbing"
              });
            }
          }
        }).catch(function (err) {
          _this.$vux.toast.text(err.msg);
        });
      }
    } else {
      var url = window.location.href; // 重定向页面路径，这里授权成功后跳转到授权页
      wxService.wxAuth(url);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/wxAuth.vue
//
//
//






/**
 * 微信授权页面
 * 进入到这里，说明缓存中没有网页授权access_token，调接口获取授权链接，拿到code，然后通过code获取到access_token
 * 授权成功后，重新回到这个页面，判断路径中有没有code，根据code获取access token并将access token缓存，成功后跳转到登录页
 */
/* harmony default export */ var selectortype_script_index_0_src_views_wxAuth = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    // 如果路径中有code，说明已经被微信授权过了，通过code拿到access_token后跳转到登录页
    if (window.location.search.indexOf("code") != -1) {
      var oauthCode = sysUtils.getUrlKey("code");
      // 如果路径包含场景值scene并且为quit，说明是从退出操作过来，直接进入登录页
      if (this.$route.query.scene == "quit") {
        this.$router.push({
          path: "/login"
        });
      } else {
        userService.wxLogin(oauthCode).then(function (res) {
          setUserInfo(res.data);
          setToken(res.data.accessToken); // 缓存accessToken
          var data = res.data;

          sysUtils.setThemeType(data.starLevel, _this); // 设置主题

          if (data.phoneStatus != 1) {
            // 如果该用户没有绑定手机号，跳转到login页，手动登录
            _this.$router.push({
              path: "/login"
            });
          } else {
            if (data.logisticsContractStatus != 1 || data.purchaseContractStatus != 1 || data.idCardStatus != 1) {
              _this.$router.push({
                path: "/remind",
                query: {
                  memberId: data.memberId,
                  companyId: data.companyId
                }
              });
            } else {
              _this.$router.push({
                path: "/robbing"
              });
            }
          }
        }).catch(function (err) {
          _this.$vux.toast.text(err.msg);
        });
      }
    } else {
      var url = window.location.href; // 重定向页面路径，这里授权成功后跳转到授权页
      wxService.wxAuth(url);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a475ebaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wxAuth.vue
var wxAuth_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-auth"})}
var staticRenderFns = []
var esExports = { render: wxAuth_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_wxAuth = (esExports);
// CONCATENATED MODULE: ./src/views/wxAuth.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_views_wxAuth,
  selectortype_template_index_0_src_views_wxAuth,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_wxAuth = (Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8acbf19e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
var _04_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var _04_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":__webpack_require__("+2J0"),"alt":"404"}})])}]
var _04_esExports = { render: _04_render, staticRenderFns: _04_staticRenderFns }
/* harmony default export */ var _04 = (_04_esExports);
// CONCATENATED MODULE: ./src/views/404.vue
function injectStyle (ssrContext) {
  __webpack_require__("7jhc")
}
var _04_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var _04___vue_template_functional__ = false
/* styles */
var _04___vue_styles__ = injectStyle
/* scopeId */
var _04___vue_scopeId__ = "data-v-8acbf19e"
/* moduleIdentifier (server only) */
var _04___vue_module_identifier__ = null
var _04_Component = _04_normalizeComponent(
  __vue_script__,
  _04,
  _04___vue_template_functional__,
  _04___vue_styles__,
  _04___vue_scopeId__,
  _04___vue_module_identifier__
)

/* harmony default export */ var views_404 = (_04_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CCheckBox.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var CCheckBox = ({
  data: function data() {
    return {
      agree: this.check
    };
  },

  props: {
    check: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    agree: function agree(e) {
      this.$emit("update:check", e);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CCheckBox.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var components_CCheckBox = ({
  data: function data() {
    return {
      agree: this.check
    };
  },

  props: {
    check: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    agree: function agree(e) {
      this.$emit("update:check", e);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b15448","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CCheckBox.vue
var CCheckBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-check flex-align-center",on:{"click":function($event){$event.stopPropagation();_vm.agree = !_vm.agree}}},[_c('span',{staticClass:"c-check-box",class:_vm.agree?'active':''},[(_vm.agree == true)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-checkmark-empty",attrs:{"type":"ios-checkmark-empty","size":"18","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M223.9 329.7c-2.4 2.4-5.8 4.4-8.8 4.4s-6.4-2.1-8.9-4.5l-56-56 17.8-17.8 47.2 47.2L340 177.3l17.5 18.1-133.6 134.3z"}})]):_vm._e()]),_vm._v(" "),_vm._t("default")],2)}
var CCheckBox_staticRenderFns = []
var CCheckBox_esExports = { render: CCheckBox_render, staticRenderFns: CCheckBox_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_CCheckBox = (CCheckBox_esExports);
// CONCATENATED MODULE: ./src/components/CCheckBox.vue
function CCheckBox_injectStyle (ssrContext) {
  __webpack_require__("5N1u")
  __webpack_require__("MPJr")
}
var CCheckBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CCheckBox___vue_template_functional__ = false
/* styles */
var CCheckBox___vue_styles__ = CCheckBox_injectStyle
/* scopeId */
var CCheckBox___vue_scopeId__ = "data-v-64b15448"
/* moduleIdentifier (server only) */
var CCheckBox___vue_module_identifier__ = null
var CCheckBox_Component = CCheckBox_normalizeComponent(
  components_CCheckBox,
  selectortype_template_index_0_src_components_CCheckBox,
  CCheckBox___vue_template_functional__,
  CCheckBox___vue_styles__,
  CCheckBox___vue_scopeId__,
  CCheckBox___vue_module_identifier__
)

/* harmony default export */ var src_components_CCheckBox = (CCheckBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CInput.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CInput = ({
  data: function data() {
    return {
      val: "",
      isFocus: false,
      hovering: false
    };
  },

  props: {
    value: {},
    placeholder: {
      type: String,
      default: "请输入"
    },
    type: {
      type: String,
      default: "text"
    }
  },
  computed: {
    deleteIcon: function deleteIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("dM38");
      } else {
        return __webpack_require__("OX1S");
      }
    }
  },
  methods: {
    /**
     * 手机号输入监听，限制位数最多11位
     */
    _handleMobileInput: function _handleMobileInput(e) {
      if (e.target.value.length > 11) {
        this.val = e.target.value.slice(0, 11);
      }
      this._handleInput();
    },
    _handleInput: function _handleInput(e) {
      this.$emit("update:value", this.val);
      sysUtils.scrollPageView();
    },
    _handleBlur: function _handleBlur() {
      this.isFocus = false;
    },
    _handleDelete: function _handleDelete() {
      this.val = "";
      this.$emit("update:value", this.val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CInput.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_CInput = ({
  data: function data() {
    return {
      val: "",
      isFocus: false,
      hovering: false
    };
  },

  props: {
    value: {},
    placeholder: {
      type: String,
      default: "请输入"
    },
    type: {
      type: String,
      default: "text"
    }
  },
  computed: {
    deleteIcon: function deleteIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("dM38");
      } else {
        return __webpack_require__("OX1S");
      }
    }
  },
  methods: {
    /**
     * 手机号输入监听，限制位数最多11位
     */
    _handleMobileInput: function _handleMobileInput(e) {
      if (e.target.value.length > 11) {
        this.val = e.target.value.slice(0, 11);
      }
      this._handleInput();
    },
    _handleInput: function _handleInput(e) {
      this.$emit("update:value", this.val);
      sysUtils.scrollPageView();
    },
    _handleBlur: function _handleBlur() {
      this.isFocus = false;
    },
    _handleDelete: function _handleDelete() {
      this.val = "";
      this.$emit("update:value", this.val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b71d616c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CInput.vue
var CInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-input vux-1px-b flex-align-center",class:_vm.isFocus ? 'isfocus' : '',on:{"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false}}},[_vm._t("prefix"),_vm._v(" "),(_vm.type == 'mobile')?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.val),expression:"val",modifiers:{"number":true}}],attrs:{"type":"number","pattern":"\\d*","placeholder":_vm.placeholder},domProps:{"value":(_vm.val)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.val=_vm._n($event.target.value)},_vm._handleMobileInput],"focus":function($event){_vm.isFocus = true},"blur":[_vm._handleBlur,function($event){return _vm.$forceUpdate()}]}}):((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.val)?_vm._i(_vm.val,null)>-1:(_vm.val)},on:{"input":_vm._handleInput,"focus":function($event){_vm.isFocus = true},"blur":_vm._handleBlur,"change":function($event){var $$a=_vm.val,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.val=$$a.concat([$$v]))}else{$$i>-1&&(_vm.val=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.val=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.val,null)},on:{"input":_vm._handleInput,"focus":function($event){_vm.isFocus = true},"blur":_vm._handleBlur,"change":function($event){_vm.val=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],attrs:{"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":(_vm.val)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},_vm._handleInput],"focus":function($event){_vm.isFocus = true},"blur":_vm._handleBlur}}),_vm._v(" "),(_vm.val && _vm.isFocus && _vm.hovering)?_c('img',{staticClass:"icon-delete",attrs:{"src":_vm.deleteIcon,"alt":""},on:{"mousedown":function($event){$event.preventDefault();},"click":_vm._handleDelete}}):_vm._e(),_vm._v(" "),_vm._t("suffix")],2)}
var CInput_staticRenderFns = []
var CInput_esExports = { render: CInput_render, staticRenderFns: CInput_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_CInput = (CInput_esExports);
// CONCATENATED MODULE: ./src/components/CInput.vue
function CInput_injectStyle (ssrContext) {
  __webpack_require__("sQ/C")
  __webpack_require__("S5jg")
}
var CInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CInput___vue_template_functional__ = false
/* styles */
var CInput___vue_styles__ = CInput_injectStyle
/* scopeId */
var CInput___vue_scopeId__ = "data-v-b71d616c"
/* moduleIdentifier (server only) */
var CInput___vue_module_identifier__ = null
var CInput_Component = CInput_normalizeComponent(
  components_CInput,
  selectortype_template_index_0_src_components_CInput,
  CInput___vue_template_functional__,
  CInput___vue_styles__,
  CInput___vue_scopeId__,
  CInput___vue_module_identifier__
)

/* harmony default export */ var src_components_CInput = (CInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/user/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var login = ({
  data: function data() {
    return {
      mobile: "",
      imgCode: "", // 图片验证码
      msgCode: "", // 短信验证码
      agree: false,
      codeImg: "", // 图片验证码图片地址
      btnText: "发送验证码",
      uuid: "",
      baseUrlStr: baseUrl()
    };
  },
  mounted: function mounted() {
    this.getImgCode();
  },

  methods: {
    /**
     * 获取图片验证码
     * 先获取uuid，再根据uuid获取图片验证码地址
     */
    getImgCode: function getImgCode() {
      var _this = this;

      userService.getUuid().then(function (res) {
        _this.uuid = res.uuid;
        _this.codeImg = userService.getImgCode(res.uuid);
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取短信验证码
     */
    getMsgCode: function getMsgCode() {
      var _this2 = this;

      if (!this.mobile) {
        this.$vux.toast.text("请填写手机号");
      } else if (!this.imgCode) {
        this.$vux.toast.text("请填写图片验证码");
      } else {
        // 1.修改按钮内容，将按钮置为不可用
        this.btnText = "59s";
        // 2.60s倒计时
        var num = 59;
        var time = setInterval(function () {
          num--;
          _this2.btnText = num + "s";
          if (num == 0) {
            _this2.btnText = "发送验证码";
            clearInterval(time);
          }
        }, 1000);
        // 3.调用获取验证码接口
        userService.getMsgCode(this.mobile).then(function (res) {
          console.log(res);
          _this2.$vux.toast.text("已发送");
        }).catch(function (err) {
          _this2.btnText = "发送验证码";
          clearInterval(time);
          _this2.$vux.toast.text(err.msg);
        });
      }
    },

    /**
     * 点击确认，执行登录操作
     * 校验手机号，图片验证码，短信验证码和协议是否都填写
     */
    handleLogin: function handleLogin() {
      var _this3 = this;

      if (!this.mobile) {
        this.$vux.toast.text("请输入手机号");
        return;
      } else if (!this.imgCode) {
        this.$vux.toast.text("请输入图片验证码");
        return;
      } else if (!this.msgCode) {
        this.$vux.toast.text("请输入短信验证码");
        return;
      } else if (!this.agree) {
        this.$vux.toast.text("请同意用户协议");
        return;
      } else {
        // 调用绑定用户手机号登录接口
        var wechatCode = sysUtils.getUrlKey("code"); // 获取路径中的code
        if (!wechatCode) wechatCode = "";
        userService.bindMobile(this.mobile, this.msgCode, wechatCode).then(function (res) {
          setUserInfo(res.data);
          setToken(res.data.accessToken); // 缓存accessToken
          var data = res.data;

          sysUtils.setThemeType(data.starLevel, _this3); // 设置主题

          if (data.logisticsContractStatus != 1 || data.purchaseContractStatus != 1 || data.idCardStatus != 1) {
            _this3.$router.push({
              path: "/remind",
              query: {
                memberId: data.memberId,
                companyId: data.companyId
              }
            });
          } else {
            _this3.$router.push({
              path: "/robbing"
            });
          }
        }).catch(function (err) {
          _this3.$vux.toast.text(err.msg);
        });
      }
    }
  },
  components: {
    CCheckBox: src_components_CCheckBox,
    CInput: src_components_CInput
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/user/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var user_login = ({
  data: function data() {
    return {
      mobile: "",
      imgCode: "", // 图片验证码
      msgCode: "", // 短信验证码
      agree: false,
      codeImg: "", // 图片验证码图片地址
      btnText: "发送验证码",
      uuid: "",
      baseUrlStr: baseUrl()
    };
  },
  mounted: function mounted() {
    this.getImgCode();
  },

  methods: {
    /**
     * 获取图片验证码
     * 先获取uuid，再根据uuid获取图片验证码地址
     */
    getImgCode: function getImgCode() {
      var _this = this;

      userService.getUuid().then(function (res) {
        _this.uuid = res.uuid;
        _this.codeImg = userService.getImgCode(res.uuid);
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取短信验证码
     */
    getMsgCode: function getMsgCode() {
      var _this2 = this;

      if (!this.mobile) {
        this.$vux.toast.text("请填写手机号");
      } else if (!this.imgCode) {
        this.$vux.toast.text("请填写图片验证码");
      } else {
        // 1.修改按钮内容，将按钮置为不可用
        this.btnText = "59s";
        // 2.60s倒计时
        var num = 59;
        var time = setInterval(function () {
          num--;
          _this2.btnText = num + "s";
          if (num == 0) {
            _this2.btnText = "发送验证码";
            clearInterval(time);
          }
        }, 1000);
        // 3.调用获取验证码接口
        userService.getMsgCode(this.mobile).then(function (res) {
          console.log(res);
          _this2.$vux.toast.text("已发送");
        }).catch(function (err) {
          _this2.btnText = "发送验证码";
          clearInterval(time);
          _this2.$vux.toast.text(err.msg);
        });
      }
    },

    /**
     * 点击确认，执行登录操作
     * 校验手机号，图片验证码，短信验证码和协议是否都填写
     */
    handleLogin: function handleLogin() {
      var _this3 = this;

      if (!this.mobile) {
        this.$vux.toast.text("请输入手机号");
        return;
      } else if (!this.imgCode) {
        this.$vux.toast.text("请输入图片验证码");
        return;
      } else if (!this.msgCode) {
        this.$vux.toast.text("请输入短信验证码");
        return;
      } else if (!this.agree) {
        this.$vux.toast.text("请同意用户协议");
        return;
      } else {
        // 调用绑定用户手机号登录接口
        var wechatCode = sysUtils.getUrlKey("code"); // 获取路径中的code
        if (!wechatCode) wechatCode = "";
        userService.bindMobile(this.mobile, this.msgCode, wechatCode).then(function (res) {
          setUserInfo(res.data);
          setToken(res.data.accessToken); // 缓存accessToken
          var data = res.data;

          sysUtils.setThemeType(data.starLevel, _this3); // 设置主题

          if (data.logisticsContractStatus != 1 || data.purchaseContractStatus != 1 || data.idCardStatus != 1) {
            _this3.$router.push({
              path: "/remind",
              query: {
                memberId: data.memberId,
                companyId: data.companyId
              }
            });
          } else {
            _this3.$router.push({
              path: "/robbing"
            });
          }
        }).catch(function (err) {
          _this3.$vux.toast.text(err.msg);
        });
      }
    }
  },
  components: {
    CCheckBox: src_components_CCheckBox,
    CInput: src_components_CInput
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc3a35fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"input-box"},[_c('c-input',{attrs:{"value":_vm.mobile,"type":"text","placeholder":"输入手机号"},on:{"update:value":function($event){_vm.mobile=$event}},scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("lUxW"),"alt":""}})]},proxy:true}])}),_vm._v(" "),_c('c-input',{attrs:{"value":_vm.imgCode,"placeholder":"请输入验证码"},on:{"update:value":function($event){_vm.imgCode=$event}},scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("4G4h"),"alt":""}})]},proxy:true},{key:"suffix",fn:function(){return [_c('img',{staticClass:"img-code",attrs:{"src":_vm.codeImg,"alt":""},on:{"click":_vm.getImgCode}})]},proxy:true}])}),_vm._v(" "),_c('c-input',{attrs:{"value":_vm.msgCode,"type":"number","placeholder":"短信验证码"},on:{"update:value":function($event){_vm.msgCode=$event}},scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("Zl4u"),"alt":""}})]},proxy:true},{key:"suffix",fn:function(){return [_c('button',{attrs:{"disabled":_vm.btnText == '发送验证码'?false:true},on:{"click":_vm.getMsgCode}},[_vm._v(_vm._s(_vm.btnText))])]},proxy:true}])})],1),_vm._v(" "),_c('c-check-box',{attrs:{"check":_vm.agree},on:{"update:check":function($event){_vm.agree=$event}}},[_c('span',{staticClass:"agreement"},[_vm._v("\n        已经阅读并同意\n        "),(_vm.baseUrlStr=='https://apisdb.giga99.com:8222')?_c('router-link',{attrs:{"to":"/agreement-dabenying"}},[_vm._v("《用户服务协议》")]):_vm._e(),_vm._v(" "),(_vm.baseUrlStr=='https://api.ganzhoubx.com:8222')?_c('router-link',{attrs:{"to":"/agreement-boxing"}},[_vm._v("《用户服务协议》")]):_vm._e(),_vm._v(" "),(_vm.baseUrlStr=='https://api.gzjiajiuhui.com:8222')?_c('router-link',{attrs:{"to":"/agreement-jiajiuhui"}},[_vm._v("《用户服务协议》")]):_vm._e(),_vm._v(" "),(_vm.baseUrlStr=='https://api.fuqiyymx.com:8222')?_c('router-link',{attrs:{"to":"/agreement-fuqi"}},[_vm._v("《用户服务协议》")]):_vm._e(),_vm._v(" "),(_vm.baseUrlStr=='https://api.beifuyymx.com:8222')?_c('router-link',{attrs:{"to":"/agreement-beifu"}},[_vm._v("《用户服务协议》")]):_vm._e(),_vm._v(" "),(_vm.baseUrlStr=='https://api.cehaoyymx.com:8222')?_c('router-link',{attrs:{"to":"/agreement-cehao"}},[_vm._v("《用户服务协议》")]):_vm._e(),_vm._v(" "),(_vm.baseUrlStr=='https://api.ganzhoublq.com:8222')?_c('router-link',{attrs:{"to":"/agreement-baoleqi"}},[_vm._v("《用户服务协议》")]):_vm._e()],1)]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":_vm.handleLogin}},[_vm._v("登 录")])],1)])}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('span',[_vm._v("营养美学")]),_vm._v(" "),_c('small',[_vm._v("Nutrition Esthetics")])]),_vm._v(" "),_c('span',{staticClass:"welcome"},[_vm._v("欢迎登录")]),_vm._v(" "),_c('p',[_vm._v("营养美学欢迎您，请绑定预留手机号")])])}]
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var views_user_login = (login_esExports);
// CONCATENATED MODULE: ./src/views/user/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("SI7V")
  __webpack_require__("N2HJ")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-dc3a35fc"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  user_login,
  views_user_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_views_user_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a9e1bfd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement.vue
var agreement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海博鹏商贸有限公司就官方微信公众号“营养美学大本营”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海博鹏商贸有限公司（如下简称“博鹏商贸”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制博鹏商贸责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用博鹏商贸帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于博鹏商贸官方微信公众号“营养美学大本营”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由博鹏商贸在旗下公众号“营养美学大本营”中用于识别您身份的标识。帐号的所有权属于博鹏商贸，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过营养美学大本营享受博鹏商贸旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“营养美学大本营”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用博鹏商贸服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，博鹏商贸不负任何责任。您可以通过博鹏商贸预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经博鹏商贸审核，如存在上述情况，博鹏商贸将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，博鹏商贸有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为博鹏商贸旗下公众号“营养美学大本营”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及博鹏商贸商业信息，您的营养美学账号仅限您本人使用。未经博鹏商贸同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据博鹏商贸各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或博鹏商贸信息安全的，博鹏商贸可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆博鹏商贸的服务，第三方帐号将与您的营养美学账号相关联，博鹏商贸将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过博鹏商贸安全验证，博鹏商贸有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过博鹏商贸提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，博鹏商贸有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时博鹏商贸保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“营养美学大本营”中的账号权限将被博鹏商贸回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，博鹏商贸会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，博鹏商贸任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，博鹏商贸并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是博鹏商贸官方在微信公众号“营养美学大本营”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向博鹏商贸与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿博鹏商贸与合作公司、关联公司，并使之免受损害。同时，博鹏商贸有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，博鹏商贸会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用博鹏商贸服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在博鹏商贸首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予博鹏商贸等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，博鹏商贸都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，博鹏商贸不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映博鹏商贸的任何观点或政策，博鹏商贸对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，博鹏商贸均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用博鹏商贸功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用博鹏商贸服务而支付给博鹏商贸的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，博鹏商贸对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，博鹏商贸有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，博鹏商贸将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用博鹏商贸服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用博鹏商贸服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用博鹏商贸服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用博鹏商贸服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用博鹏商贸服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有博鹏商贸官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是博鹏商贸。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，博鹏商贸不承担责任。博鹏商贸发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向博鹏商贸所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_esExports = { render: agreement_render, staticRenderFns: agreement_staticRenderFns }
/* harmony default export */ var agreement = (agreement_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement.vue
function agreement_injectStyle (ssrContext) {
  __webpack_require__("ygp0")
  __webpack_require__("yS1U")
}
var agreement_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement___vue_script__ = null
/* template */

/* template functional */
var agreement___vue_template_functional__ = false
/* styles */
var agreement___vue_styles__ = agreement_injectStyle
/* scopeId */
var agreement___vue_scopeId__ = "data-v-5a9e1bfd"
/* moduleIdentifier (server only) */
var agreement___vue_module_identifier__ = null
var agreement_Component = agreement_normalizeComponent(
  agreement___vue_script__,
  agreement,
  agreement___vue_template_functional__,
  agreement___vue_styles__,
  agreement___vue_scopeId__,
  agreement___vue_module_identifier__
)

/* harmony default export */ var user_agreement = (agreement_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d99b13","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-dabenying.vue
var agreement_dabenying_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_dabenying_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海博鹏商贸有限公司就官方微信公众号“营养美学大本营”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海博鹏商贸有限公司（如下简称“博鹏商贸”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制博鹏商贸责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用博鹏商贸帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于博鹏商贸官方微信公众号“营养美学大本营”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由博鹏商贸在旗下公众号“营养美学大本营”中用于识别您身份的标识。帐号的所有权属于博鹏商贸，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过营养美学大本营享受博鹏商贸旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“营养美学大本营”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用博鹏商贸服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，博鹏商贸不负任何责任。您可以通过博鹏商贸预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经博鹏商贸审核，如存在上述情况，博鹏商贸将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，博鹏商贸有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为博鹏商贸旗下公众号“营养美学大本营”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及博鹏商贸商业信息，您的营养美学账号仅限您本人使用。未经博鹏商贸同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据博鹏商贸各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或博鹏商贸信息安全的，博鹏商贸可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆博鹏商贸的服务，第三方帐号将与您的营养美学账号相关联，博鹏商贸将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过博鹏商贸安全验证，博鹏商贸有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过博鹏商贸提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，博鹏商贸有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时博鹏商贸保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“营养美学大本营”中的账号权限将被博鹏商贸回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，博鹏商贸会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，博鹏商贸任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，博鹏商贸并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是博鹏商贸官方在微信公众号“营养美学大本营”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向博鹏商贸与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿博鹏商贸与合作公司、关联公司，并使之免受损害。同时，博鹏商贸有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，博鹏商贸会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用博鹏商贸服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在博鹏商贸首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予博鹏商贸等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，博鹏商贸都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，博鹏商贸不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映博鹏商贸的任何观点或政策，博鹏商贸对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，博鹏商贸均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用博鹏商贸功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用博鹏商贸服务而支付给博鹏商贸的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，博鹏商贸对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，博鹏商贸有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，博鹏商贸将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用博鹏商贸服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用博鹏商贸服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用博鹏商贸服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用博鹏商贸服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用博鹏商贸服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有博鹏商贸官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是博鹏商贸。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，博鹏商贸不承担责任。博鹏商贸发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向博鹏商贸所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_dabenying_esExports = { render: agreement_dabenying_render, staticRenderFns: agreement_dabenying_staticRenderFns }
/* harmony default export */ var agreement_dabenying = (agreement_dabenying_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-dabenying.vue
function agreement_dabenying_injectStyle (ssrContext) {
  __webpack_require__("0TSc")
  __webpack_require__("bPdr")
}
var agreement_dabenying_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_dabenying___vue_script__ = null
/* template */

/* template functional */
var agreement_dabenying___vue_template_functional__ = false
/* styles */
var agreement_dabenying___vue_styles__ = agreement_dabenying_injectStyle
/* scopeId */
var agreement_dabenying___vue_scopeId__ = "data-v-64d99b13"
/* moduleIdentifier (server only) */
var agreement_dabenying___vue_module_identifier__ = null
var agreement_dabenying_Component = agreement_dabenying_normalizeComponent(
  agreement_dabenying___vue_script__,
  agreement_dabenying,
  agreement_dabenying___vue_template_functional__,
  agreement_dabenying___vue_styles__,
  agreement_dabenying___vue_scopeId__,
  agreement_dabenying___vue_module_identifier__
)

/* harmony default export */ var user_agreement_dabenying = (agreement_dabenying_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfccca52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-bopeng.vue
var agreement_bopeng_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_bopeng_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海博鹏商贸有限公司就官方微信公众号“上海博鹏营养美学”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海博鹏商贸有限公司（如下简称“博鹏商贸”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制博鹏商贸责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用博鹏商贸帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于博鹏商贸官方微信公众号“上海博鹏营养美学”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由博鹏商贸在旗下公众号“上海博鹏营养美学”中用于识别您身份的标识。帐号的所有权属于博鹏商贸，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过上海博鹏营养美学享受博鹏商贸旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“上海博鹏营养美学”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用博鹏商贸服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，博鹏商贸不负任何责任。您可以通过博鹏商贸预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经博鹏商贸审核，如存在上述情况，博鹏商贸将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，博鹏商贸有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为博鹏商贸旗下公众号“上海博鹏营养美学”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及博鹏商贸商业信息，您的营养美学账号仅限您本人使用。未经博鹏商贸同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据博鹏商贸各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或博鹏商贸信息安全的，博鹏商贸可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆博鹏商贸的服务，第三方帐号将与您的营养美学账号相关联，博鹏商贸将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过博鹏商贸安全验证，博鹏商贸有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过博鹏商贸提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，博鹏商贸有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时博鹏商贸保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“上海博鹏营养美学”中的账号权限将被博鹏商贸回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，博鹏商贸会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，博鹏商贸任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，博鹏商贸并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是博鹏商贸官方在微信公众号“上海博鹏营养美学”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向博鹏商贸与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿博鹏商贸与合作公司、关联公司，并使之免受损害。同时，博鹏商贸有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，博鹏商贸会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用博鹏商贸服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在博鹏商贸首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予博鹏商贸等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，博鹏商贸都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，博鹏商贸不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映博鹏商贸的任何观点或政策，博鹏商贸对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，博鹏商贸均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用博鹏商贸功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用博鹏商贸服务而支付给博鹏商贸的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，博鹏商贸对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，博鹏商贸有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，博鹏商贸将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用博鹏商贸服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用博鹏商贸服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用博鹏商贸服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用博鹏商贸服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用博鹏商贸服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有博鹏商贸官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是博鹏商贸。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，博鹏商贸不承担责任。博鹏商贸发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向博鹏商贸所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_bopeng_esExports = { render: agreement_bopeng_render, staticRenderFns: agreement_bopeng_staticRenderFns }
/* harmony default export */ var agreement_bopeng = (agreement_bopeng_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-bopeng.vue
function agreement_bopeng_injectStyle (ssrContext) {
  __webpack_require__("dg2t")
  __webpack_require__("2Eqv")
}
var agreement_bopeng_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_bopeng___vue_script__ = null
/* template */

/* template functional */
var agreement_bopeng___vue_template_functional__ = false
/* styles */
var agreement_bopeng___vue_styles__ = agreement_bopeng_injectStyle
/* scopeId */
var agreement_bopeng___vue_scopeId__ = "data-v-dfccca52"
/* moduleIdentifier (server only) */
var agreement_bopeng___vue_module_identifier__ = null
var agreement_bopeng_Component = agreement_bopeng_normalizeComponent(
  agreement_bopeng___vue_script__,
  agreement_bopeng,
  agreement_bopeng___vue_template_functional__,
  agreement_bopeng___vue_styles__,
  agreement_bopeng___vue_scopeId__,
  agreement_bopeng___vue_module_identifier__
)

/* harmony default export */ var user_agreement_bopeng = (agreement_bopeng_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752e2a34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-jiajiuhui.vue
var agreement_jiajiuhui_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_jiajiuhui_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海美响生物科技有限公司就官方微信公众号“美响”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海美响生物科技有限公司（如下简称“美响生物”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制美响生物责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用美响生物帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于美响生物官方微信公众号“美响”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由美响生物在旗下公众号“美响”中用于识别您身份的标识。帐号的所有权属于美响生物，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过美响享受美响生物旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“美响”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用美响生物服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，美响生物不负任何责任。您可以通过美响生物预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经美响生物审核，如存在上述情况，美响生物将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，美响生物有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为美响生物旗下公众号“美响”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及美响生物商业信息，您的营养美学账号仅限您本人使用。未经美响生物同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据美响生物各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或美响生物信息安全的，美响生物可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆美响生物的服务，第三方帐号将与您的营养美学账号相关联，美响生物将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过美响生物安全验证，美响生物有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过美响生物提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，美响生物有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时美响生物保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“美响”中的账号权限将被美响生物回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，美响生物会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，美响生物任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，美响生物并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是美响生物官方在微信公众号“美响”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向美响生物与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿美响生物与合作公司、关联公司，并使之免受损害。同时，美响生物有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，美响生物会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用美响生物服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在美响生物首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予美响生物等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，美响生物都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，美响生物不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映美响生物的任何观点或政策，美响生物对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，美响生物均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用美响生物功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用美响生物服务而支付给美响生物的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，美响生物对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，美响生物有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，美响生物将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用美响生物服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用美响生物服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用美响生物服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用美响生物服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用美响生物服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有美响生物官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是美响生物。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，美响生物不承担责任。美响生物发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向美响生物所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_jiajiuhui_esExports = { render: agreement_jiajiuhui_render, staticRenderFns: agreement_jiajiuhui_staticRenderFns }
/* harmony default export */ var agreement_jiajiuhui = (agreement_jiajiuhui_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-jiajiuhui.vue
function agreement_jiajiuhui_injectStyle (ssrContext) {
  __webpack_require__("IEov")
  __webpack_require__("hNYO")
}
var agreement_jiajiuhui_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_jiajiuhui___vue_script__ = null
/* template */

/* template functional */
var agreement_jiajiuhui___vue_template_functional__ = false
/* styles */
var agreement_jiajiuhui___vue_styles__ = agreement_jiajiuhui_injectStyle
/* scopeId */
var agreement_jiajiuhui___vue_scopeId__ = "data-v-752e2a34"
/* moduleIdentifier (server only) */
var agreement_jiajiuhui___vue_module_identifier__ = null
var agreement_jiajiuhui_Component = agreement_jiajiuhui_normalizeComponent(
  agreement_jiajiuhui___vue_script__,
  agreement_jiajiuhui,
  agreement_jiajiuhui___vue_template_functional__,
  agreement_jiajiuhui___vue_styles__,
  agreement_jiajiuhui___vue_scopeId__,
  agreement_jiajiuhui___vue_module_identifier__
)

/* harmony default export */ var user_agreement_jiajiuhui = (agreement_jiajiuhui_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477ad994","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-boxing.vue
var agreement_boxing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_boxing_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海泊兴生物科技有限公司就官方微信公众号“上海泊兴营养美学”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海泊兴生物科技有限公司（如下简称“泊兴生物”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制泊兴生物责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用泊兴生物帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于泊兴生物官方微信公众号“上海泊兴营养美学”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由泊兴生物在旗下公众号“上海泊兴营养美学”中用于识别您身份的标识。帐号的所有权属于泊兴生物，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过上海泊兴营养美学享受泊兴生物旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“上海泊兴营养美学”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用泊兴生物服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，泊兴生物不负任何责任。您可以通过泊兴生物预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经泊兴生物审核，如存在上述情况，泊兴生物将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，泊兴生物有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为泊兴生物旗下公众号“上海泊兴营养美学”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及泊兴生物商业信息，您的营养美学账号仅限您本人使用。未经泊兴生物同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据泊兴生物各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或泊兴生物信息安全的，泊兴生物可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆泊兴生物的服务，第三方帐号将与您的营养美学账号相关联，泊兴生物将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过泊兴生物安全验证，泊兴生物有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过泊兴生物提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，泊兴生物有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时泊兴生物保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“上海泊兴营养美学”中的账号权限将被泊兴生物回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，泊兴生物会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，泊兴生物任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，泊兴生物并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是泊兴生物官方在微信公众号“上海泊兴营养美学”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向泊兴生物与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿泊兴生物与合作公司、关联公司，并使之免受损害。同时，泊兴生物有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，泊兴生物会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用泊兴生物服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在泊兴生物首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予泊兴生物等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，泊兴生物都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，泊兴生物不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映泊兴生物的任何观点或政策，泊兴生物对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，泊兴生物均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用泊兴生物功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用泊兴生物服务而支付给泊兴生物的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，泊兴生物对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，泊兴生物有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，泊兴生物将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用泊兴生物服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用泊兴生物服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用泊兴生物服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用泊兴生物服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用泊兴生物服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有泊兴生物官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是泊兴生物。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，泊兴生物不承担责任。泊兴生物发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向泊兴生物所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_boxing_esExports = { render: agreement_boxing_render, staticRenderFns: agreement_boxing_staticRenderFns }
/* harmony default export */ var agreement_boxing = (agreement_boxing_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-boxing.vue
function agreement_boxing_injectStyle (ssrContext) {
  __webpack_require__("z+QX")
  __webpack_require__("1pDs")
}
var agreement_boxing_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_boxing___vue_script__ = null
/* template */

/* template functional */
var agreement_boxing___vue_template_functional__ = false
/* styles */
var agreement_boxing___vue_styles__ = agreement_boxing_injectStyle
/* scopeId */
var agreement_boxing___vue_scopeId__ = "data-v-477ad994"
/* moduleIdentifier (server only) */
var agreement_boxing___vue_module_identifier__ = null
var agreement_boxing_Component = agreement_boxing_normalizeComponent(
  agreement_boxing___vue_script__,
  agreement_boxing,
  agreement_boxing___vue_template_functional__,
  agreement_boxing___vue_styles__,
  agreement_boxing___vue_scopeId__,
  agreement_boxing___vue_module_identifier__
)

/* harmony default export */ var user_agreement_boxing = (agreement_boxing_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20346960","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-fuqi.vue
var agreement_fuqi_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_fuqi_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海福启生物科技有限公司就官方微信公众号“上海福启营养美学”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海福启生物科技有限公司（如下简称“复启生物”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制复启生物责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用复启生物帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于复启生物官方微信公众号“上海福启营养美学”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由复启生物在旗下公众号“上海福启营养美学”中用于识别您身份的标识。帐号的所有权属于复启生物，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过上海福启营养美学享受复启生物旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“上海福启营养美学”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用复启生物服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，复启生物不负任何责任。您可以通过复启生物预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经复启生物审核，如存在上述情况，复启生物将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，复启生物有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为复启生物旗下公众号“上海福启营养美学”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及复启生物商业信息，您的营养美学账号仅限您本人使用。未经复启生物同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据复启生物各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或复启生物信息安全的，复启生物可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆复启生物的服务，第三方帐号将与您的营养美学账号相关联，复启生物将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过复启生物安全验证，复启生物有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过复启生物提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，复启生物有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时复启生物保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“上海福启营养美学”中的账号权限将被复启生物回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，复启生物会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，复启生物任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，复启生物并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是复启生物官方在微信公众号“上海福启营养美学”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向复启生物与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿复启生物与合作公司、关联公司，并使之免受损害。同时，复启生物有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，复启生物会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用复启生物服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在复启生物首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予复启生物等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，复启生物都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，复启生物不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映复启生物的任何观点或政策，复启生物对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，复启生物均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用复启生物功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用复启生物服务而支付给复启生物的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，复启生物对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，复启生物有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，复启生物将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用复启生物服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用复启生物服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用复启生物服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用复启生物服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用复启生物服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有复启生物官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是复启生物。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，复启生物不承担责任。复启生物发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向复启生物所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_fuqi_esExports = { render: agreement_fuqi_render, staticRenderFns: agreement_fuqi_staticRenderFns }
/* harmony default export */ var agreement_fuqi = (agreement_fuqi_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-fuqi.vue
function agreement_fuqi_injectStyle (ssrContext) {
  __webpack_require__("Ej8a")
  __webpack_require__("yjEN")
}
var agreement_fuqi_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_fuqi___vue_script__ = null
/* template */

/* template functional */
var agreement_fuqi___vue_template_functional__ = false
/* styles */
var agreement_fuqi___vue_styles__ = agreement_fuqi_injectStyle
/* scopeId */
var agreement_fuqi___vue_scopeId__ = "data-v-20346960"
/* moduleIdentifier (server only) */
var agreement_fuqi___vue_module_identifier__ = null
var agreement_fuqi_Component = agreement_fuqi_normalizeComponent(
  agreement_fuqi___vue_script__,
  agreement_fuqi,
  agreement_fuqi___vue_template_functional__,
  agreement_fuqi___vue_styles__,
  agreement_fuqi___vue_scopeId__,
  agreement_fuqi___vue_module_identifier__
)

/* harmony default export */ var user_agreement_fuqi = (agreement_fuqi_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f94f4982","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-beifu.vue
var agreement_beifu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_beifu_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海北府生物科技有限公司就官方微信公众号“上海北府营养美学”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海北府生物科技有限公司（如下简称“北府生物”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制北府生物责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用北府生物帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于北府生物官方微信公众号“上海北府营养美学”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由北府生物在旗下公众号“上海北府营养美学”中用于识别您身份的标识。帐号的所有权属于北府生物，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过上海北府营养美学享受北府生物旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“上海北府营养美学”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用北府生物服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，北府生物不负任何责任。您可以通过北府生物预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经北府生物审核，如存在上述情况，北府生物将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，北府生物有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为北府生物旗下公众号“上海北府营养美学”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及北府生物商业信息，您的营养美学账号仅限您本人使用。未经北府生物同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据北府生物各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或北府生物信息安全的，北府生物可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆北府生物的服务，第三方帐号将与您的营养美学账号相关联，北府生物将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过北府生物安全验证，北府生物有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过北府生物提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，北府生物有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时北府生物保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“上海北府营养美学”中的账号权限将被北府生物回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，北府生物会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，北府生物任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，北府生物并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是北府生物官方在微信公众号“上海北府营养美学”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向北府生物与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿北府生物与合作公司、关联公司，并使之免受损害。同时，北府生物有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，北府生物会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用北府生物服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在北府生物首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予北府生物等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，北府生物都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，北府生物不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映北府生物的任何观点或政策，北府生物对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，北府生物均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用北府生物功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用北府生物服务而支付给北府生物的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，北府生物对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，北府生物有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，北府生物将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用北府生物服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用北府生物服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用北府生物服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用北府生物服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用北府生物服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有北府生物官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是北府生物。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，北府生物不承担责任。北府生物发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向北府生物所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_beifu_esExports = { render: agreement_beifu_render, staticRenderFns: agreement_beifu_staticRenderFns }
/* harmony default export */ var agreement_beifu = (agreement_beifu_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-beifu.vue
function agreement_beifu_injectStyle (ssrContext) {
  __webpack_require__("Ta6R")
  __webpack_require__("OfBk")
}
var agreement_beifu_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_beifu___vue_script__ = null
/* template */

/* template functional */
var agreement_beifu___vue_template_functional__ = false
/* styles */
var agreement_beifu___vue_styles__ = agreement_beifu_injectStyle
/* scopeId */
var agreement_beifu___vue_scopeId__ = "data-v-f94f4982"
/* moduleIdentifier (server only) */
var agreement_beifu___vue_module_identifier__ = null
var agreement_beifu_Component = agreement_beifu_normalizeComponent(
  agreement_beifu___vue_script__,
  agreement_beifu,
  agreement_beifu___vue_template_functional__,
  agreement_beifu___vue_styles__,
  agreement_beifu___vue_scopeId__,
  agreement_beifu___vue_module_identifier__
)

/* harmony default export */ var user_agreement_beifu = (agreement_beifu_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f0f254","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-cehao.vue
var agreement_cehao_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_cehao_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海策浩生物科技有限公司就官方微信公众号“上海策浩营养美学”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海策浩生物科技有限公司（如下简称“策浩生物”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制策浩生物责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用策浩生物帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于策浩生物官方微信公众号“上海策浩营养美学”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由策浩生物在旗下公众号“上海策浩营养美学”中用于识别您身份的标识。帐号的所有权属于策浩生物，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过上海策浩营养美学享受策浩生物旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“上海策浩营养美学”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用策浩生物服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，策浩生物不负任何责任。您可以通过策浩生物预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经策浩生物审核，如存在上述情况，策浩生物将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，策浩生物有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为策浩生物旗下公众号“上海策浩营养美学”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及策浩生物商业信息，您的营养美学账号仅限您本人使用。未经策浩生物同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据策浩生物各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或策浩生物信息安全的，策浩生物可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆策浩生物的服务，第三方帐号将与您的营养美学账号相关联，策浩生物将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过策浩生物安全验证，策浩生物有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过策浩生物提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，策浩生物有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时策浩生物保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“上海策浩营养美学”中的账号权限将被策浩生物回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，策浩生物会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，策浩生物任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，策浩生物并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是策浩生物官方在微信公众号“上海策浩营养美学”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向策浩生物与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿策浩生物与合作公司、关联公司，并使之免受损害。同时，策浩生物有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，策浩生物会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用策浩生物服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在策浩生物首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予策浩生物等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，策浩生物都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，策浩生物不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映策浩生物的任何观点或政策，策浩生物对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，策浩生物均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用策浩生物功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用策浩生物服务而支付给策浩生物的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，策浩生物对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，策浩生物有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，策浩生物将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用策浩生物服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用策浩生物服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用策浩生物服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用策浩生物服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用策浩生物服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有策浩生物官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是策浩生物。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，策浩生物不承担责任。策浩生物发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向策浩生物所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_cehao_esExports = { render: agreement_cehao_render, staticRenderFns: agreement_cehao_staticRenderFns }
/* harmony default export */ var agreement_cehao = (agreement_cehao_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-cehao.vue
function agreement_cehao_injectStyle (ssrContext) {
  __webpack_require__("T5i4")
  __webpack_require__("08Al")
}
var agreement_cehao_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_cehao___vue_script__ = null
/* template */

/* template functional */
var agreement_cehao___vue_template_functional__ = false
/* styles */
var agreement_cehao___vue_styles__ = agreement_cehao_injectStyle
/* scopeId */
var agreement_cehao___vue_scopeId__ = "data-v-70f0f254"
/* moduleIdentifier (server only) */
var agreement_cehao___vue_module_identifier__ = null
var agreement_cehao_Component = agreement_cehao_normalizeComponent(
  agreement_cehao___vue_script__,
  agreement_cehao,
  agreement_cehao___vue_template_functional__,
  agreement_cehao___vue_styles__,
  agreement_cehao___vue_scopeId__,
  agreement_cehao___vue_module_identifier__
)

/* harmony default export */ var user_agreement_cehao = (agreement_cehao_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361a8060","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/agreement-baoleqi.vue
var agreement_baoleqi_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"title flex-between"},[_c('span',[_vm._v("用户服务协议")]),_vm._v(" "),(_vm.$root.themeType == 'yellow')?_c('img',{attrs:{"src":__webpack_require__("XwiW"),"alt":""}}):_vm._e()]),_vm._v(" "),_vm._m(0)])}
var agreement_baoleqi_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h4',[_vm._v("欢迎您注册、使用“营养美学下单提货”系统帐号！")]),_vm._v(" "),_c('p',[_vm._v("\n      本协议系您与上海宝乐淇生物科技有限公司就官方微信公众号“上海宝乐淇营养美学”中“营养美学下单提货”功能下的帐号注册和使用而订立的。上海宝乐淇生物科技有限公司（如下简称“宝乐淇生物”）在此特别提醒您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制宝乐淇生物责任的条款，对您的权利限制条款，争议解决和法律适用条款等。请您审慎阅读并选择接受或不接受本协议（限制民事行为能力人应在监护人或法定代理人陪同下阅读）。除非您接受本协议所有条款，否则您无权注册、使用帐号。您的注册和使用宝乐淇生物帐号行为将视为您已充分理解本协议（即本协议及后续更新版本或开通或使用某项服务的单项协议），并同意接受本协议各项条款的约束。\n      "),_c('span')]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        一、 关于宝乐淇生物官方微信公众号“上海宝乐淇营养美学”中“营养美学下单提货”功能帐号（以下简称“营养美学账号”）\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.1营养美学账号系由宝乐淇生物在旗下公众号“上海宝乐淇营养美学”中用于识别您身份的标识。帐号的所有权属于宝乐淇生物，您作为初始申请注册人仅拥有您所注册帐号的使用权。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.2您可通过上海宝乐淇营养美学享受宝乐淇生物旗下公众号“营养美学下单提货”中提供的单项服务包括但不限于下单、支付、发货等服务。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        1.3 本服务条款的效力范围仅限于公众号“上海宝乐淇营养美学”中“营养美学下单提货”功能所提供的服务，您在享受任何单项服务时，应当受本服务条款的约束。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("\n        二、帐号使用规则\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.1注册帐号")]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.1 您确认，在您开始注册（绑定预留手机号）程序使用宝乐淇生物服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.1.2 您应提供真实有效的个人资料。您保证在注册时所提交的所有资料（包括但不限于手机号码、姓名等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，宝乐淇生物不负任何责任。您可以通过宝乐淇生物预先通知您的“实名认证”功能认证个人信息，且您提交的帐号名称、头像和其他个人信息等注册信息中不得出现违法和不良信息，经宝乐淇生物审核，如存在上述情况，宝乐淇生物将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、其他个人信等注册信息存在违法和不良信息的，宝乐淇生物有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册（或绑定预留手机号）页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得营养美学账号并成为宝乐淇生物旗下公众号“上海宝乐淇营养美学”的用户。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.2帐号使用")]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.1 您应对您帐号项下的所有行为结果（包括但不限于在线支付货款、在线支付运费、编辑和使用收件人信息等）负责。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.2 由于您的营养美学账号关联您的个人信息及宝乐淇生物商业信息，您的营养美学账号仅限您本人使用。未经宝乐淇生物同意，您直接或间接授权第三方使用您营养美学账号或获取您帐号项下信息的行为无效。如根据宝乐淇生物各平台规则中约定的违约认定程序及标准判断您营养美学账号的使用可能危及您的帐号安全及或宝乐淇生物信息安全的，宝乐淇生物可拒绝提供相应服务或终止本协议。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.2.3 若您选择第三方帐号登陆宝乐淇生物的服务，第三方帐号将与您的营养美学账号相关联，宝乐淇生物将根据您授权第三方提供的信息而使用您的信息（如头像）。您后续使用该营养美学账号的行为受本协议约束。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.3帐号保管和找回")]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.1 营养美学账号包括已绑定的个人微信名称和头像，以及预留并绑定好的手机号，您应妥善保管好您的预留手机号及短信验证码，因您个人原因导致的帐号信息遗失，如需找回营养美学账号信息，请及时联系官方服务人员进行处理，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过宝乐淇生物安全验证，宝乐淇生物有权拒绝提供帐号找回服务；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.3.2 如果您当前使用的营养美学账号并非您初始申请注册的预留手机号或通过宝乐淇生物提供的其他途径获得的，可以联系官方服务人员进行身份核实后修改。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.4帐号转让")]),_vm._v(" "),_c('p',[_vm._v("\n            2.4.1 您可在本协议约定的范围内使用营养美学账号，您不得恶意注册营养美学账号，不得赠与、借用、租用、有偿或无偿转让或售卖营养美学账号或者以其他方式许可非初始申请注册人使用营养美学账号，宝乐淇生物有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时宝乐淇生物保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.5帐号回收")]),_vm._v(" "),_c('p',[_vm._v("\n            2.5.1为了防止资源占用，如您已经不是我们的会员，您所关注的官方微信公众号“上海宝乐淇营养美学”中的账号权限将被宝乐淇生物回收处理，您将不再享受任何权利，您账号中的所有信息将被注销。如该帐号有关联的待处理交易等，宝乐淇生物会在合理范围内协助您处理，请您按照服务人员提示的方式进行操作。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.6 帐号安全")]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.1 您的帐号为您自行设置并由您保管，宝乐淇生物任何时候均不会主动索取您的短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.6.2 营养美学账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，宝乐淇生物并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("2.7帐号注销")]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.1 您所绑定并使用的营养美学账号是宝乐淇生物官方在微信公众号“上海宝乐淇营养美学”中参与“营养美学下单提货”时需要的账号，“营养美学下单提货”功能为时效性功能，此功能下线或者改版前官方会发送通知给所有用户，通知会采取但不限于手机短信通知、微信公众号信息推送等方式。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.2 您的营养美学账号在官方统一注销前，会保证您的账号中已无商品可交易，竟可放心。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            2.7.3 您应当知晓您的帐号注销意味着您的用户内容将从我们的活动数据库中删除。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("\n        3.1您在使用微信公众号的“营养美学限量抢单”服务时，必须遵守《网络安全法》、《互联网新闻信息服务管理规定》等中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.2您违反本协议或相关的服务条款的规定，导致或产生的任何第三方向宝乐淇生物与合作公司、关联公司主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿宝乐淇生物与合作公司、关联公司，并使之免受损害。同时，宝乐淇生物有权视您的行为性质，采取包括但不限于删除发布信息内容、终止服务、限制使用营养美学账号、追究法律责任等措施。同时，宝乐淇生物会视司法部门的要求，协助调查。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.3您须对自己在使用宝乐淇生物服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在宝乐淇生物首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予宝乐淇生物等额的赔偿。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        3.4在任何情况下，宝乐淇生物都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("四、免责声明")]),_vm._v(" "),_c('p',[_vm._v("\n        4.1如发生下述情形，宝乐淇生物不承担任何法律责任：\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.1 依据法律规定或相关政府部门的要求提供您的个人信息；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.2 由于您的使用不当或其他自身原因而导致任何个人信息的泄露；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.4 因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.5 用户之间通过“营养美学下单提货”功能与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.6 您在利用营养美学账号所发布的任何内容并不代表和反映宝乐淇生物的任何观点或政策，宝乐淇生物对此不承担任何责任。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            4.1.7 在任何情况下，宝乐淇生物均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用宝乐淇生物功能服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在注册期内因使用宝乐淇生物服务而支付给宝乐淇生物的费用(如有)。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        4.2 您可以选择使用您已有的第三方帐号关联营养美学账号，宝乐淇生物对于因第三方原因对您造成的损失不承担任何责任。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("五、修订")]),_vm._v(" "),_c('p',[_vm._v("\n        5.1鉴于互联网相关技术、市场、业务模式等等的发展迅速，您同意，宝乐淇生物有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等不定时地制定、修改本协议及各类规则。如有修订，宝乐淇生物将通过法定程序通知。经修订的协议、规则一经公布，则立即自动生效，且成为本服务协议不可分割的一部分。如您不同意上述修订，则您必须立即停止使用本协议下各项服务。您继续登录或继续使用宝乐淇生物服务，则表明您认可并接受经修订的协议、规则。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("六、 终止")]),_vm._v(" "),_c('p',[_vm._v("\n        6.1 本协议自您接受之日起生效，在您使用宝乐淇生物服务的过程中持续有效，直至依据本协议终止；\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.2 尽管有上述规定，如果您使用宝乐淇生物服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用宝乐淇生物服务时生效，除非依据本协议提前终止。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        6.3 我们可能会依据法律的规定，保留您使用宝乐淇生物服务、或者营养美学账号的权利；无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意地相信您违反了我们可接受使用政策或本协议的其他规定。\n        "),_c('span')])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("七、其他")]),_vm._v(" "),_c('p',[_vm._v("\n        7.1短信验证码\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.1.1 当您绑定预留手机号时，会收到有宝乐淇生物官方通过第三方通讯平台发送给您的验证码，验证码是以“营养美学”开头，此时“营养美学”代表的是宝乐淇生物。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.2 通知\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.2.1 您必须提供您最近经常使用的有效的手机号码。您所提供的手机号码无法使用或者因任何原因我们无法将通知送达给您而产生的风险，宝乐淇生物不承担责任。宝乐淇生物发布的公告通知及向您所发送的包含此类通知的短信毫无疑问构成有效通知。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.3 适用法律\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.1 本协议适用中华人民共和国法律。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向宝乐淇生物所在的人民法院提起诉讼。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n        7.4 独立性\n        "),_c('span')]),_vm._v(" "),_c('p',[_vm._v("\n            7.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。\n        "),_c('span')])])])}]
var agreement_baoleqi_esExports = { render: agreement_baoleqi_render, staticRenderFns: agreement_baoleqi_staticRenderFns }
/* harmony default export */ var agreement_baoleqi = (agreement_baoleqi_esExports);
// CONCATENATED MODULE: ./src/views/user/agreement-baoleqi.vue
function agreement_baoleqi_injectStyle (ssrContext) {
  __webpack_require__("fwTf")
  __webpack_require__("Ic6x")
}
var agreement_baoleqi_normalizeComponent = __webpack_require__("VU/8")
/* script */
var agreement_baoleqi___vue_script__ = null
/* template */

/* template functional */
var agreement_baoleqi___vue_template_functional__ = false
/* styles */
var agreement_baoleqi___vue_styles__ = agreement_baoleqi_injectStyle
/* scopeId */
var agreement_baoleqi___vue_scopeId__ = "data-v-361a8060"
/* moduleIdentifier (server only) */
var agreement_baoleqi___vue_module_identifier__ = null
var agreement_baoleqi_Component = agreement_baoleqi_normalizeComponent(
  agreement_baoleqi___vue_script__,
  agreement_baoleqi,
  agreement_baoleqi___vue_template_functional__,
  agreement_baoleqi___vue_styles__,
  agreement_baoleqi___vue_scopeId__,
  agreement_baoleqi___vue_module_identifier__
)

/* harmony default export */ var user_agreement_baoleqi = (agreement_baoleqi_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/user/remind.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var remind = ({
  data: function data() {
    return {};
  },

  computed: {
    memberId: function memberId() {
      return this.$route.query.memberId;
    },
    companyId: function companyId() {
      return this.$route.query.companyId;
    },
    inforImg: function inforImg() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("Kssp");
      } else {
        return __webpack_require__("lmQy");
      }
    },
    remindImg: function remindImg() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("R3hu");
      } else {
        return __webpack_require__("w5Ii");
      }
    }
  },
  methods: {
    clickKnown: function clickKnown() {
      sysUtils.navWeb(this.memberId, this.companyId, this.$root.themeType);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/user/remind.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var user_remind = ({
  data: function data() {
    return {};
  },

  computed: {
    memberId: function memberId() {
      return this.$route.query.memberId;
    },
    companyId: function companyId() {
      return this.$route.query.companyId;
    },
    inforImg: function inforImg() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("Kssp");
      } else {
        return __webpack_require__("lmQy");
      }
    },
    remindImg: function remindImg() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("R3hu");
      } else {
        return __webpack_require__("w5Ii");
      }
    }
  },
  methods: {
    clickKnown: function clickKnown() {
      sysUtils.navWeb(this.memberId, this.companyId, this.$root.themeType);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d1cd0e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/remind.vue
var remind_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remind"},[_c('div',{staticClass:"header flex-between"},[_c('div',[(_vm.$root.themeType == 'black')?_c('h3',[_vm._v("亲爱的会员")]):_vm._e(),_vm._v(" "),_c('h1',[_vm._v("欢迎使用")])]),_vm._v(" "),_c('img',{attrs:{"src":_vm.inforImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('p',[_vm._v("为响应国家保障网络安全交易的号召，保障您的销售权益，我们将在本次登陆时为您进行线上实名和销售协议签署，以便更好地为您服务。")]),_vm._v(" "),_c('div',{staticClass:"vux-1px-tb"},[_c('ul',[_c('li',{staticClass:"flex-between"},[_c('img',{attrs:{"src":_vm.remindImg,"alt":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('li',{staticClass:"flex-between"},[_c('img',{attrs:{"src":_vm.remindImg,"alt":""}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('li',{staticClass:"flex-between"},[_c('img',{attrs:{"src":_vm.remindImg,"alt":""}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":_vm.clickKnown}},[_vm._v("去完成")])])}
var remind_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n            请使用您之前预留的身份信息，按照指示步骤进行\n            "),_c('span',[_vm._v("实名认证")]),_vm._v("和\n            "),_c('span',[_vm._v("销售协议")]),_vm._v("的阅读、确认和签署。\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n            您的认证和签约\n            "),_c('span',[_vm._v("仅需进行一次")]),_vm._v("，此次完成后，未来登陆可直接进入服务页面。\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n            在实名认证和确认、签署协议的过程中，有疑问可退出，并联系您的\n            "),_c('span',[_vm._v("商务服务人员")]),_vm._v("咨询解决。\n          ")])}]
var remind_esExports = { render: remind_render, staticRenderFns: remind_staticRenderFns }
/* harmony default export */ var views_user_remind = (remind_esExports);
// CONCATENATED MODULE: ./src/views/user/remind.vue
function remind_injectStyle (ssrContext) {
  __webpack_require__("yUBp")
  __webpack_require__("5QQ9")
}
var remind_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var remind___vue_template_functional__ = false
/* styles */
var remind___vue_styles__ = remind_injectStyle
/* scopeId */
var remind___vue_scopeId__ = "data-v-6d1cd0e2"
/* moduleIdentifier (server only) */
var remind___vue_module_identifier__ = null
var remind_Component = remind_normalizeComponent(
  user_remind,
  views_user_remind,
  remind___vue_template_functional__,
  remind___vue_styles__,
  remind___vue_scopeId__,
  remind___vue_module_identifier__
)

/* harmony default export */ var src_views_user_remind = (remind_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CRater.vue
//
//
//
//
//

/* harmony default export */ var CRater = ({
  props: {
    max: {
      type: Number,
      default: 5
    },
    size: {
      type: Number
    },
    value: {
      default: 0
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CRater.vue
//
//
//
//
//

/* harmony default export */ var components_CRater = ({
  props: {
    max: {
      type: Number,
      default: 5
    },
    size: {
      type: Number
    },
    value: {
      default: 0
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa7c6784","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CRater.vue
var CRater_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-rater"},_vm._l((_vm.max),function(i){return _c('img',{key:i,style:({width: _vm.size + 'px'}),attrs:{"src":i<=_vm.value?__webpack_require__("ZLiK"):__webpack_require__("1TGD"),"alt":""}})}),0)}
var CRater_staticRenderFns = []
var CRater_esExports = { render: CRater_render, staticRenderFns: CRater_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_CRater = (CRater_esExports);
// CONCATENATED MODULE: ./src/components/CRater.vue
function CRater_injectStyle (ssrContext) {
  __webpack_require__("hHyT")
}
var CRater_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CRater___vue_template_functional__ = false
/* styles */
var CRater___vue_styles__ = CRater_injectStyle
/* scopeId */
var CRater___vue_scopeId__ = "data-v-fa7c6784"
/* moduleIdentifier (server only) */
var CRater___vue_module_identifier__ = null
var CRater_Component = CRater_normalizeComponent(
  components_CRater,
  selectortype_template_index_0_src_components_CRater,
  CRater___vue_template_functional__,
  CRater___vue_styles__,
  CRater___vue_scopeId__,
  CRater___vue_module_identifier__
)

/* harmony default export */ var src_components_CRater = (CRater_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CAvatar.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CAvatar = ({
  data: function data() {
    return {
      star: 0,
      avatar: ""
    };
  },

  props: {
    size: {
      type: String,
      default: "normal" // normal mini big
    },
    enable: {
      type: Boolean,
      default: true // 是否有点击事件，默认有
    }
  },
  mounted: function mounted() {
    var userInfo = auth_getUserInfo();
    if (userInfo) {
      this.star = Number(userInfo.starLevel);
      if (userInfo.headImgUrl) {
        this.avatar = userInfo.headImgUrl;
      } else {
        this.avatar = __webpack_require__("HfaK");
      }
    }
  },

  methods: {
    toUserCenter: function toUserCenter() {
      if (this.enable === true) {
        this.$router.push({
          path: "/userCenter"
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CAvatar.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_CAvatar = ({
  data: function data() {
    return {
      star: 0,
      avatar: ""
    };
  },

  props: {
    size: {
      type: String,
      default: "normal" // normal mini big
    },
    enable: {
      type: Boolean,
      default: true // 是否有点击事件，默认有
    }
  },
  mounted: function mounted() {
    var userInfo = auth_getUserInfo();
    if (userInfo) {
      this.star = Number(userInfo.starLevel);
      if (userInfo.headImgUrl) {
        this.avatar = userInfo.headImgUrl;
      } else {
        this.avatar = __webpack_require__("HfaK");
      }
    }
  },

  methods: {
    toUserCenter: function toUserCenter() {
      if (this.enable === true) {
        this.$router.push({
          path: "/userCenter"
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-558a7858","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CAvatar.vue
var CAvatar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-avatar",class:{'mini':_vm.size == 'mini','big':_vm.size == 'big'},on:{"click":_vm.toUserCenter}},[(_vm.star <= 5)?_c('div',{staticClass:"star"},_vm._l((_vm.star),function(it,idx){return _c('img',{key:idx,attrs:{"src":__webpack_require__("Gbqg"),"alt":""}})}),0):_c('div',{staticClass:"crown"},[_c('img',{attrs:{"src":__webpack_require__("a6mX"),"alt":""}})]),_vm._v(" "),_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar,"alt":""}})])}
var CAvatar_staticRenderFns = []
var CAvatar_esExports = { render: CAvatar_render, staticRenderFns: CAvatar_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_CAvatar = (CAvatar_esExports);
// CONCATENATED MODULE: ./src/components/CAvatar.vue
function CAvatar_injectStyle (ssrContext) {
  __webpack_require__("lKRo")
  __webpack_require__("mfud")
}
var CAvatar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CAvatar___vue_template_functional__ = false
/* styles */
var CAvatar___vue_styles__ = CAvatar_injectStyle
/* scopeId */
var CAvatar___vue_scopeId__ = "data-v-558a7858"
/* moduleIdentifier (server only) */
var CAvatar___vue_module_identifier__ = null
var CAvatar_Component = CAvatar_normalizeComponent(
  components_CAvatar,
  selectortype_template_index_0_src_components_CAvatar,
  CAvatar___vue_template_functional__,
  CAvatar___vue_styles__,
  CAvatar___vue_scopeId__,
  CAvatar___vue_module_identifier__
)

/* harmony default export */ var src_components_CAvatar = (CAvatar_Component.exports);

// CONCATENATED MODULE: ./src/utils/numberUtils.js
/**
 * @author Bruce
 * @time 2019/4/9
 * @description 数字操作相关工具方法
 */

/* harmony default export */ var numberUtils = ({
  /**
   * 小数转化成百分数
   */
  toPercent: function toPercent(val) {
    return Number(val * 100).toFixed(2) + "%";
  },

  /**
   * 过滤手机号，将手机号变成中间四位*
   */
  filtMobile: function filtMobile(val) {
    val = val + '';
    return val.substr(0, 3) + "****" + val.substr(7);
  },

  /**
   * 过滤首位是0的数字，第一位不能是0
   * @param val 
   */
  filtFirstZero: function filtFirstZero(val) {
    var res = val;
    var reg = /^[1-9]\d*$/;
    if (!reg.test(val)) {
      res = val.replace(/^0/g, "");
    }
    return res;
  },

  /**
   * 将毫秒数转为对应的时分秒
   */
  toHMS: function toHMS(val) {
    var totalSeconds = parseInt(val / 1000);
    var hour = parseInt(totalSeconds / 3600); // 剩余多少小时
    var minute = parseInt(totalSeconds % 3600 / 60); // 剩余多少分钟
    var second = parseInt(totalSeconds % 3600 % 60); // 剩余多少秒
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    if (second < 10) {
      second = "0" + second;
    }
    return {
      hour: hour,
      minute: minute,
      second: second
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/user/userCenter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var userCenter = ({
  data: function data() {
    return {
      star: 0,
      starName: "",
      children: "",
      progress: "", // 进度条
      assessmentProgress: "", // 考核进度
      assessmentInfo: {}, // 考核信息
      stock: 0
    };
  },

  computed: {
    level: function level() {
      return auth_getUserInfo().memberLevel;
    },
    name: function name() {
      var userInfo = auth_getUserInfo();
      if (userInfo.phone) {
        return userInfo.phone;
      } else {
        return userInfo.nickName;
      }
    },
    status: function status() {
      return auth_getUserInfo().phoneStatus;
    },
    crownIcon: function crownIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("MzHY");
      } else {
        return __webpack_require__("1sGk");
      }
    },
    zhifuIcon: function zhifuIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("D7TH");
      } else {
        return __webpack_require__("TT4j");
      }
    },
    kucunIcon: function kucunIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("fswM");
      } else {
        return __webpack_require__("6vAA");
      }
    },
    tihuoIcon: function tihuoIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("e7qV");
      } else {
        return __webpack_require__("SFeO");
      }
    },
    dizhiIcon: function dizhiIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("EgD5");
      } else {
        return __webpack_require__("fu0F");
      }
    },
    hetongIcon: function hetongIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("IPaY");
      } else {
        return __webpack_require__("HhrA");
      }
    }
  },
  mounted: function mounted() {
    // 页面初始化获取用户信息
    this.getUserInfo();
  },

  methods: {
    /**
     * 获取用户信息，更新本地用户信息数据
     */
    getUserInfo: function getUserInfo() {
      var _this = this;

      userService.getUserInfo().then(function (res) {
        var userInfo = res.data;
        _this.star = Number(userInfo.starLevel);
        _this.starName = userInfo.starLevelName;
        _this.children = userInfo.totalChildren;
        _this.progress = numberUtils.toPercent(userInfo.totalChildren / 30);

        setUserInfo(userInfo);

        _this.getStock();
        _this.agentExamineCycle();
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取用户库存
     */
    getStock: function getStock() {
      var _this2 = this;

      userService.queryStock(PRODUCTID).then(function (res) {
        _this2.stock = res.data.stock;
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取考核信息
     */
    agentExamineCycle: function agentExamineCycle() {
      var _this3 = this;

      userService.agentExamineCycle().then(function (res) {
        var data = res.data;
        var assessmentProgress = numberUtils.toPercent(data.extractNum / data.assessmentCriteria);
        var lastNum = data.assessmentCriteria - data.extractNum;
        lastNum = lastNum <= 0 ? 0 : lastNum;

        _this3.assessmentInfo = extends_default()({}, data, {
          assessmentProgress: assessmentProgress,
          lastNum: lastNum
        });
      }).catch(function (err) {
        _this3.$vux.toast.text(err.msg);
      });
    },
    clickOrderList: function clickOrderList() {
      this.$router.push({
        path: "/orderList"
      });
    },
    clickInventory: function clickInventory() {
      this.$router.push({
        path: "/inventory"
      });
    },
    clickDeliveryList: function clickDeliveryList() {
      this.$router.push({
        path: "/deliveryList"
      });
    },
    clickAddress: function clickAddress() {
      this.$router.push({
        path: "/addressList"
      });
    },
    clickAgreement: function clickAgreement() {
      var userInfo = auth_getUserInfo();
      if (userInfo) {
        sysUtils.navWeb(userInfo.memberId, userInfo.companyId, this.$root.themeType, true);
      } else {
        this.$vux.toast.text("用户信息失效，请重新登录后再试");
      }
    },
    backHome: function backHome() {
      this.$router.push({
        path: "/robbing"
      });
    },

    /**
     * 退出操作
     * 清空缓存，保留主题缓存
     * 进入授权页，重新获取code，并进入登录页
     */
    handleQuit: function handleQuit() {
      var self = this;
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: "提示",
        content: "是否确认退出？",
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          userService.logout().then(function (res) {
            removeToken();
            removeUserInfo();
            sessionStorage.clear();
            // self.$router.push({
            //   path: "/login",
            // });

            self.$router.push({
              path: "/wxAuth",
              query: {
                scene: "quit"
              }
            });
          }).catch(function (err) {
            self.$vux.toast.text(err.msg);
          });
        }
      });
    }
  },
  components: {
    CRater: src_components_CRater,
    CAvatar: src_components_CAvatar
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/user/userCenter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var user_userCenter = ({
  data: function data() {
    return {
      star: 0,
      starName: "",
      children: "",
      progress: "", // 进度条
      assessmentProgress: "", // 考核进度
      assessmentInfo: {}, // 考核信息
      stock: 0
    };
  },

  computed: {
    level: function level() {
      return auth_getUserInfo().memberLevel;
    },
    name: function name() {
      var userInfo = auth_getUserInfo();
      if (userInfo.phone) {
        return userInfo.phone;
      } else {
        return userInfo.nickName;
      }
    },
    status: function status() {
      return auth_getUserInfo().phoneStatus;
    },
    crownIcon: function crownIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("MzHY");
      } else {
        return __webpack_require__("1sGk");
      }
    },
    zhifuIcon: function zhifuIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("D7TH");
      } else {
        return __webpack_require__("TT4j");
      }
    },
    kucunIcon: function kucunIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("fswM");
      } else {
        return __webpack_require__("6vAA");
      }
    },
    tihuoIcon: function tihuoIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("e7qV");
      } else {
        return __webpack_require__("SFeO");
      }
    },
    dizhiIcon: function dizhiIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("EgD5");
      } else {
        return __webpack_require__("fu0F");
      }
    },
    hetongIcon: function hetongIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("IPaY");
      } else {
        return __webpack_require__("HhrA");
      }
    }
  },
  mounted: function mounted() {
    // 页面初始化获取用户信息
    this.getUserInfo();
  },

  methods: {
    /**
     * 获取用户信息，更新本地用户信息数据
     */
    getUserInfo: function getUserInfo() {
      var _this = this;

      userService.getUserInfo().then(function (res) {
        var userInfo = res.data;
        _this.star = Number(userInfo.starLevel);
        _this.starName = userInfo.starLevelName;
        _this.children = userInfo.totalChildren;
        _this.progress = numberUtils.toPercent(userInfo.totalChildren / 30);

        setUserInfo(userInfo);

        _this.getStock();
        _this.agentExamineCycle();
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取用户库存
     */
    getStock: function getStock() {
      var _this2 = this;

      userService.queryStock(PRODUCTID).then(function (res) {
        _this2.stock = res.data.stock;
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取考核信息
     */
    agentExamineCycle: function agentExamineCycle() {
      var _this3 = this;

      userService.agentExamineCycle().then(function (res) {
        var data = res.data;
        var assessmentProgress = numberUtils.toPercent(data.extractNum / data.assessmentCriteria);
        var lastNum = data.assessmentCriteria - data.extractNum;
        lastNum = lastNum <= 0 ? 0 : lastNum;

        _this3.assessmentInfo = extends_default()({}, data, {
          assessmentProgress: assessmentProgress,
          lastNum: lastNum
        });
      }).catch(function (err) {
        _this3.$vux.toast.text(err.msg);
      });
    },
    clickOrderList: function clickOrderList() {
      this.$router.push({
        path: "/orderList"
      });
    },
    clickInventory: function clickInventory() {
      this.$router.push({
        path: "/inventory"
      });
    },
    clickDeliveryList: function clickDeliveryList() {
      this.$router.push({
        path: "/deliveryList"
      });
    },
    clickAddress: function clickAddress() {
      this.$router.push({
        path: "/addressList"
      });
    },
    clickAgreement: function clickAgreement() {
      var userInfo = auth_getUserInfo();
      if (userInfo) {
        sysUtils.navWeb(userInfo.memberId, userInfo.companyId, this.$root.themeType, true);
      } else {
        this.$vux.toast.text("用户信息失效，请重新登录后再试");
      }
    },
    backHome: function backHome() {
      this.$router.push({
        path: "/robbing"
      });
    },

    /**
     * 退出操作
     * 清空缓存，保留主题缓存
     * 进入授权页，重新获取code，并进入登录页
     */
    handleQuit: function handleQuit() {
      var self = this;
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: "提示",
        content: "是否确认退出？",
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          userService.logout().then(function (res) {
            removeToken();
            removeUserInfo();
            sessionStorage.clear();
            // self.$router.push({
            //   path: "/login",
            // });

            self.$router.push({
              path: "/wxAuth",
              query: {
                scene: "quit"
              }
            });
          }).catch(function (err) {
            self.$vux.toast.text(err.msg);
          });
        }
      });
    }
  },
  components: {
    CRater: src_components_CRater,
    CAvatar: src_components_CAvatar
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbbdea10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/userCenter.vue
var userCenter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-center"},[_c('div',{staticClass:"header"},[_c('a',{staticClass:"flex-align-center",attrs:{"href":"javascript:;"},on:{"click":_vm.backHome}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-left",attrs:{"type":"ios-arrow-left","size":"18","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M352 115.4L331.3 96 160 256l171.3 160 20.7-19.3L201.5 256z"}})]),_vm._v("返回首页\n    ")]),_vm._v(" "),_c('div',{staticClass:"name-box"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"star-avatar"},[(_vm.star <= 5)?_c('span',[_vm._v(_vm._s(_vm.starName))]):_vm._e(),_vm._v(" "),_c('c-avatar',{attrs:{"size":"big","enable":false}})],1)]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"progress flex-justify-center"},[_c('div',{staticClass:"progress-box"},[_c('div',{staticClass:"progress-main",style:({width: _vm.progress})})]),_vm._v(" "),_c('img',{attrs:{"src":_vm.crownIcon,"alt":""}})]),_vm._v(" "),(_vm.level == 'upperest')?_c('div',{staticClass:"assessment-progress box-shadow"},[_c('div',{staticClass:"title"},[_c('b',[_vm._v("考核进度")]),_vm._v(" "),_c('span',[_vm._v("(当前考核周期"+_vm._s(_vm.assessmentInfo.beginDate)+"至"+_vm._s(_vm.assessmentInfo.endDate)+")")])]),_vm._v(" "),_c('div',{staticClass:"progress flex-justify-center"},[_c('div',{staticClass:"progress-box"},[_c('div',{staticClass:"progress-main",style:({width: _vm.assessmentInfo.assessmentProgress})})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.assessmentInfo.extractNum)+"/"+_vm._s(_vm.assessmentInfo.assessmentCriteria))])]),_vm._v(" "),_c('p',[_vm._v("\n        当前提货盒数换算成双蛋白是"),_c('span',[_vm._v(_vm._s(_vm.assessmentInfo.extractNum)+"盒")]),_vm._v("，还差"),_c('span',[_vm._v(_vm._s(_vm.assessmentInfo.lastNum)+"盒")]),_vm._v("完成考核\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',{staticClass:"vux-1px-b flex-between",on:{"click":_vm.clickOrderList}},[_c('div',{staticClass:"flex-align-center"},[_c('img',{attrs:{"src":_vm.zhifuIcon,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("支付记录")])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"16","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])]),_vm._v(" "),_c('div',{staticClass:"vux-1px-b flex-between",on:{"click":_vm.clickInventory}},[_c('div',{staticClass:"flex-align-center"},[_c('img',{attrs:{"src":_vm.kucunIcon,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("我的库存")])]),_vm._v(" "),_c('div',{staticClass:"flex-align-center"},[_c('span',{staticClass:"stock"},[_vm._v(_vm._s(_vm.stock)+"盒")]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"16","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])])]),_vm._v(" "),_c('div',{staticClass:"vux-1px-b flex-between",on:{"click":_vm.clickDeliveryList}},[_c('div',{staticClass:"flex-align-center"},[_c('img',{attrs:{"src":_vm.tihuoIcon,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("提货记录")])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"16","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])]),_vm._v(" "),_c('div',{staticClass:"vux-1px-b flex-between",on:{"click":_vm.clickAddress}},[_c('div',{staticClass:"flex-align-center"},[_c('img',{attrs:{"src":_vm.dizhiIcon,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("地址管理")])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"16","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])]),_vm._v(" "),_c('div',{staticClass:"flex-between",on:{"click":_vm.clickAgreement}},[_c('div',{staticClass:"flex-align-center"},[_c('img',{attrs:{"src":_vm.hetongIcon,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("我的合同")])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"16","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])])]),_vm._v(" "),_c('button',{staticClass:"quit",on:{"click":_vm.handleQuit}},[_vm._v("退出")])])])}
var userCenter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status flex-align-center"},[_c('img',{attrs:{"src":__webpack_require__("QDPz"),"alt":""}}),_vm._v("已绑定\n      ")])}]
var userCenter_esExports = { render: userCenter_render, staticRenderFns: userCenter_staticRenderFns }
/* harmony default export */ var views_user_userCenter = (userCenter_esExports);
// CONCATENATED MODULE: ./src/views/user/userCenter.vue
function userCenter_injectStyle (ssrContext) {
  __webpack_require__("sWd/")
  __webpack_require__("boEI")
}
var userCenter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userCenter___vue_template_functional__ = false
/* styles */
var userCenter___vue_styles__ = userCenter_injectStyle
/* scopeId */
var userCenter___vue_scopeId__ = "data-v-dbbdea10"
/* moduleIdentifier (server only) */
var userCenter___vue_module_identifier__ = null
var userCenter_Component = userCenter_normalizeComponent(
  user_userCenter,
  views_user_userCenter,
  userCenter___vue_template_functional__,
  userCenter___vue_styles__,
  userCenter___vue_scopeId__,
  userCenter___vue_module_identifier__
)

/* harmony default export */ var src_views_user_userCenter = (userCenter_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55721ad8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TransitionFade.vue
var TransitionFade_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_vm._t("default")],2)}
var TransitionFade_staticRenderFns = []
var TransitionFade_esExports = { render: TransitionFade_render, staticRenderFns: TransitionFade_staticRenderFns }
/* harmony default export */ var TransitionFade = (TransitionFade_esExports);
// CONCATENATED MODULE: ./src/components/TransitionFade.vue
function TransitionFade_injectStyle (ssrContext) {
  __webpack_require__("Drhy")
}
var TransitionFade_normalizeComponent = __webpack_require__("VU/8")
/* script */
var TransitionFade___vue_script__ = null
/* template */

/* template functional */
var TransitionFade___vue_template_functional__ = false
/* styles */
var TransitionFade___vue_styles__ = TransitionFade_injectStyle
/* scopeId */
var TransitionFade___vue_scopeId__ = "data-v-55721ad8"
/* moduleIdentifier (server only) */
var TransitionFade___vue_module_identifier__ = null
var TransitionFade_Component = TransitionFade_normalizeComponent(
  TransitionFade___vue_script__,
  TransitionFade,
  TransitionFade___vue_template_functional__,
  TransitionFade___vue_styles__,
  TransitionFade___vue_scopeId__,
  TransitionFade___vue_module_identifier__
)

/* harmony default export */ var components_TransitionFade = (TransitionFade_Component.exports);

// CONCATENATED MODULE: ./src/api/orderService.js


/**
 * 订单相关接口
 * @author 小圣贤君
 * @time 2020/03/13
 */
/* harmony default export */ var orderService = ({
  /**
   * 下单，生成订单id
   * @param productId 产品id
   * @param num 购买数量
   */
  rushBuy: function rushBuy(productId, num) {
    return api_request.post("/trade/tradeorder/rushbuy?productId=" + productId + "&num=" + num);
  },

  /**
   * 根据订单id，获取微信支付环境配置信息
   * @param orderId 订单id
   */
  getWxPay: function getWxPay(orderId) {
    return api_request.post("/api/channel/wxpay?orderId=" + orderId);
  },

  /**
   * 获取支付订单记录
   * @param page 当前查询页
   * @param limit 每页限制条数
   * @param payStatus 支付状态 0 1
   * @param productType 这里默认3
   */
  queryOrderList: function queryOrderList(page, limit, payStatus) {
    return api_request.post("/trade/tradeorder/rush/orderlist?page=" + page + "&limit=" + limit + "&payStatus=" + payStatus + "&productType=3");
  },

  /**
   * 提货记录
   * @param page 当前查询页
   * @param limit 每页限制条数
   * @param flowStep 提货状态 0全部 1运输中 2已签收
   * @param productType 这里默认3
   */
  deliveryList: function deliveryList(page, limit, flowStep) {
    return api_request.post("/trade/tradeextract/rush/extractlist?page=" + page + "&limit=" + limit + "&flowStep=" + flowStep + "&productType=3");
  },

  /**
   * 产品列表
   * @param productId
   */
  queryProducts: function queryProducts(productId) {
    return api_request.get("/product//select?productId=" + productId);
  },

  /**
   * 计算运费
   * @param productNum 产品数量
   * @param userAddrId 地址id
   * @param productId 产品id
   */
  getFreight: function getFreight(productNum, userAddrId, productId) {
    return api_request.post("/trade/tradeorder/getFreight?productNum=" + productNum + "&userAddrId=" + userAddrId + "&productId=" + productId);
  },

  /**
   * 提货
   * @param productList
   * @param freightType
   * @param addrId
   */
  extract: function extract(data) {
    return api_request.post("/trade/tradeextract/extract", data);
  },

  /**
   * 提货微信支付
   * @param orderId
   */
  extractWxPay: function extractWxPay(orderId) {
    return api_request.post("/api/channel/extract/wxpay?orderId=" + orderId);
  },

  /**
   * 补货微信支付
   * @param orderId
   */
  orderWxPay: function orderWxPay(orderId) {
    return api_request.post("/api/channel/wxpay?orderId=" + orderId);
  },

  /**
   * 获取系统时间
   */
  getSysTime: function getSysTime() {
    return api_request.post("/trade/tradeorder/rushinfo");
  },

  /**
   * 获取产品兑换比例
   * @param {*} sourceProductId 原产品
   * @param {*} sourceProductQuantity 原产品数量
   * @param {*} targetProductId 兑换目标产品
   */
  calcExchange: function calcExchange(data) {
    return api_request.post("/trade/tradeextract/exchange/calculation", data);
  },

  /**
   * 获取剩余可抢提盒数
   */
  getLastCount: function getLastCount(productId) {
    return api_request.get("/trade/tradeextract/getAvailableQuantity?productId=" + productId);
  },

  /**
   * 查询物流记录
   */
  traceQuery: function traceQuery(trackingNumber) {
    return api_request.get("/trade/logistics/traceQuery?trackingNumber=" + trackingNumber);
  }
});
// CONCATENATED MODULE: ./src/api/productService.js


/**
 * 产品相关接口
 * @author 小圣贤君
 * @time 2020/03/12
 */
/* harmony default export */ var productService = ({

  /**
   * 获取产品信息
   */
  getProductInfo: function getProductInfo() {
    return api_request.get("/product/productInfo");
  }
});
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// CONCATENATED MODULE: ./src/utils/wxJsSdk.js




/**
* @author Bruce
* @time 2019-07-15
* @description 微信JS-SDK相关的处理方法
*/

/* harmony default export */ var wxJsSdk = ({
  /**
  * 判断当前客户端版本是否支持指定JS接口
  * @param jsApiList 接口列表
  */
  checkJsApi: function checkJsApi(jsApiList) {
    return new promise_default.a(function (resolve, reject) {
      wechat["a" /* default */].$wechat.checkJsApi({
        jsApiList: jsApiList, // 需要检测的JS接口列表
        success: function success(res) {

          var checkResult = res.checkResult;
          if (typeof checkResult == "string") {

            checkResult = JSON.parse(checkResult);
          }
          resolve(checkResult);
        },
        fail: function fail(err) {
          reject(err);
        }
      });
    });
  },

  /**
  * 选择图片或者拍照接口
  */
  chooseImage: function chooseImage() {
    return new promise_default.a(function (resolve, reject) {
      wechat["a" /* default */].$wechat.chooseImage({
        count: 1, // 默认9
        sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {

          console.log("chooseImage result:------------------");
          console.log(res);
          resolve(res);
        },
        fail: function fail(err) {
          reject(err);
        }
      });
    });
  },

  /**
  * 图片上传接口
  * @param localId 需要上传的图片id，由chooseImage接口获取，chooseImage返回的是个数组列表，这里仅需要其中一项就可以，例如：localIds[0]
  */
  uploadImage: function uploadImage(localId) {
    return new promise_default.a(function (resolve, reject) {
      wechat["a" /* default */].$wechat.uploadImage({
        localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function success(res) {
          console.log("uploadImage result:------------------");
          console.log(res);

          resolve(res);
        },
        fail: function fail(err) {
          reject(err);
        }
      });
    });
  },

  /**
  * 获取本地图片接口
  */
  getLocalImgData: function getLocalImgData(localId) {
    return new promise_default.a(function (resolve, reject) {
      wechat["a" /* default */].$wechat.getLocalImgData({
        localId: localId, // 图片的localID
        success: function success(res) {
          var localData = res.localData;
          if (localData.substr(0, 5) != 'data:') {
            localData = 'data:image;base64,' + localData;
          }

          resolve(localData);
        },
        fail: function fail(err) {
          reject(err);
        }
      });
    });
  },

  /**
  * 选择图片并且上传，返回上传后的id
  */
  chooseAndUpload: function chooseAndUpload() {
    var _this = this;

    return new promise_default.a(function (resolve, reject) {
      var jsApiList = ["chooseImage", "uploadImage"];
      _this.checkJsApi(jsApiList).then(function (res) {
        if (res.chooseImage && res.uploadImage) {

          return _this.chooseImage();
        } else {
          vue_esm["a" /* default */].$vux.alert.show({
            content: "当前客户端不支持相关微信图片接口，请更换设备操作或联系客服！"
          });
        }
      }).then(function (res) {

        return _this.uploadImage(res.localIds[0]);
      }).then(function (res) {

        resolve(res);
      }).catch(function (err) {
        console.log(err);
        vue_esm["a" /* default */].$vux.toast.text(err);
        reject(err);
      });
    });
  },

  /**
  * 微信分享操作
  * @param title 分享标题
  * @param desc 分享描述
  * @param link 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  * @param imgUrl 分享图标
  */
  handleWxShare: function handleWxShare(title, desc, link, imgUrl) {
    var jsApiList = ["updateAppMessageShareData"];
    this.checkJsApi(jsApiList).then(function (res) {

      if (res.updateAppMessageShareData && wechat["a" /* default */].$wechat.updateAppMessageShareData) {
        wechat["a" /* default */].$wechat.updateAppMessageShareData({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success: function success() {

            console.log("分享微信朋友成功");
          }
        });
        wechat["a" /* default */].$wechat.updateTimelineShareData({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success: function success() {

            console.log("分享朋友圈成功");
          }
        });
      } else {
        wechat["a" /* default */].$wechat.onMenuShareTimeline({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success: function success() {

            console.log("分享朋友圈成功");
          }
        });
        wechat["a" /* default */].$wechat.onMenuShareAppMessage({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success: function success() {

            console.log("分享微信朋友成功");
          }
        });
        wechat["a" /* default */].$wechat.onMenuShareQQ({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success: function success() {

            console.log("分享QQ好友成功");
          },
          cancel: function cancel() {}
        });
      }
    }).catch(function (err) {
      console.log(err);
      vue_esm["a" /* default */].$vux.toast.text(err);
    });
  },

  /**
  * 发起微信支付
  */
  chooseWXPay: function chooseWXPay(wxPayData) {
    return new promise_default.a(function (resolve, reject) {
      wechat["a" /* default */].$wechat.chooseWXPay({
        appId: wxPayData.appId, // 这里要传公众号appId。注释时间2020-07-23
        timestamp: wxPayData.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: wxPayData.nonceStr, // 支付签名随机串，不长于 32 位
        package: wxPayData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: wxPayData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: wxPayData.paySign, // 支付签名
        success: function success(res) {

          resolve(res);
        },
        fail: function fail(err) {
          reject(err);
        },
        cancel: function cancel(res) {

          resolve(res);
        }
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/robbing/robbing.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var robbing = ({
  data: function data() {
    return {
      btnDisabled: false, // 控制支付按钮是否可点击
      inputNum: "113.000",
      defaultNum: "113.000",
      totalPrice: "14464.00",
      minBuy: 113,
      productVipPrice: 128,
      shareImg: __webpack_require__("7Otq"),
      showBirthday: false // 是否用户生日
    };
  },

  computed: {
    banner: function banner() {
      return __webpack_require__("4Lrk");
    },
    minusIcon: function minusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("G0MN");
      } else {
        return __webpack_require__("1knL");
      }
    },
    plusIcon: function plusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("Knmv");
      } else {
        return __webpack_require__("VRHR");
      }
    },
    buyIcon: function buyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("Khvw");
      } else {
        return __webpack_require__("Z9K3");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay", "updateAppMessageShareData", "updateTimelineShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ"] // 必填，需要使用的JS接口列表
          });
          var link = window.location.origin + window.location.pathname;
          var title = "营养美学";
          var des = "胶原蛋白弹性蛋白饮料";
          var imgUrl = _this.shareImg;
          _this.$wechat.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            wxJsSdk.handleWxShare(title, des, link, imgUrl);
          });
          _this.$wechat.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log(res);
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    this.getUserInfo();
  },

  methods: {
    /**
     * 处理输入内容，限制小数点后三位
     * 不输入数字默认
     */
    handleInput: function handleInput(e) {
      this.inputNum = e.target.value.match(/^\d*(\.?\d{0,3})/g)[0];
      this.defaultNum = this.inputNum;
      if (!this.inputNum) {
        this.defaultNum = this.minBuy;
      }
    },

    /* 聚焦事件，置空inputNum */
    handleFocus: function handleFocus() {
      if (this.defaultNum == this.minBuy || this.defaultNum == this.minBuy) {
        this.inputNum = "";
      }
    },
    handleBlur: function handleBlur() {
      sysUtils.scrollPageView();

      if (this.defaultNum < this.minBuy) {
        this.$vux.toast.text("最小值为" + this.minBuy);
        this.inputNum = this.minBuy;
        this.defaultNum = this.minBuy;
      } else {
        if (this.inputNum == "") {
          this.inputNum = this.defaultNum;
        } else {
          this.defaultNum = this.inputNum;
        }
      }
      this.calcTotalPrice();
    },
    calcTotalPrice: function calcTotalPrice() {
      this.totalPrice = (this.inputNum * this.productVipPrice).toFixed(2);
    },

    /**
     * 点击支付按钮
     * 先生成订单，再调用微信支付操作
     */
    handlePay: function handlePay() {
      var _this2 = this;

      // 先禁用支付按钮，避免重复点击
      this.btnDisabled = true;
      if (this.defaultNum >= this.minBuy) {
        orderService.rushBuy(PRODUCTID, this.inputNum).then(function (res) {
          return orderService.getWxPay(res.data.id);
        }).then(function (res) {
          _this2.btnDisabled = false;

          var wxPayData = {
            appId: res.data.appId,
            nonceStr: res.data.nonceStr,
            package: res.data.package,
            paySign: res.data.paySign,
            signType: res.data.signType,
            timestamp: res.data.timeStamp
          };
          wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
            // 如果当前取消了支付
            if (result.errMsg == "chooseWXPay:cancel") {
              // res.payFlowId
            } else {
              // 微信支付成功后，进入订单列表
              _this2.$router.push({
                path: "/orderList"
              });
            }
          }).catch(function (err) {
            console.log("支付失败:-------------");
            console.log(err);
          });
        }).catch(function (err) {
          _this2.btnDisabled = false;
          _this2.$vux.toast.text(err.msg);
        });
      }
    },
    clickPlus: function clickPlus() {
      this.inputNum = Number(this.inputNum) + 1;
      this.calcTotalPrice();
    },
    clickMinus: function clickMinus() {
      this.inputNum = Number(this.inputNum) - 1;
      if (this.inputNum <= this.minBuy) {
        this.inputNum = this.minBuy;
      }
      this.calcTotalPrice();
    },
    toInventory: function toInventory() {
      this.$router.push({
        path: "/inventory"
      });
    },

    /**
     * 获取产品信息
     */
    getProductInfo: function getProductInfo() {
      var _this3 = this;

      productService.getProductInfo().then(function (res) {
        var userInfo = res.data;
        setUserInfo(userInfo);

        _this3.setTheme(userInfo.starLevel);

        _this3.inputNum = res.data.minBuy;
        _this3.defaultNum = res.data.minBuy;
        _this3.minBuy = res.data.minBuy;
        _this3.productVipPrice = res.data.productVipPrice;
        _this3.totalPrice = res.data.minBuy * res.data.productVipPrice;

        var isBirthday = userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
        // 查询本地缓存，判断是否查看过生日祝福
        var isBless = localStorage.getItem("BIRTH_BLESS");
        if (isBirthday == 1) {
          // 如果有缓存祝福，说明已经提醒过，不显示祝福
          if (isBless == 1) {
            _this3.showBirthday = false; // 不显示祝福
          } else {
            _this3.showBirthday = true; // 显示祝福
            localStorage.setItem("BIRTH_BLESS", 1); // 设置本地缓存，当不是生日的时候清除此缓存
          }
        } else {
          // 不是生日并且有祝福缓存的情况下清除缓存
          if (isBless == 1) {
            localStorage.removeItem("BIRTH_BLESS");
          }
        }
      }).catch(function (err) {
        _this3.setTheme(1); // 如果接口失败，也要调用设置主题操作，设为默认样式
        _this3.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取用户信息，更新本地用户信息数据
     */
    getUserInfo: function getUserInfo() {
      var _this4 = this;

      userService.getUserInfo().then(function (res) {
        var userInfo = res.data;
        setUserInfo(userInfo);

        _this4.setTheme(userInfo.starLevel);

        _this4.inputNum = res.data.minBuy;
        _this4.defaultNum = res.data.minBuy;
        _this4.minBuy = res.data.minBuy;
        _this4.productVipPrice = res.data.productVipPrice;
        _this4.totalPrice = res.data.minBuy * res.data.productVipPrice;

        var isBirthday = userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
        // 查询本地缓存，判断是否查看过生日祝福
        var isBless = localStorage.getItem("BIRTH_BLESS");
        if (isBirthday == 1) {
          // 如果有缓存祝福，说明已经提醒过，不显示祝福
          if (isBless == 1) {
            _this4.showBirthday = false; // 不显示祝福
          } else {
            _this4.showBirthday = true; // 显示祝福
            localStorage.setItem("BIRTH_BLESS", 1); // 设置本地缓存，当不是生日的时候清除此缓存
          }
        } else {
          // 不是生日并且有祝福缓存的情况下清除缓存
          if (isBless == 1) {
            localStorage.removeItem("BIRTH_BLESS");
          }
        }
      }).catch(function (err) {
        _this4.setTheme(1); // 如果接口失败，也要调用设置主题操作，设为默认样式
        _this4.$vux.toast.text(err.msg);
      });
    },

    /**
     * 设置主题
     */
    setTheme: function setTheme(starLevel) {
      sysUtils.setThemeType(starLevel, this); // 设置主题

      // 单独设置背景色
      document.documentElement.style.backgroundColor = "#EFEBE2";
    }
  },
  components: {
    CAvatar: src_components_CAvatar,
    TransitionFade: components_TransitionFade
  },
  destroyed: function destroyed() {
    // 单独设置背景色
    if (this.$root.themeType == "yellow") {
      document.documentElement.style.backgroundColor = "#fff";
    } else {
      document.documentElement.style.backgroundColor = "#242626";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/robbing/robbing.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var robbing_robbing = ({
  data: function data() {
    return {
      btnDisabled: false, // 控制支付按钮是否可点击
      inputNum: "113.000",
      defaultNum: "113.000",
      totalPrice: "14464.00",
      minBuy: 113,
      productVipPrice: 128,
      shareImg: __webpack_require__("7Otq"),
      showBirthday: false // 是否用户生日
    };
  },

  computed: {
    banner: function banner() {
      return __webpack_require__("4Lrk");
    },
    minusIcon: function minusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("G0MN");
      } else {
        return __webpack_require__("1knL");
      }
    },
    plusIcon: function plusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("Knmv");
      } else {
        return __webpack_require__("VRHR");
      }
    },
    buyIcon: function buyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("Khvw");
      } else {
        return __webpack_require__("Z9K3");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay", "updateAppMessageShareData", "updateTimelineShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ"] // 必填，需要使用的JS接口列表
          });
          var link = window.location.origin + window.location.pathname;
          var title = "营养美学";
          var des = "胶原蛋白弹性蛋白饮料";
          var imgUrl = _this.shareImg;
          _this.$wechat.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            wxJsSdk.handleWxShare(title, des, link, imgUrl);
          });
          _this.$wechat.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log(res);
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    this.getUserInfo();
  },

  methods: {
    /**
     * 处理输入内容，限制小数点后三位
     * 不输入数字默认
     */
    handleInput: function handleInput(e) {
      this.inputNum = e.target.value.match(/^\d*(\.?\d{0,3})/g)[0];
      this.defaultNum = this.inputNum;
      if (!this.inputNum) {
        this.defaultNum = this.minBuy;
      }
    },

    /* 聚焦事件，置空inputNum */
    handleFocus: function handleFocus() {
      if (this.defaultNum == this.minBuy || this.defaultNum == this.minBuy) {
        this.inputNum = "";
      }
    },
    handleBlur: function handleBlur() {
      sysUtils.scrollPageView();

      if (this.defaultNum < this.minBuy) {
        this.$vux.toast.text("最小值为" + this.minBuy);
        this.inputNum = this.minBuy;
        this.defaultNum = this.minBuy;
      } else {
        if (this.inputNum == "") {
          this.inputNum = this.defaultNum;
        } else {
          this.defaultNum = this.inputNum;
        }
      }
      this.calcTotalPrice();
    },
    calcTotalPrice: function calcTotalPrice() {
      this.totalPrice = (this.inputNum * this.productVipPrice).toFixed(2);
    },

    /**
     * 点击支付按钮
     * 先生成订单，再调用微信支付操作
     */
    handlePay: function handlePay() {
      var _this2 = this;

      // 先禁用支付按钮，避免重复点击
      this.btnDisabled = true;
      if (this.defaultNum >= this.minBuy) {
        orderService.rushBuy(PRODUCTID, this.inputNum).then(function (res) {
          return orderService.getWxPay(res.data.id);
        }).then(function (res) {
          _this2.btnDisabled = false;

          var wxPayData = {
            appId: res.data.appId,
            nonceStr: res.data.nonceStr,
            package: res.data.package,
            paySign: res.data.paySign,
            signType: res.data.signType,
            timestamp: res.data.timeStamp
          };
          wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
            // 如果当前取消了支付
            if (result.errMsg == "chooseWXPay:cancel") {
              // res.payFlowId
            } else {
              // 微信支付成功后，进入订单列表
              _this2.$router.push({
                path: "/orderList"
              });
            }
          }).catch(function (err) {
            console.log("支付失败:-------------");
            console.log(err);
          });
        }).catch(function (err) {
          _this2.btnDisabled = false;
          _this2.$vux.toast.text(err.msg);
        });
      }
    },
    clickPlus: function clickPlus() {
      this.inputNum = Number(this.inputNum) + 1;
      this.calcTotalPrice();
    },
    clickMinus: function clickMinus() {
      this.inputNum = Number(this.inputNum) - 1;
      if (this.inputNum <= this.minBuy) {
        this.inputNum = this.minBuy;
      }
      this.calcTotalPrice();
    },
    toInventory: function toInventory() {
      this.$router.push({
        path: "/inventory"
      });
    },

    /**
     * 获取产品信息
     */
    getProductInfo: function getProductInfo() {
      var _this3 = this;

      productService.getProductInfo().then(function (res) {
        var userInfo = res.data;
        setUserInfo(userInfo);

        _this3.setTheme(userInfo.starLevel);

        _this3.inputNum = res.data.minBuy;
        _this3.defaultNum = res.data.minBuy;
        _this3.minBuy = res.data.minBuy;
        _this3.productVipPrice = res.data.productVipPrice;
        _this3.totalPrice = res.data.minBuy * res.data.productVipPrice;

        var isBirthday = userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
        // 查询本地缓存，判断是否查看过生日祝福
        var isBless = localStorage.getItem("BIRTH_BLESS");
        if (isBirthday == 1) {
          // 如果有缓存祝福，说明已经提醒过，不显示祝福
          if (isBless == 1) {
            _this3.showBirthday = false; // 不显示祝福
          } else {
            _this3.showBirthday = true; // 显示祝福
            localStorage.setItem("BIRTH_BLESS", 1); // 设置本地缓存，当不是生日的时候清除此缓存
          }
        } else {
          // 不是生日并且有祝福缓存的情况下清除缓存
          if (isBless == 1) {
            localStorage.removeItem("BIRTH_BLESS");
          }
        }
      }).catch(function (err) {
        _this3.setTheme(1); // 如果接口失败，也要调用设置主题操作，设为默认样式
        _this3.$vux.toast.text(err.msg);
      });
    },

    /**
     * 获取用户信息，更新本地用户信息数据
     */
    getUserInfo: function getUserInfo() {
      var _this4 = this;

      userService.getUserInfo().then(function (res) {
        var userInfo = res.data;
        setUserInfo(userInfo);

        _this4.setTheme(userInfo.starLevel);

        _this4.inputNum = res.data.minBuy;
        _this4.defaultNum = res.data.minBuy;
        _this4.minBuy = res.data.minBuy;
        _this4.productVipPrice = res.data.productVipPrice;
        _this4.totalPrice = res.data.minBuy * res.data.productVipPrice;

        var isBirthday = userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
        // 查询本地缓存，判断是否查看过生日祝福
        var isBless = localStorage.getItem("BIRTH_BLESS");
        if (isBirthday == 1) {
          // 如果有缓存祝福，说明已经提醒过，不显示祝福
          if (isBless == 1) {
            _this4.showBirthday = false; // 不显示祝福
          } else {
            _this4.showBirthday = true; // 显示祝福
            localStorage.setItem("BIRTH_BLESS", 1); // 设置本地缓存，当不是生日的时候清除此缓存
          }
        } else {
          // 不是生日并且有祝福缓存的情况下清除缓存
          if (isBless == 1) {
            localStorage.removeItem("BIRTH_BLESS");
          }
        }
      }).catch(function (err) {
        _this4.setTheme(1); // 如果接口失败，也要调用设置主题操作，设为默认样式
        _this4.$vux.toast.text(err.msg);
      });
    },

    /**
     * 设置主题
     */
    setTheme: function setTheme(starLevel) {
      sysUtils.setThemeType(starLevel, this); // 设置主题

      // 单独设置背景色
      document.documentElement.style.backgroundColor = "#EFEBE2";
    }
  },
  components: {
    CAvatar: src_components_CAvatar,
    TransitionFade: components_TransitionFade
  },
  destroyed: function destroyed() {
    // 单独设置背景色
    if (this.$root.themeType == "yellow") {
      document.documentElement.style.backgroundColor = "#fff";
    } else {
      document.documentElement.style.backgroundColor = "#242626";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cebe405","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robbing/robbing.vue
var robbing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"robbing"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"flex-between"},[_c('button',{staticClass:"btn",on:{"click":_vm.toInventory}},[_vm._v("我的库存")]),_vm._v(" "),_c('c-avatar')],1),_vm._v(" "),_c('img',{attrs:{"src":_vm.banner,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('h2',[_vm._v("双蛋白 为美狂欢")]),_vm._v(" "),_c('p',[_vm._v("*最少"+_vm._s(_vm.minBuy)+"盒，您也可以手动输入想要的数量")]),_vm._v(" "),_c('p',[_vm._v("*下单购买成功后，货品将运输到您的协议仓库进行保存")]),_vm._v(" "),_c('div',{staticClass:"num-box flex-justify-center"},[_c('button',{attrs:{"disabled":_vm.inputNum<=_vm.minBuy},on:{"click":_vm.clickMinus}},[_c('img',{attrs:{"src":_vm.minusIcon,"alt":""}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputNum),expression:"inputNum"}],attrs:{"type":"number","placeholder":_vm.defaultNum},domProps:{"value":(_vm.inputNum)},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"input":[function($event){if($event.target.composing){ return; }_vm.inputNum=$event.target.value},_vm.handleInput]}}),_vm._v(" "),_c('button',{on:{"click":_vm.clickPlus}},[_c('img',{attrs:{"src":_vm.plusIcon,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"flex-between"},[_c('div',[_c('span',[_c('span',{staticClass:"text"},[_vm._v("总价：")]),_vm._v("\n          ￥"+_vm._s(_vm.totalPrice)+"\n        ")]),_vm._v(" "),_c('p',[_vm._v("不含运费")])]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.btnDisabled},on:{"click":_vm.handlePay}},[_c('img',{attrs:{"src":_vm.buyIcon,"alt":""}}),_vm._v("\n        下单购买\n      ")])])]),_vm._v(" "),_c('transition-fade',[(_vm.showBirthday)?_c('div',{staticClass:"birthday"},[_c('img',{attrs:{"src":__webpack_require__("wOEh"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"text-info"},[_c('h2',[_vm._v("亲爱的生日快乐！")]),_vm._v(" "),_c('span',[_vm._v("金卡会员生日当天")]),_vm._v(" "),_c('h1',[_vm._v("提货免运费")]),_vm._v(" "),_c('p',[_vm._v("祝您接单不停歇，利润不间断")])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-outline",attrs:{"type":"ios-close-outline","size":"40","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.showBirthday = false}}},[_c('path',{staticClass:"st0",attrs:{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zm-12.3 281.9c-74.3 74.3-195.3 74.3-269.6 0-74.3-74.3-74.3-195.3 0-269.6s195.3-74.3 269.6 0c74.4 74.3 74.4 195.3 0 269.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.2-84-83.8-11.8 11.8 84 83.8-84 83.8 11.8 11.8 84-83.8 84.4 84.2 11.8-11.8-84.4-84.2 84.4-84.2z"}})])]):_vm._e()])],1)}
var robbing_staticRenderFns = []
var robbing_esExports = { render: robbing_render, staticRenderFns: robbing_staticRenderFns }
/* harmony default export */ var views_robbing_robbing = (robbing_esExports);
// CONCATENATED MODULE: ./src/views/robbing/robbing.vue
function robbing_injectStyle (ssrContext) {
  __webpack_require__("Z0L7")
  __webpack_require__("QgKr")
}
var robbing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var robbing___vue_template_functional__ = false
/* styles */
var robbing___vue_styles__ = robbing_injectStyle
/* scopeId */
var robbing___vue_scopeId__ = "data-v-0cebe405"
/* moduleIdentifier (server only) */
var robbing___vue_module_identifier__ = null
var robbing_Component = robbing_normalizeComponent(
  robbing_robbing,
  views_robbing_robbing,
  robbing___vue_template_functional__,
  robbing___vue_styles__,
  robbing___vue_scopeId__,
  robbing___vue_module_identifier__
)

/* harmony default export */ var src_views_robbing_robbing = (robbing_Component.exports);

// EXTERNAL MODULE: ./node_modules/clipboard/dist/clipboard.js
var dist_clipboard = __webpack_require__("TQvf");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(dist_clipboard);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ad2681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("KPh9")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CTab.vue




/* harmony default export */ var CTab = ({
  data: function data() {
    return {
      selected: 0
    };
  },

  props: ["tabs", "active"],
  methods: {
    onItemClick: function onItemClick(e) {
      this.selected = e;
      this.$emit("on-tab-click", e);
    }
  },
  watch: {
    active: function active(e) {
      this.selected = e;
    }
  },
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CTab.vue




/* harmony default export */ var components_CTab = ({
  data: function data() {
    return {
      selected: 0
    };
  },

  props: ["tabs", "active"],
  methods: {
    onItemClick: function onItemClick(e) {
      this.selected = e;
      this.$emit("on-tab-click", e);
    }
  },
  watch: {
    active: function active(e) {
      this.selected = e;
    }
  },
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90765008","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CTab.vue
var CTab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tab"},[_c('ul',{staticClass:"v-tab"},_vm._l((_vm.tabs),function(item,index){return _c('li',{key:index,class:{'selected':_vm.selected == index},on:{"click":function($event){return _vm.onItemClick(index)}}},[_vm._v("\n      "+_vm._s(item.value)+"\n      "),_c('small',[_vm._v(_vm._s(item.number))])])}),0),_vm._v(" "),_vm._t("default")],2)}
var CTab_staticRenderFns = []
var CTab_esExports = { render: CTab_render, staticRenderFns: CTab_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_CTab = (CTab_esExports);
// CONCATENATED MODULE: ./src/components/CTab.vue
function CTab_injectStyle (ssrContext) {
  __webpack_require__("C3Yn")
  __webpack_require__("55wZ")
}
var CTab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CTab___vue_template_functional__ = false
/* styles */
var CTab___vue_styles__ = CTab_injectStyle
/* scopeId */
var CTab___vue_scopeId__ = "data-v-90765008"
/* moduleIdentifier (server only) */
var CTab___vue_module_identifier__ = null
var CTab_Component = CTab_normalizeComponent(
  components_CTab,
  selectortype_template_index_0_src_components_CTab,
  CTab___vue_template_functional__,
  CTab___vue_styles__,
  CTab___vue_scopeId__,
  CTab___vue_module_identifier__
)

/* harmony default export */ var src_components_CTab = (CTab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ScrollMore.vue
//
//
//
//
//

/* harmony default export */ var ScrollMore = ({
  data: function data() {
    return {
      sTop: "",
      sHeight: ""
    };
  },

  props: {
    top: {
      type: String
    },
    height: {
      type: String
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    reset: {
      // 是否重置内容，用于tab切换时，
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.sTop = _this.top;
      _this.sHeight = _this.height;
      _this.$refs.scrollerMore.finishInfinite(true);
    });
  },

  methods: {
    /**
     * 用户触发下拉刷下状态，监听该事件以获取加载新数据
     */
    onRefresh: function onRefresh(done) {
      var _this2 = this;

      setTimeout(function () {
        _this2.$emit("onPulldown");
        done();
      }, 1000);
    },
    onInfinite: function onInfinite(done) {
      var _this3 = this;

      if (this.hasMore == false) {
        setTimeout(function () {
          done(true);
        }, 1500);
        return;
      }
      setTimeout(function () {
        _this3.$emit("onScrollBottom");
        done();
      }, 1500);
    }
  },
  watch: {
    reset: function reset(e) {
      if (e) {
        // 如果为true,说明此滚动组件需要重新刷新，官方方法不好用，此处采用重新渲染页面方案
        // 解决当页面内容过长，向上滚动并切换数据后，内容数据上移问题
        this.$refs.scrollerMore.scrollTo(0, 0, true);
        this.$emit("update:reset", false);
      }
    }
  },
  components: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ScrollMore.vue
//
//
//
//
//

/* harmony default export */ var components_ScrollMore = ({
  data: function data() {
    return {
      sTop: "",
      sHeight: ""
    };
  },

  props: {
    top: {
      type: String
    },
    height: {
      type: String
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    reset: {
      // 是否重置内容，用于tab切换时，
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.sTop = _this.top;
      _this.sHeight = _this.height;
      _this.$refs.scrollerMore.finishInfinite(true);
    });
  },

  methods: {
    /**
     * 用户触发下拉刷下状态，监听该事件以获取加载新数据
     */
    onRefresh: function onRefresh(done) {
      var _this2 = this;

      setTimeout(function () {
        _this2.$emit("onPulldown");
        done();
      }, 1000);
    },
    onInfinite: function onInfinite(done) {
      var _this3 = this;

      if (this.hasMore == false) {
        setTimeout(function () {
          done(true);
        }, 1500);
        return;
      }
      setTimeout(function () {
        _this3.$emit("onScrollBottom");
        done();
      }, 1500);
    }
  },
  watch: {
    reset: function reset(e) {
      if (e) {
        // 如果为true,说明此滚动组件需要重新刷新，官方方法不好用，此处采用重新渲染页面方案
        // 解决当页面内容过长，向上滚动并切换数据后，内容数据上移问题
        this.$refs.scrollerMore.scrollTo(0, 0, true);
        this.$emit("update:reset", false);
      }
    }
  },
  components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6a66ffa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollMore.vue
var ScrollMore_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroller',{ref:"scrollerMore",style:({top:_vm.sTop,height:_vm.sHeight}),attrs:{"on-refresh":_vm.onRefresh,"on-infinite":_vm.onInfinite,"noDataText":"--人家是有底线的--"}},[_vm._t("default")],2)}
var ScrollMore_staticRenderFns = []
var ScrollMore_esExports = { render: ScrollMore_render, staticRenderFns: ScrollMore_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_ScrollMore = (ScrollMore_esExports);
// CONCATENATED MODULE: ./src/components/ScrollMore.vue
function ScrollMore_injectStyle (ssrContext) {
  __webpack_require__("82bl")
}
var ScrollMore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ScrollMore___vue_template_functional__ = false
/* styles */
var ScrollMore___vue_styles__ = ScrollMore_injectStyle
/* scopeId */
var ScrollMore___vue_scopeId__ = "data-v-d6a66ffa"
/* moduleIdentifier (server only) */
var ScrollMore___vue_module_identifier__ = null
var ScrollMore_Component = ScrollMore_normalizeComponent(
  components_ScrollMore,
  selectortype_template_index_0_src_components_ScrollMore,
  ScrollMore___vue_template_functional__,
  ScrollMore___vue_styles__,
  ScrollMore___vue_scopeId__,
  ScrollMore___vue_module_identifier__
)

/* harmony default export */ var src_components_ScrollMore = (ScrollMore_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NoData.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var NoData = ({
  computed: {
    nullImg: function nullImg() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("s14R");
      } else {
        return __webpack_require__("9fs9");
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NoData.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var components_NoData = ({
  computed: {
    nullImg: function nullImg() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("s14R");
      } else {
        return __webpack_require__("9fs9");
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b544644","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoData.vue
var NoData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data flex-center"},[_c('img',{attrs:{"src":_vm.nullImg,"alt":"no-data"}}),_vm._v(" "),_c('p',[_vm._t("default")],2)])}
var NoData_staticRenderFns = []
var NoData_esExports = { render: NoData_render, staticRenderFns: NoData_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_NoData = (NoData_esExports);
// CONCATENATED MODULE: ./src/components/NoData.vue
function NoData_injectStyle (ssrContext) {
  __webpack_require__("5z+K")
}
var NoData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NoData___vue_template_functional__ = false
/* styles */
var NoData___vue_styles__ = NoData_injectStyle
/* scopeId */
var NoData___vue_scopeId__ = "data-v-0b544644"
/* moduleIdentifier (server only) */
var NoData___vue_module_identifier__ = null
var NoData_Component = NoData_normalizeComponent(
  components_NoData,
  selectortype_template_index_0_src_components_NoData,
  NoData___vue_template_functional__,
  NoData___vue_styles__,
  NoData___vue_scopeId__,
  NoData___vue_module_identifier__
)

/* harmony default export */ var src_components_NoData = (NoData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/robbing/orderList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var orderList = ({
  data: function data() {
    return {
      tabs: [{
        value: "待支付"
      }, {
        value: "已支付"
      }],
      flowStep: 0,
      pageData: {
        page: 1,
        size: 20,
        nextPage: false
      },
      list: [],
      scrollReset: false,
      disabled: false // 是否禁用提交操作
    };
  },

  computed: {
    copyIcon: function copyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("J4c5");
      } else {
        return __webpack_require__("xXI2");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    this.query(this.flowStep);
  },

  methods: {
    handleTabClick: function handleTabClick(e) {
      console.info(e);
      this.flowStep = e;
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
      this.scrollReset = true;
    },

    /**
     * 查询提货记录
     */
    query: function query(flowStep) {
      var _this2 = this;

      orderService.queryOrderList(this.pageData.page, this.pageData.size, flowStep).then(function (result) {
        var res = result.data;
        _this2.pageData.page = res.currPage;
        _this2.pageData.pageSize = res.pageSize;
        if (res.totalPage <= res.currPage) {
          _this2.pageData.nextPage = false;
        } else {
          _this2.pageData.nextPage = true;
        }
        res.list.forEach(function (item) {
          _this2.list.push(extends_default()({}, item));
        });
        if (_this2.$root.themeType == "black") {
          // 如果当前主题是黑金
          // 如果列表没有数据，显示黑色背景，否则显示白色背景
          if (_this2.list.length > 0) {
            document.documentElement.style.backgroundColor = "#fff";
          }
        }
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 上拉加载更多
     */
    onScrollBottom: function onScrollBottom() {
      if (this.pageData.nextPage) {
        this.pageData.page += 1;
        this.query(this.flowStep);
      }
    },

    /**
     * 下拉刷新
     */
    onRefresh: function onRefresh() {
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
    },

    /**
     * 点击去支付
     */
    toPay: function toPay(e) {
      var _this3 = this;

      if (!this.disabled) {
        this.disabled = true;
        orderService.orderWxPay(e.id).then(function (res) {
          _this3.disabled = false;
          var wxPayData = {
            appId: res.data.appId,
            nonceStr: res.data.nonceStr,
            package: res.data.package,
            paySign: res.data.paySign,
            signType: res.data.signType,
            timestamp: res.data.timeStamp
          };
          wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
            // 如果当前取消了支付
            if (result.errMsg == "chooseWXPay:cancel") {
              // res.payFlowId
            } else {
              // 重新获取加载待支付的数据
              _this3.handleTabClick(0);
              _this3.$vux.toast.text("操作成功");
            }
          }).catch(function (err) {
            console.log("支付失败:-------------");
            console.log(err);
          });
        }).catch(function (err) {
          _this3.disabled = false;
          _this3.$vux.toast.text(err.msg);
        });
      }
    },

    /**
     * 复制操作
     */
    handleCopy: function handleCopy(dom) {
      var _this4 = this;

      var clipboard = new clipboard_default.a(dom);
      clipboard.on("success", function (e) {
        // console.info("Action:", e.action);
        // console.info("Text:", e.text);
        // console.info("Trigger:", e.trigger);
        _this4.$vux.toast.show({
          text: "复制成功"
        });
        e.clearSelection();
        clipboard.destroy(); // 清理事件及创建的对象
      });

      clipboard.on("error", function (e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
        clipboard.destroy();
      });
    }
  },
  components: {
    CTab: src_components_CTab,
    ScrollMore: src_components_ScrollMore,
    NoData: src_components_NoData
  },
  destroyed: function destroyed() {
    if (this.$root.themeType == "black") {
      // 如果当前主题是黑金，当前页面销毁时将主题背景色重新改为黑色
      document.documentElement.style.backgroundColor = "#242626";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/robbing/orderList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var robbing_orderList = ({
  data: function data() {
    return {
      tabs: [{
        value: "待支付"
      }, {
        value: "已支付"
      }],
      flowStep: 0,
      pageData: {
        page: 1,
        size: 20,
        nextPage: false
      },
      list: [],
      scrollReset: false,
      disabled: false // 是否禁用提交操作
    };
  },

  computed: {
    copyIcon: function copyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("J4c5");
      } else {
        return __webpack_require__("xXI2");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    this.query(this.flowStep);
  },

  methods: {
    handleTabClick: function handleTabClick(e) {
      console.info(e);
      this.flowStep = e;
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
      this.scrollReset = true;
    },

    /**
     * 查询提货记录
     */
    query: function query(flowStep) {
      var _this2 = this;

      orderService.queryOrderList(this.pageData.page, this.pageData.size, flowStep).then(function (result) {
        var res = result.data;
        _this2.pageData.page = res.currPage;
        _this2.pageData.pageSize = res.pageSize;
        if (res.totalPage <= res.currPage) {
          _this2.pageData.nextPage = false;
        } else {
          _this2.pageData.nextPage = true;
        }
        res.list.forEach(function (item) {
          _this2.list.push(extends_default()({}, item));
        });
        if (_this2.$root.themeType == "black") {
          // 如果当前主题是黑金
          // 如果列表没有数据，显示黑色背景，否则显示白色背景
          if (_this2.list.length > 0) {
            document.documentElement.style.backgroundColor = "#fff";
          }
        }
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 上拉加载更多
     */
    onScrollBottom: function onScrollBottom() {
      if (this.pageData.nextPage) {
        this.pageData.page += 1;
        this.query(this.flowStep);
      }
    },

    /**
     * 下拉刷新
     */
    onRefresh: function onRefresh() {
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
    },

    /**
     * 点击去支付
     */
    toPay: function toPay(e) {
      var _this3 = this;

      if (!this.disabled) {
        this.disabled = true;
        orderService.orderWxPay(e.id).then(function (res) {
          _this3.disabled = false;
          var wxPayData = {
            appId: res.data.appId,
            nonceStr: res.data.nonceStr,
            package: res.data.package,
            paySign: res.data.paySign,
            signType: res.data.signType,
            timestamp: res.data.timeStamp
          };
          wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
            // 如果当前取消了支付
            if (result.errMsg == "chooseWXPay:cancel") {
              // res.payFlowId
            } else {
              // 重新获取加载待支付的数据
              _this3.handleTabClick(0);
              _this3.$vux.toast.text("操作成功");
            }
          }).catch(function (err) {
            console.log("支付失败:-------------");
            console.log(err);
          });
        }).catch(function (err) {
          _this3.disabled = false;
          _this3.$vux.toast.text(err.msg);
        });
      }
    },

    /**
     * 复制操作
     */
    handleCopy: function handleCopy(dom) {
      var _this4 = this;

      var clipboard = new clipboard_default.a(dom);
      clipboard.on("success", function (e) {
        // console.info("Action:", e.action);
        // console.info("Text:", e.text);
        // console.info("Trigger:", e.trigger);
        _this4.$vux.toast.show({
          text: "复制成功"
        });
        e.clearSelection();
        clipboard.destroy(); // 清理事件及创建的对象
      });

      clipboard.on("error", function (e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
        clipboard.destroy();
      });
    }
  },
  components: {
    CTab: src_components_CTab,
    ScrollMore: src_components_ScrollMore,
    NoData: src_components_NoData
  },
  destroyed: function destroyed() {
    if (this.$root.themeType == "black") {
      // 如果当前主题是黑金，当前页面销毁时将主题背景色重新改为黑色
      document.documentElement.style.backgroundColor = "#242626";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-815abe5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robbing/orderList.vue
var orderList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-tab',{attrs:{"tabs":_vm.tabs},on:{"on-tab-click":_vm.handleTabClick}},[(_vm.list.length > 0)?_c('scroll-more',{attrs:{"top":"44px","height":"calc(100vh - 44px)","hasMore":_vm.pageData.nextPage,"reset":_vm.scrollReset},on:{"update:reset":function($event){_vm.scrollReset=$event},"onScrollBottom":_vm.onScrollBottom,"onPulldown":_vm.onRefresh}},[_c('div',{staticClass:"delivery-list"},_vm._l((_vm.list),function(it,idx){return _c('div',{key:idx,staticClass:"item vux-1px-b"},[_vm._l((it.tradeOrderDetailList),function(i,ix){return _c('div',{key:ix,staticClass:"product flex-between"},[_c('img',{attrs:{"src":i.productImgUrl}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h5',[_vm._v(_vm._s(i.productName))]),_vm._v(" "),_c('p',[_vm._v("创建时间："+_vm._s(i.createTime))]),_vm._v(" "),_c('div',{staticClass:"flex-between"},[_c('span',[_vm._v("x "+_vm._s(i.num)+"盒")]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(i.realPrice))])])])])}),_vm._v(" "),_c('div',{staticClass:"item-info"},[(_vm.flowStep == 0)?_c('div',{staticClass:"flex-between vux-1px-t"},[_c('span',[_vm._v("请支付")]),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.toPay(it)}}},[_vm._v("支付")])]):_vm._e()])],2)}),0)]):_vm._e(),_vm._v(" "),(_vm.list.length == 0)?_c('no-data',[_vm._v("暂时没有记录哦~")]):_vm._e()],1)}
var orderList_staticRenderFns = []
var orderList_esExports = { render: orderList_render, staticRenderFns: orderList_staticRenderFns }
/* harmony default export */ var views_robbing_orderList = (orderList_esExports);
// CONCATENATED MODULE: ./src/views/robbing/orderList.vue
function orderList_injectStyle (ssrContext) {
  __webpack_require__("ve4H")
  __webpack_require__("JUbA")
}
var orderList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orderList___vue_template_functional__ = false
/* styles */
var orderList___vue_styles__ = orderList_injectStyle
/* scopeId */
var orderList___vue_scopeId__ = "data-v-815abe5c"
/* moduleIdentifier (server only) */
var orderList___vue_module_identifier__ = null
var orderList_Component = orderList_normalizeComponent(
  robbing_orderList,
  views_robbing_orderList,
  orderList___vue_template_functional__,
  orderList___vue_styles__,
  orderList___vue_scopeId__,
  orderList___vue_module_identifier__
)

/* harmony default export */ var src_views_robbing_orderList = (orderList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/deliveryList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var inventory_deliveryList = ({
  data: function data() {
    return {
      tabs: [{
        value: "待支付"
      }, {
        value: "已支付"
      }, {
        value: "已发货"
      }],
      flowStep: 1,
      pageData: {
        page: 1,
        size: 20,
        nextPage: false
      },
      list: [],
      scrollReset: false,
      disabled: false // 是否禁用提交操作
    };
  },

  computed: {
    copyIcon: function copyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("J4c5");
      } else {
        return __webpack_require__("xXI2");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    this.query(this.flowStep);
  },

  methods: {
    handleTabClick: function handleTabClick(e) {
      this.flowStep = e + 1;
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
      this.scrollReset = true;
    },

    /**
     * 点击跳转查询物流记录页面
     * @param trackingNumber
     */
    clickLogisticsRecord: function clickLogisticsRecord(trackingNumber, productImgUrl) {
      // 进入到地址编辑页
      this.$router.push({
        path: "/logisticsRecord",
        query: {
          trackingNumber: trackingNumber,
          productImgUrl: productImgUrl
        }
      });
    },

    /**
     * 查询提货记录
     */
    query: function query(flowStep) {
      var _this2 = this;

      orderService.deliveryList(this.pageData.page, this.pageData.size, flowStep).then(function (result) {
        var res = result.data;
        _this2.pageData.page = res.currPage;
        _this2.pageData.pageSize = res.pageSize;
        if (res.totalPage <= res.currPage) {
          _this2.pageData.nextPage = false;
        } else {
          _this2.pageData.nextPage = true;
        }
        res.list.forEach(function (item) {
          _this2.list.push(extends_default()({}, item));
        });
        if (_this2.$root.themeType == "black") {
          // 如果当前主题是黑金
          // 如果列表没有数据，显示黑色背景，否则显示白色背景
          if (_this2.list.length > 0) {
            document.documentElement.style.backgroundColor = "#fff";
          }
        }
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 上拉加载更多
     */
    onScrollBottom: function onScrollBottom() {
      if (this.pageData.nextPage) {
        this.pageData.page += 1;
        this.query(this.flowStep);
      }
    },

    /**
     * 下拉刷新
     */
    onRefresh: function onRefresh() {
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
    },

    /**
     * 点击去支付
     */
    toPay: function toPay(e) {
      var _this3 = this;

      if (!this.disabled) {
        this.disabled = true;
        orderService.extractWxPay(e.id).then(function (res) {
          _this3.disabled = false;
          var wxPayData = {
            appId: res.data.appId,
            nonceStr: res.data.nonceStr,
            package: res.data.package,
            paySign: res.data.paySign,
            signType: res.data.signType,
            timestamp: res.data.timeStamp
          };
          wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
            // 如果当前取消了支付
            if (result.errMsg == "chooseWXPay:cancel") {
              // res.payFlowId
            } else {
              // 重新获取加载待支付的数据
              _this3.handleTabClick(0);
              _this3.$vux.toast.text("操作成功");
            }
          }).catch(function (err) {
            console.log("支付失败:-------------");
            console.log(err);
          });
        }).catch(function (err) {
          _this3.disabled = false;
          _this3.$vux.toast.text(err.msg);
        });
      }
    },

    /**
     * 复制操作
     */
    handleCopy: function handleCopy(dom) {
      var _this4 = this;

      var clipboard = new clipboard_default.a(dom);
      clipboard.on("success", function (e) {
        // console.info("Action:", e.action);
        // console.info("Text:", e.text);
        // console.info("Trigger:", e.trigger);
        _this4.$vux.toast.show({
          text: "复制成功"
        });
        e.clearSelection();
        clipboard.destroy(); // 清理事件及创建的对象
      });

      clipboard.on("error", function (e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
        clipboard.destroy();
      });
    }
  },
  components: {
    CTab: src_components_CTab,
    ScrollMore: src_components_ScrollMore,
    NoData: src_components_NoData
  },
  destroyed: function destroyed() {
    if (this.$root.themeType == "black") {
      // 如果当前主题是黑金，当前页面销毁时将主题背景色重新改为黑色
      document.documentElement.style.backgroundColor = "#242626";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/deliveryList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var views_inventory_deliveryList = ({
  data: function data() {
    return {
      tabs: [{
        value: "待支付"
      }, {
        value: "已支付"
      }, {
        value: "已发货"
      }],
      flowStep: 1,
      pageData: {
        page: 1,
        size: 20,
        nextPage: false
      },
      list: [],
      scrollReset: false,
      disabled: false // 是否禁用提交操作
    };
  },

  computed: {
    copyIcon: function copyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("J4c5");
      } else {
        return __webpack_require__("xXI2");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    this.query(this.flowStep);
  },

  methods: {
    handleTabClick: function handleTabClick(e) {
      this.flowStep = e + 1;
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
      this.scrollReset = true;
    },

    /**
     * 点击跳转查询物流记录页面
     * @param trackingNumber
     */
    clickLogisticsRecord: function clickLogisticsRecord(trackingNumber, productImgUrl) {
      // 进入到地址编辑页
      this.$router.push({
        path: "/logisticsRecord",
        query: {
          trackingNumber: trackingNumber,
          productImgUrl: productImgUrl
        }
      });
    },

    /**
     * 查询提货记录
     */
    query: function query(flowStep) {
      var _this2 = this;

      orderService.deliveryList(this.pageData.page, this.pageData.size, flowStep).then(function (result) {
        var res = result.data;
        _this2.pageData.page = res.currPage;
        _this2.pageData.pageSize = res.pageSize;
        if (res.totalPage <= res.currPage) {
          _this2.pageData.nextPage = false;
        } else {
          _this2.pageData.nextPage = true;
        }
        res.list.forEach(function (item) {
          _this2.list.push(extends_default()({}, item));
        });
        if (_this2.$root.themeType == "black") {
          // 如果当前主题是黑金
          // 如果列表没有数据，显示黑色背景，否则显示白色背景
          if (_this2.list.length > 0) {
            document.documentElement.style.backgroundColor = "#fff";
          }
        }
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 上拉加载更多
     */
    onScrollBottom: function onScrollBottom() {
      if (this.pageData.nextPage) {
        this.pageData.page += 1;
        this.query(this.flowStep);
      }
    },

    /**
     * 下拉刷新
     */
    onRefresh: function onRefresh() {
      this.list = [];
      this.pageData.page = 1;
      this.query(this.flowStep);
    },

    /**
     * 点击去支付
     */
    toPay: function toPay(e) {
      var _this3 = this;

      if (!this.disabled) {
        this.disabled = true;
        orderService.extractWxPay(e.id).then(function (res) {
          _this3.disabled = false;
          var wxPayData = {
            appId: res.data.appId,
            nonceStr: res.data.nonceStr,
            package: res.data.package,
            paySign: res.data.paySign,
            signType: res.data.signType,
            timestamp: res.data.timeStamp
          };
          wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
            // 如果当前取消了支付
            if (result.errMsg == "chooseWXPay:cancel") {
              // res.payFlowId
            } else {
              // 重新获取加载待支付的数据
              _this3.handleTabClick(0);
              _this3.$vux.toast.text("操作成功");
            }
          }).catch(function (err) {
            console.log("支付失败:-------------");
            console.log(err);
          });
        }).catch(function (err) {
          _this3.disabled = false;
          _this3.$vux.toast.text(err.msg);
        });
      }
    },

    /**
     * 复制操作
     */
    handleCopy: function handleCopy(dom) {
      var _this4 = this;

      var clipboard = new clipboard_default.a(dom);
      clipboard.on("success", function (e) {
        // console.info("Action:", e.action);
        // console.info("Text:", e.text);
        // console.info("Trigger:", e.trigger);
        _this4.$vux.toast.show({
          text: "复制成功"
        });
        e.clearSelection();
        clipboard.destroy(); // 清理事件及创建的对象
      });

      clipboard.on("error", function (e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
        clipboard.destroy();
      });
    }
  },
  components: {
    CTab: src_components_CTab,
    ScrollMore: src_components_ScrollMore,
    NoData: src_components_NoData
  },
  destroyed: function destroyed() {
    if (this.$root.themeType == "black") {
      // 如果当前主题是黑金，当前页面销毁时将主题背景色重新改为黑色
      document.documentElement.style.backgroundColor = "#242626";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da86233","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/deliveryList.vue
var deliveryList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-tab',{attrs:{"tabs":_vm.tabs},on:{"on-tab-click":_vm.handleTabClick}},[(_vm.list.length > 0)?_c('scroll-more',{attrs:{"top":"44px","height":"calc(100vh - 44px)","hasMore":_vm.pageData.nextPage,"reset":_vm.scrollReset},on:{"update:reset":function($event){_vm.scrollReset=$event},"onScrollBottom":_vm.onScrollBottom,"onPulldown":_vm.onRefresh}},[_c('div',{staticClass:"delivery-list"},_vm._l((_vm.list),function(it,idx){return _c('div',{key:idx,staticClass:"item vux-1px-b"},[_vm._l((it.productList),function(i,ix){return _c('div',{key:ix,staticClass:"product flex-between"},[_c('img',{attrs:{"src":i.productImgUrl}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h5',[_vm._v(_vm._s(i.productName))]),_vm._v(" "),_c('p',[_vm._v("提货时间："+_vm._s(i.createTime))]),_vm._v(" "),_c('div',{staticClass:"flex-between"},[_c('span',[_vm._v("x "+_vm._s(i.num)+"盒")]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(i.logisticsPrice))])])])])}),_vm._v(" "),_c('div',{staticClass:"item-info"},[_c('div',{staticClass:"flex-between vux-1px-b"},[_c('span',[_vm._v("收货人")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(it.tradeExtractAddr.receiverName)+" "+_vm._s(it.tradeExtractAddr.mobile))])]),_vm._v(" "),_c('div',{staticClass:"flex-between vux-1px-b"},[_c('span',[_vm._v("收货地址")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(it.tradeExtractAddr.provinceName + it.tradeExtractAddr.cityName + it.tradeExtractAddr.areaName))])]),_vm._v(" "),_c('div',{staticClass:"flex-between"},[_c('span',[_vm._v("快递单号")]),_vm._v(" "),_c('div',{staticClass:"value"},_vm._l((it.trackingNumberList),function(j,ix){return _c('div',{key:ix},[_c('span',[_vm._v(_vm._s(j))]),_vm._v(" "),(j!=null&&j!='')?_c('button',{on:{"click":function($event){return _vm.clickLogisticsRecord(j, it.productList[0].productImgUrl)}}},[_vm._v("物流信息")]):_vm._e()])}),0)]),_vm._v(" "),(_vm.flowStep == 1)?_c('div',{staticClass:"flex-between vux-1px-t"},[_c('span',[_vm._v("请支付")]),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.toPay(it)}}},[_vm._v("支付")])]):_vm._e()])],2)}),0)]):_vm._e(),_vm._v(" "),(_vm.list.length == 0)?_c('no-data',[_vm._v("暂时没有记录哦~")]):_vm._e()],1)}
var deliveryList_staticRenderFns = []
var deliveryList_esExports = { render: deliveryList_render, staticRenderFns: deliveryList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_inventory_deliveryList = (deliveryList_esExports);
// CONCATENATED MODULE: ./src/views/inventory/deliveryList.vue
function deliveryList_injectStyle (ssrContext) {
  __webpack_require__("/Vby")
  __webpack_require__("gu8N")
}
var deliveryList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var deliveryList___vue_template_functional__ = false
/* styles */
var deliveryList___vue_styles__ = deliveryList_injectStyle
/* scopeId */
var deliveryList___vue_scopeId__ = "data-v-5da86233"
/* moduleIdentifier (server only) */
var deliveryList___vue_module_identifier__ = null
var deliveryList_Component = deliveryList_normalizeComponent(
  views_inventory_deliveryList,
  selectortype_template_index_0_src_views_inventory_deliveryList,
  deliveryList___vue_template_functional__,
  deliveryList___vue_styles__,
  deliveryList___vue_scopeId__,
  deliveryList___vue_module_identifier__
)

/* harmony default export */ var src_views_inventory_deliveryList = (deliveryList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/logisticsRecord.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var logisticsRecord = ({
  data: function data() {
    return {
      productImgUrl: '',
      trackingNumber: '',
      expName: "",
      deliverystatusName: "",
      logo: "",
      list: []
    };
  },

  computed: {},
  mounted: function mounted() {
    this.productImgUrl = this.$route.query.productImgUrl;
    this.trackingNumber = this.$route.query.trackingNumber;
    this.query(this.trackingNumber);
  },

  methods: {
    lineColor: function lineColor(color, index) {
      var i = void 0;
      this.list.forEach(function (item, j) {
        if (item.color) {
          i = j;
        }
      });
      if (color && i != index) {
        return color;
      }
    },

    /**
     * 查询提货记录
     */
    query: function query(trackingNumber) {
      var _this = this;

      orderService.traceQuery(trackingNumber).then(function (result) {
        var res = result.data;
        _this.list = res.result.list;
        _this.expName = res.result.expName;
        _this.logo = res.result.logo;
        _this.deliverystatusName = res.result.deliverystatusName;
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }
  },
  components: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/logisticsRecord.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var inventory_logisticsRecord = ({
  data: function data() {
    return {
      productImgUrl: '',
      trackingNumber: '',
      expName: "",
      deliverystatusName: "",
      logo: "",
      list: []
    };
  },

  computed: {},
  mounted: function mounted() {
    this.productImgUrl = this.$route.query.productImgUrl;
    this.trackingNumber = this.$route.query.trackingNumber;
    this.query(this.trackingNumber);
  },

  methods: {
    lineColor: function lineColor(color, index) {
      var i = void 0;
      this.list.forEach(function (item, j) {
        if (item.color) {
          i = j;
        }
      });
      if (color && i != index) {
        return color;
      }
    },

    /**
     * 查询提货记录
     */
    query: function query(trackingNumber) {
      var _this = this;

      orderService.traceQuery(trackingNumber).then(function (result) {
        var res = result.data;
        _this.list = res.result.list;
        _this.expName = res.result.expName;
        _this.logo = res.result.logo;
        _this.deliverystatusName = res.result.deliverystatusName;
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }
  },
  components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d9ef355","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/logisticsRecord.vue
var logisticsRecord_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"--color":"#facd89","background-color":"rgb(238 244 244)"}},[_c('div',{staticClass:"delivery-list"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"product flex-between"},[_c('img',{attrs:{"src":_vm.productImgUrl}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h5',[_vm._v("物流状态："+_vm._s(_vm.deliverystatusName))]),_vm._v(" "),_c('p',[_vm._v("物流公司："+_vm._s(_vm.expName))]),_vm._v(" "),_c('p',[_vm._v("物流单号："+_vm._s(_vm.trackingNumber))]),_vm._v(" "),_c('p',[_vm._v("提示：物流信息仅供参考")])])])])]),_vm._v(" "),_c('div',{attrs:{"id":"app1"}},[_c('div',{staticClass:"items"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",style:({color:item.color})},[_c('div',{staticClass:"item-left"},[(index == 0)?_c('div',{staticClass:"point",style:({background:'#fc581f'})}):_vm._e(),_vm._v(" "),(index != 0)?_c('div',{staticClass:"point",style:({background:item.color})}):_vm._e(),_vm._v(" "),(index+1 != _vm.list.length)?_c('div',{staticClass:"line",style:({background:_vm.lineColor(item.color,index)})}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"status"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v(_vm._s(item.time))]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("  ")])])])])}),0)])])}
var logisticsRecord_staticRenderFns = []
var logisticsRecord_esExports = { render: logisticsRecord_render, staticRenderFns: logisticsRecord_staticRenderFns }
/* harmony default export */ var views_inventory_logisticsRecord = (logisticsRecord_esExports);
// CONCATENATED MODULE: ./src/views/inventory/logisticsRecord.vue
function logisticsRecord_injectStyle (ssrContext) {
  __webpack_require__("hgmr")
  __webpack_require__("i5Dh")
}
var logisticsRecord_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var logisticsRecord___vue_template_functional__ = false
/* styles */
var logisticsRecord___vue_styles__ = logisticsRecord_injectStyle
/* scopeId */
var logisticsRecord___vue_scopeId__ = "data-v-3d9ef355"
/* moduleIdentifier (server only) */
var logisticsRecord___vue_module_identifier__ = null
var logisticsRecord_Component = logisticsRecord_normalizeComponent(
  inventory_logisticsRecord,
  views_inventory_logisticsRecord,
  logisticsRecord___vue_template_functional__,
  logisticsRecord___vue_styles__,
  logisticsRecord___vue_scopeId__,
  logisticsRecord___vue_module_identifier__
)

/* harmony default export */ var src_views_inventory_logisticsRecord = (logisticsRecord_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/inventory.vue









/* harmony default export */ var inventory = ({
  data: function data() {
    return {
      off: false,
      isStart: false, // 活动是否已经开始
      name: "胶原蛋白弹性蛋白饮料",
      pic: __webpack_require__("7Otq"),
      stock: "",
      products: []
    };
  },

  computed: {
    buyIcon: function buyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("iK2A");
      } else {
        return __webpack_require__("MO6P");
      }
    }
  },
  mounted: function mounted() {
    this.getStock();
  },

  methods: {
    /**
    * 查询我的库存接口
    */
    getStock: function getStock() {
      var _this = this;

      userService.queryStock(PRODUCTID).then(function (res) {
        _this.pic = res.data.titlePic;
        _this.stock = res.data.stock;
        _this.name = res.data.productName;

        _this.queryProducts();
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    },

    /**
    * 获取商品兑换结果数据
    */
    getExhange: function getExhange(targetProductId) {
      var _this2 = this;

      var postData = {
        sourceProductId: PRODUCTID,
        sourceProductQuantity: this.stock,
        targetProductId: targetProductId
      };
      orderService.calcExchange(postData).then(function (res) {
        _this2.products.forEach(function (ele) {
          if (ele.key == targetProductId) {
            ele.convert = res.data.targetProductQuantity;
          }
        });
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
    * 查询商品列表
    */
    queryProducts: function queryProducts() {
      var _this3 = this;

      orderService.queryProducts(PRODUCTID).then(function (res) {
        _this3.products = [];
        res.list.forEach(function (it) {

          var convert = 0;

          _this3.products.push(extends_default()({}, it, {
            convert: convert
          }));
          _this3.getExhange(it.key);

          if (it.key == "1647779951578025985") {
            if (it.etxtractBeginTimeCountdown > 0) {
              _this3.isStart = false;
              var timeDown = it.etxtractBeginTimeCountdown;
              var time = setInterval(function () {
                timeDown = timeDown - 1000;

                if (timeDown < 1000) {
                  _this3.isStart = true;
                  clearInterval(time);
                }
              }, 1000);
            } else {

              _this3.isStart = true;
            }
          }
        });
      }).catch(function (err) {
        _this3.$vut.toast.text(err.msg);
      });
    },

    /**
    * 点击立即提货，进入提货操作页
    */
    clickDelivery: function clickDelivery(e) {
      this.$router.push({
        path: "/delivery",
        query: {
          product: stringify_default()(e),
          stock: this.stock
        }
      });
    },

    /**
    * 点击立即补货，返回robbing页
    */
    clickReplenish: function clickReplenish() {
      this.$router.push({
        path: "/robbing"
      });
    }
  },
  filters: {
    filtKeyName: function filtKeyName(e) {
      var res = "";
      if (e == "8153724996370400") {
        res = "固体";
      } else if (e == "8153725012044602") {
        res = "液体";
      } else if (e == "8155244507410000") {
        res = "经典版";
      } else if (e == "8156213789948654") {
        res = "裸藻";
      } else if (e == "8158735277245403") {
        res = "日本版";
      } else if (e == "8160223245934659") {
        res = "家庭装";
      } else if (e == "8160367516337895") {
        res = "益生菌";
      } else if (e == "1383959923502743554") {
        res = "小蓝";
      } else if (e == "1383959923502743555") {
        res = "红石榴";
      }
      return res;
    },
    filtBeginTime: function filtBeginTime(e) {
      var res = e;
      if (e) {
        res = res.replace(/\-/g, '/');
        res = Object(format["a" /* default */])(new Date(res), "MM月DD日 HH:mm");
      }
      return res;
    }
  },
  components: {
    CAvatar: src_components_CAvatar
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/inventory.vue









/* harmony default export */ var inventory_inventory = ({
  data: function data() {
    return {
      off: false,
      isStart: false, // 活动是否已经开始
      name: "胶原蛋白弹性蛋白饮料",
      pic: __webpack_require__("7Otq"),
      stock: "",
      products: []
    };
  },

  computed: {
    buyIcon: function buyIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("iK2A");
      } else {
        return __webpack_require__("MO6P");
      }
    }
  },
  mounted: function mounted() {
    this.getStock();
  },

  methods: {
    /**
    * 查询我的库存接口
    */
    getStock: function getStock() {
      var _this = this;

      userService.queryStock(PRODUCTID).then(function (res) {
        _this.pic = res.data.titlePic;
        _this.stock = res.data.stock;
        _this.name = res.data.productName;

        _this.queryProducts();
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    },

    /**
    * 获取商品兑换结果数据
    */
    getExhange: function getExhange(targetProductId) {
      var _this2 = this;

      var postData = {
        sourceProductId: PRODUCTID,
        sourceProductQuantity: this.stock,
        targetProductId: targetProductId
      };
      orderService.calcExchange(postData).then(function (res) {
        _this2.products.forEach(function (ele) {
          if (ele.key == targetProductId) {
            ele.convert = res.data.targetProductQuantity;
          }
        });
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
    * 查询商品列表
    */
    queryProducts: function queryProducts() {
      var _this3 = this;

      orderService.queryProducts(PRODUCTID).then(function (res) {
        _this3.products = [];
        res.list.forEach(function (it) {

          var convert = 0;

          _this3.products.push(extends_default()({}, it, {
            convert: convert
          }));
          _this3.getExhange(it.key);

          if (it.key == "1647779951578025985") {
            if (it.etxtractBeginTimeCountdown > 0) {
              _this3.isStart = false;
              var timeDown = it.etxtractBeginTimeCountdown;
              var time = setInterval(function () {
                timeDown = timeDown - 1000;

                if (timeDown < 1000) {
                  _this3.isStart = true;
                  clearInterval(time);
                }
              }, 1000);
            } else {

              _this3.isStart = true;
            }
          }
        });
      }).catch(function (err) {
        _this3.$vut.toast.text(err.msg);
      });
    },

    /**
    * 点击立即提货，进入提货操作页
    */
    clickDelivery: function clickDelivery(e) {
      this.$router.push({
        path: "/delivery",
        query: {
          product: stringify_default()(e),
          stock: this.stock
        }
      });
    },

    /**
    * 点击立即补货，返回robbing页
    */
    clickReplenish: function clickReplenish() {
      this.$router.push({
        path: "/robbing"
      });
    }
  },
  filters: {
    filtKeyName: function filtKeyName(e) {
      var res = "";
      if (e == "8153724996370400") {
        res = "固体";
      } else if (e == "8153725012044602") {
        res = "液体";
      } else if (e == "8155244507410000") {
        res = "经典版";
      } else if (e == "8156213789948654") {
        res = "裸藻";
      } else if (e == "8158735277245403") {
        res = "日本版";
      } else if (e == "8160223245934659") {
        res = "家庭装";
      } else if (e == "8160367516337895") {
        res = "益生菌";
      } else if (e == "1383959923502743554") {
        res = "小蓝";
      } else if (e == "1383959923502743555") {
        res = "红石榴";
      }
      return res;
    },
    filtBeginTime: function filtBeginTime(e) {
      var res = e;
      if (e) {
        res = res.replace(/\-/g, '/');
        res = Object(format["a" /* default */])(new Date(res), "MM月DD日 HH:mm");
      }
      return res;
    }
  },
  components: {
    CAvatar: src_components_CAvatar
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cacc2c7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/inventory.vue
var inventory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory"},[_c('div',{staticClass:"header"},[_c('p',[_vm._v("我的库存：")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"guige"},[_vm._v("规格：10条/盒 30盒/箱")]),_vm._v(" "),_c('c-avatar',{attrs:{"size":"mini"}}),_vm._v(" "),_c('div',{staticClass:"flex-between"},[_c('p',{staticClass:"stock"},[_c('span',[_vm._v(_vm._s(_vm.stock))]),_vm._v("盒\n      ")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.clickReplenish}},[_c('img',{attrs:{"src":_vm.buyIcon,"alt":""}}),_vm._v("下单补货\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"main"},_vm._l((_vm.products),function(it,idx){return _c('div',{key:idx,staticClass:"product flex-between"},[_c('img',{attrs:{"src":it.productPic,"alt":it.value}}),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('h5',[_vm._v(_vm._s(it.value))]),_vm._v(" "),_c('p',[_vm._v("折算成"+_vm._s(_vm._f("filtKeyName")(it.key))+"库存"+_vm._s(it.convert)+"盒")]),_vm._v(" "),_c('div',{staticClass:"tip-btn"},[(it.etxtractBeginTimeCountdown > 0)?_c('span',[_vm._v(_vm._s(_vm._f("filtBeginTime")(it.extractBeginTime))+"开始")]):(it.key == '1647779951578025985' && _vm.isStart)?_c('span',[_vm._v("限量抢提已开始")]):_vm._e(),_vm._v(" "),(it.key == '1647779951578025985' && !_vm.isStart)?_c('button',{attrs:{"disabled":""}},[_vm._v("未开始")]):_c('button',{on:{"click":function($event){return _vm.clickDelivery(it)}}},[_vm._v("去提货")])])])])}),0)])}
var inventory_staticRenderFns = []
var inventory_esExports = { render: inventory_render, staticRenderFns: inventory_staticRenderFns }
/* harmony default export */ var views_inventory_inventory = (inventory_esExports);
// CONCATENATED MODULE: ./src/views/inventory/inventory.vue
function inventory_injectStyle (ssrContext) {
  __webpack_require__("Y2Ce")
  __webpack_require__("Oc9N")
}
var inventory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inventory___vue_template_functional__ = false
/* styles */
var inventory___vue_styles__ = inventory_injectStyle
/* scopeId */
var inventory___vue_scopeId__ = "data-v-4cacc2c7"
/* moduleIdentifier (server only) */
var inventory___vue_module_identifier__ = null
var inventory_Component = inventory_normalizeComponent(
  inventory_inventory,
  views_inventory_inventory,
  inventory___vue_template_functional__,
  inventory___vue_styles__,
  inventory___vue_scopeId__,
  inventory___vue_module_identifier__
)

/* harmony default export */ var src_views_inventory_inventory = (inventory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RadioSwitch.vue
//
//
//
//
//

/* harmony default export */ var RadioSwitch = ({
  data: function data() {
    return {
      select: this.value
    };
  },

  props: {
    list: {
      type: Array,
      default: []
    },
    value: {
      default: 0
    }
  },
  methods: {
    _handleClick: function _handleClick(e) {
      this.$emit("update:value", e);
    }
  },
  watch: {
    value: function value(e) {
      this.select = e;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RadioSwitch.vue
//
//
//
//
//

/* harmony default export */ var components_RadioSwitch = ({
  data: function data() {
    return {
      select: this.value
    };
  },

  props: {
    list: {
      type: Array,
      default: []
    },
    value: {
      default: 0
    }
  },
  methods: {
    _handleClick: function _handleClick(e) {
      this.$emit("update:value", e);
    }
  },
  watch: {
    value: function value(e) {
      this.select = e;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3302c3f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RadioSwitch.vue
var RadioSwitch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-switch"},_vm._l((_vm.list),function(item,index){return _c('button',{key:index,class:{select:index == _vm.select},on:{"click":function($event){return _vm._handleClick(index)}}},[_vm._v(_vm._s(item))])}),0)}
var RadioSwitch_staticRenderFns = []
var RadioSwitch_esExports = { render: RadioSwitch_render, staticRenderFns: RadioSwitch_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_RadioSwitch = (RadioSwitch_esExports);
// CONCATENATED MODULE: ./src/components/RadioSwitch.vue
function RadioSwitch_injectStyle (ssrContext) {
  __webpack_require__("RYLh")
  __webpack_require__("2e05")
}
var RadioSwitch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RadioSwitch___vue_template_functional__ = false
/* styles */
var RadioSwitch___vue_styles__ = RadioSwitch_injectStyle
/* scopeId */
var RadioSwitch___vue_scopeId__ = "data-v-3302c3f7"
/* moduleIdentifier (server only) */
var RadioSwitch___vue_module_identifier__ = null
var RadioSwitch_Component = RadioSwitch_normalizeComponent(
  components_RadioSwitch,
  selectortype_template_index_0_src_components_RadioSwitch,
  RadioSwitch___vue_template_functional__,
  RadioSwitch___vue_styles__,
  RadioSwitch___vue_scopeId__,
  RadioSwitch___vue_module_identifier__
)

/* harmony default export */ var src_components_RadioSwitch = (RadioSwitch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/delivery.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var delivery = ({
  data: function data() {
    return {
      disabled: false, // 是否禁用提交操作
      showExchange: false, // 是否可以兑换
      selectAddress: "",
      account: 0, // 选择的数量
      switchs: ["在线支付", "运费到付"],
      payment: 0, // 支付方式
      exchangeNum: 0,
      extractIncrement: 30, // 数字步进器每一步增减多少
      extractMaxQuantity: 840, // 最大限制数量
      delivermoney: 0, // 实际支付快递费
      freight: 0, // 本应支付运费，只在会员生日优惠时显示
      showBirthday: false, // 是否显示生日优惠
      lastQuantity: 0 // 剩余抢提数量
    };
  },

  computed: {
    userInfo: function userInfo() {
      return auth_getUserInfo();
    },
    stock: function stock() {
      return this.$route.query.stock;
    },
    product: function product() {
      var product = this.$route.query.product;
      if (product) {
        return JSON.parse(product);
      } else {
        return "";
      }
    },
    loveIcon: function loveIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("JJUA");
      } else {
        return __webpack_require__("mh0x");
      }
    },
    minusIcon: function minusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("5JD3");
      } else {
        return __webpack_require__("1knL");
      }
    },
    plusIcon: function plusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("WRRU");
      } else {
        return __webpack_require__("VRHR");
      }
    },
    pickupIcon: function pickupIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("6AT+");
      } else {
        return __webpack_require__("nNV2");
      }
    },
    remindIcon: function remindIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("R3hu");
      } else {
        return __webpack_require__("w5Ii");
      }
    },
    isTime: function isTime() {
      var now = new Date().getTime();
      var endTime = new Date("2020/11/21 00:00:00").getTime();
      if (now <= endTime) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    if (this.product) {
      this.extractIncrement = Number(this.product.extractIncrement);
      this.extractMaxQuantity = Number(this.product.extractMaxQuantity);
      // 控制哪些产品详情显示兑换说明
      if (this.product.key == "8153978189986300" || this.product.key == "8156213789948654" || this.product.key == "8158735277245403" || this.product.key == "8160223245934659" || this.product.key == "8160367516337895" || this.product.key == "1383959923502743554" || this.product.key == "1383959923502743555" || this.product.key == "8156213789948655" || this.product.key == "8153724996370403" || this.product.key == "8156213789948656" || this.product.key == "1647779951578025985") {
        this.showExchange = true;
        if (this.account > 0) {
          this.handleCalc(this.account);
        }
      } else {
        this.showExchange = false;
      }

      // 当商品是小蓝时，查询剩余抢提数量
      if (this.product.key == "1383959923502743554") {
        this.getLastCount(this.product.key);
      }
    }

    var selectAddress = sessionStorage.getItem("TEMP_SELECT_ADDRESS");
    if (selectAddress) {
      selectAddress = JSON.parse(selectAddress);
      this.selectAddress = selectAddress;
    }

    // 判断是否是用户生日
    try {
      var isBirthday = this.userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
      if (isBirthday == 1) {
        this.showBirthday = true;
      } else {
        this.showBirthday = false;
      }
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    /**
     * 当当前产品是小蓝是，查询当前剩余可抢提数量
     */
    getLastCount: function getLastCount(key) {
      var _this2 = this;

      orderService.getLastCount(key).then(function (res) {
        var data = res.data;
        _this2.lastQuantity = data.quantity; // 剩余可抢提数量
        _this2.extractMaxQuantity = data.quantity; // 用户最大可提货数量为剩余可抢提数量
      });
    },

    /**
     * 进入地址列表选择地址
     */
    toSelectAddress: function toSelectAddress() {
      this.$router.push({
        path: "/addressList",
        query: {
          scene: "select"
        }
      });
    },

    /**
     * 计算当前运费
     */
    computerFreight: function computerFreight() {
      var _this3 = this;

      if (this.selectAddress.id && this.product.key) {
        if (this.account <= 0 || this.account == "") {
          this.$vux.toast.text("请选择数量");
          this.delivermoney = 0;
        } else {
          orderService.getFreight(this.account, this.selectAddress.id, this.product.key).then(function (res) {
            // 如果当前是在线支付
            if (_this3.payment == 0) {
              _this3.delivermoney = res.data.paymentAmount; // 实际支付运费
              _this3.freight = res.data.freight; // 计算所得本应支付运费
            }
          }).catch(function (err) {
            _this3.$vux.toast.text(err.msg);
          });
        }
      }
    },

    /**
     * 商品兑换比例计算
     */
    handleCalc: function handleCalc(newNum, oldNum) {
      var _this4 = this;

      if (newNum == "") newNum = 0;
      // 如果当前中选的是面膜或者裸藻，根据相应的比例计算可兑换的双蛋白数量
      var exchangeNum = 0;
      // if (this.product.key == "8153978189986300") {
      //   // exchangeNum = newNum * 0.375;
      //   exchangeNum = newNum * 0.1875;
      // } else if (this.product.key == "8156213789948654") {
      //   exchangeNum = newNum * 0.9;
      // } else if (this.product.key == "8158735277245403") {
      //   exchangeNum = parseInt(newNum * 1.1667);
      // }
      var postData = {
        sourceProductId: this.product.key,
        sourceProductQuantity: newNum,
        targetProductId: PRODUCTID
      };
      orderService.calcExchange(postData).then(function (res) {
        exchangeNum = res.data.targetProductQuantity;

        // 如果兑换需求量大于当前用户的库存量，提示用户补货
        if (exchangeNum > _this4.stock) {
          var self = _this4;
          setTimeout(function () {
            self.account = oldNum ? oldNum : 0;
          }, 500);
          _this4.$vux.alert.show({
            title: "温馨提示",
            content: "亲爱哒，您当前的双蛋白库存不足，请及时补货哦~"
          });
        } else {
          _this4.exchangeNum = exchangeNum;
        }
      }).catch(function (err) {
        _this4.$vux.toast.text(err.msg);
      });
    },

    /**
     * 点击提交操作，执行创建提货订单操作
     */
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      var self = this;
      if (!this.selectAddress) {
        this.$vux.toast.text("请选择地址");
      } else if (this.account <= 0) {
        this.$vux.toast.text("请选择数量");
      } else {
        var productList = [{
          productId: PRODUCTID,
          num: this.account,
          productSpecId: this.product.key
        }];
        if (!this.disabled) {
          this.disabled = true;
          var postData = {
            productId: PRODUCTID,
            productList: productList,
            freightType: this.payment,
            addrId: this.selectAddress.id
          };
          orderService.extract(postData).then(function (res) {
            // 如果当前选择在线支付，并且支付状态为0时（0表示未支付，1表示已支付），调用微信支付
            // 当用户生日时，支付状态为1，因为免运费，所以不需要调用微信支付操作
            if (_this5.payment == 0 && res.data.payStatus == "0") {
              return orderService.extractWxPay(res.data.id);
            } else {
              sessionStorage.removeItem("TEMP_SELECT_ADDRESS");
              setTimeout(function () {
                _this5.$vux.toast.text("操作成功");
              }, 100);
              _this5.$router.go(-1);
              return;
            }
          }).then(function (res) {
            _this5.disabled = false;
            var wxPayData = {
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              paySign: res.data.paySign,
              signType: res.data.signType,
              timestamp: res.data.timeStamp
            };
            wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
              // 如果当前取消了支付
              if (result.errMsg == "chooseWXPay:cancel") {
                // res.payFlowId
                _this5.$vux.confirm.show({
                  // 组件除show外的属性
                  title: "提示",
                  content: "扣减库存成功 <svg class='icon' aria-hidden='true'><use xlink:href='#iconsuccess-green' /></svg><br />提货订单生成成功 <svg class='icon' aria-hidden='true'><use xlink:href='#iconsuccess-green' /></svg><br />运费支付失败 <svg class='icon' aria-hidden='true'><use xlink:href='#icondeleteimg' /></svg>",
                  confirmText: "去支付运费",
                  cancelText: "继续提货",
                  onCancel: function onCancel() {},
                  onConfirm: function onConfirm() {
                    // 跳转到提货记录页
                    self.$router.push({
                      path: "/deliveryList"
                    });
                  }
                });
              } else {
                sessionStorage.removeItem("TEMP_SELECT_ADDRESS");
                _this5.$vux.toast.text("操作成功");
                _this5.$router.go(-1);
              }
            }).catch(function (err) {
              console.log("支付失败:-------------");
              console.log(err);
            });
          }).catch(function (err) {
            _this5.disabled = false;
            _this5.$vux.toast.text(err.msg);
          });
        }
      }
    },
    clickMinus: function clickMinus() {
      this.account -= this.extractIncrement;
      if (this.account <= 0) {
        this.account = 0;
      }
    },
    clickPlus: function clickPlus() {
      this.account += this.extractIncrement;
      if (this.account >= this.extractMaxQuantity) {
        this.account = this.extractMaxQuantity;
      }
      if (this.extractMaxQuantity <= 0) {
        this.$vux.toast.text("可提货数量不足");
      }
    },
    handleBlur: function handleBlur() {
      if (this.account <= 0) {
        this.account = 0;
      } else if (this.account >= this.extractMaxQuantity) {
        this.account = this.extractMaxQuantity;
      }
    },
    clickBack: function clickBack() {
      this.$router.go(-1);
    }
  },
  filters: {
    filtValueName: function filtValueName(e) {
      if (e == "裸藻圆苞车前子壳固体饮料") {
        return "裸藻";
      } else if (e == "绿孔雀限量版椰子味裸藻圆苞车前子固体饮料") {
        return "椰子味裸藻";
      } else if (e == "家庭装-胶原蛋白弹性蛋白固体饮料") {
        return "家庭装";
      } else if (e == "益生菌 · 即食型乳酸菌") {
        return "益生菌";
      } else if (e == "限量版小蓝透明质酸钠胶原蛋白弹性蛋白固体饮料") {
        return "小蓝";
      } else if (e == "胶原蛋白弹性蛋白玻尿酸红石榴味固体饮料") {
        return "红石榴";
      } else if (e == "荔枝玫瑰味胶原蛋白弹性蛋白固体饮料") {
        return "荔枝玫瑰味胶原蛋白弹性蛋白固体饮料";
      } else {
        return e;
      }
    }
  },
  watch: {
    account: function account(newNum, oldNum) {
      this.computerFreight();
      this.handleCalc(newNum, oldNum);
    },
    payment: function payment(e) {
      if (e == 0) {
        this.computerFreight();
      } else {
        this.delivermoney = 0;
      }
    }
  },
  components: {
    RadioSwitch: src_components_RadioSwitch,
    CAvatar: src_components_CAvatar
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/inventory/delivery.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var inventory_delivery = ({
  data: function data() {
    return {
      disabled: false, // 是否禁用提交操作
      showExchange: false, // 是否可以兑换
      selectAddress: "",
      account: 0, // 选择的数量
      switchs: ["在线支付", "运费到付"],
      payment: 0, // 支付方式
      exchangeNum: 0,
      extractIncrement: 30, // 数字步进器每一步增减多少
      extractMaxQuantity: 840, // 最大限制数量
      delivermoney: 0, // 实际支付快递费
      freight: 0, // 本应支付运费，只在会员生日优惠时显示
      showBirthday: false, // 是否显示生日优惠
      lastQuantity: 0 // 剩余抢提数量
    };
  },

  computed: {
    userInfo: function userInfo() {
      return auth_getUserInfo();
    },
    stock: function stock() {
      return this.$route.query.stock;
    },
    product: function product() {
      var product = this.$route.query.product;
      if (product) {
        return JSON.parse(product);
      } else {
        return "";
      }
    },
    loveIcon: function loveIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("JJUA");
      } else {
        return __webpack_require__("mh0x");
      }
    },
    minusIcon: function minusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("5JD3");
      } else {
        return __webpack_require__("1knL");
      }
    },
    plusIcon: function plusIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("WRRU");
      } else {
        return __webpack_require__("VRHR");
      }
    },
    pickupIcon: function pickupIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("6AT+");
      } else {
        return __webpack_require__("nNV2");
      }
    },
    remindIcon: function remindIcon() {
      if (this.$root.themeType == "yellow") {
        return __webpack_require__("R3hu");
      } else {
        return __webpack_require__("w5Ii");
      }
    },
    isTime: function isTime() {
      var now = new Date().getTime();
      var endTime = new Date("2020/11/21 00:00:00").getTime();
      if (now <= endTime) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (sysUtils.isWeiXin()) {
      var url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      wxService.getConfig(encodeURIComponent(url)).then(function (res) {
        if (res) {
          _this.$wechat.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
          });
        }
      }).catch(function (err) {
        _this.$vux.toast.text(err.msg);
      });
    }

    if (this.product) {
      this.extractIncrement = Number(this.product.extractIncrement);
      this.extractMaxQuantity = Number(this.product.extractMaxQuantity);
      // 控制哪些产品详情显示兑换说明
      if (this.product.key == "8153978189986300" || this.product.key == "8156213789948654" || this.product.key == "8158735277245403" || this.product.key == "8160223245934659" || this.product.key == "8160367516337895" || this.product.key == "1383959923502743554" || this.product.key == "1383959923502743555" || this.product.key == "8156213789948655" || this.product.key == "8153724996370403" || this.product.key == "8156213789948656" || this.product.key == "1647779951578025985") {
        this.showExchange = true;
        if (this.account > 0) {
          this.handleCalc(this.account);
        }
      } else {
        this.showExchange = false;
      }

      // 当商品是小蓝时，查询剩余抢提数量
      if (this.product.key == "1383959923502743554") {
        this.getLastCount(this.product.key);
      }
    }

    var selectAddress = sessionStorage.getItem("TEMP_SELECT_ADDRESS");
    if (selectAddress) {
      selectAddress = JSON.parse(selectAddress);
      this.selectAddress = selectAddress;
    }

    // 判断是否是用户生日
    try {
      var isBirthday = this.userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
      if (isBirthday == 1) {
        this.showBirthday = true;
      } else {
        this.showBirthday = false;
      }
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    /**
     * 当当前产品是小蓝是，查询当前剩余可抢提数量
     */
    getLastCount: function getLastCount(key) {
      var _this2 = this;

      orderService.getLastCount(key).then(function (res) {
        var data = res.data;
        _this2.lastQuantity = data.quantity; // 剩余可抢提数量
        _this2.extractMaxQuantity = data.quantity; // 用户最大可提货数量为剩余可抢提数量
      });
    },

    /**
     * 进入地址列表选择地址
     */
    toSelectAddress: function toSelectAddress() {
      this.$router.push({
        path: "/addressList",
        query: {
          scene: "select"
        }
      });
    },

    /**
     * 计算当前运费
     */
    computerFreight: function computerFreight() {
      var _this3 = this;

      if (this.selectAddress.id && this.product.key) {
        if (this.account <= 0 || this.account == "") {
          this.$vux.toast.text("请选择数量");
          this.delivermoney = 0;
        } else {
          orderService.getFreight(this.account, this.selectAddress.id, this.product.key).then(function (res) {
            // 如果当前是在线支付
            if (_this3.payment == 0) {
              _this3.delivermoney = res.data.paymentAmount; // 实际支付运费
              _this3.freight = res.data.freight; // 计算所得本应支付运费
            }
          }).catch(function (err) {
            _this3.$vux.toast.text(err.msg);
          });
        }
      }
    },

    /**
     * 商品兑换比例计算
     */
    handleCalc: function handleCalc(newNum, oldNum) {
      var _this4 = this;

      if (newNum == "") newNum = 0;
      // 如果当前中选的是面膜或者裸藻，根据相应的比例计算可兑换的双蛋白数量
      var exchangeNum = 0;
      // if (this.product.key == "8153978189986300") {
      //   // exchangeNum = newNum * 0.375;
      //   exchangeNum = newNum * 0.1875;
      // } else if (this.product.key == "8156213789948654") {
      //   exchangeNum = newNum * 0.9;
      // } else if (this.product.key == "8158735277245403") {
      //   exchangeNum = parseInt(newNum * 1.1667);
      // }
      var postData = {
        sourceProductId: this.product.key,
        sourceProductQuantity: newNum,
        targetProductId: PRODUCTID
      };
      orderService.calcExchange(postData).then(function (res) {
        exchangeNum = res.data.targetProductQuantity;

        // 如果兑换需求量大于当前用户的库存量，提示用户补货
        if (exchangeNum > _this4.stock) {
          var self = _this4;
          setTimeout(function () {
            self.account = oldNum ? oldNum : 0;
          }, 500);
          _this4.$vux.alert.show({
            title: "温馨提示",
            content: "亲爱哒，您当前的双蛋白库存不足，请及时补货哦~"
          });
        } else {
          _this4.exchangeNum = exchangeNum;
        }
      }).catch(function (err) {
        _this4.$vux.toast.text(err.msg);
      });
    },

    /**
     * 点击提交操作，执行创建提货订单操作
     */
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      var self = this;
      if (!this.selectAddress) {
        this.$vux.toast.text("请选择地址");
      } else if (this.account <= 0) {
        this.$vux.toast.text("请选择数量");
      } else {
        var productList = [{
          productId: PRODUCTID,
          num: this.account,
          productSpecId: this.product.key
        }];
        if (!this.disabled) {
          this.disabled = true;
          var postData = {
            productId: PRODUCTID,
            productList: productList,
            freightType: this.payment,
            addrId: this.selectAddress.id
          };
          orderService.extract(postData).then(function (res) {
            // 如果当前选择在线支付，并且支付状态为0时（0表示未支付，1表示已支付），调用微信支付
            // 当用户生日时，支付状态为1，因为免运费，所以不需要调用微信支付操作
            if (_this5.payment == 0 && res.data.payStatus == "0") {
              return orderService.extractWxPay(res.data.id);
            } else {
              sessionStorage.removeItem("TEMP_SELECT_ADDRESS");
              setTimeout(function () {
                _this5.$vux.toast.text("操作成功");
              }, 100);
              _this5.$router.go(-1);
              return;
            }
          }).then(function (res) {
            _this5.disabled = false;
            var wxPayData = {
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              paySign: res.data.paySign,
              signType: res.data.signType,
              timestamp: res.data.timeStamp
            };
            wxJsSdk.chooseWXPay(wxPayData).then(function (result) {
              // 如果当前取消了支付
              if (result.errMsg == "chooseWXPay:cancel") {
                // res.payFlowId
                _this5.$vux.confirm.show({
                  // 组件除show外的属性
                  title: "提示",
                  content: "扣减库存成功 <svg class='icon' aria-hidden='true'><use xlink:href='#iconsuccess-green' /></svg><br />提货订单生成成功 <svg class='icon' aria-hidden='true'><use xlink:href='#iconsuccess-green' /></svg><br />运费支付失败 <svg class='icon' aria-hidden='true'><use xlink:href='#icondeleteimg' /></svg>",
                  confirmText: "去支付运费",
                  cancelText: "继续提货",
                  onCancel: function onCancel() {},
                  onConfirm: function onConfirm() {
                    // 跳转到提货记录页
                    self.$router.push({
                      path: "/deliveryList"
                    });
                  }
                });
              } else {
                sessionStorage.removeItem("TEMP_SELECT_ADDRESS");
                _this5.$vux.toast.text("操作成功");
                _this5.$router.go(-1);
              }
            }).catch(function (err) {
              console.log("支付失败:-------------");
              console.log(err);
            });
          }).catch(function (err) {
            _this5.disabled = false;
            _this5.$vux.toast.text(err.msg);
          });
        }
      }
    },
    clickMinus: function clickMinus() {
      this.account -= this.extractIncrement;
      if (this.account <= 0) {
        this.account = 0;
      }
    },
    clickPlus: function clickPlus() {
      this.account += this.extractIncrement;
      if (this.account >= this.extractMaxQuantity) {
        this.account = this.extractMaxQuantity;
      }
      if (this.extractMaxQuantity <= 0) {
        this.$vux.toast.text("可提货数量不足");
      }
    },
    handleBlur: function handleBlur() {
      if (this.account <= 0) {
        this.account = 0;
      } else if (this.account >= this.extractMaxQuantity) {
        this.account = this.extractMaxQuantity;
      }
    },
    clickBack: function clickBack() {
      this.$router.go(-1);
    }
  },
  filters: {
    filtValueName: function filtValueName(e) {
      if (e == "裸藻圆苞车前子壳固体饮料") {
        return "裸藻";
      } else if (e == "绿孔雀限量版椰子味裸藻圆苞车前子固体饮料") {
        return "椰子味裸藻";
      } else if (e == "家庭装-胶原蛋白弹性蛋白固体饮料") {
        return "家庭装";
      } else if (e == "益生菌 · 即食型乳酸菌") {
        return "益生菌";
      } else if (e == "限量版小蓝透明质酸钠胶原蛋白弹性蛋白固体饮料") {
        return "小蓝";
      } else if (e == "胶原蛋白弹性蛋白玻尿酸红石榴味固体饮料") {
        return "红石榴";
      } else if (e == "荔枝玫瑰味胶原蛋白弹性蛋白固体饮料") {
        return "荔枝玫瑰味胶原蛋白弹性蛋白固体饮料";
      } else {
        return e;
      }
    }
  },
  watch: {
    account: function account(newNum, oldNum) {
      this.computerFreight();
      this.handleCalc(newNum, oldNum);
    },
    payment: function payment(e) {
      if (e == 0) {
        this.computerFreight();
      } else {
        this.delivermoney = 0;
      }
    }
  },
  components: {
    RadioSwitch: src_components_RadioSwitch,
    CAvatar: src_components_CAvatar
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4e18ff2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/delivery.vue
var delivery_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"flex-between"},[_c('div',[_c('img',{attrs:{"src":_vm.loveIcon,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("我的库存："+_vm._s(_vm.stock)+"盒")])]),_vm._v(" "),_c('c-avatar',{attrs:{"size":"mini"}})],1),_vm._v(" "),_c('div',{staticClass:"address flex-align-center",on:{"click":_vm.toSelectAddress}},[(_vm.selectAddress)?_c('div',{staticClass:"addr-info"},[_c('p',{staticClass:"name-mobile"},[_c('span',[_vm._v(_vm._s(_vm.selectAddress.receiverName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectAddress.mobile))])]),_vm._v(" "),_c('p',{staticClass:"addr flex-align-center"},[_c('img',{attrs:{"src":__webpack_require__("B5zY"),"alt":""}}),_vm._v("\n          "+_vm._s(_vm.selectAddress.provinceName)+" "+_vm._s(_vm.selectAddress.cityName)+" "+_vm._s(_vm.selectAddress.areaName)+" "+_vm._s(_vm.selectAddress.addr)+"\n        ")])]):_c('span',[_vm._v("请选择收货地址")]),_vm._v(" "),_c('img',{staticClass:"arrow",attrs:{"src":__webpack_require__("0kbW"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"product"},[_c('div',{staticClass:"flex-between",style:({marginBottom: _vm.product.key=='1383959923502743554'?'0.3rem':'0.4rem'})},[_c('img',{attrs:{"src":_vm.product.productPic,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('h5',[_vm._v(_vm._s(_vm.product.value))]),_vm._v(" "),(_vm.product.key == '8156213789948654')?_c('p',{staticClass:"guige"},[_vm._v("规格："+_vm._s(_vm.product.productSpec))]):(_vm.product.key == '8160223245934659')?_c('p',{staticClass:"guige"},[_vm._v("规格："+_vm._s(_vm.product.productSpec))]):(_vm.product.key == '8160367516337895')?_c('p',{staticClass:"guige"},[_vm._v("规格："+_vm._s(_vm.product.productSpec))]):_c('p',{staticClass:"guige"},[_vm._v("规格："+_vm._s(_vm.product.productSpec))]),_vm._v(" "),_c('div',{staticClass:"flex-align-center"},[_c('span',[_vm._v("数量：")]),_vm._v(" "),_c('div',{staticClass:"number-count flex-align-center"},[_c('button',{attrs:{"disabled":_vm.account<=0},on:{"click":_vm.clickMinus}},[_c('img',{attrs:{"src":_vm.minusIcon,"alt":""}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.account),expression:"account",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"0"},domProps:{"value":(_vm.account)},on:{"blur":[_vm.handleBlur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.account=_vm._n($event.target.value)}}}),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.account>=_vm.extractMaxQuantity},on:{"click":_vm.clickPlus}},[_c('img',{attrs:{"src":_vm.plusIcon,"alt":""}})])])])])]),_vm._v(" "),(_vm.product.key == '8153724996370400' && _vm.isTime)?_c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":__webpack_require__("1cBH"),"alt":""}}),_vm._v(" 现在提货将在11月21日后发货新包装\n      ")]):_vm._e(),_vm._v(" "),(_vm.product.key == '1383959923502743554')?_c('div',{staticClass:"tip-text flex-justify-center"},[_c('img',{attrs:{"src":_vm.remindIcon}}),_vm._v("\n        尊敬的"+_vm._s(_vm.userInfo.starLevelName)+"会员，你剩余可抢提"+_vm._s(_vm.lastQuantity)+"盒小蓝\n      ")]):_vm._e(),_vm._v(" "),(_vm.showExchange)?_c('div',{staticClass:"tip"},[_vm._v("您即将用 "+_vm._s(_vm.exchangeNum)+" 盒双蛋白库存兑换提货 "+_vm._s(_vm.account)+" 盒"+_vm._s(_vm._f("filtValueName")(_vm.product.value)))]):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cell vux-1px-b",class:_vm.showBirthday?'':'flex-between'},[_c('div',{staticClass:"flex-between"},[_c('span',[_vm._v("快递费（代收）")]),_vm._v(" "),_c('span',{staticClass:"color-text"},[_vm._v("￥"+_vm._s(_vm.delivermoney))])]),_vm._v(" "),(_vm.showBirthday)?_c('div',{staticClass:"birthday"},[_c('img',{attrs:{"src":__webpack_require__("3N8s")}}),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(_vm.freight))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell flex-between vux-1px-b"},[_c('span',[_vm._v("支付方式")]),_vm._v(" "),_c('radio-switch',{attrs:{"list":_vm.switchs,"value":_vm.payment},on:{"update:value":function($event){_vm.payment=$event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex-bottom"},[_c('span',[_vm._v("\n      应付\n      "),_c('span',[_vm._v("￥"+_vm._s(_vm.delivermoney))])]),_vm._v(" "),_c('a',{staticClass:"pick",attrs:{"href":"javascript:;","disabled":_vm.disabled},on:{"click":_vm.handleSubmit}},[_c('img',{attrs:{"src":_vm.pickupIcon}}),_vm._v("提货到家\n    ")]),_vm._v(" "),_c('a',{staticClass:"back",attrs:{"href":"javascript:;"},on:{"click":_vm.clickBack}},[_vm._v("取消并返回")])])])}
var delivery_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell flex-between vux-1px-b"},[_c('span',[_vm._v("配送")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("德邦")])])}]
var delivery_esExports = { render: delivery_render, staticRenderFns: delivery_staticRenderFns }
/* harmony default export */ var views_inventory_delivery = (delivery_esExports);
// CONCATENATED MODULE: ./src/views/inventory/delivery.vue
function delivery_injectStyle (ssrContext) {
  __webpack_require__("OzvI")
  __webpack_require__("Ggcn")
}
var delivery_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var delivery___vue_template_functional__ = false
/* styles */
var delivery___vue_styles__ = delivery_injectStyle
/* scopeId */
var delivery___vue_scopeId__ = "data-v-c4e18ff2"
/* moduleIdentifier (server only) */
var delivery___vue_module_identifier__ = null
var delivery_Component = delivery_normalizeComponent(
  inventory_delivery,
  views_inventory_delivery,
  delivery___vue_template_functional__,
  delivery___vue_styles__,
  delivery___vue_scopeId__,
  delivery___vue_module_identifier__
)

/* harmony default export */ var src_views_inventory_delivery = (delivery_Component.exports);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/api/addressService.js



/**
 * 地址相关接口
 * @author 小圣贤君
 * @time 2020/03/16
 */
/* harmony default export */ var addressService = ({
  /**
   * 添加收货地址
   */
  create: function create(postData) {
    var data = lib_default.a.stringify(postData);
    return api_request.post("/user/addr/addMyAddr?" + data);
  },

  /**
   * 删除地址
   * @param addrId 地址id
   */
  delete: function _delete(addrId) {
    return api_request.post("/user/addr/delMyAddr?addrId=" + addrId);
  },

  /**
   * 修改收货地址
   */
  update: function update(postData) {
    var data = lib_default.a.stringify(postData);
    return api_request.post("/user/addr/updateMyAddr?" + data);
  },

  /**
   * 查询地址列表
   */
  queryList: function queryList() {
    return api_request.post("user/addr/myAddrList");
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/address/addressList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var addressList = ({
  data: function data() {
    return {
      list: []
    };
  },

  computed: {
    scene: function scene() {
      return this.$route.query.scene;
    }
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    /**
     * 查询地址列表
     */
    query: function query() {
      var _this2 = this;

      addressService.queryList().then(function (res) {
        _this2.list = res.data;
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 点击新增、编辑地址
     * @param type create edit
     * @param value 地址信息
     */
    clickEdit: function clickEdit(type, value) {
      // 进入到地址编辑页
      this.$router.push({
        path: "/editAddress",
        query: {
          type: type,
          value: stringify_default()(value)
        }
      });
    },

    /**
     * 删除地址
     */
    clickDelete: function clickDelete(e) {
      var _this = this;
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: "提示",
        content: "该操作会删除该条地址信息，<br/>是否确认继续？",
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          addressService.delete(e.id).then(function (res) {
            console.log(res);
            _this.query();
            _this.$vux.toast.text("已删除");
          }).catch(function (err) {
            _this.$vux.toast.text(err.msg);
          });
        }
      });
    },

    /**
     * 点击选择，将当前地址数据缓存，用于上一页提货操作
     */
    clickSelect: function clickSelect(e) {
      sessionStorage.setItem("TEMP_SELECT_ADDRESS", stringify_default()(e));
      this.$router.go(-1);
    }
  },
  components: {
    NoData: src_components_NoData
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/address/addressList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var address_addressList = ({
  data: function data() {
    return {
      list: []
    };
  },

  computed: {
    scene: function scene() {
      return this.$route.query.scene;
    }
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    /**
     * 查询地址列表
     */
    query: function query() {
      var _this2 = this;

      addressService.queryList().then(function (res) {
        _this2.list = res.data;
      }).catch(function (err) {
        _this2.$vux.toast.text(err.msg);
      });
    },

    /**
     * 点击新增、编辑地址
     * @param type create edit
     * @param value 地址信息
     */
    clickEdit: function clickEdit(type, value) {
      // 进入到地址编辑页
      this.$router.push({
        path: "/editAddress",
        query: {
          type: type,
          value: stringify_default()(value)
        }
      });
    },

    /**
     * 删除地址
     */
    clickDelete: function clickDelete(e) {
      var _this = this;
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: "提示",
        content: "该操作会删除该条地址信息，<br/>是否确认继续？",
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          addressService.delete(e.id).then(function (res) {
            console.log(res);
            _this.query();
            _this.$vux.toast.text("已删除");
          }).catch(function (err) {
            _this.$vux.toast.text(err.msg);
          });
        }
      });
    },

    /**
     * 点击选择，将当前地址数据缓存，用于上一页提货操作
     */
    clickSelect: function clickSelect(e) {
      sessionStorage.setItem("TEMP_SELECT_ADDRESS", stringify_default()(e));
      this.$router.go(-1);
    }
  },
  components: {
    NoData: src_components_NoData
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb14b83","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/address/addressList.vue
var addressList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-list"},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"list-item"},[_c('p',{staticClass:"name-mobile"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.receiverName))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.mobile))])]),_vm._v(" "),_c('p',{staticClass:"address"},[_vm._v(_vm._s(item.provinceName)+" "+_vm._s(item.cityName)+" "+_vm._s(item.areaName)+" "+_vm._s(item.addr))]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[(_vm.scene == 'select')?_c('button',{staticClass:"select",on:{"click":function($event){return _vm.clickSelect(item)}}},[_vm._v("选择")]):_vm._e(),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.clickEdit('edit',item)}}},[_vm._v("编辑")]),_vm._v(" "),(_vm.scene != 'select')?_c('button',{on:{"click":function($event){return _vm.clickDelete(item)}}},[_vm._v("删除")]):_vm._e()])])}),_vm._v(" "),(_vm.list.length == 0)?_c('no-data',[_vm._v("您暂时没有收货地址记录哦~")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn flex-justify-center",on:{"click":function($event){return _vm.clickEdit('create')}}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-plus-empty",attrs:{"type":"ios-plus-empty","size":"28","xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M384 265H264v119h-17V265H128v-17h119V128h17v120h120v17z"}})]),_vm._v("添加收货地址\n  ")])],2)}
var addressList_staticRenderFns = []
var addressList_esExports = { render: addressList_render, staticRenderFns: addressList_staticRenderFns }
/* harmony default export */ var views_address_addressList = (addressList_esExports);
// CONCATENATED MODULE: ./src/views/address/addressList.vue
function addressList_injectStyle (ssrContext) {
  __webpack_require__("XwQs")
  __webpack_require__("0Eyt")
}
var addressList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addressList___vue_template_functional__ = false
/* styles */
var addressList___vue_styles__ = addressList_injectStyle
/* scopeId */
var addressList___vue_scopeId__ = "data-v-5eb14b83"
/* moduleIdentifier (server only) */
var addressList___vue_module_identifier__ = null
var addressList_Component = addressList_normalizeComponent(
  address_addressList,
  views_address_addressList,
  addressList___vue_template_functional__,
  addressList___vue_styles__,
  addressList___vue_scopeId__,
  addressList___vue_module_identifier__
)

/* harmony default export */ var src_views_address_addressList = (addressList_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/name2value.js
var name2value = __webpack_require__("dH7R");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2025380c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("/45s")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("VASZ")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("5obQ")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var libs_dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && libs_dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && libs_dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && libs_dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && libs_dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("Oags")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5bfd958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("w/mq")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a333ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("t8qE")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56bdfb3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-address/index.vue
var x_address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-picker',{attrs:{"fixed-columns":_vm.hideDistrict ? 2 : 0,"columns":3,"data":_vm.list,"title":_vm.title,"show-name":"","inline-desc":_vm.inlineDesc,"placeholder":_vm.placeholder,"value-text-align":_vm.valueTextAlign,"confirm-text":_vm.confirmText,"cancel-text":_vm.cancelText,"display-format":_vm.displayFormat,"popup-style":_vm.popupStyle,"popup-title":_vm.popupTitle,"show":_vm.showValue,"disabled":_vm.disabled},on:{"update:show":function($event){_vm.showValue=$event},"on-shadow-change":_vm.onShadowChange,"on-hide":_vm.emitHide,"on-show":function($event){return _vm.$emit('on-show')}},scopedSlots:_vm._u([{key:"title",fn:function(props){return [_vm._t("title",[(props.labelTitle)?_c('label',{class:[props.labelClass,_vm.labelClass],style:(props.labelStyle),domProps:{"innerHTML":_vm._s(props.labelTitle)}}):_vm._e()],{"labelClass":props.labelClass,"labelStyle":props.labelStyles,"labelTitle":props.title})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var x_address_staticRenderFns = []
var x_address_esExports = { render: x_address_render, staticRenderFns: x_address_staticRenderFns }
/* harmony default export */ var src_components_x_address = (x_address_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-address/index.vue
var x_address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_address___vue_template_functional__ = false
/* styles */
var x_address___vue_styles__ = null
/* scopeId */
var x_address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_address___vue_module_identifier__ = null
var x_address_Component = x_address_normalizeComponent(
  components_x_address,
  src_components_x_address,
  x_address___vue_template_functional__,
  x_address___vue_styles__,
  x_address___vue_scopeId__,
  x_address___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_address = (x_address_Component.exports);

// EXTERNAL MODULE: ./src/assets/china_address.json
var china_address = __webpack_require__("60wv");
var china_address_default = /*#__PURE__*/__webpack_require__.n(china_address);

// CONCATENATED MODULE: ./src/utils/address-parse.js
var defaultData = [];

var mCity = {};

var mArea = {};

/**
 * 处理原始地址数据转换成专用数据
 * @param list  原始数据
 * @param init  是否初始化 如传空 已转换过不会再次转换
 * @returns {boolean}
 */
function parseArea(list, init) {
  if (!init && defaultData.length) {
    return true;
  }
  defaultData = list;
  defaultData.forEach(function (province) {
    if (province.city) {
      province.city.forEach(function (city) {
        if (city.name !== '其他') {
          if (!mCity[city.name]) {
            mCity[city.name] = [];
          }
          mCity[city.name].push({
            p: province.name,
            c: city.name,
            a: city.area || []
          });
        }
        if (city.area) {
          city.area.forEach(function (area) {
            if (area !== '其他') {
              if (!mArea[area]) {
                mArea[area] = [];
              }
              mArea[area].push({
                p: province.name,
                c: city.name
              });
            }
          });
        }
      });
    }
  });
}
/**
 * 解析邮编
 * @param
 * @returns <array>
 */
function zipCodeFormat() {
  var list = [];
  zipCode.forEach(function (el) {
    if (el.child) {
      el.child.forEach(function (event) {
        if (event.child) {
          event.child.forEach(function (element) {
            list.push(element.zipcode);
          });
        }
      });
    }
  });
  return list;
}

//专用数据处理

var zipCodeList = zipCodeFormat(); //邮编
parseArea(areaList); //地址

/**
 * 解析
 * @param address 任意地址字符串
 * @returns {{name: string, mobile: string, detail: string, zip_code: string, phone: string}}
 */
function parse(address) {
  address = address || '';
  var parse = {
    name: '',
    mobile: '',
    detail: '',
    zip_code: '',
    phone: ''
  };

  //去除空格...
  /*   address = address.replace(/\r\n/g, ' ').replace(/\n/g, ' ').replace(/\t/g, ' ');
    address = address.replace(/\s+/g, ""); */
  //自定义去除关键字，可自行添加
  var search = ['地址', '收货地址', '收货人', '收件人', '收货', '邮编', '电话', '：', ':', '；', ';', '，', ',', '。', ' '];
  search.forEach(function (str) {
    address = address.replace(new RegExp(str, 'g'), ' ');
  });
  //多个空格replace为一个
  address = address.replace(/ {2,}/g, ' ');
  //整理电话格式
  address = address.replace(/(\d{3})-(\d{4})-(\d{4})/g, '$1$2$3');

  address = address.replace(/(\d{3}) (\d{4}) (\d{4})/g, '$1$2$3');

  var mobileReg = /(86-[1][0-9]{10})|(86[1][0-9]{10})|([1][0-9]{10})/g;
  var mobile = mobileReg.exec(address);
  if (mobile) {
    parse.mobile = mobile[0];
    address = address.replace(mobile[0], ' ');
  }
  //电话
  var phoneReg = /(([0-9]{3,4}-)[0-9]{7,8})|([0-9]{12})|([0-9]{11})|([0-9]{10})|([0-9]{9})|([0-9]{8})|([0-9]{7})/g;
  var phone = phoneReg.exec(address);
  if (phone) {
    parse.phone = phone[0];
    address = address.replace(phone[0], ' ');
  }

  //邮编(加入门牌号；考虑到重复邮编问题；去除之前简单的六位数字校验)

  for (var index = 0; index < zipCodeList.length; index++) {
    if (address.indexOf(zipCodeList[index]) != -1) {
      var num = address.indexOf(zipCodeList[index]);
      var code = address.slice(num, num + 6);
      parse.zip_code = code;
      address = address.replace(code, '');
    }
  }

  /*   废弃
    const zipReg = /([0-9]{6})/g;
    const zip = zipReg.exec(address);
    if (zip) {
      parse.zip_code = zip[0];
      address = address.replace(zip[0], '')
    } 
  */

  address = address.replace(/ {2,}/, ' ');

  var detail = detail_parse_forward(address.trim());
  var ignoreArea = detail.province;
  if (!detail.city) {
    detail = detail_parse(address.trim());
    if (detail.area && !detail.city) {
      detail = detail_parse(address.trim(), {
        ignoreArea: true
      });
      console.log('smart_parse->ignoreArea（忽略区）');
    } else {}
    // console.log('smart_parse');

    //这个待完善
    var list = address.replace(detail.province, '').replace(detail.city, '').replace(detail.area, '').split(' ').filter(function (str) {
      return str;
    });
    //详细住址划分关键字
    //注意：只需要填写关键字最后一位即可：比如单元填写元即可！
    var address_detail_list = ['室', '楼', '元', '号', '幢', '门', '户'];
    if (list.length > 1) {
      list.forEach(function (str) {
        if (!parse.name || str && str.length < parse.name.length) {
          parse.name = str.trim();
        }
      });
      if (parse.name) {
        detail.addr = detail.addr.replace(parse.name, '').trim();
      }
    } else {
      //若名字写在详细地址后面，根据address_detail_list进行分割；
      var key = [];
      address_detail_list.forEach(function (el) {
        key.push(detail.addr.indexOf(el));
      });
      var max = key.sort(function (a, b) {
        return b - a;
      })[0];
      if (detail.name) {
        parse.name = detail.name;
      }
      if (max != -1) {
        var addrBuild = detail.addr.slice(0, max + 1);
        var addrNum = detail.addr.replace(addrBuild, '').replace(/[^0-9]+/g, '');
        var userName = detail.addr.replace(addrBuild + addrNum, '');
        detail.addr = addrBuild + addrNum;
        parse.name = userName;
      }
    }
  } else {
    if (detail.name) {
      parse.name = detail.name;
    } else {
      var _list = detail.addr.split(' ').filter(function (str) {
        return str;
      });
      if (_list.length > 1) {
        parse.name = _list[_list.length - 1];
      }
      if (parse.name) {
        detail.addr = detail.addr.replace(parse.name, '').trim();
      }
    }
  }
  parse.province = detail.province == '' ? ignoreArea : detail.province;
  parse.city = detail.city;
  parse.area = detail.area;
  parse.addr = detail.addr;
  parse.result = detail.result;
  //添加省以及市（2019.6.21）输出字段后填入省市等等
  foramtProvince.forEach(function (el) {
    if (el.name.indexOf(parse.province) == 0) {
      parse.province = el.name;
    }
  });
  zipCode.forEach(function (provice) {
    if (parse.province.indexOf(provice.name) == 0) {
      provice.child.forEach(function (city) {
        if (city.name.indexOf(parse.city) == 0) {
          parse.city = city.name;
        }
      });
    }
  });

  return parse;
}

/**
 * 正向解析模式
 * 从前到后按 province city addr 逐级筛选
 * 有city的值即可说明解析成功
 * 此模式对地址顺序有要求
 * @param address
 * @returns {{province: string, city: string, area: string, addr: string}}
 */
function detail_parse_forward(address) {
  var parse = {
    province: '',
    city: '',
    area: '',
    addr: '',
    name: ''
  };

  var provinceKey = ['特别行政区', '古自治区', '维吾尔自治区', '壮族自治区', '回族自治区', '自治区', '省省直辖', '省', '市'];
  var cityKey = ['布依族苗族自治州', '苗族侗族自治州', '自治州', '州', '市', '县'];

  for (var i in defaultData) {
    var province = defaultData[i];
    var index = address.indexOf(province.name);
    if (index > -1) {
      if (index > 0) {
        //省份不是在第一位，在省份之前的字段识别为名称
        parse.name = address.substr(0, index).trim();
      }
      parse.province = province.name;
      address = address.substr(index + province.name.length);
      for (var k in provinceKey) {
        if (address.indexOf(provinceKey[k]) === 0) {
          address = address.substr(provinceKey[k].length);
        }
      }
      for (var j in province.city) {
        var city = province.city[j];
        index = address.indexOf(city.name);
        if (index > -1 && index < 3) {
          parse.city = city.name;
          address = address.substr(index + parse.city.length);
          for (var _k in cityKey) {
            if (address.indexOf(cityKey[_k]) === 0) {
              address = address.substr(cityKey[_k].length);
            }
          }
          if (city.area) {
            for (var _k2 in city.area) {
              var area = city.area[_k2];
              index = address.indexOf(area);
              if (index > -1 && index < 3) {
                parse.area = area;
                address = address.substr(index + parse.area.length);
                break;
              }
            }
          }
          break;
        }
      }
      parse.addr = address.trim();
      break;
    }
  }
  return parse;
}

/**
 * 逆向解析 从后【县，区，旗】往前解析
 * 有地区就能大概返回地址了
 * @param address
 * @param ignoreArea 是否忽视区 因为地址中含有区容易导致匹配错误 例：山东省蓬莱市黄海花园东区西门宝威学堂 曲荣声收15753572456
 * @returns {{province: string, city: string, area: string, name: string, _area: string, addr: string}}
 */
function detail_parse(address) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$ignoreArea = _ref.ignoreArea,
      ignoreArea = _ref$ignoreArea === undefined ? false : _ref$ignoreArea;

  var parse = {
    province: '',
    city: '',
    area: '',
    name: '',
    _area: '',
    addr: ''
  };
  var areaIndex = -1,
      cityIndex = -1;

  address = address.replace('  ', ' ');

  if (!ignoreArea && address.indexOf('县') > -1 || !ignoreArea && address.indexOf('区') > -1 || !ignoreArea && address.indexOf('旗') > -1) {
    if (address.indexOf('旗') > -1) {
      areaIndex = address.indexOf('旗');
      parse.area = address.substr(areaIndex - 1, 2);
    }
    if (address.indexOf('区') > -1) {
      areaIndex = address.indexOf('区');
      if (address.lastIndexOf('市', areaIndex) > -1) {
        cityIndex = address.lastIndexOf('市', areaIndex);
        parse.area = address.substr(cityIndex + 1, areaIndex - cityIndex);
      } else {
        parse.area = address.substr(areaIndex - 2, 3);
      }
    }
    if (address.indexOf('县') > -1) {
      areaIndex = address.lastIndexOf('县');
      if (address.lastIndexOf('市', areaIndex) > -1) {
        cityIndex = address.lastIndexOf('市', areaIndex);
        parse.area = address.substr(cityIndex + 1, areaIndex - cityIndex);
      } else {
        parse.area = address.substr(areaIndex - 2, 3);
      }
    }
    parse.addr = address.substr(areaIndex + 1);
  } else {
    if (address.indexOf('市') > -1) {
      areaIndex = address.indexOf('市');
      console.log(address.split(" "));
      if (address.split(" ")[0].indexOf("市") > -1) {
        var areindex = address.split(" ")[0].indexOf("市");
        parse.area = address.split(" ")[0].substr(0, areindex + 1);
        parse.addr = address.split(" ")[0].substr(areindex + 1);
        parse.name = address.split(" ")[1];
      } else {
        var _areindex = address.split(" ")[1].indexOf("市");
        parse.area = address.split(" ")[1].substr(0, _areindex + 1);
        parse.addr = address.split(" ")[1].substr(_areindex + 1);
        parse.name = address.split(" ")[0];
      }
    } else {
      parse.addr = address;
    }
  }

  if (address.indexOf('市') > -1 || address.indexOf('盟') > -1 || address.indexOf('州') > -1) {
    if (address.indexOf('市') > -1) {
      parse._area = address.substr(address.indexOf('市') - 2, 2);
    }
    if (address.indexOf('盟') > -1 && !mCity[parse._area]) {
      parse._area = address.substr(address.indexOf('盟') - 2, 2);
    }
    if (address.indexOf('州') > -1 && !mCity[parse._area]) {
      parse._area = address.substr(address.indexOf('州') - 2, 2);
    }
  }

  parse.area = parse.area.trim();
  if (parse.area && mArea[parse.area]) {
    if (mArea[parse.area].length === 1) {
      parse.province = mArea[parse.area][0].p;
      parse.city = mArea[parse.area][0].c;
    } else {
      parse._area = parse._area.trim();
      var addr = address.substr(0, areaIndex);
      var d = mArea[parse.area].find(function (item) {
        return item.p.indexOf(addr) > -1 || item.c === parse._area;
      });
      if (d) {
        parse.province = d.p;
        parse.city = d.c;
      } else {
        parse.result = mArea[parse.area];
      }
    }
  } else {
    if (parse._area) {
      var city = mCity[parse._area];
      if (city) {
        parse.province = city[0].p;
        parse.city = city[0].c;
        parse.addr = address.substr(address.indexOf(parse.city) + parse.city.length + 1);
        parse.area = '';
        for (var i in city[0].a) {
          if (parse.addr.indexOf(city[0].a[i]) === 0) {
            parse.area = city[0].a[i];
            parse.addr = parse.addr.replace(city[0].a[i], '');
            break;
          }
        }
      }
    } else {
      parse.area = '';
    }
  }
  parse.addr = parse.addr.trim();
  return parse;
}

/* harmony default export */ var address_parse = ({
  parseArea: parseArea,
  parse: parse

  /*export {parseArea}
  
  export default parse;*/

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/address/editAddress.vue








/* harmony default export */ var editAddress = ({
  data: function data() {
    return {
      name: "", // 姓名
      mobile: "", // 手机号
      address: "", // 收货地址显示信息
      addressDetails: "", // 详细地址
      addressIds: [], // 地址选择器返回ids
      addressNames: [], // 地址选择器返回names
      addressData: china_address_default.a,
      showAddress: false, // 控制地址选择器显示隐藏
      isSmart: false, // 是否智能识别过地址，识别操作置为true，地址选择器操作后置为false
      smartAddress: "", // 只能识别地址信息
      focus: false // 控制识别区聚焦
    };
  },

  computed: {
    scene: function scene() {
      return this.$route.query.type;
    },
    infoData: function infoData() {
      var value = this.$route.query.value;
      if (value) {
        value = JSON.parse(value);
      }
      return value;
    }
  },
  mounted: function mounted() {

    if (this.infoData) {
      document.title = "编辑地址";
      this.name = this.infoData.receiverName;
      this.mobile = this.infoData.mobile;
      this.addressDetails = this.infoData.addr;
      this.addressNames = [];
      this.addressNames.push(this.infoData.provinceName);
      this.addressNames.push(this.infoData.cityName);
      this.addressNames.push(this.infoData.areaName);
      this.addressIds = [];
      this.addressIds.push(this.infoData.provinceId);
      this.addressIds.push(this.infoData.cityId);
      this.addressIds.push(this.infoData.areaId);
      this.handleAddressStr();
    }
  },

  methods: {
    /**
    * 点击textarea，取消placeholder显示，聚焦textarea
    */
    clickTextarea: function clickTextarea() {
      this.focus = true;
      this.$refs.textarea.focus();
    },
    handleBlur: function handleBlur() {
      sysUtils.scrollPageView();
    },
    textareaBlur: function textareaBlur() {
      if (!this.smartAddress) {
        this.focus = false;
      }
    },

    /**
    * 点击清空操作
    */
    handleClear: function handleClear() {
      this.smartAddress = "";
      this.focus = false;
    },

    /**
    * 自动识别解析地址
    * */
    handleSmart: function handleSmart() {
      if (this.smartAddress) {
        var parse_list = address_parse.parse(this.smartAddress);
        this.addressNames = [];
        var province = "";
        var city = "";
        var county = "";
        for (var i in parse_list) {
          if (parse_list[i]) {
            if (i == "name") {
              this.name = parse_list[i];
            } else if (i == "mobile") {
              this.mobile = parse_list[i];
            } else if (i == "addr") {
              this.addressDetails = parse_list[i];
            } else if (i == "province") {
              this.addressNames.push(parse_list[i]);
              province = parse_list[i];
            } else if (i == "city") {
              this.addressNames.push(parse_list[i]);
              city = parse_list[i];
            } else if (i == "area") {
              this.addressNames.push(parse_list[i]);
              county = parse_list[i];
            }
          }
        }
        var subIndex = province.indexOf("市");
        if (subIndex != -1) {
          province = province.slice(0, subIndex);
        }
        var tempProvinceId = "";
        var tempCityId = "";
        var tempCountyId = "";

        for (var _i = 0; _i < this.addressData.length; _i++) {
          var ele = this.addressData[_i];
          if (ele.name == province) {
            tempProvinceId = ele.value;
            break;
          }
        }

        for (var _i2 = 0; _i2 < this.addressData.length; _i2++) {
          var _ele = this.addressData[_i2];
          if (_ele.name == city) {
            tempCityId = _ele.value;
            break;
          }
        }

        for (var _i3 = 0; _i3 < this.addressData.length; _i3++) {
          var _ele2 = this.addressData[_i3];

          if (_ele2.name == county && _ele2.parent == tempCityId) {
            tempCountyId = _ele2.value;
            break;
          }
        }

        if (tempProvinceId && tempCityId && tempCountyId) {
          this.addressIds = [];
          this.addressIds.push(tempProvinceId);
          this.addressIds.push(tempCityId);
          this.addressIds.push(tempCountyId);
          this.isSmart = true;
          this.handleAddressStr();
        } else {
          this.$vux.toast.text("解析地址失败，请手动添加地址");
        }
      } else {
        this.$vux.toast.text("请添加地址信息后再进行识别操作");
      }
    },

    /**
    * 根据addressNames合集处理页面上省市区显示
    */
    handleAddressStr: function handleAddressStr() {
      var _this = this;

      this.address = "";
      this.addressNames.forEach(function (item) {
        _this.address += item + " ";
      });
    },
    handleAddressHide: function handleAddressHide(e) {
      if (e) {
        this.handleAddressStr();
        this.isSmart = false;
      }
    },

    /**
    * 地址选择器初始化以及数据改变时都会触发此方法，可获取省市区名称及id
    */
    handleAddressChange: function handleAddressChange(ids, names) {
      this.addressNames = names;
    },

    /**
    * 校验各项数据
    */
    checkFormInfo: function checkFormInfo() {
      if (this.name == "") {
        this.$vux.toast.text("收件人不能为空");
        return false;
      } else if (this.mobile == "") {
        this.$vux.toast.text("请检查收货人手机号");
        return false;
      } else if (this.address == "") {
        this.$vux.toast.text("请选择收货地址");
        return false;
      } else if (this.addressDetails == "") {
        this.$vux.toast.text("请填写收货人详细地址");
        return false;
      } else {
        return true;
      }
    },

    /**
    * 点击保存
    * 先校验各项数据是否已经填写
    * 再调用接口执行保存操作
    */
    clickSave: function clickSave() {
      var _this2 = this;

      if (this.checkFormInfo()) {
        var postData = {
          receiverName: this.name,
          mobile: this.mobile,
          provinceId: this.addressIds[0],
          cityId: this.addressIds[1],
          areaId: this.addressIds[2],
          addr: this.addressDetails,
          setDefault: 0 // 默认设置为非默认
        };
        if (this.scene == "create") {

          addressService.create(postData).then(function (res) {
            _this2.$vux.toast.text("创建成功");
            _this2.$router.go(-1);
          }).catch(function (err) {
            _this2.$vux.toast.text(err.msg);
          });
        } else {
          postData.addrId = this.infoData.id;
          addressService.update(postData).then(function (res) {
            _this2.$vux.toast.text("修改成功");
            _this2.$router.go(-1);
          }).catch(function (err) {
            _this2.$vux.toast.text(err.msg);
          });
        }
      }
    }
  },
  components: {
    XAddress: vux_src_components_x_address
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/address/editAddress.vue








/* harmony default export */ var address_editAddress = ({
  data: function data() {
    return {
      name: "", // 姓名
      mobile: "", // 手机号
      address: "", // 收货地址显示信息
      addressDetails: "", // 详细地址
      addressIds: [], // 地址选择器返回ids
      addressNames: [], // 地址选择器返回names
      addressData: china_address_default.a,
      showAddress: false, // 控制地址选择器显示隐藏
      isSmart: false, // 是否智能识别过地址，识别操作置为true，地址选择器操作后置为false
      smartAddress: "", // 只能识别地址信息
      focus: false // 控制识别区聚焦
    };
  },

  computed: {
    scene: function scene() {
      return this.$route.query.type;
    },
    infoData: function infoData() {
      var value = this.$route.query.value;
      if (value) {
        value = JSON.parse(value);
      }
      return value;
    }
  },
  mounted: function mounted() {

    if (this.infoData) {
      document.title = "编辑地址";
      this.name = this.infoData.receiverName;
      this.mobile = this.infoData.mobile;
      this.addressDetails = this.infoData.addr;
      this.addressNames = [];
      this.addressNames.push(this.infoData.provinceName);
      this.addressNames.push(this.infoData.cityName);
      this.addressNames.push(this.infoData.areaName);
      this.addressIds = [];
      this.addressIds.push(this.infoData.provinceId);
      this.addressIds.push(this.infoData.cityId);
      this.addressIds.push(this.infoData.areaId);
      this.handleAddressStr();
    }
  },

  methods: {
    /**
    * 点击textarea，取消placeholder显示，聚焦textarea
    */
    clickTextarea: function clickTextarea() {
      this.focus = true;
      this.$refs.textarea.focus();
    },
    handleBlur: function handleBlur() {
      sysUtils.scrollPageView();
    },
    textareaBlur: function textareaBlur() {
      if (!this.smartAddress) {
        this.focus = false;
      }
    },

    /**
    * 点击清空操作
    */
    handleClear: function handleClear() {
      this.smartAddress = "";
      this.focus = false;
    },

    /**
    * 自动识别解析地址
    * */
    handleSmart: function handleSmart() {
      if (this.smartAddress) {
        var parse_list = address_parse.parse(this.smartAddress);
        this.addressNames = [];
        var province = "";
        var city = "";
        var county = "";
        for (var i in parse_list) {
          if (parse_list[i]) {
            if (i == "name") {
              this.name = parse_list[i];
            } else if (i == "mobile") {
              this.mobile = parse_list[i];
            } else if (i == "addr") {
              this.addressDetails = parse_list[i];
            } else if (i == "province") {
              this.addressNames.push(parse_list[i]);
              province = parse_list[i];
            } else if (i == "city") {
              this.addressNames.push(parse_list[i]);
              city = parse_list[i];
            } else if (i == "area") {
              this.addressNames.push(parse_list[i]);
              county = parse_list[i];
            }
          }
        }
        var subIndex = province.indexOf("市");
        if (subIndex != -1) {
          province = province.slice(0, subIndex);
        }
        var tempProvinceId = "";
        var tempCityId = "";
        var tempCountyId = "";

        for (var _i = 0; _i < this.addressData.length; _i++) {
          var ele = this.addressData[_i];
          if (ele.name == province) {
            tempProvinceId = ele.value;
            break;
          }
        }

        for (var _i2 = 0; _i2 < this.addressData.length; _i2++) {
          var _ele = this.addressData[_i2];
          if (_ele.name == city) {
            tempCityId = _ele.value;
            break;
          }
        }

        for (var _i3 = 0; _i3 < this.addressData.length; _i3++) {
          var _ele2 = this.addressData[_i3];

          if (_ele2.name == county && _ele2.parent == tempCityId) {
            tempCountyId = _ele2.value;
            break;
          }
        }

        if (tempProvinceId && tempCityId && tempCountyId) {
          this.addressIds = [];
          this.addressIds.push(tempProvinceId);
          this.addressIds.push(tempCityId);
          this.addressIds.push(tempCountyId);
          this.isSmart = true;
          this.handleAddressStr();
        } else {
          this.$vux.toast.text("解析地址失败，请手动添加地址");
        }
      } else {
        this.$vux.toast.text("请添加地址信息后再进行识别操作");
      }
    },

    /**
    * 根据addressNames合集处理页面上省市区显示
    */
    handleAddressStr: function handleAddressStr() {
      var _this = this;

      this.address = "";
      this.addressNames.forEach(function (item) {
        _this.address += item + " ";
      });
    },
    handleAddressHide: function handleAddressHide(e) {
      if (e) {
        this.handleAddressStr();
        this.isSmart = false;
      }
    },

    /**
    * 地址选择器初始化以及数据改变时都会触发此方法，可获取省市区名称及id
    */
    handleAddressChange: function handleAddressChange(ids, names) {
      this.addressNames = names;
    },

    /**
    * 校验各项数据
    */
    checkFormInfo: function checkFormInfo() {
      if (this.name == "") {
        this.$vux.toast.text("收件人不能为空");
        return false;
      } else if (this.mobile == "") {
        this.$vux.toast.text("请检查收货人手机号");
        return false;
      } else if (this.address == "") {
        this.$vux.toast.text("请选择收货地址");
        return false;
      } else if (this.addressDetails == "") {
        this.$vux.toast.text("请填写收货人详细地址");
        return false;
      } else {
        return true;
      }
    },

    /**
    * 点击保存
    * 先校验各项数据是否已经填写
    * 再调用接口执行保存操作
    */
    clickSave: function clickSave() {
      var _this2 = this;

      if (this.checkFormInfo()) {
        var postData = {
          receiverName: this.name,
          mobile: this.mobile,
          provinceId: this.addressIds[0],
          cityId: this.addressIds[1],
          areaId: this.addressIds[2],
          addr: this.addressDetails,
          setDefault: 0 // 默认设置为非默认
        };
        if (this.scene == "create") {

          addressService.create(postData).then(function (res) {
            _this2.$vux.toast.text("创建成功");
            _this2.$router.go(-1);
          }).catch(function (err) {
            _this2.$vux.toast.text(err.msg);
          });
        } else {
          postData.addrId = this.infoData.id;
          addressService.update(postData).then(function (res) {
            _this2.$vux.toast.text("修改成功");
            _this2.$router.go(-1);
          }).catch(function (err) {
            _this2.$vux.toast.text(err.msg);
          });
        }
      }
    }
  },
  components: {
    XAddress: vux_src_components_x_address
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c5cd78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/address/editAddress.vue
var editAddress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-address"},[_c('div',{staticClass:"textarea-box box-shadow"},[_c('div',{staticClass:"textarea",on:{"click":_vm.clickTextarea}},[(!_vm.focus)?_c('div',{staticClass:"placeholder"},[_vm._v("\n        粘贴或输入整段地址，点击“识别”，自动识别拆分姓名、电话和地址。\n        "),_c('br'),_vm._v("例如：小红，183****8888，广东省深圳市南山区某某街道某某大厦001号\n      ")]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.smartAddress),expression:"smartAddress"}],ref:"textarea",domProps:{"value":(_vm.smartAddress)},on:{"blur":_vm.textareaBlur,"input":function($event){if($event.target.composing){ return; }_vm.smartAddress=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('button',{staticClass:"clear",on:{"click":_vm.handleClear}},[_vm._v("清空")]),_vm._v(" "),_c('button',{staticClass:"discern",on:{"click":_vm.handleSmart}},[_vm._v("识别")])])]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('span',[_vm._v("收货人")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"vux-1px-b",attrs:{"type":"text","placeholder":"请输入收货人姓名"},domProps:{"value":(_vm.name)},on:{"blur":_vm.handleBlur,"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('span',[_vm._v("手机号码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.mobile),expression:"mobile",modifiers:{"number":true}}],staticClass:"vux-1px-b",attrs:{"type":"number","placeholder":"请输入收货人手机号"},domProps:{"value":(_vm.mobile)},on:{"blur":[_vm.handleBlur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.mobile=_vm._n($event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('span',[_vm._v("收货地址")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"vux-1px-b",attrs:{"type":"text","readonly":"","placeholder":"请选择地址"},domProps:{"value":(_vm.address)},on:{"click":function($event){_vm.showAddress = true},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('span',[_vm._v("详细地址")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addressDetails),expression:"addressDetails"}],staticClass:"vux-1px-b",attrs:{"type":"text","placeholder":"街道、楼牌号等具体信息"},domProps:{"value":(_vm.addressDetails)},on:{"blur":_vm.handleBlur,"input":function($event){if($event.target.composing){ return; }_vm.addressDetails=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":_vm.clickSave}},[_vm._v("确 认")]),_vm._v(" "),_c('x-address',{staticStyle:{"display":"none"},attrs:{"title":"","raw-value":"","list":_vm.addressData,"placeholder":"请选择地址","show":_vm.showAddress},on:{"update:show":function($event){_vm.showAddress=$event},"on-hide":_vm.handleAddressHide,"on-shadow-change":_vm.handleAddressChange},model:{value:(_vm.addressIds),callback:function ($$v) {_vm.addressIds=$$v},expression:"addressIds"}})],1)}
var editAddress_staticRenderFns = []
var editAddress_esExports = { render: editAddress_render, staticRenderFns: editAddress_staticRenderFns }
/* harmony default export */ var views_address_editAddress = (editAddress_esExports);
// CONCATENATED MODULE: ./src/views/address/editAddress.vue
function editAddress_injectStyle (ssrContext) {
  __webpack_require__("aEgY")
  __webpack_require__("CntB")
}
var editAddress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editAddress___vue_template_functional__ = false
/* styles */
var editAddress___vue_styles__ = editAddress_injectStyle
/* scopeId */
var editAddress___vue_scopeId__ = "data-v-46c5cd78"
/* moduleIdentifier (server only) */
var editAddress___vue_module_identifier__ = null
var editAddress_Component = editAddress_normalizeComponent(
  address_editAddress,
  views_address_editAddress,
  editAddress___vue_template_functional__,
  editAddress___vue_styles__,
  editAddress___vue_scopeId__,
  editAddress___vue_module_identifier__
)

/* harmony default export */ var src_views_address_editAddress = (editAddress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/maintain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maintain = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/maintain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var views_maintain = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf0c4f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/maintain.vue
var maintain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var maintain_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintain"},[_c('img',{staticClass:"product",attrs:{"src":__webpack_require__("Ms1A"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("升级维护中")]),_vm._v(" "),_c('p',[_vm._v("平台正在升级维护中，请稍后再来……")]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-main"},[_c('div',{staticClass:"progress-bar"})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("kfQm"),"alt":""}})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("GYvt"),"alt":""}})])])}]
var maintain_esExports = { render: maintain_render, staticRenderFns: maintain_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_maintain = (maintain_esExports);
// CONCATENATED MODULE: ./src/views/maintain.vue
function maintain_injectStyle (ssrContext) {
  __webpack_require__("fbE9")
}
var maintain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maintain___vue_template_functional__ = false
/* styles */
var maintain___vue_styles__ = maintain_injectStyle
/* scopeId */
var maintain___vue_scopeId__ = "data-v-6cf0c4f2"
/* moduleIdentifier (server only) */
var maintain___vue_module_identifier__ = null
var maintain_Component = maintain_normalizeComponent(
  views_maintain,
  selectortype_template_index_0_src_views_maintain,
  maintain___vue_template_functional__,
  maintain___vue_styles__,
  maintain___vue_scopeId__,
  maintain___vue_module_identifier__
)

/* harmony default export */ var src_views_maintain = (maintain_Component.exports);

// CONCATENATED MODULE: ./src/router/routers.js


 // 授权页
 // 404
 // 登录页
 // 用户协议页
 // 用户协议页
 // 用户协议页
 // 用户协议页
 // 用户协议页
 // 用户协议页
 // 用户协议页
 // 用户协议页
 // 用户协议页
 // 签署合同提示说明页
 // 用户中心
 // 抢购页面
 // 支付记录
 // 提货记录
 // 物流记录
 // 我的库存
 // 提货
 // 地址列表管理
 // 创建，编辑地址
 // 系统维护页面

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routers_router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/robbing'
  }, {
    path: '*',
    redirect: '/404'
  }, {
    path: '/404',
    name: '404',
    component: views_404
  }, {
    path: '/wxAuth',
    name: 'wxAuth',
    meta: {
      title: '授权'
    },
    component: src_views_wxAuth
  }, {
    path: '/login',
    name: 'login',
    meta: {
      title: '胶原蛋白弹性蛋白饮料'
    },
    component: src_views_user_login
  }, {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement
  }, {
    path: '/agreement-dabenying',
    name: 'agreement-dabenying',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_dabenying
  }, {
    path: '/agreement-bopeng',
    name: 'agreement-bopeng',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_bopeng
  }, {
    path: '/agreement-jiajiuhui',
    name: 'agreement-jiajiuhui',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_jiajiuhui
  }, {
    path: '/agreement-boxing',
    name: 'agreement-boxing',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_boxing
  }, {
    path: '/agreement-fuqi',
    name: 'agreement-fuqi',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_fuqi
  }, {
    path: '/agreement-beifu',
    name: 'agreement-beifu',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_beifu
  }, {
    path: '/agreement-cehao',
    name: 'agreement-cehao',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_cehao
  }, {
    path: '/agreement-baoleqi',
    name: 'agreement-baoleqi',
    meta: {
      title: '用户服务协议'
    },
    component: user_agreement_baoleqi
  }, {
    path: '/remind',
    name: 'remind',
    meta: {
      title: '合同签署'
    },
    component: src_views_user_remind
  }, {
    path: '/userCenter',
    name: 'userCenter',
    meta: {
      title: '个人中心'
    },
    component: src_views_user_userCenter
  }, {
    path: '/robbing',
    name: 'robbing',
    meta: {
      title: '胶原蛋白弹性蛋白饮料'
    },
    component: src_views_robbing_robbing
  }, {
    path: '/orderList',
    name: 'orderList',
    meta: {
      title: '支付记录'
    },
    component: src_views_robbing_orderList
  }, {
    path: '/deliveryList',
    name: 'deliveryList',
    meta: {
      title: '提货记录'
    },
    component: src_views_inventory_deliveryList
  }, {
    path: '/logisticsRecord',
    name: 'logisticsRecord',
    meta: {
      title: '物流记录'
    },
    component: src_views_inventory_logisticsRecord
  }, {
    path: '/inventory',
    name: 'inventory',
    meta: {
      title: '我的库存'
    },
    component: src_views_inventory_inventory
  }, {
    path: '/delivery',
    name: 'delivery',
    meta: {
      title: '提货'
    },
    component: src_views_inventory_delivery
  }, {
    path: '/addressList',
    name: 'addressList',
    meta: {
      title: '地址管理'
    },
    component: src_views_address_addressList
  }, {
    path: '/editAddress',
    name: 'editAddress',
    meta: {
      title: '编辑地址'
    },
    component: src_views_address_editAddress
  }, {
    path: '/maintain',
    name: 'maintain',
    meta: {
      title: '温馨提示'
    },
    component: src_views_maintain
  }],
  scrollBehavior: function scrollBehavior() {
    // 让每个页面打开后滚动到顶部
    return {
      x: 0,
      y: 0
    };
  }
});

/* harmony default export */ var routers = (routers_router);
// CONCATENATED MODULE: ./src/router/index.js




var whiteList = ['404', 'login', 'wxAuth', 'agreement', 'agreement-dabenying', 'agreement-bopeng', 'agreement-jiajiuhui', 'agreement-boxing', 'agreement-fuqi', 'agreement-beifu', 'agreement-cehao', 'agreement-baoleqi', 'maintain']; // 路由白名单，这些路由不做校验，可直接访问

/**
 * 全局前置守卫：路由拦截器
 */
routers.beforeEach(function (to, from, next) {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  var access = whiteList.some(function (ele) {
    return ele == to.name;
  });
  if (access) {
    next();
  } else {
    // 如果token不存在或token已经过期，重新登录
    if (!getToken()) {
      // 如果是微信环境，先跳转到微信授权登录页进行登录，微信授权登录后，如果没有绑定手机号会再跳转到login页
      // 如果不是微信环境，直接跳转到login页
      if (sysUtils.isWeiXin()) {
        next({
          path: "/wxAuth"
        });
      } else {
        next({
          path: "/login"
        });
      }
    } else {
      next();
    }
  }
});

/* harmony default export */ var src_router = (routers);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: "app",
  data: function data() {
    return {
      themeClass: "theme-yellow" // 默认主题金黄色
    };
  },
  created: function created() {
    // 主题设置，一下主题的设置代码不能放到mounted中，因为访问路由的组件会先于此组件渲染
    this.initTheme();
  },

  methods: {
    initTheme: function initTheme() {
      var theme = localStorage.getItem("JYDB_THEME");
      // 如果有主题缓存，并且主题为黑色，设置黑色主题，否则，设置为默认主题黄色
      var root = document.querySelector(":root");
      if (theme && theme == "black") {
        this.$root.themeType = "black";
        root.style.setProperty("--color", "#facd89");
        this.themeClass = "theme-black";
        document.documentElement.style.backgroundColor = "#242626";
      } else {
        this.$root.themeType = "yellow";
        root.style.setProperty("--color", "#fc581f");
        this.themeClass = "theme-yellow";
        document.documentElement.style.backgroundColor = "#fff";
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: "app",
  data: function data() {
    return {
      themeClass: "theme-yellow" // 默认主题金黄色
    };
  },
  created: function created() {
    // 主题设置，一下主题的设置代码不能放到mounted中，因为访问路由的组件会先于此组件渲染
    this.initTheme();
  },

  methods: {
    initTheme: function initTheme() {
      var theme = localStorage.getItem("JYDB_THEME");
      // 如果有主题缓存，并且主题为黑色，设置黑色主题，否则，设置为默认主题黄色
      var root = document.querySelector(":root");
      if (theme && theme == "black") {
        this.$root.themeType = "black";
        root.style.setProperty("--color", "#facd89");
        this.themeClass = "theme-black";
        document.documentElement.style.backgroundColor = "#242626";
      } else {
        this.$root.themeType = "yellow";
        root.style.setProperty("--color", "#fc581f");
        this.themeClass = "theme-yellow";
        document.documentElement.style.backgroundColor = "#fff";
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1c04c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.themeClass,attrs:{"id":"app"}},[_c('router-view')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("TJsZ")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vue-scroller/dist/vue-scroller.min.js
var vue_scroller_min = __webpack_require__("POcy");
var vue_scroller_min_default = /*#__PURE__*/__webpack_require__.n(vue_scroller_min);

// EXTERNAL MODULE: ./src/styles/rootTheme.less
var rootTheme = __webpack_require__("uWnD");
var rootTheme_default = /*#__PURE__*/__webpack_require__.n(rootTheme);

// CONCATENATED MODULE: ./src/main.js















vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(plugins_confirm["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(vue_scroller_min_default.a);

fastclick_default.a.prototype.focus = function (targetElement) {
  var length = void 0;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};
fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: src_router,
  data: function data() {
    return {
      themeType: 'yellow'
    };
  },

  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "OX1S":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAASFBMVEUAAAD6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYmdX+VgAAAAF3RSTlMAIuH36ijJmYlXDAjiMBfRnJvQQxpAPjsk9kMAAADYSURBVDjLjVNZFoMgDAybCAIutc39b9pWealBkc4PPGaykAV+8M52WindWefhDDErJKhZFPTQZ5ok/cDMFzxhOTiJGi+gI9kTXyhEjr9gBeOeR49V9FsAVReob5AZbzABeHLwiGG/hPgkFx4cqQ2IsPECDD06sHSXYlOEzyHp0UKHTCE5jx1oZIp1ZTxqYJ+UCSBJ9tGmoAyRUhmiTFKWSVrO05FhWaF2QrJCHUttsqE0r0OpYbptVqvd5p+BgWGsj1xraJtjTxDjhX/RXD0Ow5Z3MkS01v8Nl3Y+PRGKa6sAAAAASUVORK5CYII="

/***/ }),

/***/ "Oags":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oc9N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OfBk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OzvI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDPz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAZCAMAAAAR624oAAAAk1BMVEUAAAAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QAA0QA5dTafAAAAMHRSTlMA+vXOpALx7tbAhXFB39G2oGFTPOnaxaeblpOAd2pGHBYJBeaxknxdSzIq4mQ2NBDr+TnuAAABCUlEQVQoz32Q2ZKDIBBFL+7GLWqixj1mz2z8/9cNYDkImcp5gLqcoqEbAruvY4c65qW38crdowv7TJfTga6xjoq1LariK76ljDgWZucTth4gGQx2UMI2uf3BlTK+pW54rgCfbacjAh63UheUkyRi8yyDEvNcSb2jCuYttSJCIiuzhSaK3WTR3wRCrk9r223WKQBwXuVtQBU+gUwm40t0nbr8ZkvYwcAalpdF6RFsjB/Ann8FeDqLvsVipjWvUZaiUQD54kOHahAwnu4cHq6uDa5HMofe1HXBdUqLMO/qbXjVdcd1c8fMqFX3Jiik6ssPaAREWjfHC7n8Xov/CC9+5CXNxkjwjqGagF/TwU04UXGTbAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "QgKr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R3hu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAWlBMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB8OvH/4AAAAHXRSTlMA+psR6qJcKvftypEL1zUbDq8XLSjOd0bFj2hYJ8C9kCgAAADYSURBVDjLhZPZjsIwDEVPszRd6M7AbP7/3xxpQBC7lJw3R1Z8fW3zZK5dF6oqdK6e2XOOjTxo4hnNqa9EUfUnMqYP2TEkHoxBXtCO3EmtvKRN9/qDHDDcdPRySP/fX65/8avLe0lAlIwVfB5H8I1kzCah8dSS8wubeqhxKh7hqh4cnYqvmC87tIk/cNFmoYf0DV96aCbhAtEkBKOJT13CiAzrKEakk7c409UyTYs2yljtYdVWG9XTflikSpXwdtzlhSmvHNvR0m6ltS8dTvH0NEkfb0JzfP5/c3lSKwpBFzEAAAAASUVORK5CYII="

/***/ }),

/***/ "RYLh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RmeA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S5jg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SFeO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAABHVBMVEUAAAD04dLcxazx5eLy5+fy5+fy5+fy5+fy5+fs3NDu3tTz5uLOroLy5+fw1rvTto/awaP0383x3MncxKjy5+fy5+fv4drTt5L03cfy5+fv18DYvZzWu5nz3Mfy3MbYvZzy5+fZupHQsIPOrX/dvpYkJibhw5zMqnrv07PqzqzmyKTjxaDKqHjTs4favJPXt43VtovUtInSsYbw1bXx1rfNq3zewJny17jz2Lrt0bDrz67oy6nnyqf02bv12r0xMS7w497v4dvCrJHAqIy1oYmvmX3x5eH028LVupeznoaynIKBdGPz4tXx3c303cjfyLDUuJK+pYU6OTXhzLjgyrXPuJvNtprIro2NfWl2aVdnXU9YUUdIRT8nKSgmJydUr81+AAAAIHRSTlMAHR0P+uCunF8KBgL94f39mJeQkFtWEuXk4uHh1tXPz32odnkAAAFgSURBVEjH1dTVUsNAGIbhhUgjFajhsPXUkKItUIFQd1zv/zLIQbLZkNL9D9v3NN8zmd3JBJHk4LZWyWavb3K5fD6dvkgmD2Oxo+OTYjGwE5KRq6Bf08ozQSkeT5RCyJmyf3Y6DyTODxQH2LtkgcwuvV+/YoPMGiJxVQjwcvYLbiGgYL9iEwY2CGjBgNfaq1UYKFhgxQIvuq53Ot1u98Fo7Aarf0AvRVebsED2J+XonQXKNSfosYCmf9WoPgIM4L6lZQSdqXne6RsB0Gt9hYDKtw0mBMA+jU/goZ/vjO6N0otyrcsMolAQNQEH/c1wFhjCQJuAPgw8EoCrEJCo26APAU/YBnjIBm1MA9xigXbTBipviMF8MDImPLISsFFz4P8PjEcNbCQQIGKzOlWD1DSfigRIGJREgOyD7LdkRApDQBhRedh7D6JTmcKjImcRYd5ciCBXiiT6+Flj3idKCpn9Aj47OvRyg6BiAAAAAElFTkSuQmCC"

/***/ }),

/***/ "SI7V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T5i4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TJsZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TT4j":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEkUlEQVRoge2ZW2wUVRjHfzO7291S67ag0CI0BSEYbOqFB8UHY9AoCiKaeHvBy4MPGhMVESNPJsaoEe+X+GA0xsuTSvCCQYkmEl4ULbVGI8QqRmJMq8jSCrY9nznTb3CYzO7OTDfdGvpLNjuZOefM/zvnm+985xymmeYExxnauwMRARHvX8Tof/Ba/40JPR+/h5isiOkSkW4xZoFgOkVMk4g0G+M9K4mYg2LkgIjsEzF9IqZHjIza9oxouyb8zvFr7HsZv4cn9b9y2QmMXwdwNbAauACYkbD+YeBz4GPgHeDnNCLchOUd4CrgI6AfeAq4JIV4y0nA5cAT2tYn2nYiTUkKXwn0AFuAy1IYXwnbMRdr2736rpoZMB/Yqr/uGooux5n6rreBudUKVzNgrfZ67B6pIdcAfcAVaQ3YpB/XzDqI92nV0dhYrkA5A+yH9ZD6Zr3JAI8Aj8c14H7g7ikgPMxdwKXhm2EDbEx/uC7yyvOXesQiYHu4VHAiawNenSJuY9kHPAu8ApRCz/LAUUIjYP1s1uRqjOQzjX5LgGdC4pcC24AX/Rv+CJwLrKujaNubbwFPa9gOcwrwIHCbajbAk8A3/gjcVyfX+V2FdQK3RIi3Yu8A9gK3Bzrc1TDv3SjqkE0mvZpHven7cgQrgc3qNlHYRLLV1YQqH0O8jQbXAh+mNNQO+3ua/J2lH2eUeN/Pt1UQb2kAVrnaYBxGdFZcrcM6HLOeTZufA84A1gA7ypSzfv48sEd7Pw4rrAFnxyxsX3AT3pKCF4BlwO4K5W1+v0GTwTvVj6OwPbk+ws/j0O3qwiQu6wOh93tguU58Y4H6u4DrgNN1+j9YoW3rx99quZYEOnw6stqzcVmibrBFy49oNHgdOE+H/+sYbS3VSWpFCtFBZmbVJZKE0I0BA3y+0181wvF8orjWHQYTNnI+cGHCOhPx80oMWAN+SlFxQ4KyE/XzSvRbA75IUXGVLv0qcQ7wqS6KFtVYuE+PNWBnioqOph9RtAMvA18CF9Vc8vHstAa8n2BSCnJDKAQ3qFE/ALfWeNciin+AD1xNV99N0YAV/JKmBdernz+q+z2TgdX8hx8N7FrgxhS9tjLBtF9LbOh/jIBgu33xRh2EpOU14CtCPX4PjnvkfyB+UDcePIIGDEjjvF+nzpI4EtGE8jf/4TEDzMldLrliO41tU0ZtBA/YyBO8HRyBTm+XOT8bCnPqLTSKzRpsjiNowDz/wmlsx5lRdV91shD1+Xuj3hdMqlqDD5zCHFy3wFjpR3sCUy/x9oO9WSfbSIIjMBQu4DQUybZ24RZOrcemxVbNp8qKJ2TAbp2eQyVyZJoXkJvVjVtIsvZJzR7dzrenNb9Ua+SYAe6hvj/1Q4nEyRTItSwmP3sZ2aa5OE6mlqKNHlutjdPrQcILi026JFyni327Z9SsWyp2dEpOpjCcKy48km3uKI0OHWgbHR48bezooWbEJPUxm0Du0q0Wu8Lbn7C+R02OWfMtC5tG/x5cPjI80C7GLBbMfD1mLRpjxkTMYe+o1ch+EekXMb3eUWsNjlmnmeaEBvgXVEPdeyAj0LoAAAAASUVORK5CYII="

/***/ }),

/***/ "Ta6R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VASZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VRHR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhBAMAAAClyt9cAAAAG1BMVEUAAAAkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYLY0YnAAAACHRSTlMAwPPGIrwgH1Ba8nAAAAA8SURBVCjPY4ACR1UHBlRg0WGAJtLR0TC8RAo7UEBjAkNEByoQYNBAE1HAVINpzqDzKaUiBNOGoyIs/QAAkYJTLWppCdsAAAAASUVORK5CYII="

/***/ }),

/***/ "WJby":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WRRU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAG1BMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB+nrSXcAAAACHRSTlMAiIfCe8caGWDmnKwAAAAwSURBVAjXYwCBYnMGGPBogTM1mihhpggKCka0Agk3BosOKGhGZiIUUGYbutMRHgIAmuwYtYcVnfwAAAAASUVORK5CYII="

/***/ }),

/***/ "XwQs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XwiW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIUAAABOCAMAAAA5KyV5AAAAtFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////oK74hAAAAO3RSTlMA/flaA9IKAfHoJQXZs6ecMi4R9ut6D7uOgxTfiHRLPTkYB+O4rZVvUUIrH8nFwappYkYbzcOiXn9XZpEk02gAAAN0SURBVGjezdnbWuIwFIbhv9ANUCmlQCug7ARF9iqCuu7/vuYRnaZpGmZimXTeI4/aT0iTNKAgC896vd41USi/QidRDcXpWfStNUdRgj3FjCcUI1wRFZ5hr4ljDKCfvaGUdgjd7IgED9DMnZIogl5unTJcQSt3RsVXmFvKVIdG5oGyfUAfpyGJ6E8goy+iNII2zrUsYgB9pBFz6HMjiTDeoc+bLKIMfTrEFLaq38oidE4UD7IInWvpzpBU6Ix4kkV0oM9RFvEGfd5lEV3oM5dFXEOfQel/jrh3oM1zSxLR0BgxlEUcTMjoi/A0RowqkoiZxghfFlF3oU2zLYmYaoxYyCIiG9rUqpKIjXpE7faw9brNH0TcSSJelSOW3tcSYNybUDOWRaxDqDE7rR/P+VtJxF41IpgSY4ygoimJsAKoebFyvFJ3JBE91Yg+cUpKF4iyjyjGqhFXlKLyEme3MiNeoCa0KO1GZTmnDH3VCDfKd9ZykxWxhKLG35w7LW9n601jbkJkkeCuBkU7ymC4/Nw4M77HvXj5sbjdrSpHDEvs1h7Falxoi91A+KiPQkR7AUW9xOTbKbO/HxGbeGdHzEGIaEKRU09sk5GoKLNZ9ZU4fuoK1XSEn+cNPzKTFbfCzyss9uz0XV1AVbPEnooAKIv3Cixh6JlI8rk5d9MdQ9WE3aKyAFcxw4m9IkGZv0b1d8Fr99HOdwBmzMFX7PHJrJNoC86wzRUoGxncjM1VVE4j70AZquDZw5GNH5uwNWzjpivoJTU3t9kU28MFddl/N4ZQ8Qh0uElgIT6rohzPhzGAWFHmIio+JonAizFX4jbzOVnBRYwAxNP4AOPd9S687GHg3o0XLWLW6V8eA3YMEBmf62YTuY0r8UyzYOOVBGwifRT2EDby8hK3YKqUZepkb0OOyIn9Y2sTzIoyrL+ezCtK85CPG1+yVeM/IYHRdXFSEc8lLnZY3vnDm0V/KP+2Hi41NC33/HbaC+TfVjVAHmygGT44IX9QWDme2Wpf+cjFNyQ7FmBGqbmKqXG7XOvdRC7OJl4cAqQME7fqN2VvDMZ04CCneXy1p3M//EU98EKvdUrYd5fI756+rRwInLevoXH3YUIQPj8dn3u4iPr5U4rlW33aeJ/gH9uynZtu4mpaWqJI4R3bahbI738+8DYKNqxPuwEK9QsC+BSTDB6mcgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Y2Ce":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eb4a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("/Mkz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z0L7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z9K3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAMAAADHso01AAAAkFBMVEUAAAAkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiaTJ33JAAAAL3RSTlMAI90D5fv4yaNELvPnxLCBSzchFc2WkGnreXRwGQvg19K9t6mbmoZlPzwcDl1XUlJOcO0AAAELSURBVCjPfZLncsIwEIRluUbunWITOkkI7Pu/HWgkg+QR+n7dzXrWe6cjKRCRz4SA/0csHLG2yV9IbbK7gNX9hNwxMwr3T1Dp7lEDG3iE02JFDPwik9lDk7xGLrInqAxyhIJY3L8xiOLH5H71E1GY3N2qx35qWixlNbKiP0ep5wMimXBv+ARZs8BEvM2cl5UHh0cFAppG575gV6LScffhXg4uMW+oIQY0dwsdEjpHuSLmY4Z+o7Uzp9Jj2mGHsK1f95mlXa2qBf95Ild/w5NNrT1fznY4yjH9S7lFrgyO+H02NV/SBRl546FwTziIb+OYjXt0itwDAYJSNEvexNoe/2kQllOzosHu2TwAe2QgMOPHajEAAAAASUVORK5CYII="

/***/ }),

/***/ "ZLiK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAMAAACPHmKLAAAApVBMVEUAAAD+0BH90BH90BH+0RH90BH90BD90BH90BH90BH/0BH90BH90BH90BH+0BH90BD90RH+0RL/0RD90BH+0RH90BH90BH90BH90BH9zxD+0hH+0BH90RD90RD/1A/4zRX90BH90BH80BH90BD5zRH/xQD/1QD90BH8zxH+0BL80BH+0BH8zxH90BD90BL/0xH/0Q/60Q//zBT/zA3/1Q7/zxD90BF4y0A5AAAANnRSTlMA1abizId+eWliNvuddnBsVkck9unCoZiSXVlTTj4hC+3dyKotBgPxxry5s7CMgUtDMhkUEhDAwQvqAAABPElEQVRIx5XV2XKCQBCF4WYREDSIAioouESz78l5/0eLihg00zL9XVlW/U4JPTPE6ZKUNRUGXSylSwCZKPAAGKIixk4uCEJAuMgCBzPt4AYVW7u4w9GbZtAHhIuMcBJpBS7+3GsVARreNQIHTQm1GEYhzvUHfkkqP37mpHYAJStJnbygWjFzTQM64tXY8zfkQGa9f5gSZvWK9aX14OnqnWZVElRC6Bif7+t2k4vTRieQJS/0zxTXdEghkwSVATivxFiCUXIFOHNuO4ETkvR/9JiiA47NFE/gBExhgDXkzkIGd8rfoslCk0sVfrAWHg3N5vZueVQjt1r0GXv8dVX/ZtDZ1l/5j3XypSpWx735TQ1Rws/JJj683YIu5DZ2PEXhAzA/SKFrABPlVK3n7FVqPahuv4h4pbMlqc/6wy/slso44UYbwQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Zl4u":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAMAAACsjQ8GAAAAb1BMVEUAAADV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dUFO9ljAAAAJHRSTlMA7hHwDh7nsBfy2Ldd4FY9G/jQy72oZ2JRNAWnmY9+dnBLRyjnCDnsAAAArElEQVQoz82S2RLCIBRDoRRs6UY3u7hr/v8bLTA6VQRfm+HtJMMlF3IvEJCsSJADDQGIXzFY2MCNoeM+PgpjAMt/4qQHjGG3nMTlpUB6sTPkFLT8ji+xjL+GVBlwiFZYZ9iwfsU+hbi9sdJx9flM3gHH2PKBgeZuD9caRaWtmR3aLerRAqdYX1Z6mpzPNVKgT/xVTw3EGN4Fn/8ua5uGyC/9oySCakklaUByegKD1h5JT5G7YwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "a6mX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "aEgY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bPdr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "boEI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dM38":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAS1BMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB9CA8ohAAAAGHRSTlMAIuH36smbiVcMCOIo0TAYnJnQQxpAPhcFmDUiAAAA10lEQVQ4y4VTWxKDIAwMDxEERa1tc/+TtlUmNSCyPzDshg0hgT+cXTqtlO4W66CEMAoJyoiMHvpEk6QfWPiKBdbTJZPGC+iJ4onPFCL5r1jBeOTRYxX9bqDqAvUzMXiDGcDRBY/gj42fnnSFA0vqAMLvvIBAh/bkIMWu8N9F0qGBDplCch470MgU28Z41MAeKSPAW7KHloLIBblFjJlFkaTMkzScpyXBsEIdhGSFYqVOgTK8TqWGufFZze9uNwwMY73lWk3bbHuCuHAZRWv0bod3pvDm+H8AhB9AqIpUe/kAAAAASUVORK5CYII="

/***/ }),

/***/ "dg2t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e7qV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAA7VBMVEUAAAD7YSz4kG37ZzPy5+fy5+fy5+f2uKby5+f6dUfy5+f4knD6c0Xy5+fy5ub5f1b5g1ry5+f4knDy5+f3nH73nX/y5+fy5+f4jWr7azr1uqf6cUL5fVPy5+fy5+f4jWny5+f4jmvy5+fy5+f3o4j4lnXy5+fz0sny5+f3mHn3mXry5+f8WB/y5+f////z3dr/6eL9hVv9eUv/9PD8WiL/5979g1f7ZjP+rI/9i2T7flP8Xyj/8ezy5OPz4N7z08v1vKv2taH4lXT8azn8YCr/+Pb+3tPz2dP+tJv3n4P3mHn7lHD5hl/6cED8Yy5Pp2+YAAAALHRSTlMA/pT84lpTBfDvv4n++e7Z0Z6QLSgcFQ/5+fXz4dnJqaidlJOBbWxkYlRLPvoE4PQAAAEvSURBVEjH5dHXcsIwEEBRERNMrwHSe88uIYlcwHRIL///OWEGS65j7WMynPerndUy6aa6wyFWKnfUZGFb+5AkdcKCbjVQqOiB9zVQqvqDHBAUmFQACk0PDaCPaHJaUBHBBdDsiaBODDQRbMCKYz54TCd6vVCwMDp+3R9V0OsEfaqCfigwVQHYRtdj2Iodov5l8DZ4WjF6pMDsSAMQiId75pTAeZGBTduBP7rmf+Zb1yqoEwNLBOfEoCiCK04LtkWw2acFuzKYAMW8LAMkjZhkveDVAqUPlEEGcfwNCjPEtAjuEHE044knmCLioQjaJVwavxcXEIdbX9MhLtWYkEfX6D7GEF0Z5i1BkdaZbwRBhnlaaVQ6ZX4NZVHTWUDrGJOUr1lE4+yghLGy+cs2E34BbwE+CYFAyP0AAAAASUVORK5CYII="

/***/ }),

/***/ "ers8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fbE9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fswM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAh1BMVEUAAAD8WB/y5+f8WB/8WB/8WB/y5+f8WB/y5+fy5+f8WB/y5+fy5+f8WB/1wLDy5+fy5+fy5+f5flXy5+f8WB/y5+f8WB/8WB/8WB/y5+f8WB/y5+fy5+fy5+f8WSD8WB/y5+f8WB/y5+fy5+fy5+fy5+fy5+f8WB/y5+f8WB/y5+f3pIr2qI/eYdm2AAAAKXRSTlMAVREiEevpXBoB+fLu48y3q6GaXFdPTkMkIBkUBP7w5eTasJplY1VLSAIxPO4AAAC2SURBVEjH7dHXDoJAEIXhgwiIhd7BXhl5/+fThARFWNg1Xqjhuz5/MsngfdmoQ4Ymmzrs0eBTl+UFL1KVOm1GqLOoh42aE/Xy8WSiUi81xcOOOFiouMTFrQ6aE5f5pNzrJnEyy+BA3I64i2fEbRYDulFcuRWGDicX4kARC1bIBQ3B9wWKFsktIk1hBBIYNEYgg0FmBAEYPEawCMetwsXv/GEIPhdsxfZrSFOR/dQDkrPELUjwD26ypBOJ01tRpAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "fu0F":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAB0VBMVEUAAADy5+fy5+fy5+fy5+fy5+fgwpry38/SsYXnyabz2bry1rjw1LTMqnvfwJrNq3z049jYuZDhw53ewJjy5+fMrHzy5+fKqXjy5+ffwZrYuZDmyKXy5+fy5+fv1LTy5+fKqHjbvJPProDbvZTw1LTkxqLOrX/y5+fv1LPy5+fy5+fy5+fKqHj12rzRsYTy5+fu0bHy5+fKqXnLqnnIpnXNrH302bvgwZvbvJP2277w1bXXuI7SsofJp3f12r3s0K/RsYXrz6302bvdw6Ts1b7ixJ7dv5b12r3y2Lnv07PRsYXLqnrgwpvewJnjxaDbvZTNq3z12r3x1rfrz63Ssof02bvoy6rVtovjxaDlxqP12r3Jp3flxqPau5Px1rfNq3zy5+fy5+fu0rHrz63YuZDOroDy5+fy5+fv07PUtInNq3zy5+fy5+fixJ712r3y5+fnyqfau5PXuI7pzavoy6rlxqPVtovmyKXjxaDYuZDUtInbvZTixJ7dv5brz63gwpvewJnSsofs0K/RsYXu0rHQr4LLqnrv07POroDNrH7w1bXx1rfNq3zy2Ln02bv12r3Jp3ft3tTw4dnq2Mrp0Lfx5ePx5ODv4d3t2szkzLDbwJ0f5ihkAAAAb3RSTlMA9LWyKyIVCwX8STwoJR0QD/35+e7q5eLh3djX1NHQzsKnpKOiop2Zk5CKhHd2blxZVFRMOjAvGQsG/Pr5+fj4+PXr6uno6OXi4trU0NDIyMjCvry7uLCwrauko5qaiol3dnFmXFJLSkY/ODEoIB6m5IWyAAAB5ElEQVRIx6XVZVMbURQG4JOEJNBCkuK0uEuLtUjdcXd3t0twd/fg8GsZ2Am5cu5lGN6PZ95nZ/fKLIgxpTaV/Pf2ySlt7jLB03ld4zE9ObOwvLI4b5/9WtsP6nhWjk+MusDY1FyVl6rf8XOJB6u/kqV19+iNNRGsb8a6S0D0Ng52IvF+y54M7LZi/Vf7cnDwUeyb81QgIFsAHw5VYOs93//8Rw38+JVKPVKDrXQONLDAu6jYhwWNHMhlQIwJwBTFgAC2bzumQYw2jKLBiZUBmTTwyNKGWW9okMEeahq8c07f0uDTy4An80oWbWhhXsmL3bcf9EfXa8MI+qO/cztXzixr3TCAJYJZ1nD+KHE7HRTE7rRwmEaeOhrC1a5Wg3Dx/qgBcoNCVaDwuVc0HZBUyEEZYMn8IgUDgCZeBmIBjzkfB35WkKQPB90gTTwGIkGe7FARFFiV/4ffPPiWAcp08iBZ3XdL+seCv0mDinpaGCHknAa3F4SEpQEem4Hc53LcBexXDyODDd22EKLldNQJ7A6iJcSMgDbijMMJzh5H7QgwkMdca8DVJwYExBFXTs8nZ24c1CAOW1EdkUY3BEh6pELXC2iMeryvN8o3OjGQbwcmuoEyxpQEfbC/LyG+/sH6hBTh4XfJITixtIsRkgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "fwTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gu8N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hHyT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hNYO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hgmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i5Dh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iK2A":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAMAAADHso01AAAAmVBMVEUAAADu7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u4e1wwNAAAAMnRSTlMAId0E+efK46P887BENxnQxo+AbzAkE+vBlnZoT0o8C9e3qZuahnpjQSsOupODc11XHa5Ok5UAAAENSURBVCjPjZLXcoMwEEUXIUyvJhgbCHGPnX7//+Mi0wKx0Pi8SDuXOYN2lyLAonlEbAekYI+lKvYQqWJ9hR9VfkCiyalb+xyssxtMggmzsa/xSRKe4TbnKxayeImk/XcDmiS2UFJn30jiFwQ0b7/aRn+9t+tagW1fvA/2+lIVRys3bQAfwxsau+eGK/Q4oftEf3ZxtwBwllvHorpcaUyME1FQ+vLRC3tIKkxhVxBLxjLaotTGP6Y7mml36PQ46W6xHt7luVGcjdOKAzC61n9DwLLJ+JL0DfvumfbZD5GMJgRHKLvBZrfzDHfSl1I/YNd+6zhpvUU82SxwcL8tTrfCmfTxi/GF3xcbxnNR/AI0KCGZA07bJgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "kfQm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAjVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8DizOFAAAALnRSTlMAAwYNGQgeFRIKKCL0JBDup0b8+OW3ZDjal4N4bzEszMOxkIl9aEE20r2qoVJKX94bdgAAASRJREFUKM9dkteWwyAMRAOiY7Cd3nvZyv9/3sqsSBzPk8f3jDRwGHVio54Y6vnJpeRoyVgAy1k2HLQQGjgj40NQRmYHYjtb3TuHJKr2VFdfe8MRcfOTUqrWQUvOjd9UCdUoYIjEJWXnNBi/Hmcz2UdEUqwTMRXmSLJ+Ne9Sc7LnRVsnUpuR2VX/dnydFTLZGdY1DOVPNS7oEKBrL3HiUBdlWW7vPgakWuAqFLNqGFv5PA9j0X2+kelDS7pfKag1Nd3uNWfEwG/7m1YLBZwQNmlST8tW2BKz4nF820YV8wHu57rPGvWMwWbyXtJDQVK726G/7YWYNWr3neqS3QiZET0REWZNez0t6+nxVtqXoVEIpbxzzgsoZy5BKa2FGCNIIj1YlMEfmog1bw2RSNIAAAAASUVORK5CYII="

/***/ }),

/***/ "lKRo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lUxW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAgCAMAAAA7dZg3AAAASFBMVEUAAADV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXk2KSQAAAAF3RSTlMAd2a0aTzMIlUTqKHi+Ip0OCnr2LI1HwXCUkkAAABeSURBVCjP7dM7EoAgDEXRgKhAUPGb/e/UDPXDsbBxhtPeIikSouAMsKxakkDTSVaiBWZhMuII6KVr6XfJjIAvCSspDcD+wYbBqwumQ9QGU+YY2b+b5aqHXX+H/PBEN+2FD+RZXZapAAAAAElFTkSuQmCC"

/***/ }),

/***/ "lmQy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "mfud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mh0x":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAMAAADTXB33AAAATlBMVEUAAAD6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYlYGVkkAAAAGXRSTlMA6gbdLeK89NZnXjMhDvCxqcuzjlwoFAHAY7TuuwAAAJZJREFUKM91zlkShCAMRdFHQAQF56Gz/402rW05kfNF1a2QICFvG1ZDRQBNg+LGesKm1rxzxjje6XorJR/KyzM10pylCZ4FHlZKHzRSUmARCnmqlVKLSkoVSPixIGCShpIuv+kn6nfREZugXocH/Bn1KAY4m1CSubicPeMmuKO4gIel30u/4CVaTmxEBnXMHSFrHccVpy9VMShrQrF0lgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("WJby")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nNV2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAgCAMAAACvkzHFAAAAq1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0NbREAAAAOHRSTlMA+QMH8RGHbu3KSkEL9enZsZNnJdPDu7isn408NyEZ34B7YFVQLh0VDuPNp6JaK8C/mZd1WzNHeL8ss3YAAAHASURBVDjLhZPplqIwEIUr7IgKqOziguLWamurPff9n2xSmcPBcRj7+1GnQurWqdwQ+h9mbdI7dM86ADjuqBvtcUsGgLiELgLqYFN9DAEI0evL6gvOjXC6jAJVkPu8n522V0xJcseNFP09JDXR1IAR2Achh1hhyVszJKTQj+Hahk3ki0ojWmBNZOKTmMlAJ6YRjJFyWiCU0RV9XuTwiGkEJTLV1vBltNDjRQ9WWxPC05w5MQE2RB5yNatwSdEIUow5tVHJboMJMZ9ozd5JwQgjTs/4kDHGjBdLrNpGkTBLpMTsh+vQB+6cT/FFDerIc0fjNAPYqA3nasiGQgq+/ri7ihYFFytSlO1NGr5y9xU1ZEOAkt19ZcwnaLAxUu6+oCP+W8DuvmC3Tqsja+zuM7Udw9hQS4YHu9swq45DAFFNT5zwixKM1TX1wgmA4bFis59m3CKWdYdvbxEJwEjsM3+8Z3vxaIsODtEVEuEuCp275apb9vSGzt8yeJa13ql//CKAQXKrqZPxKHUAuJan/7MVGXFJu3AOYH5ddb1SzYcPlwo46aikbmYIKIZJW+3NG3ec3BjSe04DGD36gW1hUie/AZqRMczss/D0AAAAAElFTkSuQmCC"

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("xBcY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s14R":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaMAAAEzCAMAAACrLZyFAAACdlBMVEUAAAD8qWb8WB/8Ziv8Yyj8WiD8XCL8bDD8cTT8aC38ejz8oV78fD78djn8fkD8g0T8dDf8ai/8gUP8o2D8YSf8n1z8czb8ikv8eDv8mVf8klH8hUf8hEX8bzP8iEn8jEz////8iUr8hkf8XiT8bjL8m1r8h0j8XyX8nVv8YCb8k1P8gEL8qGX8p2T8pmP8pWL8pGH8lVT8jU38l1b8kFD8mln8llX8jk78j0/8qWb8qWb9qWb9p2f8qWb8qWb8qWb8qWX8qWb8qWb8qWb8qWb8qWb8qWb8qWb8qWb8qWb8qWb8qWb8qWb9qmr8qWb8qWX8qWb9o2L8qWb8qWX8jU78qWb8qWX8qWb8qWb8qWb8qWb8qWb8qWX8qWb8qWb9qmf8qWb8pGH8qWb8p2T9rWz8qWb8qWb8qWb9qmf8qWb8qWb8qWb8qWb8qWb8oV/8qWb8qWb8qWb8qWb8qWb8i0v8WB/8qWb8qWb8nFr8ejz9uZL9sor8aCz9rHv8n1z8dDf8qWb+za/+wJr8qWb8qmf8qWb9sYT8qWb8czb8lFP8iEn8azD8qWb+0bP9o3b//Pn8qGX9nXD8dTj8qWb8qWb8eDv8aC38qWb8qmf8Ziv8ZSv8qWX8YCb8qWb8WyL/8OP8qWX8f0H8qWb8fT/+6dz8hEX8hUb+2MH8ejz/7uD+27/8cDT8XyX8YCX8bTH8dzr/7+P8bzP9l2f9h1T8lVT8bjL9yJ38snf8XSP9zaX+2bz8eTv+yZ//9u//8un+5NH8omD+4sv8l1b8eTv/6Nf8qWb/+vX9yaH9jV78oV7//Pn8Zir9u4X8fT/+483+38f8t3/9xZeZtCbQAAAA0nRSTlMAs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7N4jTsBYYVJElKSmVwuRGkpTVchpwg/MooDbxazDyV1NZ19lhikfDcdBa8NDHOBZhqgcEOyqgplq4CtoiqcWiMqKrOzKbN3aFWzs6ODH7MsEXd2aCeys5VGs4prZCFbUEiupWs/MKumnZVsUrNdRrOjl5WSinE0enQbs7Olo52bkotycGBZsrGtppSDRxwbs7OWgE1LOzUqcCeANYGcAAAcpUlEQVR42uzd908TYRjA8UfFWTfixL1w4J5waBVEtFStg9aJtQgoiqIodU/EjcYZF8aYGI0aR+KKIyauqHH8R773cPTtHa3e9E58PpTeFf3Jb97zfV+OAv88YYFbAOJg3ttpaWVFeUAcS1h78+m8JfMzKJJzZeeeeDJl8sysWV4gDpWW+7TmoL9o9tQKIM5UuvFAZs3BtRnTsgM0b3CoBevXLH1y50bWhZK5BUAcKZi7ePqUmh9bZ6XPcANxprTMtLLnt/eeyq+iRk41eymbed9+URI4To2catE8NvPOqP56tWIBEIeaW8hm3i+r8z20IeRcVTfYzPtl9U+3D4hTuUvYzPtd9Xdq5GTuihzP9+pXFMnZfEHvq+oPQByugPZVCSGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEELIf8gzbeZkhd0KR6Id5c4D+Qs88xpFDB+emjpixMiRo0YlJia6XK6kpKSUlIEDx3fr1m3shNGjhw7t3n3cpIkLe/fu0qVvr0H9eiS3pEh/QWBTdCKpESaSGg3ERmNZI0zEGo3p3ZslwkZNmt4HYrHKjY20DiPWqG4YtWvS+NphINaa1yhOI1e8RixRdKPGl+jt2q3lwTbxL3WYaLyYSHapw0RSo8Z3gVhpL8bRNmOIutSxRgzNGyw1X5Yo7qVuLDaKGkayRjRvsJRfPoywkXIYjY8eRpOiZgzJ7TqyRkz/h0A40xsZWBy1ExuhS0EgVvH/fsYQd3E0CBt1rG1E8wZL+Y0sjrCR5BgQi/jVzxj44og3GhZp1PQKEGv4688Y1C2OeoiXOmwkaUbzBov4dS+OcBi1FRtJrtG8wRp+ndupvBH3DAiyrhEmUrs4wkTYKMo9IBbw695OxWGEjTiaN1jBr387tWP9Rk3PATGdX/+MgTfirpUCMZtf9XZqd+V2KkuEjWSeCWAKQek//gXqfhXbqRNib6eKjVpjI9PnDYLPFxQfMv9RJe8cf+YqDGNsO1VMxBtxX4wXCga9Xi8+4ad4hof/pFJwa66sjd7FkTSMWic0Vmq6E4wRi5SWloqfpXiKD/zSf7FKXpnJ8yC926nxGxm8CUUoDRUwoVAB+2DPeCIKiZ+lDX8oXc2VknAGFkexGxm7CUUILfqtkMMiudNnn82YVQmmydkUXSdVNFz/dipLpGxk+JtJPvcfOeguJCG/LLfW9DkCmKJ0sywPGq57OxUbtarfyMhNKIJ7wR+5HTOSPAcPcM9DYIYMsQ43QjQ83owhJfaMgTdiiXgjk+YN7mXFomXsgYrFD/YQz5jaP3GDM5zKXBzx9M3bKWZEcm+S5UEjxUZYTvN2Kg6jVk2axqRv3rBopSohcIILmdyT108yM2+AcdOwDs+DhutfHGGjVl3btGnfvnPnFi1a9BzQvHnzDh1atmzC3Aftgh5U4eEq+FPUwQlT8FPTuTs1T8VDDhg2j+eRsCqpWrdToxdHrVmiSKOeskZXQLviPKXjeTEVg+0q5qVFvH2bhjaAUV55HUmq/sURH0btZcMIG30Bzbw5qnnBZsL8KRE1d6STQh8YVMnzSBKZVP3bqb8bRgnnQbPKGapVgs1mLKlTVvM8cr4IDMqJypMYkapYHCWe6BPD6x18GMkvdW0ijQYMwERSoz2gVfDqXPWCYK+syXVqnuMBhQw34nk4V6riUvexT2yP1M4YsFGCjkYLAvn5gfxAgB3y8cBOGHwtvcKv4HEZ2Mq9ts7tO3hANwTDjZR50AjFjOFWnEY7ZPea/HbGoLNRVboGVWCrGTMld+7M5C6AUWFFHalRJNHvG+2KM2PARi34pU53IyF9jgbpAthpTkatF7czonjMaeRSGqmYMeyKnejmpFiXuq5xFkcJOhqFsuM6lV1fCOw0dSt6WZO1lbsoGG/kUkgSSY34duqufSck+7j9Q/m9JrFnDLWNWupvVDwVXcTPei7yQ61isNOsaej2y2ncrBCY2SiJG6VnOzXe4shIo7xZmuSBnaaiFw+mchfdYFxYmQdzRBolqvjRPbUzBj2NZkzTZAbYyFci+lp9sSRijhtMEFbmQaO0/+gebxR3xpDQSXOjubM1mQs2EtJFD16kRwQKwNRGKRIxxsBR5m+nJuhqFMjSJAB2CjBzqgMRHh+Y1ojXqZNo/naqmEjHOMrQZC7YKYftRz14NUOSVwAmCSvysBRMopHtVOWlzkijqqKiDUUb8IEH9sFswJcifIEH/DtVYKfK48dzqnOOI08ITBOW5UEsBW9UN6PYdSjKrign65yOeBxrGOlrtJIt1C+zzzPsmX3gqfglfMbzy+IfMfhcCXZa4PG8e+ARLfOCicLKPMilmDGMuNlHi/3YqN4w0tHIO1+TENgpVFz8+Rv7pr47CKYKYx3Mw411KS51+/po87jedio2GnIMtMpYLfGv9rMnvx/P8CGpPfeLH0Vgq+CC4mp294sXTBZW1KnlUiyObmlsdFJ2qTPSaOpkDaaCrYRF3x5YcatfWJFnAnIpZgwnNDb6FPNSN0RHo4oVzBL2iYclTOQMT5bgC+lv5IG9vK/eeQUwXViZZ7TIpfgGbOprTYn21Vsc6W7k8xcWlpWVFYrwUIZntc94xFN85feBvXyfPwhgvrA8Dxo6NEm5OHJt389tV9ghc+jQo5iLI9ZosPZGMGeKatlgM6FaAAuE5XUkSeZvp7JEuhoVFM5TqbAA7ISNwAphRR7WgMFG5m6nisNITyPITlPJ9mEEwgewQliZByWZvJ2KiXQ28q2YrsqKIDRQYUUeloBJMn07FRv119MIPNOXqjDdAw1VuawOmjRpUoqWd0JTc6nDGYPORpCdqUIJNFjl8jyiiRMnppi+nYrDSGcjyLq+GF2/jg88x9f8JAsarnJ5HrRwTIqKd0LTcq8Jzhj0NxKKNm9es4Y9EJ7hMz+b6ZgfP7JAOauDpDoMKzBQ84/uKe81UQ4jbNRMZyMQspb/VlZDTgTlfPCIdRBvNDC5BQ6DiE5oCDO4Vn9Rs3qaxnZtS33ProAKJZtz49rcgP8vwkbKPF1EA2sT9UhQ8S/PNDZkC6jxfsr6OKbYfi++xcrleVDfvuOxUVfZILEs1l1QRSjJ3LRx06aNG9kTgyfsNDO7QV/nsJG8DurVa7yYqG3U5Sx+LeOxroBKvuy0VQppp3zQ4JXL8vRCgwZ1Y40m4P87aDCvZf7Q2uID9VbuPZi7TpJ7cG9Dv8rxRjzPINSvn9ioVUInzsJY50EbYVlV+qmL6VXL4H9RLsvTD/Xo0S3RlcIndPFjGb8O0i9KUtFIlqcHSk4em+hKxpUNihPL+NCid1tV10iWJ1nUrl071mhAE05FLb2x6H08VTRS5kFjXRNbMk2Q7lhqatFvpFDRSJmno2iCq02HlpzmWOqHFr1nsYpGrA7Pg4YNGzZhrLjfJokfy/h1cEuD/cacmY14HczDsG3s0R2bcx3i1jIei34fnArblHlQd/bdBYSRzI7Fa3Wiibe6RlIdrnXr5BZMTxQjlnnXQZp4q2oky9Na0qZzi2g8lslDaycQFY14Hq6reJOcRBELmRWLJt6/2Dv3n7bKMI6/L2VcegXKoRcKJ3RtV9tSaGlpB+iQ4XRMVBTcvGyLMG8TDYqJd533S9QoMs2Mmsx7YtR4S0z8QaMx6g/+Tz7nLeWFt5Sdy3suxfMJ66LGraefPs/5vpdzjjxHjB6nBFlQrdLD2uLXB+3gLc8RtUMJeigdNba49UH7sZcKHDm3+gkGq78Dnlpb/PqgHbxlOtquh3hhpDG2uPXBC3bwlu2I9eB0U2pl8euDdvCW66j2k2eiOGOLXx+0g7dsR2xhBJlJB0YWtz74FbKR6ajmw/UyE3iMLG590A7esh2xX30PXaogMLK49cGf7OAt2xHbmbzbFs0BRhavPmgHb/mOmFbUk2A2oOgky2MHb/mOmDOFm91rJ0FlceuD3yIb2Y6Y1NW/w75VKotfH3wM2Sh11FchyOzQZ2Rx64MXkY1sntw+GxDdejFSjS1+ffBzZCPf0bbhf0/NdZcEKotTH/zSDt5KHBE9VXzMFeYEWlrc+uBnyEaBo9atpOjdGnawxakPAnbwVuOoU8LL3DeIkcWtD76GbJQ42roCF2buwcXI4tYHH0Y2ShxtWSD1FEOUWlnc+qAdvBU6aqeI9MaqrCyAXx+0g7c6R7AFpI+5hzRji1sf/NEO3oodOTaICrX3Y6e2+PVBO3grdeSo0h4XtpJkbPHrgzchG5WOvK5NhFpb/Prgq8hGjaNmQLqWnEWgcOuDdvBWyvnmDTr8lDqyuPTB3/f8bUm480DVUYF5Sixji1sftIO3cn4mhro7hzbhIKt+af1o+gOrG5B3uwmJ7CasLLDFrw9ejmwU8x1R1Owf3KSOLD598P9zBxmefH0Z4M5UGWRkEbj1waeRjQpe+QguHk7iChkCa4tfH7we2ajhm8sOtGEGRhavPviPHbxV8sFlUczA2OLVBw8hG5U8GcAy0N4Hx+wyUs91WAaa++A/9myqUmZvf/3EkXPrd956w20nlzO4Lpz64G9j04dOX/On6Q/AsT4Tk8dOvDVz9a1jtzyEGTJ+msMoye0EHJt4I7CFJCrt4R8IBEqhrYxsISQAfvodWFydevDs9NHTr0/+D25Xq4iFR04fXT84du8i1ka+aRPpgj8feEpIksJYOcurU7fefeX4NZP/89PUmWPjV75z1220aHRwlCCONLB4yxVnZ667ZgH9z1i45sj08bGTmMLbkTPd5ePhiLIyderyQ1f9D8pq7p7T586OXYspujqK9EZ5OaKqDk5fd2xv7kyZuP30ueNTi1gv2F7HOOLM8uFT0+PH9lCuOPPye2fHVrD+zNc4ikZpZuDP4m0Hz52YRA3O5IlzBw9jufA/H0Wl89FAGOvJ6oOXj9/emKepMx+eO7WKDYWtI5oZdOf+K6ZP11TU3KR10+DczUfvPLyMDSe/Q6+jjvTn3lPnrqLL7Tfd+ZzLf/JuC/bC2Q+nr1jB5pCvrSN6PjKIxbH1caLl5h+FXx8XBNdv48hKLIzfPaWyfPiPYYkjWkeGcvjskRd/DIWEX5+KJ5OCZRY9HjixrskP/zrqMs8R4Aqncrnsp65QqBh/FJnP3FWXjy1j89ma60gdReh8ndGESuVCIfzSF7nc6IjpWytvOnRqBVuDrY7MrqPQQEAU86UvniiEwykTtyhDAa3fhq0Dez6i8wzGk6z83SOfFvKl8u/js8gUZsfvvBZbCibXmVpHmUjlHTz3OLyBHH7o1rcMHystHLn1IWw1tp+Pukj2TgyY4wjH3W6v15sOfArVXMLA8g1XGrjJ8sx9Dy5iC1K7fkTn64ynX7rRtdv97JvetIg3GLvSkCHt7HWnLCnIYr0Oul0X3AnPE/z+Dae7hKtANR3SuelNvHzWKiFORmYg8wxkTtUUsl64LWKP51OPJ4e3svzguH7rTzfNHMZWZoc6ouMjE8hEW2Oxvi9+6HFhhmvvfgTpwNz4C1YYpyrez0Ayg1kU4BYgj7/pwTswdfQBxJfJmVVseXZaP+o31REeaXe8/YRYZ9n96hcRP14+btWYcKnzEc0MJlFu/vu5LK7HFeNzfHLC+BhuDJheZwlHuOeHZ/Eu3HJ0FmnljresnRN2m/em+xlMpPz9G3hXTs4saTP0XgOchuqdjyKWqCP/E3/hS7CyvqA+yh1qJEM7zAVFLOBIFiuXL6kzdN8t7L74ZChXEMWBaDTi83kBOC0n+vPlVCjuymLzYTODzwp1JJNrZ1Sclz6srjoMF8P9Xk9fezM8Hno/AFeoXgZ0A80bOID2No83URoVBrE5sI4sMIZVxskjE0gRt58i672RYGs3PAC/pQp11C1BFVVol2hzRwuhIWwC87V7ic3PDAqYugbJZ3b6t4K3D+xIMI4O1HdEFHVKtLZ2pMWRYawQ/uOjBqojYPn4JJLJ+JcOOMyqIIVlRBQRYjFPb1jARsE6qu6vCzSOIzgtHZLV8F75qomwT00ZUUegKAb3uW/riKT8WB7854IsMD5SyhUyLsz9pJkqYhztkhjYMqKOJNx5WeXEP9dFGybXUe5/61KD1rV9TTzKCKCKYBWlxxlIYj1h68gKaxNqOXgG7cJ37zdV4VhGPQA8nss578L12DN7iblw+Biqy7/dVJG2xMCWUYeEx9OVy2IG/ebrGraOMF4Zr3sqammijtQH7zplBIoAp8gUk765LtF45yPC8lG0I8/sYxUR1JZRjChiHQWDwWgcb2NPrx+pZn2nEP5tE4Fn8KaKqo4qT+73FTFFp17X6I7wnbWSfmEU8U4MoKjqiLFkz9ftzPGJ+o2ufmJQG7w7ahy53b00i+t3PmrE8RHlaiYuEEU6Bm9WETDgx3yZr10rb9TMUOFKtIXzB5oAnYM368jrLWTtXrcbyyeoolkydNU5eLOKwJHXF9d3fASSBhrYEb6WzoOvNQH6B2+2jID0/BDGe3WfKgdeqOaGf+nJiPtUHRu8WUfpSFHPXtfgdYTxfagCdDqDEwNVBOf2/NBemgvKplIpAXPj+dlKpmsCDAzerCNfVNCn1/kiJjhyQVPyYn7M0DJS0uqatSYGqog48vlymT2T61zwufF0dFIqpG+0lRGgsYyAiDikW2YIGO6oJY05coSEOpOCNy2jSCTSL+hTRwnD66ilha+jK8DRBb7Bm3Ukq4ykuwiH9sa8t2v//pYuzJHlJXS+yZzgzTqKRlMZvo7MuUbMBZ+VD/PkNPrMzOANbCgCR4lylv/4qN9wR92XXRbBPJlG35obvGkZwblDHOZeR8Y5Cnj8xJH04DPMk+NozYTE4GUTAykjKYO5uO0lNjwzpJtdxBF8Nv2Y4G0T+ISGr3gH75jaMiJjGYHnfbck88Y5clQcORzNA5jQ4UhiDkyBIw6JQVPwpmUkNaYilhBK4khG81yQofMMvk1HjgAmePg4GkNrKoI3wDl4b5QROAqMYByP7QOaRe1jWANzna+94gg+j6qjdoHL3Df6xRrBO1FxFAByuQOVt7CvS0OvM9xRpLOSGeCzEDHB2cnF0cfoc4sE72oZBcRAd0uVnGpHxtdRbytx5IePobThqJWLo6PogX1aEgO34E3LSAwe2H8AfvYDbVqzt4G5LhqrOILvaRgT3DEujq6BaW+rBO+KI1GMwd9FgN+zqs9Hhq/xJdoqjtr62sKY4O3j4ejaCYR+sUzw3nDU2UwRNDoycAw70FNxBMce5jk++li6JqzFvODNJgbiqNVBSTbOvHego+IIjjqFCekOF5dWB3ylenMq/+ANisRYO0VoHEeip+IIDnjDkc/j4jE6kjjfomfwBpQEb3DU1kkRNIxhjXYUrDiCb2QOE7rg32jmekRYs0Lw3kgMQE/lTyM/grbxEUgaMGodNu+sOIIjHcEEr3OQxwofYemCdYK3KOY7Kn9KH/z0FRtnP0PZPYyBYTjIEJZwuXuxVh66h+72tkzwBkfBHkq+mNXqyKg6KngrjuAAi1gi7M1hrZxDm/zBOXgD6oI3KMo7PZT5VCo+rDJ7G7wOG+5yEUdwdHEMDPkiWW7bVIGJn/QL3soSAzhyO53w/5CXYAl2FOZCwlAD7IFM+ULEERyX5Cgj+pJYI7csoC28csEiwVvMz3vdlLLkKJcbDcVdQxlVmcEwR6OREimf3t5IEhSFIyHNMwzM5eXnL+i0Rq64jOa7vJSqo9FReLh4XPAPDyqcCzKujoREwi85SkQTSTxcHhCwRhavQgwPN1sieOfzpUiXT/rv0mtXGBQBoAgcSRSLSTA1NCh7bcIwRxlxoCA5gmPJpcLxQc2Krkc1PNZsheCdny/1924S3VpGG47iEsmkILj8/qHsYGb3+wUljLtPviCKIXAEh5HE2lmpKmLanQWCd75Umu/fRKwtoyJRBAgEF+D3Q2UNZbPi9l4XMXT9CBDm83GchWNwYc2s3ox25JWfwJGJwRuAMiqV8yL5B3gJV8uIOoqzjgh+iQGz9xIPhwoj/nK5rN3R4ZtQHe74Sm3w5rFGvlFGJTjIEqGQqldGdR2x2dvwfaqDw4Vwwa95XLSE6vPMAcMTA1tGoKggEYYiomXEOGIVEQJW2EssXSOm0dHy9ATajW8uGLo5lS0jcEQUgZ9tjqgimY7S1NGAoY4G4R1rc7T6IboED6zt17+M6ieGqqPcKAiSkRi2ObLCNcuD8JUaxho4uIAuzecXzAveVUXhkVCKKSNg9zIaBoaALDAIZCSw0QzC+xzSMLdwH5IDlNIB/a8Ko2XEJgbiKBRXXEaMokEzDIEjeJfqHR1fQHJ57Cf9rwqrnxhAUbgo5JjEIL+MzNBDHcE7zGJ1TL2MlPDJBUM3p7JlFI67crVlBH421Gy1Uq0bYsZ0MkJSUOfo5KE5pIzZbx1GB+88KKo6Evyj4AjmUePgBHSABnkCMuG0ojuv8XckqHqew+LdZ5ByXvnDIaOM+CeGcG6kmPQP+4fUHGrIsU+iw49NIgNVPqjc0Mc3IXV8t9ZMFBkzVVdKjRaTLn+20tazqvpWqDoGbx/G5pDx+xU7Wj5+D1LP+TWHzsEbHImFXFEgbijqTi2Z9v1VvNgcMtABMspq6OyLSBuvfNupX/AOlHOwwIq5Ee6G7gw/8NKcxboT8rrna3xAjFHiaGV9Emln9pc+HYK3GA6BHc74mimjWG+8+4BOtqlCzJTvaHVmCXHiky8d/IJ3REwVXfqkZK+DEsY6U95PCOLtwCAAy+SG6+YQR86vtfIoo/5CCPToRrqTksI646mEXrapyh2lrXx8DPFm9rMvNSUGn5hKZrG++GJAa4y85rDOtDkqCFgFY0fPIF04/0ePuuCdFkehfPSnt42iuyMPvW5AISfXjyEd+fxiTOFVYekA8WMIiQ7KCNYZp7QnHX4pdPTQwdNzSGdmP7kYk11G0RT4MY5AUMJJXkNYZ7zkWDsUXQi2eOt9s8gQHvjsy9ilHaXFYhYbi+im6O7IR76FTrdLtqAXjiwh4wBNF3t2Cd7O3pQLG085DXSRBJmOY53pT1dG5X55Me7gfWeQ4cx9fjG4YxkFE6ND2BTCvRGJXukniXWmHCUksjJCwo0n7kBm8fBrX/ZsLyPnQGgQm0VImqTd+KV7HQsiIYV3Z/mGmZsnkLksfXbRWS2j4EA8g03EL25S0v+NJMPAyK7fyNWz40vIGjz82sVghycaMn0d9L927KYllSiMA/h51i7FRR9AiEujF+4NmqPjjPNunbIXTJ1szHEiLcss0O2AI25aBBPYpo/T96owKCIpIo9nyt/ibM/iz/Nw/mfh/6OVpyMG07cUW0jARKfWaC2NmLKb4wnMXPzPWAxoiC5OKkG+d8VYPs/Sg9vDMsxWIhL/F49wQEUy8t4Dwc6aW4hpUuoIOzBD0eW/QAn35qaWcqwfoHComaPizAYqupgESpa4V+NjreZdFDKFUtdqAn3JSALoIhkhtYNCq3CXLSotoCkR5YCasq1WQxzPi/Wr67bfB0q4JJUKQDaDnMZK+fkudS0XZPZh+rgpZ3SKj7P5HzE8E9RNXeDlCwgjR+m0RU1Cv0NaGupqETNQej/lXLYFMd9gvPVMidtLjW543Ac2EdkyvA2zgOYQqjXu9FXDxk0HGNCXO9uqWBqcobl3l+BaSffah758STeu1v5ehje6YtWUfudK+5r6wbB6MlKNYgcrxPn+VEhZzvCBkL1OaQOJzR/QkKkVKr1haePW6wpGwNv+JlaUJiHn8BGHkEtFwdi3+O1AUD3xpKr1GtI6mqOn5rpSZey+92RQGZNc9yck8QAFARBHty0xzgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "sQ/C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sWd/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t8qE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWnD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ve4H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w/mq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w5Ii":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAXVBMVEUAAAD6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYluFYaeAAAAHnRSTlMA+hGb6lwoC/eiLO3XkRzKyTQYsJLuzql3RjjFaFhf5NUeAAAA30lEQVQ4y42T6xKCQAiFz150ddWt1PJS8f6P2VSOLajp9w+WWeAA+KETc7JK2ZNJNJakeUYzWZ6C4ypFDFU5RIQbLSijTy6WVigumPAFrVL4KX9JG5TfOirapPr0F9ff6drEvbwLzSmiBnRs54DOYocTAZlGQjEp4JkjgWH2CAzMYXBm9gDx5RlcxCfQc7HAh/SQsigR0AOdCLCiJtx5ClGkrUcSRRr6ixFdNSE0XCghtQZqLrUYVpDDkuNugubj3lmY9tjKwV/X369+b+2PHw7gWnl6rQPH8+Od0++e/wt5NVTX9D3stwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "wOEh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/birthday_pop.0ea17bc.png";

/***/ }),

/***/ "xBcY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xXI2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAABO0lEQVRIDe1VO27CQBCdcZYLWHABKkSVtCkgXACOAEhUCFKSM6SORAtSLmIXaWjSJHUuQEPJz5MZa0falZCMjem8kjXj9cx79qz8HsaraUQAXbh97TB46HWHH98ulBFwRDwQ0Z/7IE+OgCEBNQCSJ+7zCQRIwF/Gy1YeULc2Ws8WDPLu7mluNNEYf74+wzmp6/1VkajNkwC+HuP1rK89Qa324xEIOJ1OX1qQOyY051HNte983G89An1zPpMNAkVaWCQS4YRHX/cJLJKAd0bLtyLA2hOtpgPOw0A37hUrgszJViOqRpQ5gcyCVCpEz63ktjM7chYIwS41C9ZzkdyylxGbs06U6jmw5JZJYqyHpjYnZuHqeRlEd/+TL/qBmIXV88IfgQBNOVOPwAD+HhG24kT8LCyMzo0CziTxPzFjacLXJ1wUAAAAAElFTkSuQmCC"

/***/ }),

/***/ "yS1U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yUBp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ygp0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yjEN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z+QX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.61a9a566412367c9ec27.js